import srDict from "./locales/sr.json";
import hrDict from "./locales/hr.json";
import sqDict from "./locales/sq.json";
import slDict from "./locales/sl.json";
import ptDict from "./locales/pt.json";
import csDict from "./locales/cs.json";
import huDict from "./locales/hu.json";
import hiDict from "./locales/hi.json";
import msDict from "./locales/ms.json";
import zhDict from "./locales/zh.json";
import nlDict from "./locales/nl.json";
export const T = {
  de: {
    appTitle: "Team Phoenix Portal",
    tabs: { welcome: "Willkommen", dashboard: "Meine Reise", calculator: "Rechner", tracking: "Tracking", history: "Historie", strategy: "Landingpage", risk: "Risiko", social: "Social", settings: "Einstellungen", members: "Mitglieder", riskCenter: "Risiko-Center", riskDocs: "Risiko-Dokumente", academy: "Wissensdatenbank", support: "Portal Support", adminAcademy: "Wissens-CMS", audit: "Audit-Log", calendar: "Kalender", adminSupport: "Support (Admin)", marketing: "Marketing", adminGroup: "Admin", leads: "Leads", links: "Links & Mailadressen", adminLinks: "Links & Mailadressen (Admin)", profitCalc: "Profitrechner", marketingMaterial: "Marketing-Material", adminMarketingMaterial: "Material (Admin)", news: "News" },
    heroSubtitles: {
      dashboard: "Dein persönlicher Fortschritt & Meilensteine im Copy-Trading",
      calculator: "Simuliere Renditen, Hebel und Auszahlungen",
      tracking: "Erfasse deine Trades sauber und lückenlos",
      history: "Deine vollständige Trade-Historie im Überblick",
      strategy: "Deine persönliche Landing-Page & Referral-Verwaltung",
      calendar: "Live-Calls, Webinare & Termine – alles auf einen Blick",
      riskCenter: "Deine Risiko-Dokumente und dein persönliches Risiko-Profil",
      academy: "Kurze Lektionen, Tutorials und Ressourcen",
      support: "Dein direkter Draht zum Portal-Admin – Fragen und Probleme rund ums Team Portal",
      social: "Automatisch Beiträge für Community & Social Media generieren",
      settings: "Portal-Einstellungen und Präferenzen",
      members: "Mitglieder-Verwaltung und Einladungen",
      riskDocs: "Verwalte versionierte Risiko-Dokumente",
      adminAcademy: "Kategorien und Lektionen der Wissensdatenbank verwalten",
      adminSupport: "Alle Support-Tickets im Überblick",
      audit: "Chronologisches Protokoll aller Portal-Aktionen",
    },
    edu: {
      heroBadge: "Wissensplattform · Kein Verkauf, keine Versprechen",
      heroH1a: "Lass erfahrene Trader für dich handeln —",
      heroH1b: "dein Geld bleibt jederzeit auf deinem eigenen Brokerkonto.",
      heroSub: "Du musst weder Charts lesen noch selbst handeln. Eine geprüfte Strategie wird automatisch auf dein eigenes Konto übertragen. Du behältst jederzeit die volle Kontrolle.",
      b1t: "Dein Kapital bleibt bei dir",
      b1x: "Das Geld liegt auf deinem eigenen Brokerkonto – nicht bei uns.",
      b2t: "Trades werden kopiert",
      b2x: "Automatisch, ohne dass du selbst eingreifen musst.",
      b3t: "Alles transparent",
      b3x: "Jeder einzelne Trade ist öffentlich nachvollziehbar.",
      ctaStart: "Jetzt starten",
      ctaLearn: "Mehr erfahren",
      illBroker: "Dein Brokerkonto",
      illControl: "unter deiner Kontrolle",
      illGold: "Gold",
      illGoldNote: "Der Markt, in dem die Strategie handelt.",
      illApp: "Sonic App",
      illProgress: "Fortschritt",
      illLastTrade: "Letzter Trade",
      illStrategy: "Strategie",
      illActive: "Aktiv · Kontrolle bei dir",
      whatEye: "Grundlagen zuerst",
      whatTitle: "Was ist Copy Trading?",
      whatIntro: "Kurz gesagt: Ein erfahrener Trader trifft die Handelsentscheidungen. Diese werden automatisch auf dein eigenes Konto übertragen. Du selbst musst nichts tun.",
      whatStep: "Schritt",
      whatS1t: "Erfahrener Trader",
      whatS1x: "Analysiert den Markt und trifft die Entscheidung.",
      whatS2t: "Eröffnet einen Trade",
      whatS2x: "Kauf- oder Verkauf-Order auf sein Konto.",
      whatS3t: "Automatisch auf dein Konto",
      whatS3x: "Die gleiche Order wird gespiegelt – proportional zu deinem Kapital.",
      whatS4t: "Ergebnis fließt zu dir",
      whatS4x: "Gewinn oder Verlust erscheinen anteilig in deinem Konto.",
      whatImportant: "Wichtig: Du handelst nicht selbst. Du kopierst die Strategie. Die Handelsentscheidungen bleiben beim Trader, dein Kapital bleibt bei dir.",
      howEye: "Der Ablauf",
      howTitle: "Wie funktioniert das genau?",
      howS1t: "Konto eröffnen",
      howS1x: "Ein kostenloses Brokerkonto bei TAG Markets aufmachen – dauert wenige Minuten.",
      howS2t: "Strategie verbinden",
      howS2x: "Über einen speziellen Service (COPYX) autorisierst du das automatische Kopieren.",
      howS3t: "Trader eröffnet Position",
      howS3x: "Der erfahrene Trader trifft die Handelsentscheidung auf seinem Konto.",
      howS4t: "Trade erscheint bei dir",
      howS4x: "Die gleiche Order landet automatisch auf deinem Konto – ohne dein Zutun.",
      howS5t: "Entwicklung verfolgen",
      howS5x: "Du siehst jederzeit im Portal, was passiert – transparent und in Echtzeit.",
      skillEye: "Für Einsteiger",
      skillTitle: "Muss ich traden können?",
      skillNo: "Nein.",
      skillNoNote: "Kein Vorwissen erforderlich.",
      skillDesc: "Die gesamten Handelsentscheidungen übernimmt der erfahrene Trader. Du siehst nur, was passiert – und lernst dabei automatisch mit.",
      skill1: "keine Charts lesen",
      skill2: "keine Marktanalyse",
      skill3: "keine Kaufentscheidungen",
      skill4: "keine Verkaufssignale",
      skill5: "keine Newsauswertung",
      skill6: "keine Sonntagsarbeit",
      moneyEye: "Vertrauen",
      moneyTitle: "Wo liegt eigentlich mein Geld?",
      moneySub: "Die wichtigste Frage – und die einfachste Antwort:",
      moneyAccLabel: "Dein Brokerkonto",
      moneyAccNote: "Hier – und nur hier – liegt dein Kapital.",
      moneyP1t: "Auf deinem Brokerkonto",
      moneyP1x: "Ein reguliertes Konto, das nur dir gehört. Wir haben keinerlei Zugriff auf dein Guthaben.",
      moneyP2t: "Nur Handelsvollmacht",
      moneyP2x: "Die Strategie darf ausschließlich Trades platzieren – aber niemals dein Geld anfassen.",
      moneyP3t: "Kein Zahlungsempfang durch Dritte",
      moneyP3x: "Deine Ein- und Auszahlungen laufen direkt zwischen dir und deinem Broker.",
      moneyP4t: "Jederzeit pausierbar oder kündbar",
      moneyP4x: "Ein Klick genügt, um das Kopieren zu stoppen oder komplett zu beenden.",
      moneyCtrl: "Volle Kontrolle bleibt bei dir.",
      moneyCtrlSub: "Kein Fondsmanager, keine Verwahrung, keine Auszahlung durch Dritte.",
      whyEye: "Zielgruppe",
      whyTitle: "Warum nutzen Menschen Copy Trading?",
      whyP1t: "„Ich habe keine Zeit“",
      whyP1x: "Beruf, Familie, Alltag – Copy Trading arbeitet weiter, während du dein Leben lebst.",
      whyP2t: "„Ich habe keine Erfahrung“",
      whyP2x: "Du brauchst kein Trading-Wissen. Die Strategie trifft die Entscheidungen, du lernst nebenbei mit.",
      whyP3t: "„Ich will transparent investieren“",
      whyP3x: "Jeder Trade ist nachvollziehbar. Du siehst genau, was gemacht wird und warum.",
      whyP4t: "„Ich überlasse das lieber Profis“",
      whyP4x: "Erfahrene Trader haben Jahre an Erfahrung. Ihre Entscheidungen kannst du 1:1 nutzen.",
      transEye: "Transparenz",
      transTitle: "Was ist Myfxbook — und warum ist das wichtig?",
      transPara: "Myfxbook ist ein unabhängiger Verifizierungs-Dienst für Trading-Konten. Er verbindet sich direkt mit dem Brokerkonto des Traders und protokolliert jeden einzelnen Trade automatisch – ohne dass irgendjemand die Zahlen im Nachhinein &bdquo;schönrechnen&ldquo; kann.",
      trans1: "Jeder Trade wird in Echtzeit gespeichert – nicht erst am Monatsende.",
      trans2: "Manipulation ist ausgeschlossen: die Daten kommen direkt vom Broker.",
      trans3: "Du kannst jederzeit selbst reinschauen – öffentlich, ohne Anmeldung.",
      trans4: "So sieht man auch Verluste – nicht nur die Gewinne. Das schafft echtes Vertrauen.",
      transCta: "Öffentlichen Track Record ansehen",
      transVer: "Verifiziertes Konto",
      transLive: "Live",
      transK1: "Trades gesamt",
      transK2: "Winrate",
      transK3: "Live seit",
      transK4: "Max. Verlust-Phase",
      transK3v: "21 Monaten",
      transExpl: "&bdquo;Verlust-Phase&ldquo; heißt: der größte Rückgang zwischen einem Höchststand und einem darauffolgenden Tief. Je kleiner die Zahl, desto ruhiger die Kurve.",
      oppEye: "Ehrlich statt werblich",
      oppTitle: "Chancen & Risiken im Klartext",
      oppSub: "Beides gehört zusammen. Wir zeigen es nebeneinander – ohne Beschönigung.",
      oppTitleC: "Chancen",
      oppTitleR: "Risiken",
      opp1: "Klare Trennung von Kapital (bei dir) und Strategie (beim Trader).",
      opp2: "Zeitersparnis: keine Marktanalyse, keine Chart-Studie, kein Alarm-Handy.",
      opp3: "Volle Transparenz durch verifizierten Track Record.",
      opp4: "Lernkurve inklusive: du siehst, wie ein Profi arbeitet.",
      opp5: "Jederzeit pausierbar – kein Vertrag, keine Bindung.",
      risk1: "Verluste sind möglich – auch Totalverlust deiner Einlage.",
      risk2: "Historische Performance ist keine Garantie für zukünftige Ergebnisse.",
      risk3: "Der Markt (Gold) kann sich stark bewegen, auch in kurzer Zeit.",
      risk4: "Ohne Broker-Kenntnisse braucht der erste Kontoaufbau Zeit.",
      risk5: "Nicht geeignet für Kapital, das du kurzfristig brauchst.",
      faqEye: "FAQ",
      faqTitle: "Häufige Fragen",
      faqQ1: "Was ist Copy Trading eigentlich?",
      faqA1: "Copy Trading heißt: Ein erfahrener Trader trifft die Handelsentscheidungen. Diese werden automatisch auf dein eigenes Brokerkonto übertragen. Du handelst nicht selbst – du kopierst die Strategie.",
      faqQ2: "Bleibt mein Geld wirklich auf meinem Konto?",
      faqA2: "Ja. Dein Kapital liegt bei einem regulierten Broker auf einem Konto, das nur dir gehört. Die Strategie hat lediglich die Erlaubnis, Trades zu platzieren – niemals aber Zugriff auf dein Geld.",
      faqQ3: "Kann ich jederzeit aufhören?",
      faqA3: "Ja. Du kannst das Kopieren mit einem Klick pausieren oder ganz beenden. Es gibt keine Mindestlaufzeit, keine Kündigungsfrist.",
      faqQ4: "Wie zahle ich Gewinne aus?",
      faqA4: "Direkt vom Brokerkonto auf dein eigenes Bankkonto. Ein- und Auszahlungen laufen ausschließlich zwischen dir und deinem Broker – nicht über uns.",
      faqQ5: "Brauche ich Erfahrung mit Trading?",
      faqA5: "Nein. Kein Vorwissen erforderlich. Die Strategie übernimmt alle Handelsentscheidungen. Wenn du mehr lernen willst, findest du im Mitgliederportal eine strukturierte Wissensdatenbank.",
      faqQ6: "Was kostet das?",
      faqA6: "Die Nutzung der Strategie erfolgt auf Erfolgsbasis: Es fällt eine Performance-Fee auf tatsächlich erzielte Gewinne an. Ohne Gewinn keine Gebühr. Alle Details siehst du vor der Verbindung.",
      faqQ7: "Was passiert bei Verlusten?",
      faqA7: "Verluste sind Teil des Marktes und werden proportional zu deinem Kapital gespiegelt. Der Track Record zeigt sowohl Gewinn- als auch Verlust-Phasen offen.",
      faqQ8: "Warum wird gerade Gold gehandelt?",
      faqA8: "Gold (Ticker &bdquo;XAUUSD&ldquo;) ist einer der liquidesten Märkte der Welt: enge Spreads, klare Bewegungen und rund um die Uhr handelbar. Die Strategie ist speziell auf die Eigenschaften dieses Marktes optimiert.",
      faqQ9: "Was ist MT5?",
      faqA9: "MetaTrader 5 (MT5) ist eine weit verbreitete Handelsplattform. Der Broker stellt sie kostenlos zur Verfügung. Die Strategie &bdquo;spricht&ldquo; über MT5 mit deinem Broker und platziert dort die Trades. Du selbst musst MT5 nicht bedienen.",
      softH1: "Wenn du verstanden hast, wie Copy Trading funktioniert,",
      softH2: "kannst du dir jetzt anschauen, wie die Strategie historisch gearbeitet hat.",
      softSub: "Keine Versprechen, kein Druck. Nur Zahlen aus echten, verifizierten Konten.",
      softAgain: "Nochmal von vorne lesen",
    },
    strategy: {
      badge: "Strategie aktiv – läuft live",
      hero1: "Automatisiertes Gold-Trading –",
      heroHighlight: "meine Strategie im Überblick",
      heroSub: "Die SONIC-Strategie handelt Gold (XAUUSD) durch erfahrene Trader. Jeder Trade wird über MT5 auf das eigene Konto gespiegelt – ohne dass man selbst handeln muss. Hier findest du die wichtigsten Fakten und den Weg zum Einstieg.",
      kpiDaily: "Tagesrendite (24x, netto)",
      kpiMonthly: "Monatsrendite (24x, netto)",
      kpiDrawdown: "Max. Drawdown (1x)",
      kpiTrades: "Trades · Gewinnquote",
      kpiNote: "Netto-Kennzahlen (24×-Konto, nach 30 % Performance-Fee) gemäß Präsentation (Folie 8, verifizierter Real-Follower-Account). Drawdown & Trades live aus der Historie ({months} Monate). Vergangene Ergebnisse sind keine Garantie für die Zukunft.",
      cta: "Jetzt starten",
      ctaBandTitle: "Bereit für den nächsten Schritt?",
      ctaBandSub: "Verbinde dein Konto und lass die Strategie für dich handeln.",
      verified: "Verifizierter Track Record (myfxbook)",
      howTitle: "So funktioniert es",
      howSub: "Vom Konto bis zum ersten kopierten Trade in wenigen Schritten.",
      step1Title: "Konto verbinden",
      step1Text: "Du verknüpfst dein eigenes MT5-Konto in wenigen Minuten mit der Strategie. Das Kapital bleibt dabei jederzeit auf deinem eigenen Konto.",
      step2Title: "Trades werden gespiegelt",
      step2Text: "Öffnet die Strategie eine Position, wird sie automatisch und ohne Verzögerung auf deinem Konto nachgebildet – Einstieg, Ausstieg und Positionsgröße inklusive.",
      step3Title: "Gemeinsam unterwegs",
      step3Text: "Eine aktive Community aus vielen Ländern nutzt die Strategie bereits. Bei Fragen zur Einrichtung gibt es Unterstützung Schritt für Schritt.",
      mirrorTitle: "Kopieren statt selbst traden",
      whatTitle: "Was ist Copy-Trading?",
      whatText1: "Beim Copy-Trading wird ein Handelskonto automatisch mit einer bestehenden Strategie verbunden. Jeder Trade, den die Strategie ausführt, wird in Echtzeit auf dem eigenen Konto nachgebildet – proportional zur eigenen Kontogröße. Man muss selbst keine Charts lesen, keine Ein- und Ausstiege timen und keine Handelserfahrung mitbringen.",
      whatText2: "Der große Unterschied zu klassischen Fonds oder Vermögensverwaltung: Das Kapital bleibt die ganze Zeit auf dem eigenen Broker-Konto. Niemand außer dir hat Zugriff darauf – die Strategie erhält lediglich die Berechtigung, Trades zu platzieren.",
      whatFacts: [
        "Kapital bleibt auf deinem eigenen Konto – volle Kontrolle, jederzeit",
        "Trades werden vollautomatisch in Echtzeit gespiegelt",
        "Kopieren lässt sich jederzeit pausieren oder komplett beenden",
        "Jeder Trade ist öffentlich auf Myfxbook nachvollziehbar",
      ],
      possTitle: "Welche Möglichkeiten hast du damit?",
      possSub: "Copy-Trading ist flexibel – du entscheidest, wie du es für dich nutzt.",
      poss1Title: "Zinseszins-Effekt nutzen",
      poss1Text: "Gewinne bleiben auf dem Konto und werden automatisch mitgehandelt. Dadurch wächst die Positionsgröße mit – der Zinseszins-Effekt kann das Kapital über Monate deutlich schneller wachsen lassen als lineares Sparen.",
      poss2Title: "Regelmäßige Auszahlungen",
      poss2Text: "Alternativ lässt sich ein Teil der Gewinne regelmäßig auszahlen – zum Beispiel, um zuerst das eingesetzte Startkapital zurückzuholen. Ab diesem Punkt handelst du nur noch mit „Haus-Geld“.",
      poss3Title: "Kopierfaktor selbst wählen",
      poss3Text: "Über den Kopierfaktor (z. B. 12x oder 24x) bestimmst du, wie stark dein Konto die Strategie hebelt. Höherer Faktor bedeutet höhere mögliche Rendite – aber genauso höheres Verlustrisiko.",
      poss4Title: "Komplett passiv teilnehmen",
      poss4Text: "Nach der einmaligen Einrichtung läuft alles automatisch. Kein Chartlesen, keine Handelsentscheidungen, kein Zeitaufwand – die Entwicklung lässt sich jederzeit transparent mitverfolgen.",
      riskTitle: "Chancen & Risiken – ehrlich betrachtet",
      riskSub: "Copy-Trading mit Hebel ist ein Hochrisiko-Investment. Beides gehört auf den Tisch.",
      chancesLabel: "Chancen",
      risksLabel: "Risiken",
      chances: [
        "Überdurchschnittliche Monatsrenditen möglich – die komplette Historie ist auf Myfxbook verifiziert",
        "Zinseszins-Effekt durch automatisches Reinvestieren der Gewinne",
        "Kein eigenes Trading-Wissen nötig – vollautomatische Umsetzung",
        "Volle Kontrolle: eigenes Konto, jederzeit pausieren oder aussteigen",
      ],
      risks: [
        "Der Hebel wirkt in beide Richtungen – Verluste werden genauso verstärkt wie Gewinne",
        "Ein Totalverlust des eingesetzten Kapitals ist jederzeit möglich",
        "Vergangene Ergebnisse sind keine Garantie für zukünftige Entwicklungen",
        "Nur Kapital einsetzen, dessen vollständigen Verlust man verkraften kann",
      ],
      videoTitle: "So funktioniert das Copy-Trading-System",
      videoSub: "Das Erklärvideo zeigt Schritt für Schritt, wie das System arbeitet.",
      mirrorText: "Das Prinzip ist einfach: Ein erfahrenes System handelt, dein Konto zieht automatisch mit. Du behältst die volle Kontrolle über dein Kapital und kannst jederzeit pausieren oder aussteigen. Auf dieser Seite dokumentiere ich transparent, wie sich das bei mir entwickelt.",
      disclaimer: "Persönliche Erfahrungsdokumentation – keine Anlage-, Finanz- oder Rechtsberatung und keine Empfehlung. Der Handel mit Finanzinstrumenten ist mit erheblichen Risiken verbunden und kann zum Totalverlust führen. Jede Entscheidung triffst du eigenverantwortlich.",
      landing: {
        liveBadge: "Strategie aktiv · Live-Signal",
        heroHead1: "Automatisiertes Gold-Trading",
        heroHead2: "mit transparenter Historie.",
        heroSub: "Spiegele eine geprüfte Copy-Trading-Strategie auf dein eigenes Brokerkonto. Dein Kapital bleibt jederzeit unter deiner Kontrolle – pausieren oder beenden auf Knopfdruck.",
        ctaStart: "Jetzt starten",
        ctaLive: "Live Performance ansehen",
        trust: ["Verifizierter Myfxbook Track Record", "Eigenes Brokerkonto", "Jederzeit pausierbar", "Volle Kontrolle über dein Kapital"],
        liveDash: "Live Dashboard",
        kpiAvgMonth: "Ø Monat",
        kpiWinRate: "Winrate",
        kpiDrawdown: "Drawdown",
        kpiTrades: "Trades",
        timelineEyebrow: "So einfach geht's",
        timelineTitle: "In fünf Schritten aktiv",
        steps: [
          { title: "Brokerkonto eröffnen", text: "Kostenloses Konto bei TAG Markets in wenigen Minuten." },
          { title: "Strategie verbinden", text: "Copy-Trading via COPYX aktivieren – dauert 2 Minuten." },
          { title: "Trades werden gespiegelt", text: "Automatisch, 1:1 auf dein Konto. Kein Eingriff nötig." },
          { title: "Entwicklung verfolgen", text: "Täglicher Fortschritt im Mitgliederportal & Myfxbook." },
          { title: "Community nutzen", text: "Live-Calls, Wissensdatenbank, direkter Support." },
        ],
        perfEyebrow: "Real & verifiziert",
        perfTitle: "Live Performance seit Tag Eins",
        perfSub: "Simulierte Netto-Kapitalkurve auf einem 1 000 $ Startkonto (24× Amplified, 30 % Performance-Fee bereits abgezogen) – jeder Trade lückenlos dokumentiert.",
        perfAvgMonth: "Ø Monat (netto)",
        perfWinRate: "Winrate",
        perfDrawdown: "Max Drawdown",
        perfMonths: "Monate live",
        perfChartLabel: "Kapitalkurve",
        perfSourceLine1: "Live-Datenquelle: history_trades.",
        perfSourceLine2: "Simulation nach Broker-Fees & Performance-Fee.",
        perfMilestones: "Meilensteine",
        perfMilestoneGoal: "Ziel",
        perfMilestoneReached: "Erreicht:",
        perfMilestoneOpen: "Noch offen",
        portalEyebrow: "Dein Mitgliederbereich",
        portalTitle: "Alles an einem Ort. Sauber. Klar. Deins.",
        portalSub: "Als Mitglied bekommst du drei zentrale Werkzeuge, die deinen Weg strukturieren – vom Startkapital bis zur ersten Auszahlung.",
        journeyLabel: "Meine Reise",
        journeyLive: "Live",
        journeySub: "Netto-Fortschritt · 6 Monate",
        journeyMilestone: "Meilenstein",
        journeyReached: "erreicht",
        journeyShare: "Teilbar via öffentlichem Link · PDF-Export",
        calendarLabel: "Kalender",
        calendarMonth: "Februar 2026",
        calendarSub: "4 Community-Events · .ics Export",
        calendarNext: "Nächstes Event",
        calendarNextText: "Live Q&A · 18. Feb · 19:00 Uhr",
        kbLabel: "Wissensdatenbank",
        kbTitle: "AI Q&A · Instant Antworten",
        kbSub: "Kuratierte Lektionen · KI-gestützte Suche",
        kbUserQ: "Deine Frage",
        kbUserQText: "Wie hoch sollte mein Startkapital sein?",
        kbAI: "Sonic AI antwortet",
        kbAnswer: "Empfohlener Start ab 1 000 € auf einem 24×-Konto. Kleinere Beträge sind möglich, verlangsamen aber den Compound-Effekt spürbar…",
        kbLatency: "0,8 s · basierend auf 24 Lektionen",
        cardJourney: { title: "Meine Reise", desc: "Setze Meilensteine, tracke deinen Netto-Fortschritt und teile ihn via öffentlichem Link." },
        cardCalendar: { title: "Kalender", desc: "Live-Calls, Q&A-Sessions und Trade-Recaps – ein Klick auf „Add to Calendar\" erzeugt eine .ics-Datei." },
        cardKb: { title: "Wissensdatenbank", desc: "Kuratierte Lektionen plus KI-gestützte Suche. Fragen wie „Wie hoch sollte mein Kapital sein?\" in Sekunden beantwortet." },
        ctaMember: "Jetzt Mitglied werden",
      },
    },
    disclaimer: {
      title: "Bevor du fortfährst",
      intro: "Bitte lies und bestätige die folgenden Punkte, um die Seite zu nutzen.",
      items: [
        "Ich habe den Haftungsausschluss gelesen und verstanden: Sämtliche Inhalte auf dieser Seite stellen keine Anlage-, Finanz-, Steuer- oder Rechtsberatung dar. Es handelt sich ausschließlich um die Dokumentation persönlicher Erfahrungen und Meinungen des Betreibers.",
        "Eigenverantwortung: Alle Angaben dienen ausschließlich der allgemeinen Information. Jede Entscheidung, die ich auf Grundlage dieser Inhalte treffe, erfolgt eigenständig und auf eigenes Risiko.",
        "Risikohinweis: Der Handel mit Finanzinstrumenten (z. B. Aktien, Fonds oder Kryptowerten) ist mit erheblichen Risiken verbunden und kann zum vollständigen Verlust des eingesetzten Kapitals führen. Ergebnisse der Vergangenheit sind keine Garantie für zukünftige Entwicklungen.",
        "Mir ist bewusst, dass auch ich selbst keine Beratung erbringen und keine Empfehlungen aussprechen darf. Diese Seite berichtet ausschließlich über eigene Erfahrungen.",
      ],
      yes: "JA",
      accept: "Akzeptieren & fortfahren",
      ipNote: "Mit dem Akzeptieren wird deine IP-Adresse zu Nachweiszwecken protokolliert.",
    },
    kpi: {
      startCapital: "Startkapital",
      currentBalance: "Aktueller Kontostand",
      totalProfit: "Gesamtgewinne",
      totalPayouts: "Auszahlungen",
      netProfit: "Netto-Gewinn",
      totalReturn: "Gesamtrendite",
      monthlyReturn: "Monatsrendite",
      dailyReturn: "Ø Tagesrendite",
      volume: "Handelsvolumen",
      leverage: "Hebel",
    },
    recovery: "Rückholung des Startkapitals",
    recoveryHint: "über Auszahlungen zurückgeholt",
    growthChart: "Wachstumskurve",
    balance: "Kontostand",
    planLine: "Plan ({target} %/Monat)",
    payoutsCurve: "Kumulierte Auszahlungen",
    monthlyTable: "Monatsübersicht",
    month: "Monat",
    profit: "Gewinn",
    fees: "Gebühren",
    feesHint: "Kommission: −{c} · Provision: −{p}",
    payout: "Auszahlung",
    trades: "Trades",
    return: "Rendite",
    endBalance: "Endstand",
    noData: "Noch keine Einträge. Trage deinen ersten Tag im Tracking ein.",
    calc: {
      title: "Zinseszins-Rechner",
      startCapital: "Startkapital ($)",
      monthlyReturn: "Monatliche Rendite (%)",
      months: "Laufzeit (Monate)",
      reinvestRate: "Reinvestitionsquote (%)",
      payoutRate: "Auszahlungsquote (%)",
      leverage: "Hebelfaktor",
      compare: "Vergleich: 100% reinvestieren vs. Auszahlungsstrategie",
      fullReinvest: "100% reinvestiert",
      withPayout: "mit Auszahlungen",
      cumPayout: "Auszahlungen kumuliert",
      tableTitle: "Monatliche Entwicklung",
      balanceEnd: "Kontostand",
      volume: "Volumen",
      totalWithPayout: "Endwert inkl. Auszahlungen",
      totalFull: "Endwert 100% reinvestiert",
      payoutSum: "Summe Auszahlungen",
      breakeven: "Break-even (Auszahlungen ≥ Startkapital)",
      breakevenDouble: "Break-even (Kontostand ≥ 2× Einlage)",
      payoutEur: "Auszahlung ($/Monat)",
      effReturn: "≙ effektiv {eff} % pro Monat bei {lev}x",
      histAvgNote: "Vorbelegt: historischer Ø {avg} % (bei 24x, vor Gewinnbeteiligung)",
      feeNote: "− 30 % Gewinnbeteiligung (Abzug jeden Freitag vom Wochengewinn) ≙ netto {net} % pro Monat",
      noCompound: "Ohne Compounding: {v}",
      breakevenMonths: "nach {m} Monaten",
      breakevenWeeks: "≈ {w} Wochen",
      breakevenNot: "Im Zeitraum nicht erreicht",
      calcDisclaimer: "Modellrechnung – keine Garantie. Reale Renditen schwanken, Totalverlust möglich.",
    },
    track: {
      title: "Tages-Tracking",
      date: "Datum",
      startBalance: "Start-Kontostand ($)",
      endBalance: "End-Kontostand ($)",
      payout: "Auszahlung ($)",
      commission: "Kommission ($)",
      traderFee: "Trader-Provision 30% ($)",
      commissionShort: "Kommission",
      traderFeeShort: "Provision",
      netProfit: "Netto",
      suggestedFee: "Vorschlag (30% vom Gewinn)",
      netPreview: "Netto nach Gebühren",
      trades: "Anzahl Trades",
      note: "Bemerkung",
      marketEvent: "Marktereignis",
      profitPreview: "Tagesgewinn/-verlust",
      suggestedPayout: "Vorschlag (10% vom Gewinn)",
      apply: "übernehmen",
      save: "Tag speichern",
      update: "Aktualisieren",
      editing: "Bearbeite Eintrag vom {date}",
      cancel: "Abbrechen",
      saved: "Eintrag gespeichert",
      deleted: "Eintrag gelöscht",
      entries: "Einträge",
      exportCsv: "CSV Export",
      settings: "Einstellungen",
      settingsStart: "Startkapital ($)",
      settingsLeverage: "Hebel",
      settingsSave: "Speichern",
      settingsSaved: "Einstellungen gespeichert",
      reinvested: "Reinvestiert",
      actions: "",
    },
    social: {
      title: "Social-Media-Generator",
      type: "Post-Typ",
      types: { daily: "Tagesupdate", weekly: "Wochenupdate", monthly: "Monatsupdate", milestone: "Meilenstein", loss: "Ehrliches Verlust-Update" },
      language: "Sprache des Posts",
      context: "Zusatzkontext (optional)",
      contextPlaceholder: "z.B. heute starker Markt, 25% Meilenstein erreicht ...",
      generate: "Post generieren",
      generating: "Generiere ...",
      copy: "Kopieren",
      copied: "In Zwischenablage kopiert",
      empty: "Der generierte Post erscheint hier.",
      note: "Jeder Post endet automatisch mit dem Risiko-Hinweis.",
      imgTitle: "Als Bild generieren",
      imgSubtitle: "Erstelle ein motivierendes Bild aus deinem Post – für Instagram Story, Feed oder TikTok.",
      format: "Format",
      formatStory: "Story / TikTok (9:16)",
      formatFeed: "Feed Post (1:1)",
      styleLabel: "Bild-Stil",
      styleBranded: "Motivierend + Emerald-Branding",
      stylePhoto: "Foto-realistisch",
      imgGenerate: "Bild generieren",
      imgGenerating: "Erstelle Bild ...",
      imgDownload: "Bild herunterladen",
      imgNeedPost: "Bitte generiere oder tippe zuerst einen Post-Text.",
      imgReady: "Dein Bild ist bereit",
      imgError: "Bilderstellung fehlgeschlagen",
    },
    risk: {
      title: "Risiko-Tracking",
      worstDay: "Größter Tagesverlust",
      maxDrawdown: "Max. Drawdown",
      lossStreak: "Längste Verlustserie",
      winStreak: "Höchste Gewinnserie",
      currentStreak: "Aktuelle Serie",
      liqDistance: "Abstand zur Liquidation",
      days: "Tage",
      hypoTitle: "Hypothetischer Verlust bei Markt-/Strategiebewegung (mit Hebel)",
      move: "Bewegung",
      loss: "Verlust",
      remaining: "Restkapital",
      wiped: "Konto ausgelöscht",
      ddChart: "Drawdown-Verlauf",
      milestones: "Meilensteine – Startkapital-Rückholung",
      milestoneReached: "Meilenstein erreicht: {th} % des Startkapitals zurückgeholt!",
      reachedOn: "erreicht am",
      open: "offen",
      generatePost: "Post generieren",
      milestoneContext: "Meilenstein erreicht: {th} % des Startkapitals über Auszahlungen zurückgeholt (am {date}).",
      warnTitle: "Warnhinweise",
      warnings: {
        liquidation_close: "Bei Hebel {lev}x reicht bereits eine Bewegung von ca. -{liq} % für einen Totalverlust (Liquidation).",
        drawdown_high: "Der maximale Drawdown übersteigt 15 % – erhöhtes Risiko.",
        loss_streak: "Aktuelle Verlustserie von 3+ Tagen – Strategie kritisch prüfen.",
        big_daily_loss: "Es gab bereits einen Tagesverlust von über 5 % – hohe Volatilität.",
        none: "Keine akuten Warnungen. Das Grundrisiko durch den Hebel bleibt bestehen.",
      },
    },
    settings: {
      title: "Referenz-Kapital & Ziele",
      description: "Diese Werte steuern deine persönliche Reise: Fortschritts-Berechnungen, Auszahlungsvorschlag und Ziel-Kennzahlen. Sie beeinflussen keine echten Trades – sie sind rein zur Simulation und Visualisierung deiner Reise gedacht.",
      startCapital: "Startkapital ($)",
      leverage: "Hebelfaktor",
      reinvestRate: "Reinvestitionsquote (%)",
      payoutRate: "Auszahlungsquote (%)",
      monthlyTarget: "Ziel-Monatsrendite (%)",
      journeyDays: "Zieldauer der Reise (Tage)",
      goalAmount: "Kontostand-Ziel ($)",
      sumHint: "Hinweis: Reinvest + Auszahlung ergeben zusammen nicht 100 %.",
      save: "Speichern",
      saved: "Einstellungen gespeichert",
      preview: "Vorschau",
      leverageWarning: "Achtung: Bei Hebel {lev}x führt bereits eine Bewegung von ca. -{liq} % zum Totalverlust.",
    },
    share: {
      live: "Live · Öffentliches Experiment",
      subtitle: "Transparentes Copy-Trading-Experiment – alle Zahlen ungeschönt, inklusive Verlusten.",
      copyLink: "Share-Link kopieren",
      copied: "Share-Link kopiert",
      historySubtitle: "Echte Trade-Historie aus 21 Monaten – simuliere selbst, was aus deinem Einstieg geworden wäre.",
      calcTitle: "Rechne deinen möglichen weiteren Verlauf",
      calcHero1: "Rechne deinen möglichen",
      calcHeroHighlight: "weiteren Verlauf",
      tabHistory: "Trade-Historie",
      tabCalc: "Rechner",
      tabJourney: "Meine Reise",
      tabLive: "Live-Dashboard",
      hero1: "Deine",
      heroHighlight: "Performance",
      hero2: "im Blick",
      config: "Deine Konfiguration",
      configStart: "Startkapital",
      configLeverage: "Hebel / Faktor",
      configPayout: "Auszahlungsquote",
      configEdit: "Konfiguration bearbeiten",
      quote: "Disziplin heute, Freiheit morgen.",
      quoteSub: "Dein Ziel. Dein Weg. Dein Erfolg.",
      footerLine: "Transparenz. Disziplin. Erfolg.",
      historyBadge: "Echte Trades · Historisch belegt",
      copyHistoryLink: "Public-Link zur Historie kopieren",
      toDashboard: "Zum Live-Dashboard",
      toHistory: "Zur Trade-Historie",
    },
    weekly: {
      title: "Wochenupdate fällig",
      desc: "Zeitraum {since} – {until} · {days} Tage getrackt · Gewinn {profit} · Auszahlungen {payout} · Rendite {return}",
      context: "Wochenupdate für den Zeitraum {since} bis {until}: Gewinn {profit}, Auszahlungen {payout}, Wochenrendite {return}, {days} getrackte Tage.",
      generate: "Wochenupdate generieren",
      dismiss: "Später",
    },
    history: {
      title: "Historischer Backtest",
      subtitle: "Basierend auf {trades} echten Trades ({first} bis {last}, {months} Monate). Was wäre aus deinem Einstieg geworden?",
      startCapital: "Startkapital ($)",
      leverage: "Hebel / Kopierfaktor",
      payoutRate: "Auszahlungsquote (%)",
      endBalance: "Kontostand am Ende",
      endBalanceFull: "Ohne Auszahlungen (100 % Reinvest)",
      totalPayouts: "Summe Auszahlungen",
      totalReturn: "Gesamtrendite (inkl. Auszahlungen)",
      maxDrawdown: "Max. Drawdown",
      avgMonthly: "Ø Monatsrendite",
      winRate: "Trade-Gewinnquote",
      bestDay: "Bester Tag",
      worstDay: "Schlechtester Tag",
      breakeven: "Break-even (Auszahlungen ≥ Startkapital)",
      breakevenDouble: "Break-even (Kontostand ≥ 2× Einlage)",
      payoutEur: "Auszahlung ($/Monat)",
      feeNote: "Alle Werte berücksichtigen 30 % Gewinnbeteiligung der Trader (jeden Freitag vom wöchentlichen Brutto-Gewinn abgezogen, nur bei positiver Woche).",
      simpleReturn: "Rendite ohne Compounding",
      simpleReturnSub: "Gewinne nicht reinvestiert",
      breakevenMonths: "nach {m} Monaten",
      breakevenWeeks: "≈ {w} Wochen · erreicht am {date}",
      breakevenNot: "Im Zeitraum nicht erreicht",
      curve: "Kapitalentwicklung (historisch simuliert)",
      withPayout: "Kontostand (mit Auszahlungen)",
      fullReinvest: "100 % reinvestiert",
      cumPayout: "Auszahlungen kumuliert",
      monthlyTable: "Monatliche Entwicklung",
      note: "Historische Simulation auf Basis vergangener Trades. Vergangene Ergebnisse sind KEINE Garantie für die Zukunft – mit Hebel {lev}x war der maximale Drawdown {dd} %. Totalverlust ist jederzeit möglich.",
      loading: "Berechne ...",
      noData: "Keine historischen Trades gefunden.",
      upload: "Trades aktualisieren (CSV)",
      uploadOk: "{n} Trades importiert (bis {last})",
      uploadFail: "Import fehlgeschlagen",
      dataStatus: "Datenbestand: {n} Trades · letzter Trade {last}",
      mfbStatus: "myfxbook live: {gain} % Gain · {dd} % Drawdown",
      mfbLink: "Verifizierte Historie auf Myfxbook ansehen",
    },
    stats: {
      title: "Trade-Analyse",
      profitFactor: "Profit-Faktor",
      profitFactorSub: "Bruttogewinn ÷ Bruttoverlust",
      avgWin: "Ø Gewinn-Trade",
      avgLoss: "Ø Verlust-Trade",
      longWinRate: "Gewinnquote Long",
      shortWinRate: "Gewinnquote Short",
      avgDuration: "Ø Trade-Dauer",
      byWeekday: "Performance nach Wochentag",
      byHour: "Performance nach Uhrzeit",
      byMonth: "Performance nach Monat",
      pips: "Pips",
      winShort: "Gewinnquote",
      winTrades: "Gewinn-Trades",
      lossTrades: "Verlust-Trades",
      weekdaysShort: ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"],
    },
    journey: {
      heroTitle: "Mein Weg zur finanziellen Freiheit",
      publicNote: "Was du hier siehst, ist mein persönliches Trading-Konto, das ich Tag für Tag transparent dokumentiere – mit allen Gewinnen, Verlusten und Rückschlägen. Ich teile diese Reise, um meine eigenen Erfahrungen festzuhalten. Alle Inhalte dienen ausschließlich deiner Information und stellen keine Empfehlung oder Beratung dar.",
      heroSubtitle: "Jeder Trade bringt mich meinem Ziel näher. Dieses Projekt dokumentiert transparent meinen gesamten Weg – inklusive Gewinne, Verluste und Rückschläge.",
      dayLabel: "Meine Reise",
      day: "Tag {d} von {total}",
      totalProfit: "Gesamtgewinn seit Start",
      remaining: "Noch bis Startkapital zurück",
      balance: "Aktueller Kontostand",
      doneShort: "Geschafft!",
      capitalBack: "Startkapital zurückholen",
      capitalBackDone: "Startkapital vollständig zurückgeholt",
      goal: "Ziel: {goal}",
      goalHint: "Bezogen auf den Kontostand – Ziel in den Einstellungen anpassbar.",
      payoutIncluded: "davon ausgezahlt (im Gewinn enthalten)",
      todayProfit: "Gewinn heute",
      lastProfit: "Letzter Handelstag",
      winStreak: "Gewinnserie",
      days: "Tage",
      roi: "ROI",
      timeline: "Meine Reise – Tag für Tag",
      win: "Gewinn",
      loss: "Verlust",
      noTrade: "Kein Handel",
      trades: "Trades",
      tradesOne: "Trade",
      balanceArrow: "Kontostand",
      achievements: "Meilensteine",
      achievedAt: "Erreicht am {date}",
      locked: "Noch nicht erreicht",
      newAchievement: "Neuer Meilenstein erreicht:",
      goalBanner: "Dein Ziel wartet am Horizont – bleib dran.",
      quotes: [
        "Konsequenz schlägt Talent.",
        "Kleine Schritte führen zu großen Zielen.",
        "Disziplin ist die Brücke zwischen Ziel und Erfolg.",
        "Jeder Trade ist nur ein weiterer Schritt auf deinem Weg.",
        "Nicht Perfektion gewinnt – sondern Beständigkeit.",
        "Der beste Zeitpunkt anzufangen war gestern. Der zweitbeste ist heute.",
      ],
      a: {
        first_trade: "Erster Trade",
        first_payout: "Erste Auszahlung",
        profit_100: "100 $ Gewinn",
        profit_500: "500 $ Gewinn",
        profit_1000: "1.000 $ Gewinn",
        capital_back: "Startkapital zurückgeholt",
        streak_10: "10 Gewinn-Tage in Folge",
        trades_100: "100 Trades",
        balance_10k: "10.000 $ Kontostand",
        balance_50k: "50.000 $ Kontostand",
        balance_100k: "100.000 $ Kontostand",
      },
    },
    auth: {
      title: "Geschützter Bereich",
      email: "E-Mail (Mitglieder-Login)",
      desc: "Bitte Passwort eingeben, um das Dashboard zu verwalten. Die öffentlichen Seiten bleiben frei zugänglich.",
      password: "Passwort",
      login: "Anmelden",
      back: "Zurück zur Übersicht",
      error: "Falsches Passwort",
      locked: "Zu viele Versuche – bitte 15 Minuten warten.",
      logout: "Abmelden",
      forgot: "Passwort vergessen?",
      forgotPanel: {
        backShort: "zurück",
        title: "Passwort zurücksetzen",
        desc: "Gib deine E-Mail ein. Wenn ein Konto existiert, senden wir dir einen Reset-Link.",
        emailLabel: "E-Mail",
        emailPh: "deine@email.com",
        submit: "Reset-Link senden",
        done: {
          title: "E-Mail versendet",
          desc: "Wenn ein Konto mit dieser E-Mail existiert, findest du in deinem Postfach jetzt einen Link zum Zurücksetzen des Passworts. Der Link ist 2 Stunden gültig.",
          toLogin: "Zum Login",
        },
      },
      reset: {
        title: "Passwort zurücksetzen",
        newPw: "Neues Passwort",
        confirmPw: "Neues Passwort bestätigen",
        submit: "Passwort setzen",
        intro: "Bitte gib dein neues Passwort ein (mindestens 8 Zeichen).",
        pwTooShort: "Passwort zu kurz (min. 8 Zeichen)",
        pwMismatch: "Passwörter stimmen nicht überein",
        invalidToken: "Der Reset-Link ist ungültig oder unvollständig.",
        genericError: "Fehler beim Zurücksetzen. Der Link könnte abgelaufen sein.",
        done: {
          title: "Passwort geändert",
          desc: "Du kannst dich jetzt mit deinem neuen Passwort einloggen. Weiterleitung …",
        },
      },
    },
    footer: "Persönliches Experiment. Historische und erwartete Renditen sind keine Garantie für zukünftige Ergebnisse. Ein Totalverlust ist möglich. Der Hebel erhöht Gewinne und Verluste gleichermaßen. Dies ist keine Finanzberatung.",
    register: {
      title: "Registrierung (nur mit Einladung)",
      desc: "Du wurdest zum Sonic-Trading-Mitgliederportal eingeladen. Erstelle dein persönliches Konto.",
      displayName: "Vor- und Nachname",
      email: "E-Mail",
      password: "Passwort (min. 8 Zeichen)",
      password2: "Passwort wiederholen",
      submit: "Konto erstellen",
      invalid: "Diese Einladung ist ungültig oder wurde bereits verwendet. Bitte wende dich an deinen Ansprechpartner.",
      expired: "Diese Einladung ist abgelaufen. Bitte fordere einen neuen Einladungslink an.",
      pendingMsg: "Registrierung erfolgreich! Dein Konto muss noch von einem Administrator freigeschaltet werden.",
      pwShort: "Passwort muss mindestens 8 Zeichen haben.",
      pwMismatch: "Passwörter stimmen nicht überein.",
      riskNote: "Mit der Registrierung bestätigst du, dass dieses Portal der Dokumentation dient und keine Anlageberatung darstellt. Trading kann zum Totalverlust führen.",
    },
    admin: {
      members: "Mitglieder",
      invitations: "Einladungen",
      inviteLabel: "Bezeichnung",
      inviteLabelPh: "z. B. Name des Eingeladenen",
      inviteExpiry: "Gültigkeit",
      days: "Tage",
      createInvite: "Einladungslink erstellen",
      inviteCreated: "Einladung erstellt – Link in Zwischenablage kopiert",
      inviteRevoked: "Einladung widerrufen",
      inviteHint: "Der Link wird beim Erstellen automatisch kopiert. Schicke ihn per E-Mail oder Messenger an das neue Mitglied. Jeder Link ist nur einmal verwendbar.",
      invOpen: "Offen",
      invUsed: "Verwendet",
      invRevoked: "Widerrufen",
      invExpired: "Abgelaufen",
      role: "Rolle",
      actions: "Aktionen",
      statuses: { active: "Aktiv", pending: "Wartet auf Freischaltung", locked: "Gesperrt", disabled: "Deaktiviert" },
      activate: "Freischalten",
      lock: "Sperren",
      resetPw: "Passwort setzen",
      newPwFor: "Neues Passwort für",
      pwReset: "Passwort zurückgesetzt",
      saved: "Gespeichert",
      riskDocs: "Risiko-Dokumente",
      riskDocsHint: "Verwalte hier die Risiko-Dokumente, die jedes Mitglied vor der Portal-Nutzung bestätigen muss. Beim Veröffentlichen einer neuen Version müssen alle Mitglieder erneut zustimmen.",
      docKey: "Schlüssel",
      docOrder: "Reihenfolge",
      docVersion: "Version",
      docPublished: "Veröffentlicht",
      docDraft: "Entwurf",
      docTitleDe: "Titel (DE)",
      docContentDe: "Inhalt (DE)",
      docTitleEn: "Title (EN)",
      docContentEn: "Content (EN)",
      publish: "Veröffentlichen",
      publishNew: "Neue Version veröffentlichen",
      publishHint: "Veröffentlichen erhöht die Version und alle Mitglieder müssen erneut zustimmen.",
      newDoc: "Neues Dokument",
      save: "Speichern",
      edit: "Bearbeiten",
      delete: "Löschen",
      confirmDelete: "Wirklich löschen?",
    },
    onboarding: {
      title: "Willkommen bei Team Phoenix",
      subtitle: "Bitte gehe die folgenden Schritte durch, um dein persönliches Portal freizuschalten.",
      step: "Schritt",
      of: "von",
      next: "Weiter",
      back: "Zurück",
      finish: "Portal freischalten",
      step1Title: "Willkommen",
      step1Desc: "Kurze Vorstellung des Portals. Hier trackst du deine Copy-Trading-Reise transparent, dokumentierst Auszahlungen und behältst dein Risiko im Blick.",
      step1Points: [
        "Deine Daten sind privat – nur du und der Admin sehen sie.",
        "Trading ist ein Hochrisiko-Geschäft. Wir bilden lediglich ab, wir beraten nicht.",
        "Alle Renditen basieren auf deinen tatsächlichen Eingaben.",
      ],
      step2Title: "Risiko-Dokumente bestätigen",
      step2Desc: "Bitte lies jedes Dokument sorgfältig und bestätige einzeln, dass du den Inhalt verstanden hast.",
      readAndAccept: "Ich habe gelesen und verstanden",
      accepted: "Bestätigt",
      openDoc: "Anzeigen",
      allAccepted: "Alle Dokumente bestätigt",
      pendingHint: "Noch offen: {n}",
      step3Title: "Persönliches Risiko-Profil",
      step3Desc: "Definiere deine Ausgangsparameter. Du kannst diese jederzeit im Risiko-Center anpassen.",
      startCapital: "Startkapital ($)",
      targetLeverage: "Ziel-Kopierfaktor",
      payoutRate: "Auszahlungsquote (%)",
      maxLoss: "Max. Verlust-Toleranz (%)",
      maxLossHint: "Ab diesem Drawdown willst du eingreifen bzw. informiert werden.",
      step4Title: "Zusammenfassung",
      step4Desc: "Prüfe deine Angaben und schalte dein Portal frei.",
      summaryProfile: "Dein Risiko-Profil",
      summaryDocs: "Bestätigte Dokumente",
      completed: "Portal freigeschaltet",
      reconsentTitle: "Aktualisierte Risiko-Dokumente",
      reconsentDesc: "Wir haben ein oder mehrere Risiko-Dokumente aktualisiert. Bitte lies und bestätige die neue Version, um dein Portal weiter zu nutzen.",
    },
    riskCenter: {
      title: "Risiko-Center",
      subtitle: "Deine akzeptierten Dokumente und dein persönliches Risiko-Profil.",
      docsSection: "Risiko-Dokumente",
      profileSection: "Dein Risiko-Profil",
      updateProfile: "Profil speichern",
      profileUpdated: "Profil aktualisiert",
      version: "Version",
      acceptedOn: "Bestätigt am",
      notAccepted: "Noch nicht bestätigt",
      reAccept: "Neue Version bestätigen",
      view: "Anzeigen",
      close: "Schließen",
    },
    personal: {
      title: "Mein Fortschritt",
      subtitle: "Persönlicher Fortschritt gegenüber deinen Zielen aus dem Risiko-Profil.",
      profileMissing: "Bitte richte zunächst dein Risiko-Profil ein.",
      goalDouble: "Kapital verdoppeln",
      goalGain: "Zielgewinn",
      currentGain: "Aktueller Gewinn",
      progress: "Fortschritt",
      currentDrawdown: "Aktueller Drawdown",
      maxDrawdown: "Max. Drawdown",
      lossToleranceReached: "Verlust-Toleranz überschritten – bitte überprüfe dein Risiko-Setup.",
      lossToleranceNear: "Verlust nähert sich deiner Toleranz.",
      openRiskCenter: "Zum Risiko-Center",
      payoutRateGoal: "Auszahlungsziel",
      payoutRateActual: "Tatsächlich",
      leverageTarget: "Ziel-Hebel",
      entries: "Einträge",
    },
    academy: {
      title: "Akademie",
      subtitle: "Kurze Lektionen zu Grundlagen, Risikomanagement, Copy-Trading und Steuer.",
      overallProgress: "Gesamt-Fortschritt",
      lessons: "Lektionen",
      minutes: "Min.",
      completed: "Abgeschlossen",
      startLesson: "Öffnen",
      markComplete: "Als abgeschlossen markieren",
      markIncomplete: "Rückgängig",
      noLessons: "Noch keine Lektionen verfügbar.",
      videoLabel: "Video",
      close: "Schließen",
    },
    support: {
      title: "Support",
      subtitle: "Deine Anfragen an das Team. Wir antworten so schnell wie möglich.",
      newTicket: "Neues Ticket",
      subject: "Betreff",
      subjectPh: "z. B. Frage zu einer Lektion",
      message: "Nachricht",
      messagePh: "Beschreibe dein Anliegen so detailliert wie möglich.",
      send: "Absenden",
      reply: "Antworten",
      status: "Status",
      statusOpen: "Offen",
      statusInProgress: "In Bearbeitung",
      statusClosed: "Geschlossen",
      you: "Du",
      admin: "Support",
      noTickets: "Keine Anfragen bisher.",
      created: "Erstellt",
      updated: "Aktualisiert",
      ticketCreated: "Anfrage gesendet",
      replySent: "Antwort gesendet",
      adminTitle: "Support-Tickets",
      adminSubtitle: "Alle Anfragen von Mitgliedern. Antworte direkt aus dem Ticket.",
      setStatus: "Status ändern",
      unread: "Neu",
      filterAll: "Alle",
    },
    audit: {
      title: "Audit-Log",
      subtitle: "Chronologisches Protokoll aller wichtigen Änderungen im Portal.",
      timestamp: "Zeitpunkt",
      action: "Aktion",
      actor: "Akteur",
      target: "Ziel",
      meta: "Details",
    },
    landing: {
      title: "Deine Landingpage",
      subtitle: "Erstelle deine persönliche Referenz und trage deinen Link aus dem IB Portal Backoffice ein. Alle CTA-Buttons auf der öffentlichen Landingpage verlinken dann auf deinen Link.",
      slugLabel: "Deine persönliche Referenz",
      slugPh: "z. B. max, sonic-max, max-2026",
      slugHint: "2–30 Zeichen, a–z, 0–9 und Bindestrich. Wird Teil deiner URL.",
      refLabel: "Dein Link aus dem CopyXapp / IB Portal Backoffice (unter Profile den Link unter Partner → Link kopieren)",
      refPh: "https://...?ref=...",
      refHint: "Muss mit http(s):// beginnen. Dieser Link wird auf allen CTA-Buttons deiner Landingpage verwendet.",
      save: "Speichern",
      saved: "Landingpage aktualisiert",
      yourUrl: "Deine öffentliche URL",
      copyUrl: "URL kopieren",
      copied: "In Zwischenablage kopiert",
      openPreview: "Vorschau öffnen",
      notSet: "Bitte trage zuerst eine Referenz ein.",
      slugTaken: "Diese Referenz ist bereits vergeben.",
    },
    kb: {
      title: "Wissensdatenbank",
      subtitle: "Handverlesene Themen, Tutorials und Ressourcen.",
      minutes: "Min.",
      readMore: "Öffnen",
      empty: "Noch keine Beiträge verfügbar.",
      videoLabel: "Video",
      close: "Schließen",
      downloadPdf: "Als PDF herunterladen",
      searchPh: "Suche nach Themen, Kursen oder Inhalten…",
      categories: "Kategorien",
      showAll: "Alle anzeigen",
      featured: "Empfohlene Inhalte für dich",
      popular: "Beliebte Inhalte",
      recent: "Zuletzt angesehen",
      noRecent: "Noch nichts angesehen.",
      items: "Inhalte",
      lessons: "Lektionen",
      typeCourse: "Kurs",
      typeVideo: "Video",
      typeGuide: "Anleitung",
      typeArticle: "Artikel",
      typeFaq: "FAQ",
      typeQuiz: "Quiz",
      viewsSuffix: "Aufrufe",
      relativeDayAgo: "vor {n} Tag",
      relativeDaysAgo: "vor {n} Tagen",
      relativeToday: "heute",
      relativeYesterday: "gestern",
      noResults: "Keine Inhalte gefunden.",
      backToOverview: "Zurück zur Übersicht",
    },
    calendar: {
      title: "Kalender",
      subtitle: "Alle Live-Calls, Webinare und Wartungsfenster auf einen Blick.",
      today: "Heute",
      prev: "Zurück",
      next: "Weiter",
      newEvent: "Neuer Termin",
      editEvent: "Termin bearbeiten",
      upcoming: "Nächste Termine",
      noEvents: "Keine Termine in diesem Monat.",
      noUpcoming: "Keine kommenden Termine.",
      allCategories: "Alle Kategorien",
      moreEvents: "+ {n} weitere",
      ical: {
        title: "Google Kalender importieren",
        subtitle: "Füge entweder die geheime iCal-URL oder einen öffentlichen Embed-Link deines Google-Kalenders ein – wir konvertieren automatisch. Wird stündlich synchronisiert.",
        urlLabel: "iCal- oder Kalender-URL",
        urlPh: "https://calendar.google.com/calendar/...",
        enabledLabel: "Auto-Sync aktiv",
        save: "URL speichern",
        syncNow: "Jetzt syncen",
        lastSync: "Zuletzt synchronisiert",
        neverSynced: "Noch nicht synchronisiert",
        lastError: "Letzter Fehler",
        stats: "{added} hinzugefügt · {updated} aktualisiert · {removed} entfernt",
        openAdmin: "Google-Kalender-Import",
        close: "Schließen",
        detectedUrl: "Erkannt und konvertiert zu",
      },
      fields: {
        title: "Titel",
        titlePh: "z. B. Wöchentlicher Live-Call",
        description: "Beschreibung",
        descriptionPh: "Details, Agenda, Notizen …",
        startAt: "Start",
        endAt: "Ende (optional)",
        link: "Link (Zoom / Meet / Webinar)",
        linkPh: "https://…",
        location: "Ort (optional)",
        locationPh: "z. B. Online, Zoom, Berlin",
        category: "Kategorie",
        recurrence: "Wiederholung",
        recurrenceNone: "Keine (einmalig)",
        recurrenceWeekly: "Jede Woche",
        recurrenceUntil: "Wiederholung bis (optional)",
      },
      recurringBadge: "Wöchentlich",
      recurringUntil: "bis {date}",
      save: "Speichern",
      created: "Termin erstellt",
      updated: "Termin aktualisiert",
      deleted: "Termin gelöscht",
      confirmDelete: "Diesen Termin wirklich löschen?",
      duration: "Dauer",
      joinLink: "Zum Termin",
      when: "Zeit",
      weekdaysShort: ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"],
      months: ["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],
    },
    error: "Fehler – bitte erneut versuchen",
  },
  en: {
    appTitle: "Team Phoenix Portal",
    tabs: { welcome: "Welcome", dashboard: "My Journey", calculator: "Calculator", tracking: "Tracking", history: "History", strategy: "Landing page", risk: "Risk", social: "Social", settings: "Settings", members: "Members", riskCenter: "Risk Center", riskDocs: "Risk Documents", academy: "Knowledge Base", support: "Portal Support", adminAcademy: "Knowledge CMS", audit: "Audit Log", calendar: "Calendar", adminSupport: "Support (Admin)", marketing: "Marketing", adminGroup: "Admin", leads: "Leads", links: "Links & Emails", adminLinks: "Links & Emails (Admin)", profitCalc: "Profit calculator", marketingMaterial: "Marketing material", adminMarketingMaterial: "Material (Admin)", news: "News" },
    heroSubtitles: {
      dashboard: "Your personal progress & milestones in copy trading",
      calculator: "Simulate returns, leverage and payouts",
      tracking: "Track your trades cleanly and completely",
      history: "Your full trade history at a glance",
      strategy: "Your personal landing page & referral management",
      calendar: "Live calls, webinars & events – all at a glance",
      riskCenter: "Your risk documents and personal risk profile",
      academy: "Short lessons, tutorials and resources",
      support: "Your direct line to the portal admin – questions and issues about the Team Portal",
      social: "Generate posts for community & social media automatically",
      settings: "Portal settings and preferences",
      members: "Member management and invitations",
      riskDocs: "Manage versioned risk documents",
      adminAcademy: "Manage knowledge base categories and lessons",
      adminSupport: "Overview of all support tickets",
      audit: "Chronological log of all portal actions",
    },
    edu: {
      heroBadge: "Knowledge platform · No sales, no promises",
      heroH1a: "Let experienced traders trade for you —",
      heroH1b: "your money stays on your own broker account at all times.",
      heroSub: "You don't need to read charts or trade yourself. A verified strategy is automatically mirrored to your own account. You always keep full control.",
      b1t: "Your capital stays with you",
      b1x: "Your money sits on your own broker account – not with us.",
      b2t: "Trades are copied",
      b2x: "Automatically – you never have to intervene.",
      b3t: "Fully transparent",
      b3x: "Every single trade is publicly verifiable.",
      ctaStart: "Get started",
      ctaLearn: "Learn more",
      illBroker: "Your broker account",
      illControl: "under your control",
      illGold: "Gold",
      illGoldNote: "The market the strategy trades in.",
      illApp: "Sonic App",
      illProgress: "Progress",
      illLastTrade: "Last trade",
      illStrategy: "Strategy",
      illActive: "Active · You're in control",
      whatEye: "Basics first",
      whatTitle: "What is copy trading?",
      whatIntro: "In short: an experienced trader makes the trading decisions. These are automatically transferred to your own account. You don't have to do anything yourself.",
      whatStep: "Step",
      whatS1t: "Experienced trader",
      whatS1x: "Analyses the market and takes the decision.",
      whatS2t: "Opens a trade",
      whatS2x: "Buy or sell order on their account.",
      whatS3t: "Automatically on your account",
      whatS3x: "The same order is mirrored – proportional to your capital.",
      whatS4t: "Result flows to you",
      whatS4x: "Profit or loss appears pro-rata on your account.",
      whatImportant: "Important: you don't trade yourself. You copy the strategy. Trading decisions stay with the trader, your capital stays with you.",
      howEye: "The flow",
      howTitle: "How exactly does it work?",
      howS1t: "Open a broker account",
      howS1x: "Free account at TAG Markets – takes a few minutes.",
      howS2t: "Connect the strategy",
      howS2x: "Via a dedicated service (COPYX) you authorise automatic copying.",
      howS3t: "Trader opens a position",
      howS3x: "The experienced trader makes the decision on their account.",
      howS4t: "Trade appears on yours",
      howS4x: "The same order lands on your account automatically – no action required.",
      howS5t: "Track progress",
      howS5x: "You can see everything in the portal at any time – transparent and real-time.",
      skillEye: "For beginners",
      skillTitle: "Do I need to know how to trade?",
      skillNo: "No.",
      skillNoNote: "No prior knowledge required.",
      skillDesc: "All trading decisions are handled by the experienced trader. You just see what's happening – and learn along the way.",
      skill1: "no chart reading",
      skill2: "no market analysis",
      skill3: "no buy decisions",
      skill4: "no sell signals",
      skill5: "no news evaluation",
      skill6: "no weekend homework",
      moneyEye: "Trust",
      moneyTitle: "So where's my money?",
      moneySub: "The most important question – and the simplest answer:",
      moneyAccLabel: "Your broker account",
      moneyAccNote: "This – and only this – is where your capital sits.",
      moneyP1t: "On your broker account",
      moneyP1x: "A regulated account that belongs only to you. We have no access to your balance.",
      moneyP2t: "Trading authorisation only",
      moneyP2x: "The strategy can only place trades – it can never touch your money.",
      moneyP3t: "No third-party payments",
      moneyP3x: "Deposits and withdrawals go directly between you and your broker.",
      moneyP4t: "Pause or cancel any time",
      moneyP4x: "One click stops or fully ends the copying.",
      moneyCtrl: "Full control stays with you.",
      moneyCtrlSub: "No fund manager, no custody, no third-party payouts.",
      whyEye: "Target audience",
      whyTitle: "Why do people use copy trading?",
      whyP1t: "“I don't have time”",
      whyP1x: "Job, family, life – copy trading keeps working while you live yours.",
      whyP2t: "“I have no experience”",
      whyP2x: "You don't need trading knowledge. The strategy makes the decisions, you learn along the way.",
      whyP3t: "“I want to invest transparently”",
      whyP3x: "Every trade is verifiable. You see exactly what happens and why.",
      whyP4t: "“I'd rather leave it to the pros”",
      whyP4x: "Experienced traders have years of practice. You can leverage their decisions 1:1.",
      transEye: "Transparency",
      transTitle: "What is Myfxbook — and why does it matter?",
      transPara: "Myfxbook is an independent verification service for trading accounts. It connects directly to the trader's broker account and logs every single trade automatically – so nobody can &bdquo;pretty up&ldquo; the numbers afterwards.",
      trans1: "Every trade is stored in real time – not at month end.",
      trans2: "Manipulation is impossible: the data comes directly from the broker.",
      trans3: "You can look in at any time – publicly, no login needed.",
      trans4: "You also see the losses – not just the wins. That builds real trust.",
      transCta: "See the public track record",
      transVer: "Verified account",
      transLive: "Live",
      transK1: "Total trades",
      transK2: "Win rate",
      transK3: "Live for",
      transK4: "Max. loss phase",
      transK3v: "21 months",
      transExpl: "&bdquo;Loss phase&ldquo; means the biggest drop between a peak and a following trough. The lower the number, the calmer the curve.",
      oppEye: "Honest, not promotional",
      oppTitle: "Opportunities & risks – no sugar-coating",
      oppSub: "Both belong together. We show them side by side.",
      oppTitleC: "Opportunities",
      oppTitleR: "Risks",
      opp1: "Clear separation of capital (with you) and strategy (with the trader).",
      opp2: "Time saved: no market analysis, no chart studies, no alarm phone.",
      opp3: "Full transparency via a verified track record.",
      opp4: "Learning curve included: you see how a professional works.",
      opp5: "Pause any time – no contract, no lock-in.",
      risk1: "Losses are possible – including a total loss of your deposit.",
      risk2: "Historical performance is no guarantee of future results.",
      risk3: "The market (gold) can move sharply, even over short timeframes.",
      risk4: "Without broker experience, the first setup takes time.",
      risk5: "Not suitable for capital you might need short-term.",
      faqEye: "FAQ",
      faqTitle: "Frequently asked questions",
      faqQ1: "What is copy trading exactly?",
      faqA1: "Copy trading means: an experienced trader makes the trading decisions, and they are automatically transferred to your own broker account. You don't trade yourself – you copy the strategy.",
      faqQ2: "Does my money really stay on my account?",
      faqA2: "Yes. Your capital sits with a regulated broker on an account that belongs only to you. The strategy only has permission to place trades – it never has access to your money.",
      faqQ3: "Can I stop any time?",
      faqA3: "Yes. You can pause or end the copying with a single click. No minimum term, no notice period.",
      faqQ4: "How do I withdraw profits?",
      faqA4: "Directly from the broker account to your own bank account. All deposits and withdrawals go between you and your broker – not through us.",
      faqQ5: "Do I need trading experience?",
      faqA5: "No. No prior knowledge required. The strategy handles all trading decisions. If you want to learn more, there's a structured knowledge base in the members portal.",
      faqQ6: "What does it cost?",
      faqA6: "You pay purely on results: a performance fee on realised profits. No profit, no fee. All details are shown before you connect.",
      faqQ7: "What happens in a loss?",
      faqA7: "Losses are part of the market and are mirrored proportionally to your capital. The track record shows both profit and loss phases openly.",
      faqQ8: "Why gold specifically?",
      faqA8: "Gold (ticker &bdquo;XAUUSD&ldquo;) is one of the most liquid markets in the world: tight spreads, clear moves and around-the-clock trading. The strategy is tuned to its characteristics.",
      faqQ9: "What is MT5?",
      faqA9: "MetaTrader 5 (MT5) is a widely used trading platform. Your broker provides it for free. The strategy &bdquo;talks&ldquo; to your broker through MT5 to place trades. You don't need to operate MT5 yourself.",
      softH1: "Once you've understood how copy trading works,",
      softH2: "you can look at how the strategy has actually performed.",
      softSub: "No promises, no pressure. Just numbers from real, verified accounts.",
      softAgain: "Read from the top again",
    },
    strategy: {
      badge: "Strategy active – running live",
      hero1: "Automated gold trading –",
      heroHighlight: "my strategy at a glance",
      heroSub: "The SONIC strategy trades gold (XAUUSD) through experienced traders. Every trade is mirrored to your own account via MT5 – no manual trading required. Here you'll find the key facts and how to get started.",
      kpiDaily: "Daily return (24x, net)",
      kpiMonthly: "Monthly return (24x, net)",
      kpiDrawdown: "Max drawdown (1x)",
      kpiTrades: "Trades · win rate",
      kpiNote: "Net figures (24× account, after 30 % performance fee) per presentation (Slide 8, verified real-follower account). Drawdown & trades live from history ({months} months). Past results are no guarantee of future performance.",
      cta: "Get started",
      ctaBandTitle: "Ready for the next step?",
      ctaBandSub: "Connect your account and let the strategy trade for you.",
      verified: "Verified track record (myfxbook)",
      howTitle: "How it works",
      howSub: "From account to your first copied trade in a few steps.",
      step1Title: "Connect your account",
      step1Text: "Link your own MT5 account to the strategy in a few minutes. Your capital always stays in your own account.",
      step2Title: "Trades are mirrored",
      step2Text: "When the strategy opens a position, it is replicated on your account automatically and without delay – entry, exit and position size included.",
      step3Title: "Travel together",
      step3Text: "An active community from many countries is already using the strategy. Step-by-step support is available for setup questions.",
      mirrorTitle: "Copy instead of trading yourself",
      whatTitle: "What is copy trading?",
      whatText1: "With copy trading, a trading account is automatically connected to an existing strategy. Every trade the strategy executes is mirrored on your own account in real time – proportional to your account size. You don't need to read charts, time entries and exits, or bring any trading experience.",
      whatText2: "The big difference to classic funds or asset management: your capital stays in your own broker account the entire time. Nobody but you has access to it – the strategy only gets permission to place trades.",
      whatFacts: [
        "Capital stays in your own account – full control, at all times",
        "Trades are mirrored fully automatically in real time",
        "Copying can be paused or stopped completely at any time",
        "Every trade is publicly verifiable on Myfxbook",
      ],
      possTitle: "What can you do with it?",
      possSub: "Copy trading is flexible – you decide how to use it.",
      poss1Title: "Use compound interest",
      poss1Text: "Profits stay in the account and are traded along automatically. Position sizes grow with your balance – over months, compounding can grow capital significantly faster than linear saving.",
      poss2Title: "Regular payouts",
      poss2Text: "Alternatively, part of the profits can be withdrawn regularly – for example to recover your initial capital first. From that point on you are only trading with “house money”.",
      poss3Title: "Choose your copy factor",
      poss3Text: "The copy factor (e.g. 12x or 24x) determines how strongly your account leverages the strategy. A higher factor means higher potential returns – but equally higher risk of loss.",
      poss4Title: "Participate fully passively",
      poss4Text: "After the one-time setup everything runs automatically. No chart reading, no trading decisions, no time required – and you can transparently follow the development at any time.",
      riskTitle: "Opportunities & risks – an honest look",
      riskSub: "Leveraged copy trading is a high-risk investment. Both sides belong on the table.",
      chancesLabel: "Opportunities",
      risksLabel: "Risks",
      chances: [
        "Above-average monthly returns possible – the full history is verified on Myfxbook",
        "Compound effect through automatic reinvestment of profits",
        "No trading knowledge required – fully automated execution",
        "Full control: your own account, pause or exit at any time",
      ],
      risks: [
        "Leverage works both ways – losses are amplified just like profits",
        "A total loss of the invested capital is possible at any time",
        "Past results are no guarantee of future performance",
        "Only invest capital you can afford to lose completely",
      ],
      videoTitle: "How the copy-trading system works",
      videoSub: "The explainer video shows step by step how the system works.",
      mirrorText: "The principle is simple: an experienced system trades, your account follows automatically. You keep full control of your capital and can pause or exit at any time. On this site I transparently document how this develops for me.",
      disclaimer: "Personal experience documentation – no investment, financial or legal advice and no recommendation. Trading financial instruments involves substantial risks and can lead to total loss. Every decision is your own responsibility.",
      landing: {
        liveBadge: "Strategy active · Live signal",
        heroHead1: "Automated Gold Trading",
        heroHead2: "with a transparent track record.",
        heroSub: "Mirror a verified copy-trading strategy onto your own broker account. Your capital stays under your control at all times – pause or stop with a single click.",
        ctaStart: "Get started",
        ctaLive: "View live performance",
        trust: ["Verified Myfxbook track record", "Your own broker account", "Pause any time", "Full control over your capital"],
        liveDash: "Live Dashboard",
        kpiAvgMonth: "Ø month",
        kpiWinRate: "Win rate",
        kpiDrawdown: "Drawdown",
        kpiTrades: "Trades",
        timelineEyebrow: "It's this simple",
        timelineTitle: "Live in five steps",
        steps: [
          { title: "Open a broker account", text: "Free account with TAG Markets in a few minutes." },
          { title: "Connect the strategy", text: "Activate copy-trading via COPYX – takes 2 minutes." },
          { title: "Trades get mirrored", text: "Automatically, 1:1 to your account. Zero intervention needed." },
          { title: "Track your progress", text: "Daily updates in the members portal & on Myfxbook." },
          { title: "Leverage the community", text: "Live calls, knowledge base, direct support." },
        ],
        perfEyebrow: "Real & verified",
        perfTitle: "Live performance since day one",
        perfSub: "Simulated net equity curve on a $1,000 starting account (24× amplified, 30 % performance fee already deducted) – every trade fully documented.",
        perfAvgMonth: "Ø month (net)",
        perfWinRate: "Win rate",
        perfDrawdown: "Max drawdown",
        perfMonths: "Months live",
        perfChartLabel: "Equity curve",
        perfSourceLine1: "Live data source: history_trades.",
        perfSourceLine2: "Simulation after broker & performance fees.",
        perfMilestones: "Milestones",
        perfMilestoneGoal: "Goal",
        perfMilestoneReached: "Reached:",
        perfMilestoneOpen: "Still open",
        portalEyebrow: "Your members area",
        portalTitle: "Everything in one place. Clean. Clear. Yours.",
        portalSub: "As a member you get three central tools that structure your journey – from starting capital to your first payout.",
        journeyLabel: "My Journey",
        journeyLive: "Live",
        journeySub: "Net progress · 6 months",
        journeyMilestone: "Milestone",
        journeyReached: "reached",
        journeyShare: "Shareable via public link · PDF export",
        calendarLabel: "Calendar",
        calendarMonth: "February 2026",
        calendarSub: "4 community events · .ics export",
        calendarNext: "Next event",
        calendarNextText: "Live Q&A · Feb 18 · 7:00 pm",
        kbLabel: "Knowledge Base",
        kbTitle: "AI Q&A · Instant answers",
        kbSub: "Curated lessons · AI-powered search",
        kbUserQ: "Your question",
        kbUserQText: "How high should my starting capital be?",
        kbAI: "Sonic AI answers",
        kbAnswer: "Recommended start from €1,000 on a 24× account. Smaller amounts are possible but noticeably slow down the compounding effect…",
        kbLatency: "0.8 s · based on 24 lessons",
        cardJourney: { title: "My Journey", desc: "Set milestones, track your net progress and share it via a public link." },
        cardCalendar: { title: "Calendar", desc: "Live calls, Q&A sessions and trade recaps – one click on \"Add to Calendar\" generates an .ics file." },
        cardKb: { title: "Knowledge Base", desc: "Curated lessons plus AI-powered search. Questions like \"How high should my capital be?\" answered in seconds." },
        ctaMember: "Become a member",
      },
    },
    disclaimer: {
      title: "Before you continue",
      intro: "Please read and confirm the following points to use this site.",
      items: [
        "I have read and understood the liability disclaimer: No content on this site constitutes investment, financial, tax or legal advice. It solely documents the operator's personal experiences and opinions.",
        "Personal responsibility: All information is provided for general informational purposes only. Any decision I make based on this content is made independently and at my own risk.",
        "Risk notice: Trading financial instruments (e.g. stocks, funds or crypto assets) involves substantial risks and can lead to the complete loss of the invested capital. Past results are no guarantee of future performance.",
        "I am aware that I myself must not provide advice or make recommendations either. This site reports exclusively on personal experiences.",
      ],
      yes: "YES",
      accept: "Accept & continue",
      ipNote: "By accepting, your IP address is logged for verification purposes.",
    },
    kpi: {
      startCapital: "Start capital",
      currentBalance: "Current balance",
      totalProfit: "Total profit",
      totalPayouts: "Payouts",
      netProfit: "Net profit",
      totalReturn: "Total return",
      monthlyReturn: "Monthly return",
      dailyReturn: "Ø daily return",
      volume: "Trading volume",
      leverage: "Leverage",
    },
    recovery: "Start capital recovery",
    recoveryHint: "recovered via payouts",
    growthChart: "Growth curve",
    balance: "Balance",
    planLine: "Plan ({target} %/month)",
    payoutsCurve: "Cumulative payouts",
    monthlyTable: "Monthly overview",
    month: "Month",
    profit: "Profit",
    fees: "Fees",
    feesHint: "Commission: −{c} · Trader fee: −{p}",
    payout: "Payout",
    trades: "Trades",
    return: "Return",
    endBalance: "End balance",
    noData: "No entries yet. Add your first day in Tracking.",
    calc: {
      title: "Compound Interest Calculator",
      startCapital: "Start capital ($)",
      monthlyReturn: "Monthly return (%)",
      months: "Duration (months)",
      reinvestRate: "Reinvest rate (%)",
      payoutRate: "Payout rate (%)",
      leverage: "Leverage factor",
      compare: "Comparison: 100% reinvest vs. payout strategy",
      fullReinvest: "100% reinvested",
      withPayout: "with payouts",
      cumPayout: "Cumulative payouts",
      tableTitle: "Monthly development",
      balanceEnd: "Balance",
      volume: "Volume",
      totalWithPayout: "Final value incl. payouts",
      totalFull: "Final value 100% reinvested",
      payoutSum: "Total payouts",
      breakeven: "Break-even (payouts ≥ start capital)",
      breakevenDouble: "Break-even (balance ≥ 2× deposit)",
      payoutEur: "Payout ($/month)",
      effReturn: "≙ effective {eff} % per month at {lev}x",
      histAvgNote: "Prefilled: historical avg {avg} % (at 24x, before performance fee)",
      feeNote: "− 30 % performance fee (deducted every Friday from weekly profits) ≙ net {net} % per month",
      noCompound: "Without compounding: {v}",
      breakevenMonths: "after {m} months",
      breakevenWeeks: "≈ {w} weeks",
      breakevenNot: "Not reached in period",
      calcDisclaimer: "Model calculation – no guarantee. Real returns fluctuate, total loss possible.",
    },
    track: {
      title: "Daily Tracking",
      date: "Date",
      startBalance: "Start balance ($)",
      endBalance: "End balance ($)",
      payout: "Payout ($)",
      commission: "Commission ($)",
      traderFee: "Trader fee 30% ($)",
      commissionShort: "Commission",
      traderFeeShort: "Trader fee",
      netProfit: "Net",
      suggestedFee: "Suggestion (30% of profit)",
      netPreview: "Net after fees",
      trades: "Number of trades",
      note: "Note",
      marketEvent: "Market event",
      profitPreview: "Daily profit/loss",
      suggestedPayout: "Suggestion (10% of profit)",
      apply: "apply",
      save: "Save day",
      update: "Update",
      editing: "Editing entry from {date}",
      cancel: "Cancel",
      saved: "Entry saved",
      deleted: "Entry deleted",
      entries: "Entries",
      exportCsv: "CSV export",
      settings: "Settings",
      settingsStart: "Start capital ($)",
      settingsLeverage: "Leverage",
      settingsSave: "Save",
      settingsSaved: "Settings saved",
      reinvested: "Reinvested",
      actions: "",
    },
    social: {
      title: "Social Media Generator",
      type: "Post type",
      types: { daily: "Daily update", weekly: "Weekly update", monthly: "Monthly update", milestone: "Milestone", loss: "Honest loss update" },
      language: "Post language",
      context: "Extra context (optional)",
      contextPlaceholder: "e.g. strong market today, 25% milestone reached ...",
      generate: "Generate post",
      generating: "Generating ...",
      copy: "Copy",
      copied: "Copied to clipboard",
      empty: "The generated post will appear here.",
      note: "Every post automatically ends with the risk disclaimer.",
      imgTitle: "Generate as image",
      imgSubtitle: "Create a motivational image from your post – for Instagram Story, Feed or TikTok.",
      format: "Format",
      formatStory: "Story / TikTok (9:16)",
      formatFeed: "Feed post (1:1)",
      styleLabel: "Image style",
      styleBranded: "Motivational + Emerald branding",
      stylePhoto: "Photo-realistic",
      imgGenerate: "Generate image",
      imgGenerating: "Creating image ...",
      imgDownload: "Download image",
      imgNeedPost: "Please generate or type a post text first.",
      imgReady: "Your image is ready",
      imgError: "Image generation failed",
    },
    risk: {
      title: "Risk Tracking",
      worstDay: "Largest daily loss",
      maxDrawdown: "Max drawdown",
      lossStreak: "Longest loss streak",
      winStreak: "Longest win streak",
      currentStreak: "Current streak",
      liqDistance: "Distance to liquidation",
      days: "days",
      hypoTitle: "Hypothetical loss on market/strategy move (with leverage)",
      move: "Move",
      loss: "Loss",
      remaining: "Remaining capital",
      wiped: "Account wiped out",
      ddChart: "Drawdown history",
      milestones: "Milestones – start capital recovery",
      milestoneReached: "Milestone reached: {th} % of start capital recovered!",
      reachedOn: "reached on",
      open: "open",
      generatePost: "Generate post",
      milestoneContext: "Milestone reached: {th} % of start capital recovered via payouts (on {date}).",
      warnTitle: "Warnings",
      warnings: {
        liquidation_close: "With {lev}x leverage, a move of only ~-{liq} % is enough for total loss (liquidation).",
        drawdown_high: "Max drawdown exceeds 15 % – elevated risk.",
        loss_streak: "Current loss streak of 3+ days – review the strategy critically.",
        big_daily_loss: "There has already been a daily loss of over 5 % – high volatility.",
        none: "No acute warnings. The base risk from leverage remains.",
      },
    },
    settings: {
      title: "Reference Capital & Goals",
      description: "These values drive your personal journey: progress calculations, payout suggestion and goal metrics. They do not affect real trades – they are purely for simulation and visualising your journey.",
      startCapital: "Start capital ($)",
      leverage: "Leverage factor",
      reinvestRate: "Reinvest rate (%)",
      payoutRate: "Payout rate (%)",
      monthlyTarget: "Target monthly return (%)",
      journeyDays: "Journey target duration (days)",
      goalAmount: "Balance goal ($)",
      sumHint: "Note: reinvest + payout do not add up to 100 %.",
      save: "Save",
      saved: "Settings saved",
      preview: "Preview",
      leverageWarning: "Warning: at {lev}x leverage a move of only ~-{liq} % causes total loss.",
    },
    share: {
      live: "Live · Public experiment",
      subtitle: "Transparent copy-trading experiment – all numbers unfiltered, including losses.",
      copyLink: "Copy share link",
      copied: "Share link copied",
      historySubtitle: "Real trade history from 21 months – simulate yourself what your entry would have become.",
      calcTitle: "Calculate your possible future development",
      calcHero1: "Calculate your possible",
      calcHeroHighlight: "future path",
      tabHistory: "Trade history",
      tabCalc: "Calculator",
      tabJourney: "My journey",
      tabLive: "Live dashboard",
      hero1: "Your",
      heroHighlight: "performance",
      hero2: "at a glance",
      config: "Your configuration",
      configStart: "Start capital",
      configLeverage: "Leverage / factor",
      configPayout: "Payout rate",
      configEdit: "Edit configuration",
      quote: "Discipline today, freedom tomorrow.",
      quoteSub: "Your goal. Your path. Your success.",
      footerLine: "Transparency. Discipline. Success.",
      historyBadge: "Real trades · Historically documented",
      copyHistoryLink: "Copy public history link",
      toDashboard: "To live dashboard",
      toHistory: "To trade history",
    },
    weekly: {
      title: "Weekly update due",
      desc: "Period {since} – {until} · {days} days tracked · profit {profit} · payouts {payout} · return {return}",
      context: "Weekly update for the period {since} to {until}: profit {profit}, payouts {payout}, weekly return {return}, {days} tracked days.",
      generate: "Generate weekly update",
      dismiss: "Later",
    },
    history: {
      title: "Historical Backtest",
      subtitle: "Based on {trades} real trades ({first} to {last}, {months} months). What would your entry have become?",
      startCapital: "Start capital ($)",
      leverage: "Leverage / copy factor",
      payoutRate: "Payout rate (%)",
      endBalance: "Final balance",
      endBalanceFull: "Without payouts (100 % reinvest)",
      totalPayouts: "Total payouts",
      totalReturn: "Total return (incl. payouts)",
      maxDrawdown: "Max drawdown",
      avgMonthly: "Ø monthly return",
      winRate: "Trade win rate",
      bestDay: "Best day",
      worstDay: "Worst day",
      breakeven: "Break-even (payouts ≥ start capital)",
      breakevenDouble: "Break-even (balance ≥ 2× deposit)",
      payoutEur: "Payout ($/month)",
      feeNote: "All figures include the traders' 30 % performance fee (deducted every Friday from the weekly gross profit, only in positive weeks).",
      simpleReturn: "Return without compounding",
      simpleReturnSub: "Profits not reinvested",
      breakevenMonths: "after {m} months",
      breakevenWeeks: "≈ {w} weeks · reached on {date}",
      breakevenNot: "Not reached in period",
      curve: "Capital development (historically simulated)",
      withPayout: "Balance (with payouts)",
      fullReinvest: "100 % reinvested",
      cumPayout: "Cumulative payouts",
      monthlyTable: "Monthly development",
      note: "Historical simulation based on past trades. Past results are NO guarantee for the future – at {lev}x leverage the max drawdown was {dd} %. Total loss is possible at any time.",
      loading: "Calculating ...",
      noData: "No historical trades found.",
      upload: "Update trades (CSV)",
      uploadOk: "{n} trades imported (until {last})",
      uploadFail: "Import failed",
      dataStatus: "Data: {n} trades · last trade {last}",
      mfbStatus: "myfxbook live: {gain} % gain · {dd} % drawdown",
      mfbLink: "View verified history on Myfxbook",
    },
    stats: {
      title: "Trade Analysis",
      profitFactor: "Profit factor",
      profitFactorSub: "Gross profit ÷ gross loss",
      avgWin: "Avg winning trade",
      avgLoss: "Avg losing trade",
      longWinRate: "Long win rate",
      shortWinRate: "Short win rate",
      avgDuration: "Avg trade duration",
      byWeekday: "Performance by weekday",
      byHour: "Performance by hour",
      byMonth: "Performance by month",
      pips: "Pips",
      winShort: "win rate",
      winTrades: "winning trades",
      lossTrades: "losing trades",
      weekdaysShort: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    },
    journey: {
      heroTitle: "My Journey to Financial Freedom",
      publicNote: "What you see here is my personal trading account, which I document transparently day by day – with all profits, losses and setbacks. I share this journey to record my own experiences. All content is for your information only and does not constitute a recommendation or advice.",
      heroSubtitle: "Every trade brings me closer to my goal. This project transparently documents my entire journey – including profits, losses and setbacks.",
      dayLabel: "My Journey",
      day: "Day {d} of {total}",
      totalProfit: "Total profit since start",
      remaining: "Left until capital recovered",
      balance: "Current balance",
      doneShort: "Done!",
      capitalBack: "Recover start capital",
      capitalBackDone: "Start capital fully recovered",
      goal: "Goal: {goal}",
      goalHint: "Based on account balance – goal adjustable in settings.",
      payoutIncluded: "of which paid out (already in profit)",
      todayProfit: "Profit today",
      lastProfit: "Last trading day",
      winStreak: "Win streak",
      days: "days",
      roi: "ROI",
      timeline: "My journey – day by day",
      win: "Profit",
      loss: "Loss",
      noTrade: "No trading",
      trades: "trades",
      tradesOne: "trade",
      balanceArrow: "Balance",
      achievements: "Milestones",
      achievedAt: "Achieved on {date}",
      locked: "Not achieved yet",
      newAchievement: "New milestone achieved:",
      goalBanner: "Your goal is waiting on the horizon – keep going.",
      quotes: [
        "Consistency beats talent.",
        "Small steps lead to big goals.",
        "Discipline is the bridge between goals and success.",
        "Every trade is just another step on your journey.",
        "It's not perfection that wins – it's persistence.",
        "The best time to start was yesterday. The second best is today.",
      ],
      a: {
        first_trade: "First trade",
        first_payout: "First payout",
        profit_100: "$100 profit",
        profit_500: "$500 profit",
        profit_1000: "$1,000 profit",
        capital_back: "Start capital recovered",
        streak_10: "10 winning days in a row",
        trades_100: "100 trades",
        balance_10k: "$10,000 balance",
        balance_50k: "$50,000 balance",
        balance_100k: "$100,000 balance",
      },
    },
    auth: {
      title: "Protected area",
      desc: "Enter the password to manage the dashboard. Public pages stay freely accessible.",
      password: "Password",
      login: "Log in",
      back: "Back to overview",
      error: "Wrong password",
      locked: "Too many attempts – please wait 15 minutes.",
      logout: "Log out",
      forgot: "Forgot password?",
      forgotPanel: {
        backShort: "back",
        title: "Reset password",
        desc: "Enter your email. If an account exists, we'll send you a reset link.",
        emailLabel: "Email",
        emailPh: "you@email.com",
        submit: "Send reset link",
        done: {
          title: "Email sent",
          desc: "If an account with this email exists, you will find a password reset link in your inbox. The link is valid for 2 hours.",
          toLogin: "Back to login",
        },
      },
      reset: {
        title: "Reset password",
        newPw: "New password",
        confirmPw: "Confirm new password",
        submit: "Set password",
        intro: "Please enter your new password (at least 8 characters).",
        pwTooShort: "Password too short (min. 8 characters)",
        pwMismatch: "Passwords do not match",
        invalidToken: "The reset link is invalid or incomplete.",
        genericError: "Reset failed. The link may have expired.",
        done: {
          title: "Password changed",
          desc: "You can now log in with your new password. Redirecting …",
        },
      },
    },
    footer: "Personal experiment. Historical and expected returns are no guarantee of future results. Total loss is possible. Leverage amplifies gains and losses equally. This is not financial advice.",
    register: {
      title: "Registration (invitation only)",
      desc: "You have been invited to the Team Phoenix member portal. Create your personal account.",
      displayName: "First and last name",
      email: "Email",
      password: "Password (min. 8 characters)",
      password2: "Repeat password",
      submit: "Create account",
      invalid: "This invitation is invalid or has already been used. Please contact your point of contact.",
      expired: "This invitation has expired. Please request a new invitation link.",
      pendingMsg: "Registration successful! Your account still needs to be activated by an administrator.",
      pwShort: "Password must be at least 8 characters.",
      pwMismatch: "Passwords do not match.",
      riskNote: "By registering you confirm that this portal serves documentation purposes and is not financial advice. Trading can lead to total loss.",
    },
    admin: {
      members: "Members",
      invitations: "Invitations",
      inviteLabel: "Label",
      inviteLabelPh: "e.g. name of the invitee",
      inviteExpiry: "Validity",
      days: "days",
      createInvite: "Create invitation link",
      inviteCreated: "Invitation created – link copied to clipboard",
      inviteRevoked: "Invitation revoked",
      inviteHint: "The link is copied automatically when created. Send it to the new member via email or messenger. Each link can only be used once.",
      invOpen: "Open",
      invUsed: "Used",
      invRevoked: "Revoked",
      invExpired: "Expired",
      role: "Role",
      actions: "Actions",
      statuses: { active: "Active", pending: "Awaiting activation", locked: "Locked", disabled: "Disabled" },
      activate: "Activate",
      lock: "Lock",
      resetPw: "Set password",
      newPwFor: "New password for",
      pwReset: "Password reset",
      saved: "Saved",
      riskDocs: "Risk Documents",
      riskDocsHint: "Manage the risk documents that every member has to confirm before using the portal. Publishing a new version forces every member to consent again.",
      docKey: "Key",
      docOrder: "Order",
      docVersion: "Version",
      docPublished: "Published",
      docDraft: "Draft",
      docTitleDe: "Title (DE)",
      docContentDe: "Content (DE)",
      docTitleEn: "Title (EN)",
      docContentEn: "Content (EN)",
      publish: "Publish",
      publishNew: "Publish new version",
      publishHint: "Publishing bumps the version and forces every member to reconfirm.",
      newDoc: "New document",
      save: "Save",
      edit: "Edit",
      delete: "Delete",
      confirmDelete: "Delete for good?",
    },
    onboarding: {
      title: "Welcome to Team Phoenix",
      subtitle: "Please walk through the following steps to unlock your personal portal.",
      step: "Step",
      of: "of",
      next: "Next",
      back: "Back",
      finish: "Unlock portal",
      step1Title: "Welcome",
      step1Desc: "Short intro to the portal. Here you track your copy-trading journey transparently, document payouts and keep your risk in check.",
      step1Points: [
        "Your data is private – only you and the admin see it.",
        "Trading is a high-risk activity. We only document, we do not advise.",
        "All returns are based on your actual entries.",
      ],
      step2Title: "Confirm risk documents",
      step2Desc: "Please read every document carefully and individually confirm that you understood its content.",
      readAndAccept: "I have read and understood",
      accepted: "Confirmed",
      openDoc: "Show",
      allAccepted: "All documents confirmed",
      pendingHint: "Still open: {n}",
      step3Title: "Personal risk profile",
      step3Desc: "Define your starting parameters. You can change them any time in the risk center.",
      startCapital: "Start capital ($)",
      targetLeverage: "Target copy factor",
      payoutRate: "Payout rate (%)",
      maxLoss: "Max loss tolerance (%)",
      maxLossHint: "You want to intervene / be alerted once drawdown reaches this level.",
      step4Title: "Summary",
      step4Desc: "Review your settings and unlock the portal.",
      summaryProfile: "Your risk profile",
      summaryDocs: "Confirmed documents",
      completed: "Portal unlocked",
      reconsentTitle: "Updated risk documents",
      reconsentDesc: "We updated one or more risk documents. Please read and confirm the new version to keep using the portal.",
    },
    riskCenter: {
      title: "Risk Center",
      subtitle: "Your confirmed documents and personal risk profile.",
      docsSection: "Risk Documents",
      profileSection: "Your risk profile",
      updateProfile: "Save profile",
      profileUpdated: "Profile updated",
      version: "Version",
      acceptedOn: "Confirmed on",
      notAccepted: "Not yet confirmed",
      reAccept: "Confirm new version",
      view: "Show",
      close: "Close",
    },
    personal: {
      title: "My progress",
      subtitle: "Personal progress against your goals from the risk profile.",
      profileMissing: "Please set up your risk profile first.",
      goalDouble: "Double capital",
      goalGain: "Target gain",
      currentGain: "Current gain",
      progress: "Progress",
      currentDrawdown: "Current drawdown",
      maxDrawdown: "Max drawdown",
      lossToleranceReached: "Loss tolerance exceeded – please review your risk setup.",
      lossToleranceNear: "Loss is approaching your tolerance.",
      openRiskCenter: "Open risk center",
      payoutRateGoal: "Payout goal",
      payoutRateActual: "Actual",
      leverageTarget: "Target leverage",
      entries: "Entries",
    },
    academy: {
      title: "Academy",
      subtitle: "Short lessons on basics, risk management, copy trading and tax.",
      overallProgress: "Overall progress",
      lessons: "Lessons",
      minutes: "min",
      completed: "Completed",
      startLesson: "Open",
      markComplete: "Mark as completed",
      markIncomplete: "Undo",
      noLessons: "No lessons available yet.",
      videoLabel: "Video",
      close: "Close",
    },
    support: {
      title: "Support",
      subtitle: "Your requests to the team. We reply as soon as possible.",
      newTicket: "New ticket",
      subject: "Subject",
      subjectPh: "e.g. Question about a lesson",
      message: "Message",
      messagePh: "Describe your issue as detailed as possible.",
      send: "Send",
      reply: "Reply",
      status: "Status",
      statusOpen: "Open",
      statusInProgress: "In progress",
      statusClosed: "Closed",
      you: "You",
      admin: "Support",
      noTickets: "No requests yet.",
      created: "Created",
      updated: "Updated",
      ticketCreated: "Request sent",
      replySent: "Reply sent",
      adminTitle: "Support tickets",
      adminSubtitle: "All member requests. Reply directly from within the ticket.",
      setStatus: "Change status",
      unread: "New",
      filterAll: "All",
    },
    audit: {
      title: "Audit log",
      subtitle: "Chronological log of all important changes in the portal.",
      timestamp: "Timestamp",
      action: "Action",
      actor: "Actor",
      target: "Target",
      meta: "Details",
    },
    landing: {
      title: "Your landing page",
      subtitle: "Create your personal link and set your referral URL. All CTA buttons on the public landing page will link to your referral.",
      slugLabel: "Your personal slug",
      slugPh: "e.g. max, sonic-max, max-2026",
      slugHint: "2–30 chars, a–z, 0–9 and dashes. Becomes part of your URL.",
      refLabel: "Your link from the CopyXapp / IB Portal back office (under Profile, the link under Partner → Copy link)",
      refPh: "https://...?ref=...",
      refHint: "Must start with http(s)://. This link is used on every CTA button of your landing page.",
      save: "Save",
      saved: "Landing page updated",
      yourUrl: "Your public URL",
      copyUrl: "Copy URL",
      copied: "Copied to clipboard",
      openPreview: "Open preview",
      notSet: "Please set a slug first.",
      slugTaken: "This slug is already taken.",
    },
    kb: {
      title: "Knowledge base",
      subtitle: "Hand-picked topics, tutorials and resources.",
      minutes: "min",
      readMore: "Open",
      empty: "No entries available yet.",
      videoLabel: "Video",
      close: "Close",
      downloadPdf: "Download as PDF",
      searchPh: "Search topics, courses or content…",
      categories: "Categories",
      showAll: "Show all",
      featured: "Recommended for you",
      popular: "Popular content",
      recent: "Recently viewed",
      noRecent: "Nothing viewed yet.",
      items: "items",
      lessons: "lessons",
      typeCourse: "Course",
      typeVideo: "Video",
      typeGuide: "Guide",
      typeArticle: "Article",
      typeFaq: "FAQ",
      typeQuiz: "Quiz",
      viewsSuffix: "views",
      relativeDayAgo: "{n} day ago",
      relativeDaysAgo: "{n} days ago",
      relativeToday: "today",
      relativeYesterday: "yesterday",
      noResults: "No content found.",
      backToOverview: "Back to overview",
    },
    calendar: {
      title: "Calendar",
      subtitle: "All live calls, webinars and maintenance windows at a glance.",
      today: "Today",
      prev: "Prev",
      next: "Next",
      newEvent: "New event",
      editEvent: "Edit event",
      upcoming: "Upcoming events",
      noEvents: "No events this month.",
      noUpcoming: "No upcoming events.",
      allCategories: "All categories",
      moreEvents: "+ {n} more",
      ical: {
        title: "Import Google Calendar",
        subtitle: "Paste either the secret iCal URL or a public embed link from your Google Calendar – we convert automatically. Auto-syncs hourly.",
        urlLabel: "iCal or calendar URL",
        urlPh: "https://calendar.google.com/calendar/...",
        enabledLabel: "Auto-sync enabled",
        save: "Save URL",
        syncNow: "Sync now",
        lastSync: "Last synced",
        neverSynced: "Never synced yet",
        lastError: "Last error",
        stats: "{added} added · {updated} updated · {removed} removed",
        openAdmin: "Google Calendar import",
        close: "Close",
        detectedUrl: "Detected and converted to",
      },
      fields: {
        title: "Title",
        titlePh: "e.g. Weekly live call",
        description: "Description",
        descriptionPh: "Details, agenda, notes …",
        startAt: "Start",
        endAt: "End (optional)",
        link: "Link (Zoom / Meet / Webinar)",
        linkPh: "https://…",
        location: "Location (optional)",
        locationPh: "e.g. Online, Zoom, Berlin",
        category: "Category",
        recurrence: "Repeat",
        recurrenceNone: "None (one-off)",
        recurrenceWeekly: "Every week",
        recurrenceUntil: "Repeat until (optional)",
      },
      recurringBadge: "Weekly",
      recurringUntil: "until {date}",
      save: "Save",
      created: "Event created",
      updated: "Event updated",
      deleted: "Event deleted",
      confirmDelete: "Delete this event?",
      duration: "Duration",
      joinLink: "Join event",
      when: "When",
      weekdaysShort: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      months: ["January","February","March","April","May","June","July","August","September","October","November","December"],
    },
    error: "Error – please try again",
  },
  it: {
      appTitle: "Team Phoenix Portal",
      disclaimer: {
        title: "Prima di continuare",
        intro: "Leggi e conferma i seguenti punti per usare il sito.",
        items: [
          "Ho letto e compreso l'esclusione di responsabilità: tutti i contenuti di questa pagina non costituiscono consulenza finanziaria, d'investimento, fiscale o legale. Si tratta esclusivamente della documentazione di esperienze e opinioni personali del gestore.",
          "Responsabilità personale: tutte le informazioni hanno scopo puramente informativo. Ogni decisione presa sulla base di questi contenuti avviene in autonomia e a proprio rischio.",
          "Avviso di rischio: il trading di strumenti finanziari (es. azioni, fondi o criptovalute) comporta rischi significativi e può portare alla perdita totale del capitale investito. I risultati passati non garantiscono sviluppi futuri.",
          "Sono consapevole che nemmeno io posso fornire consulenza o raccomandazioni. Questa pagina riporta esclusivamente esperienze personali."
        ],
        yes: "SÌ",
        accept: "Accetta e continua",
        ipNote: "Accettando, il tuo indirizzo IP viene registrato a fini probatori."
      },
      tabs: {
        dashboard: "Il mio viaggio",
        calculator: "Calcolatore",
        tracking: "Tracking",
        history: "Storico",
        strategy: "Strategia",
        risk: "Rischio",
        social: "Social",
        settings: "Impostazioni",
        academy: "Knowledge base",
        adminAcademy: "CMS knowledge base",
        adminGroup: "Admin",
        adminSupport: "Supporto (Admin)",
        audit: "Log di audit",
        calendar: "Calendario",
        marketing: "Marketing",
        members: "Membri",
        riskCenter: "Centro rischi",
        riskDocs: "Documenti rischio",
        support: "Portal Support",
        links: "Link e indirizzi email",
        adminLinks: "Link e indirizzi email (Admin)"
      },
      edu: {
        heroBadge: "Piattaforma didattica · Nessuna vendita, nessuna promessa",
        heroH1a: "Fai fare il trading a professionisti esperti —",
        heroH1b: "il tuo denaro resta sempre sul tuo conto broker.",
        heroSub: "Non devi leggere grafici né fare trading tu stesso. Una strategia verificata viene replicata automaticamente sul tuo conto. Il controllo resta sempre nelle tue mani.",
        b1t: "Il tuo capitale resta con te",
        b1x: "Il denaro è sul tuo conto broker – non da noi.",
        b2t: "I trade vengono copiati",
        b2x: "In automatico, senza che tu debba intervenire.",
        b3t: "Tutto trasparente",
        b3x: "Ogni singolo trade è verificabile pubblicamente.",
        ctaStart: "Inizia ora",
        ctaLearn: "Scopri di più",
        illBroker: "Il tuo conto broker",
        illControl: "sotto il tuo controllo",
        illGold: "Oro",
        illGoldNote: "Il mercato in cui opera la strategia.",
        illApp: "Sonic App",
        illProgress: "Progressi",
        illLastTrade: "Ultimo trade",
        illStrategy: "Strategia",
        illActive: "Attiva · Il controllo è tuo",
        whatEye: "Prima le basi",
        whatTitle: "Cos'è il copy trading?",
        whatIntro: "In breve: un trader esperto prende le decisioni. Queste vengono trasferite automaticamente sul tuo conto. Tu non devi fare nulla.",
        whatStep: "Passo",
        whatS1t: "Trader esperto",
        whatS1x: "Analizza il mercato e prende la decisione.",
        whatS2t: "Apre un trade",
        whatS2x: "Ordine di acquisto o vendita sul suo conto.",
        whatS3t: "Automatico sul tuo conto",
        whatS3x: "Lo stesso ordine viene replicato – in proporzione al tuo capitale.",
        whatS4t: "Il risultato arriva a te",
        whatS4x: "Profitto o perdita compaiono in proporzione sul tuo conto.",
        whatImportant: "Importante: tu non fai trading. Copi la strategia. Le decisioni restano al trader, il tuo capitale resta con te.",
        howEye: "Il flusso",
        howTitle: "Come funziona esattamente?",
        howS1t: "Apri un conto broker",
        howS1x: "Conto gratuito su TAG Markets – bastano pochi minuti.",
        howS2t: "Collega la strategia",
        howS2x: "Tramite un servizio dedicato (COPYX) autorizzi la copia automatica.",
        howS3t: "Il trader apre una posizione",
        howS3x: "Il trader esperto decide sul suo conto.",
        howS4t: "Il trade compare sul tuo",
        howS4x: "Lo stesso ordine arriva sul tuo conto in automatico – senza tuo intervento.",
        howS5t: "Segui l'andamento",
        howS5x: "Vedi tutto nel portale in ogni momento – trasparente e in tempo reale.",
        skillEye: "Per principianti",
        skillTitle: "Devo saper fare trading?",
        skillNo: "No.",
        skillNoNote: "Nessuna esperienza richiesta.",
        skillDesc: "Tutte le decisioni le prende il trader esperto. Tu vedi cosa succede – e impari nel frattempo.",
        skill1: "niente grafici",
        skill2: "niente analisi di mercato",
        skill3: "niente decisioni di acquisto",
        skill4: "niente segnali di vendita",
        skill5: "niente valutazione news",
        skill6: "niente lavoro domenicale",
        moneyEye: "Fiducia",
        moneyTitle: "Dov'è il mio denaro?",
        moneySub: "La domanda più importante – e la risposta più semplice:",
        moneyAccLabel: "Il tuo conto broker",
        moneyAccNote: "Qui – e solo qui – si trova il tuo capitale.",
        moneyP1t: "Sul tuo conto broker",
        moneyP1x: "Un conto regolamentato che appartiene solo a te. Noi non abbiamo alcun accesso al saldo.",
        moneyP2t: "Solo autorizzazione di trading",
        moneyP2x: "La strategia può solo aprire trade – non può mai toccare il denaro.",
        moneyP3t: "Nessun pagamento a terzi",
        moneyP3x: "Versamenti e prelievi passano solo tra te e il tuo broker.",
        moneyP4t: "Metti in pausa o annulla in qualsiasi momento",
        moneyP4x: "Un clic ferma o termina completamente la copia.",
        moneyCtrl: "Il pieno controllo resta a te.",
        moneyCtrlSub: "Nessun gestore di fondi, nessuna custodia, nessun pagamento da terzi.",
        whyEye: "Pubblico",
        whyTitle: "Perché le persone usano il copy trading?",
        whyP1t: "“Non ho tempo”",
        whyP1x: "Lavoro, famiglia, vita – il copy trading continua mentre tu vivi la tua.",
        whyP2t: "“Non ho esperienza”",
        whyP2x: "Non serve conoscenza di trading. La strategia decide, tu impari nel frattempo.",
        whyP3t: "“Voglio investire in modo trasparente”",
        whyP3x: "Ogni trade è verificabile. Vedi esattamente cosa succede e perché.",
        whyP4t: "“Lo lascio ai professionisti”",
        whyP4x: "I trader esperti hanno anni di pratica. Puoi usarne le decisioni 1:1.",
        transEye: "Trasparenza",
        transTitle: "Cos'è Myfxbook — e perché è importante?",
        transPara: "Myfxbook è un servizio di verifica indipendente per conti di trading. Si collega direttamente al conto del trader e registra automaticamente ogni singolo trade – impossibile &bdquo;abbellire&ldquo; i numeri a posteriori.",
        trans1: "Ogni trade viene salvato in tempo reale – non a fine mese.",
        trans2: "Manipolazione impossibile: i dati arrivano direttamente dal broker.",
        trans3: "Puoi consultarlo in qualsiasi momento – pubblicamente, senza login.",
        trans4: "Si vedono anche le perdite – non solo i guadagni. Questo crea vera fiducia.",
        transCta: "Vedi lo storico pubblico",
        transVer: "Conto verificato",
        transLive: "Live",
        transK1: "Trade totali",
        transK2: "Win rate",
        transK3: "Live da",
        transK4: "Perdita max.",
        transK3v: "21 mesi",
        transExpl: "&bdquo;Fase di perdita&ldquo; = massimo calo tra un picco e il minimo successivo. Più bassa, più tranquilla la curva.",
        oppEye: "Onesti, non pubblicitari",
        oppTitle: "Opportunità e rischi – senza filtri",
        oppSub: "Entrambi vanno mostrati. Insieme, senza abbellimenti.",
        oppTitleC: "Opportunità",
        oppTitleR: "Rischi",
        opp1: "Separazione chiara tra capitale (da te) e strategia (dal trader).",
        opp2: "Risparmio di tempo: niente analisi, niente studio di grafici, niente notifiche.",
        opp3: "Trasparenza totale grazie al track record verificato.",
        opp4: "Curva di apprendimento inclusa: vedi come lavora un professionista.",
        opp5: "Pausa in ogni momento – nessun contratto, nessun vincolo.",
        risk1: "Le perdite sono possibili – incluso il totale del versato.",
        risk2: "La performance passata non garantisce risultati futuri.",
        risk3: "Il mercato (oro) può muoversi molto, anche in poco tempo.",
        risk4: "Senza esperienza col broker, la configurazione iniziale richiede tempo.",
        risk5: "Non adatto per capitale che ti serve a breve.",
        faqEye: "FAQ",
        faqTitle: "Domande frequenti",
        faqQ1: "Cos'è esattamente il copy trading?",
        faqA1: "Copy trading significa: un trader esperto prende le decisioni e queste vengono trasferite in automatico sul tuo conto. Non fai trading tu – copi la strategia.",
        faqQ2: "Il mio denaro resta davvero sul mio conto?",
        faqA2: "Sì. Il tuo capitale è presso un broker regolamentato su un conto che appartiene solo a te. La strategia ha solo il permesso di aprire trade – mai accesso al denaro.",
        faqQ3: "Posso smettere in qualsiasi momento?",
        faqA3: "Sì. Puoi mettere in pausa o interrompere la copia con un clic. Nessun periodo minimo, nessun preavviso.",
        faqQ4: "Come prelevo i profitti?",
        faqA4: "Direttamente dal conto broker al tuo conto bancario. Versamenti e prelievi passano solo tra te e il broker – non per noi.",
        faqQ5: "Ho bisogno di esperienza di trading?",
        faqA5: "No. Nessuna esperienza richiesta. La strategia gestisce tutte le decisioni. Se vuoi approfondire trovi una base di conoscenza nel portale membri.",
        faqQ6: "Quanto costa?",
        faqA6: "Paghi solo a risultato: una performance fee sui profitti effettivi. Senza profitti, nessuna commissione. Tutti i dettagli visibili prima di collegare.",
        faqQ7: "Cosa succede in caso di perdita?",
        faqA7: "Le perdite fanno parte del mercato e vengono replicate in proporzione al tuo capitale. Il track record mostra sia le fasi in profitto sia quelle in perdita.",
        faqQ8: "Perché proprio l'oro?",
        faqA8: "L'oro (ticker &bdquo;XAUUSD&ldquo;) è uno dei mercati più liquidi al mondo: spread stretti, movimenti chiari e disponibilità 24/7. La strategia è ottimizzata per le sue caratteristiche.",
        faqQ9: "Cos'è MT5?",
        faqA9: "MetaTrader 5 (MT5) è una piattaforma di trading molto diffusa. Il broker la fornisce gratuitamente. La strategia &bdquo;dialoga&ldquo; col broker tramite MT5 per piazzare i trade. Tu non devi usare MT5.",
        softH1: "Quando hai capito come funziona il copy trading,",
        softH2: "puoi guardare come la strategia ha lavorato storicamente.",
        softSub: "Nessuna promessa, nessuna pressione. Solo numeri da conti reali e verificati.",
        softAgain: "Rileggi dall'inizio",
      },
      strategy: {
        badge: "Strategia attiva – live",
        hero1: "Trading automatico sull'oro –",
        heroHighlight: "la mia strategia in sintesi",
        heroSub: "La strategia SONIC opera sull'oro (XAUUSD) tramite trader esperti. Ogni trade viene replicato via MT5 sul proprio conto – senza dover operare personalmente. Qui trovi i fatti principali e come iniziare.",
        kpiDaily: "Rendimento giornaliero (24x)",
        kpiMonthly: "Rendimento mensile (24x)",
        kpiDrawdown: "Drawdown max (1x)",
        kpiTrades: "Trade · Tasso di successo",
        kpiNote: "Indicatori calcolati in tempo reale dallo storico reale dei trade ({months} mesi, al lordo delle commissioni, leva 12x). I risultati passati non garantiscono il futuro.",
        cta: "Inizia ora",
        ctaBandTitle: "Pronto per il prossimo passo?",
        ctaBandSub: "Collega il tuo conto e lascia che la strategia operi per te.",
        verified: "Track record verificato (myfxbook)",
        howTitle: "Come funziona",
        howSub: "Dal conto al primo trade copiato in pochi passaggi.",
        step1Title: "Collega il conto",
        step1Text: "Colleghi il tuo conto MT5 alla strategia in pochi minuti. Il capitale resta sempre sul tuo conto personale.",
        step2Title: "I trade vengono replicati",
        step2Text: "Quando la strategia apre una posizione, viene replicata automaticamente e senza ritardi sul tuo conto – ingresso, uscita e dimensione della posizione inclusi.",
        step3Title: "Insieme nel percorso",
        step3Text: "Una community attiva di molti Paesi usa già la strategia. Per la configurazione c'è supporto passo dopo passo.",
        mirrorTitle: "Copiare invece di fare trading da soli",
        whatTitle: "Cos'è il copy trading?",
        whatText1: "Con il copy trading un conto di trading viene collegato automaticamente a una strategia esistente. Ogni trade eseguito dalla strategia viene replicato in tempo reale sul proprio conto – in proporzione alla dimensione del conto. Non serve leggere grafici, scegliere ingressi e uscite o avere esperienza di trading.",
        whatText2: "La grande differenza rispetto a fondi classici o gestioni patrimoniali: il capitale resta sempre sul proprio conto broker. Nessuno tranne te vi ha accesso – la strategia riceve solo l'autorizzazione a piazzare trade.",
        whatFacts: [
          "Il capitale resta sul tuo conto – pieno controllo, sempre",
          "I trade vengono replicati in automatico e in tempo reale",
          "La copia può essere messa in pausa o interrotta in qualsiasi momento",
          "Ogni trade è verificabile pubblicamente su Myfxbook"
        ],
        possTitle: "Quali possibilità hai?",
        possSub: "Il copy trading è flessibile – decidi tu come usarlo.",
        poss1Title: "Sfruttare l'interesse composto",
        poss1Text: "I profitti restano sul conto e vengono negoziati automaticamente. La dimensione delle posizioni cresce con il saldo – l'effetto dell'interesse composto può far crescere il capitale molto più velocemente del risparmio lineare.",
        poss2Title: "Prelievi regolari",
        poss2Text: "In alternativa, parte dei profitti può essere prelevata regolarmente – ad esempio per recuperare prima il capitale iniziale. Da quel momento operi solo con i „soldi della casa“.",
        poss3Title: "Scegli il fattore di copia",
        poss3Text: "Con il fattore di copia (es. 12x o 24x) decidi quanto il tuo conto amplifica la strategia. Fattore più alto significa rendimenti potenziali maggiori – ma anche un rischio di perdita altrettanto maggiore.",
        poss4Title: "Partecipazione completamente passiva",
        poss4Text: "Dopo la configurazione iniziale tutto funziona in automatico. Niente grafici, niente decisioni di trading, nessun impegno di tempo – e puoi seguire l'andamento in modo trasparente in ogni momento.",
        riskTitle: "Opportunità e rischi – uno sguardo onesto",
        riskSub: "Il copy trading con leva è un investimento ad alto rischio. Entrambi i lati vanno messi sul tavolo.",
        chancesLabel: "Opportunità",
        risksLabel: "Rischi",
        chances: [
          "Rendimenti mensili sopra la media possibili – l'intero storico è verificato su Myfxbook",
          "Effetto interesse composto grazie al reinvestimento automatico dei profitti",
          "Nessuna conoscenza di trading richiesta – esecuzione completamente automatica",
          "Pieno controllo: conto proprio, pausa o uscita in qualsiasi momento"
        ],
        risks: [
          "La leva agisce in entrambe le direzioni – le perdite vengono amplificate come i profitti",
          "La perdita totale del capitale investito è possibile in qualsiasi momento",
          "I risultati passati non garantiscono le performance future",
          "Investi solo capitale di cui puoi sopportare la perdita totale"
        ],
        videoTitle: "Come funziona il sistema di copy trading",
        videoSub: "Il video esplicativo mostra passo dopo passo come lavora il sistema.",
        mirrorText: "Il principio è semplice: un sistema esperto fa trading, il tuo conto lo segue automaticamente. Mantieni il pieno controllo del tuo capitale e puoi mettere in pausa o uscire quando vuoi. Su questa pagina documento in modo trasparente come si sviluppa per me.",
        disclaimer: "Documentazione di esperienze personali – nessuna consulenza finanziaria, d'investimento o legale e nessuna raccomandazione. Il trading di strumenti finanziari comporta rischi elevati e può portare alla perdita totale. Ogni decisione è sotto la tua responsabilità.",
        landing: {
          liveBadge: "Strategia attiva · Segnale live",
          heroHead1: "Trading automatizzato sull'oro",
          heroHead2: "con uno storico trasparente.",
          heroSub: "Rispecchia una strategia di copy-trading verificata sul tuo conto broker personale. Il tuo capitale resta sempre sotto il tuo controllo – metti in pausa o esci con un clic.",
          ctaStart: "Inizia ora",
          ctaLive: "Vedi la performance live",
          trust: ["Track record Myfxbook verificato", "Conto broker personale", "In pausa quando vuoi", "Controllo totale del tuo capitale"],
          liveDash: "Live Dashboard",
          kpiAvgMonth: "Ø mese",
          kpiWinRate: "Win rate",
          kpiDrawdown: "Drawdown",
          kpiTrades: "Trade",
          timelineEyebrow: "È così semplice",
          timelineTitle: "Attivo in cinque passi",
          steps: [
            { title: "Apri il conto broker", text: "Conto gratuito su TAG Markets in pochi minuti." },
            { title: "Collega la strategia", text: "Attiva il copy-trading via COPYX – ci vogliono 2 minuti." },
            { title: "I trade vengono replicati", text: "Automaticamente, 1:1 sul tuo conto. Nessun intervento richiesto." },
            { title: "Monitora l'andamento", text: "Progressi quotidiani nel portale membri & su Myfxbook." },
            { title: "Sfrutta la community", text: "Live call, base di conoscenza, supporto diretto." },
          ],
          perfEyebrow: "Reale e verificato",
          perfTitle: "Performance live dal primo giorno",
          perfSub: "Curva di capitale netta simulata su un conto iniziale da 1 000 $ (24× amplificato, 30 % di performance-fee già dedotta) – ogni trade documentato senza lacune.",
          perfAvgMonth: "Ø mese (netto)",
          perfWinRate: "Win rate",
          perfDrawdown: "Max drawdown",
          perfMonths: "Mesi live",
          perfChartLabel: "Curva del capitale",
          perfSourceLine1: "Fonte dati live: history_trades.",
          perfSourceLine2: "Simulazione al netto di commissioni broker & performance-fee.",
          perfMilestones: "Traguardi",
          perfMilestoneGoal: "Obiettivo",
          perfMilestoneReached: "Raggiunto:",
          perfMilestoneOpen: "Ancora aperto",
          portalEyebrow: "La tua area membri",
          portalTitle: "Tutto in un posto. Pulito. Chiaro. Tuo.",
          portalSub: "Come membro ottieni tre strumenti chiave che strutturano il tuo percorso – dal capitale iniziale al primo prelievo.",
          journeyLabel: "Il mio percorso",
          journeyLive: "Live",
          journeySub: "Progressi netti · 6 mesi",
          journeyMilestone: "Traguardo",
          journeyReached: "raggiunto",
          journeyShare: "Condivisibile tramite link pubblico · Export PDF",
          calendarLabel: "Calendario",
          calendarMonth: "Febbraio 2026",
          calendarSub: "4 eventi community · export .ics",
          calendarNext: "Prossimo evento",
          calendarNextText: "Live Q&A · 18 feb · ore 19:00",
          kbLabel: "Base di conoscenza",
          kbTitle: "AI Q&A · Risposte istantanee",
          kbSub: "Lezioni curate · Ricerca potenziata da IA",
          kbUserQ: "La tua domanda",
          kbUserQText: "Quanto dovrebbe essere alto il mio capitale iniziale?",
          kbAI: "Sonic AI risponde",
          kbAnswer: "Inizio consigliato a partire da 1 000 € su un conto 24×. Importi minori sono possibili ma rallentano sensibilmente l'effetto composto…",
          kbLatency: "0,8 s · basato su 24 lezioni",
          cardJourney: { title: "Il mio percorso", desc: "Imposta traguardi, monitora i progressi netti e condividili tramite link pubblico." },
          cardCalendar: { title: "Calendario", desc: "Live call, sessioni Q&A e trade recap – un clic su \"Aggiungi al calendario\" genera un file .ics." },
          cardKb: { title: "Base di conoscenza", desc: "Lezioni curate più ricerca con IA. Domande come \"Quanto capitale mi serve?\" con risposta in pochi secondi." },
          ctaMember: "Diventa membro",
        },
      },
      kpi: {
        startCapital: "Capitale iniziale",
        currentBalance: "Saldo attuale",
        totalProfit: "Profitto totale",
        totalPayouts: "Prelievi",
        netProfit: "Profitto netto",
        totalReturn: "Rendimento totale",
        monthlyReturn: "Rendimento mensile",
        dailyReturn: "Ø rendimento giornaliero",
        volume: "Volume di trading",
        leverage: "Leva"
      },
      recovery: "Recupero del capitale iniziale",
      recoveryHint: "recuperato tramite prelievi",
      growthChart: "Curva di crescita",
      balance: "Saldo",
      planLine: "Piano ({target} %/mese)",
      payoutsCurve: "Prelievi cumulati",
      monthlyTable: "Riepilogo mensile",
      month: "Mese",
      profit: "Profitto",
      fees: "Commissioni",
      feesHint: "Commissione: −{c} · Provvigione: −{p}",
      payout: "Prelievo",
      trades: "Trade",
      return: "Rendimento",
      endBalance: "Saldo finale",
      noData: "Ancora nessun dato. Inserisci il tuo primo giorno nel tracking.",
      calc: {
        title: "Calcolatore dell'interesse composto",
        startCapital: "Capitale iniziale ($)",
        monthlyReturn: "Rendimento mensile (%)",
        months: "Durata (mesi)",
        reinvestRate: "Quota di reinvestimento (%)",
        payoutRate: "Quota di prelievo (%)",
        leverage: "Fattore di leva",
        compare: "Confronto: 100% reinvestito vs. strategia di prelievo",
        fullReinvest: "100% reinvestito",
        withPayout: "con prelievi",
        cumPayout: "Prelievi cumulati",
        tableTitle: "Andamento mensile",
        balanceEnd: "Saldo",
        volume: "Volume",
        totalWithPayout: "Valore finale incl. prelievi",
        totalFull: "Valore finale 100% reinvestito",
        payoutSum: "Somma prelievi",
        breakeven: "Break-even (prelievi ≥ capitale iniziale)",
        breakevenDouble: "Break-even (saldo ≥ 2× deposito)",
        payoutEur: "Prelievo ($/mese)",
        effReturn: "≙ effettivo {eff} % al mese con {lev}x",
        histAvgNote: "Precompilato: media storica {avg} % (a 24x, prima della partecipazione agli utili)",
        feeNote: "− 30 % di partecipazione agli utili (detratta ogni venerdì dal profitto settimanale) ≙ netto {net} % al mese",
        noCompound: "Senza compounding: {v}",
        breakevenMonths: "dopo {m} mesi",
        breakevenWeeks: "≈ {w} settimane",
        breakevenNot: "Non raggiunto nel periodo",
        calcDisclaimer: "Calcolo modello – nessuna garanzia. I rendimenti reali oscillano, perdita totale possibile."
      },
      track: {
        title: "Tracking giornaliero",
        date: "Data",
        startBalance: "Saldo iniziale ($)",
        endBalance: "Saldo finale ($)",
        payout: "Prelievo ($)",
        commission: "Commissione ($)",
        traderFee: "Provvigione trader 30% ($)",
        commissionShort: "Commissione",
        traderFeeShort: "Provvigione",
        netProfit: "Netto",
        suggestedFee: "Suggerimento (30% del profitto)",
        netPreview: "Netto dopo le commissioni",
        trades: "Numero di trade",
        note: "Nota",
        marketEvent: "Evento di mercato",
        profitPreview: "Profitto/perdita giornaliero",
        suggestedPayout: "Suggerimento (10% del profitto)",
        apply: "applica",
        save: "Salva giorno",
        update: "Aggiorna",
        editing: "Modifica voce del {date}",
        cancel: "Annulla",
        saved: "Voce salvata",
        deleted: "Voce eliminata",
        entries: "Voci",
        exportCsv: "Esporta CSV",
        settings: "Impostazioni",
        settingsStart: "Capitale iniziale ($)",
        settingsLeverage: "Leva",
        settingsSave: "Salva",
        settingsSaved: "Impostazioni salvate",
        reinvested: "Reinvestito",
        actions: ""
      },
      social: {
        title: "Generatore social media",
        type: "Tipo di post",
        types: {
          daily: "Aggiornamento giornaliero",
          weekly: "Aggiornamento settimanale",
          monthly: "Aggiornamento mensile",
          milestone: "Traguardo",
          loss: "Aggiornamento onesto sulle perdite"
        },
        language: "Lingua del post",
        context: "Contesto aggiuntivo (opzionale)",
        contextPlaceholder: "es. mercato forte oggi, traguardo del 25% raggiunto ...",
        generate: "Genera post",
        generating: "Generazione in corso ...",
        copy: "Copia",
        copied: "Copiato negli appunti",
        empty: "Il post generato apparirà qui.",
        note: "Ogni post termina automaticamente con l'avviso di rischio."
      },
      risk: {
        title: "Monitoraggio del rischio",
        worstDay: "Maggiore perdita giornaliera",
        maxDrawdown: "Drawdown max",
        lossStreak: "Serie di perdite più lunga",
        winStreak: "Serie di vincite più lunga",
        currentStreak: "Serie attuale",
        liqDistance: "Distanza dalla liquidazione",
        days: "giorni",
        hypoTitle: "Perdita ipotetica con movimento di mercato/strategia (con leva)",
        move: "Movimento",
        loss: "Perdita",
        remaining: "Capitale residuo",
        wiped: "Conto azzerato",
        ddChart: "Andamento del drawdown",
        milestones: "Traguardi – recupero del capitale iniziale",
        milestoneReached: "Traguardo raggiunto: {th} % del capitale iniziale recuperato!",
        reachedOn: "raggiunto il",
        open: "aperto",
        generatePost: "Genera post",
        milestoneContext: "Traguardo raggiunto: {th} % del capitale iniziale recuperato tramite prelievi (il {date}).",
        warnTitle: "Avvertenze",
        warnings: {
          liquidation_close: "Con leva {lev}x basta già un movimento di circa -{liq} % per una perdita totale (liquidazione).",
          drawdown_high: "Il drawdown massimo supera il 15 % – rischio elevato.",
          loss_streak: "Serie di perdite attuale di 3+ giorni – verificare criticamente la strategia.",
          big_daily_loss: "C'è già stata una perdita giornaliera superiore al 5 % – alta volatilità.",
          none: "Nessun avviso acuto. Il rischio di base dovuto alla leva rimane."
        }
      },
      settings: {
        title: "Parametri dell'esperimento",
        description: "Questi valori controllano l'intero esperimento: calcoli della dashboard, suggerimento di prelievo, linea del piano e indicatori di rischio.",
        startCapital: "Capitale iniziale ($)",
        leverage: "Fattore di leva",
        reinvestRate: "Quota di reinvestimento (%)",
        payoutRate: "Quota di prelievo (%)",
        monthlyTarget: "Rendimento mensile obiettivo (%)",
        journeyDays: "Durata obiettivo del viaggio (giorni)",
        goalAmount: "Obiettivo di saldo ($)",
        sumHint: "Nota: reinvestimento + prelievo non sommano al 100 %.",
        save: "Salva",
        saved: "Impostazioni salvate",
        preview: "Anteprima",
        leverageWarning: "Attenzione: con leva {lev}x basta un movimento di circa -{liq} % per la perdita totale."
      },
      share: {
        live: "Live · Esperimento pubblico",
        subtitle: "Esperimento di copy trading trasparente – tutti i numeri senza abbellimenti, perdite incluse.",
        copyLink: "Copia link di condivisione",
        copied: "Link copiato",
        historySubtitle: "Storico reale di 21 mesi di trade – simula tu stesso cosa sarebbe successo al tuo ingresso.",
        calcTitle: "Calcola il tuo possibile percorso futuro",
        calcHero1: "Calcola il tuo possibile",
        calcHeroHighlight: "percorso futuro",
        tabHistory: "Storico trade",
        tabCalc: "Calcolatore",
        tabJourney: "Il mio viaggio",
        tabLive: "Dashboard live",
        hero1: "La tua",
        heroHighlight: "performance",
        hero2: "sotto controllo",
        config: "La tua configurazione",
        configStart: "Capitale iniziale",
        configLeverage: "Leva / fattore",
        configPayout: "Quota di prelievo",
        configEdit: "Modifica configurazione",
        quote: "Disciplina oggi, libertà domani.",
        quoteSub: "Il tuo obiettivo. Il tuo percorso. Il tuo successo.",
        footerLine: "Trasparenza. Disciplina. Successo.",
        historyBadge: "Trade reali · Documentati storicamente",
        copyHistoryLink: "Copia link pubblico dello storico",
        toDashboard: "Alla dashboard live",
        toHistory: "Allo storico dei trade"
      },
      weekly: {
        title: "Aggiornamento settimanale in scadenza",
        desc: "Periodo {since} – {until} · {days} giorni tracciati · Profitto {profit} · Prelievi {payout} · Rendimento {return}",
        context: "Aggiornamento settimanale per il periodo da {since} a {until}: profitto {profit}, prelievi {payout}, rendimento settimanale {return}, {days} giorni tracciati.",
        generate: "Genera aggiornamento settimanale",
        dismiss: "Più tardi"
      },
      history: {
        title: "Backtest storico",
        subtitle: "Basato su {trades} trade reali (da {first} a {last}, {months} mesi). Cosa sarebbe successo al tuo ingresso?",
        startCapital: "Capitale iniziale ($)",
        leverage: "Leva / fattore di copia",
        payoutRate: "Quota di prelievo (%)",
        endBalance: "Saldo finale",
        endBalanceFull: "Senza prelievi (100 % reinvestito)",
        totalPayouts: "Somma prelievi",
        totalReturn: "Rendimento totale (incl. prelievi)",
        maxDrawdown: "Drawdown max",
        avgMonthly: "Ø rendimento mensile",
        winRate: "Tasso di successo dei trade",
        bestDay: "Giorno migliore",
        worstDay: "Giorno peggiore",
        breakeven: "Break-even (prelievi ≥ capitale iniziale)",
        breakevenDouble: "Break-even (saldo ≥ 2× deposito)",
        payoutEur: "Prelievo ($/mese)",
        feeNote: "Tutti i valori includono il 30 % di partecipazione agli utili dei trader (detratto ogni venerdì dal profitto lordo settimanale, solo nelle settimane positive).",
        simpleReturn: "Rendimento senza compounding",
        simpleReturnSub: "Profitti non reinvestiti",
        breakevenMonths: "dopo {m} mesi",
        breakevenWeeks: "≈ {w} settimane · raggiunto il {date}",
        breakevenNot: "Non raggiunto nel periodo",
        curve: "Andamento del capitale (simulazione storica)",
        withPayout: "Saldo (con prelievi)",
        fullReinvest: "100 % reinvestito",
        cumPayout: "Prelievi cumulati",
        monthlyTable: "Andamento mensile",
        note: "Simulazione storica basata su trade passati. I risultati passati NON garantiscono il futuro – con leva {lev}x il drawdown massimo è stato del {dd} %. La perdita totale è sempre possibile.",
        loading: "Calcolo in corso ...",
        noData: "Nessun trade storico trovato.",
        upload: "Aggiorna trade (CSV)",
        uploadOk: "{n} trade importati (fino al {last})",
        uploadFail: "Importazione fallita",
        dataStatus: "Dati: {n} trade · ultimo trade {last}",
        mfbStatus: "myfxbook live: {gain} % gain · {dd} % drawdown",
        mfbLink: "Vedi lo storico verificato su Myfxbook"
      },
      stats: {
        title: "Analisi dei trade",
        profitFactor: "Fattore di profitto",
        profitFactorSub: "Profitto lordo ÷ perdita lorda",
        avgWin: "Ø trade vincente",
        avgLoss: "Ø trade perdente",
        longWinRate: "Successo long",
        shortWinRate: "Successo short",
        avgDuration: "Ø durata trade",
        byWeekday: "Performance per giorno della settimana",
        byHour: "Performance per ora",
        byMonth: "Performance per mese",
        pips: "Pips",
        winShort: "Successo",
        winTrades: "Trade vincenti",
        lossTrades: "Trade perdenti",
        weekdaysShort: ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"]
      },
      journey: {
        heroTitle: "Il mio cammino verso la libertà finanziaria",
        publicNote: "Quello che vedi qui è il mio conto di trading personale, che documento giorno per giorno in modo trasparente – con tutti i profitti, le perdite e le battute d'arresto. Condivido questo viaggio per registrare le mie esperienze. Tutti i contenuti sono solo a scopo informativo e non costituiscono raccomandazione o consulenza.",
        heroSubtitle: "Ogni trade mi avvicina al mio obiettivo. Questo progetto documenta in modo trasparente tutto il mio percorso – profitti, perdite e battute d'arresto inclusi.",
        dayLabel: "Il mio viaggio",
        day: "Giorno {d} di {total}",
        totalProfit: "Profitto totale dall'inizio",
        remaining: "Manca al recupero del capitale",
        balance: "Saldo attuale",
        doneShort: "Fatto!",
        capitalBack: "Recuperare il capitale iniziale",
        capitalBackDone: "Capitale iniziale completamente recuperato",
        goal: "Obiettivo: {goal}",
        goalHint: "Riferito al saldo – obiettivo modificabile nelle impostazioni.",
        payoutIncluded: "di cui prelevato (già nel profitto)",
        todayProfit: "Profitto oggi",
        lastProfit: "Ultimo giorno di trading",
        winStreak: "Serie di vincite",
        days: "giorni",
        roi: "ROI",
        timeline: "Il mio viaggio – giorno per giorno",
        win: "Profitto",
        loss: "Perdita",
        noTrade: "Nessun trade",
        trades: "trade",
        tradesOne: "trade",
        balanceArrow: "Saldo",
        achievements: "Traguardi",
        achievedAt: "Raggiunto il {date}",
        locked: "Non ancora raggiunto",
        newAchievement: "Nuovo traguardo raggiunto:",
        goalBanner: "Il tuo obiettivo ti aspetta all'orizzonte – non mollare.",
        quotes: [
          "La costanza batte il talento.",
          "Piccoli passi portano a grandi obiettivi.",
          "La disciplina è il ponte tra obiettivo e successo.",
          "Ogni trade è solo un altro passo sul tuo cammino.",
          "Non vince la perfezione – ma la costanza.",
          "Il momento migliore per iniziare era ieri. Il secondo migliore è oggi."
        ],
        a: {
          first_trade: "Primo trade",
          first_payout: "Primo prelievo",
          profit_100: "100 $ di profitto",
          profit_500: "500 $ di profitto",
          profit_1000: "1.000 $ di profitto",
          capital_back: "Capitale iniziale recuperato",
          streak_10: "10 giorni di profitto di fila",
          trades_100: "100 trade",
          balance_10k: "Saldo di 10.000 $",
          balance_50k: "Saldo di 50.000 $",
          balance_100k: "Saldo di 100.000 $"
        }
      },
      auth: {
        title: "Area protetta",
        desc: "Inserisci la password per gestire la dashboard. Le pagine pubbliche restano liberamente accessibili.",
        password: "Password",
        login: "Accedi",
        back: "Torna alla panoramica",
        error: "Password errata",
        locked: "Troppi tentativi – attendi 15 minuti.",
        logout: "Esci",
        email: "E-mail (login membri)",
        forgot: "Password dimenticata?",
        forgotPanel: {
          backShort: "indietro",
          title: "Reimposta password",
          desc: "Inserisci la tua e-mail. Se esiste un account, ti invieremo un link di reset.",
          emailLabel: "E-mail",
          emailPh: "tua@email.com",
          submit: "Invia link di reset",
          done: {
            title: "E-mail inviata",
            desc: "Se esiste un account con questa e-mail, troverai nella tua casella un link per reimpostare la password. Il link è valido per 2 ore.",
            toLogin: "Torna al login",
          },
        },
        reset: {
          title: "Reimposta password",
          newPw: "Nuova password",
          confirmPw: "Conferma nuova password",
          submit: "Imposta password",
          intro: "Inserisci la tua nuova password (minimo 8 caratteri).",
          pwTooShort: "Password troppo corta (min. 8 caratteri)",
          pwMismatch: "Le password non coincidono",
          invalidToken: "Il link di reset non è valido o è incompleto.",
          genericError: "Errore durante il reset. Il link potrebbe essere scaduto.",
          done: {
            title: "Password modificata",
            desc: "Ora puoi accedere con la nuova password. Reindirizzamento …",
          },
        },
      },
      footer: "Esperimento personale. Rendimenti storici e attesi non garantiscono risultati futuri. La perdita totale è possibile. La leva amplifica profitti e perdite allo stesso modo. Questa non è consulenza finanziaria.",
      error: "Errore – riprova",
      academy: {
        close: "Chiudi",
        completed: "Completato",
        lessons: "Lezioni",
        markComplete: "Segna come completato",
        markIncomplete: "Annulla",
        minutes: "Min.",
        noLessons: "Nessuna lezione disponibile per ora.",
        overallProgress: "Progresso totale",
        startLesson: "Apri",
        subtitle: "Lezioni brevi su basi, gestione del rischio, copy trading e tasse.",
        title: "Accademia",
        videoLabel: "Video"
      },
      admin: {
        actions: "Azioni",
        activate: "Abilita",
        confirmDelete: "Vuoi davvero eliminare?",
        createInvite: "Crea link d’invito",
        days: "Giorni",
        delete: "Elimina",
        docContentDe: "Contenuto (DE)",
        docContentEn: "Contenuto (EN)",
        docDraft: "Bozza",
        docKey: "Chiave",
        docOrder: "Ordine",
        docPublished: "Pubblicato",
        docTitleDe: "Titolo (DE)",
        docTitleEn: "Titolo (EN)",
        docVersion: "Versione",
        edit: "Modifica",
        invExpired: "Scaduto",
        invOpen: "Aperto",
        invRevoked: "Revocato",
        invUsed: "Utilizzato",
        invitations: "Inviti",
        inviteCreated: "Invito creato – link copiato negli appunti",
        inviteExpiry: "Validità",
        inviteHint: "Il link viene copiato automaticamente alla creazione. Inviarlo via e-mail o messenger al nuovo membro. Ogni link è utilizzabile una sola volta.",
        inviteLabel: "Etichetta",
        inviteLabelPh: "es. nome dell’invitato",
        inviteRevoked: "Invito revocato",
        lock: "Blocca",
        members: "Membri",
        newDoc: "Nuovo documento",
        newPwFor: "Nuova password per",
        publish: "Pubblica",
        publishHint: "La pubblicazione aumenta la versione e tutti i membri devono accettare di nuovo.",
        publishNew: "Pubblica nuova versione",
        pwReset: "Password reimpostata",
        resetPw: "Imposta password",
        riskDocs: "Documenti di rischio",
        riskDocsHint: "Gestisci qui i documenti di rischio che ogni membro deve confermare prima di usare il portale. Pubblicando una nuova versione, tutti i membri devono accettare di nuovo.",
        role: "Ruolo",
        save: "Salva",
        saved: "Salvato",
        statuses: {
          active: "Attivo",
          disabled: "Disattivato",
          locked: "Bloccato",
          pending: "In attesa di attivazione"
        }
      },
      audit: {
        action: "Azione",
        actor: "Attore",
        meta: "Dettagli",
        subtitle: "Registro cronologico di tutte le modifiche importanti nel portale.",
        target: "Destinazione",
        timestamp: "Data/ora",
        title: "Audit log"
      },
      calendar: {
        allCategories: "Tutte le categorie",
        confirmDelete: "Vuoi davvero eliminare questo appuntamento?",
        created: "Appuntamento creato",
        deleted: "Appuntamento eliminato",
        duration: "Durata",
        editEvent: "Modifica appuntamento",
        fields: {
          category: "Categoria",
          description: "Descrizione",
          descriptionPh: "Dettagli, agenda, note …",
          endAt: "Fine (opzionale)",
          link: "Link (Zoom / Meet / webinar)",
          linkPh: "https://…",
          location: "Luogo (opzionale)",
          locationPh: "es. Online, Zoom, Berlino",
          recurrence: "Ricorrenza",
          recurrenceNone: "Nessuna (una tantum)",
          recurrenceUntil: "Ripeti fino al (opzionale)",
          recurrenceWeekly: "Ogni settimana",
          startAt: "Inizio",
          title: "Titolo",
          titlePh: "es. Live call settimanale"
        },
        ical: {
          close: "Chiudi",
          detectedUrl: "Rilevato e convertito in",
          enabledLabel: "Auto-sync attivo",
          lastError: "Ultimo errore",
          lastSync: "Ultima sincronizzazione",
          neverSynced: "Mai sincronizzato",
          openAdmin: "Importa Google Calendar",
          save: "Salva URL",
          stats: "{added} aggiunti · {updated} aggiornati · {removed} rimossi",
          subtitle: "Incolla l’URL iCal segreto o un link di embed pubblico del tuo Google Calendar: lo convertiamo automaticamente. Si sincronizza ogni ora.",
          syncNow: "Sincronizza ora",
          title: "Importa Google Calendar",
          urlLabel: "URL iCal o calendario",
          urlPh: "https://calendar.google.com/calendar/..."
        },
        joinLink: "Vai all’evento",
        months: [
          "Gennaio",
          "Febbraio",
          "Marzo",
          "Aprile",
          "Maggio",
          "Giugno",
          "Luglio",
          "Agosto",
          "Settembre",
          "Ottobre",
          "Novembre",
          "Dicembre"
        ],
        moreEvents: "+ altri {n}",
        newEvent: "Nuovo evento",
        next: "Avanti",
        noEvents: "Nessun evento questo mese.",
        noUpcoming: "Nessun evento in arrivo.",
        prev: "Indietro",
        recurringBadge: "Settimanale",
        recurringUntil: "fino al {date}",
        save: "Salva",
        subtitle: "Tutte le live call, i webinar e le finestre di manutenzione a colpo d’occhio.",
        title: "Calendario",
        today: "Oggi",
        upcoming: "Prossimi appuntamenti",
        updated: "Appuntamento aggiornato",
        weekdaysShort: ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"],
        when: "Orario"
      },
      heroSubtitles: {
        academy: "Lezioni brevi, tutorial e risorse",
        adminAcademy: "Gestisci categorie e lezioni della knowledge base",
        adminSupport: "Panoramica di tutti i ticket di supporto",
        audit: "Log cronologico di tutte le azioni nel portale",
        calculator: "Simula rendimenti, leva e prelievi",
        calendar: "Live call, webinar e appuntamenti – tutto a colpo d’occhio",
        dashboard: "I tuoi progressi e traguardi nel copy trading",
        history: "Panoramica completa della tua cronologia trade",
        members: "Gestione membri e inviti",
        riskCenter: "I tuoi documenti di rischio e il tuo profilo di rischio personale",
        riskDocs: "Gestisci documenti di rischio versionati",
        settings: "Impostazioni e preferenze del portale",
        social: "Genera automaticamente post per community e social media",
        strategy: "La tua landing page personale e gestione referral",
        support: "Il tuo filo diretto con l'admin del portale – domande e problemi sul Team Portal",
        tracking: "Traccia le tue operazioni in modo preciso e senza lacune"
      },
      kb: {
        backToOverview: "Torna alla panoramica",
        categories: "Categorie",
        close: "Chiudi",
        empty: "Nessun articolo disponibile.",
        featured: "Contenuti consigliati per te",
        items: "Contenuti",
        lessons: "Lezioni",
        minutes: "min",
        noRecent: "Non hai ancora visto nulla.",
        noResults: "Nessun contenuto trovato.",
        popular: "Contenuti popolari",
        readMore: "Apri",
        recent: "Visti di recente",
        relativeDayAgo: "{n} giorno fa",
        relativeDaysAgo: "{n} giorni fa",
        relativeToday: "oggi",
        relativeYesterday: "ieri",
        searchPh: "Cerca argomenti, corsi o contenuti…",
        showAll: "Mostra tutto",
        subtitle: "Argomenti, tutorial e risorse selezionati.",
        title: "Knowledge Base",
        typeArticle: "Articolo",
        typeCourse: "Corso",
        typeFaq: "FAQ",
        typeGuide: "Guida",
        typeQuiz: "Quiz",
        typeVideo: "Video",
        videoLabel: "Video",
        viewsSuffix: "visualizzazioni"
      },
      landing: {
        copied: "Copiato negli appunti",
        copyUrl: "Copia URL",
        notSet: "Inserisci prima uno slug.",
        openPreview: "Apri anteprima",
        refHint: "Deve iniziare con http(s)://. Questo link viene usato su tutti i pulsanti CTA della tua landing page.",
        refLabel: "Il tuo link dal back office CopyXapp / IB Portal (in Profile, il link sotto Partner → Copia link)",
        refPh: "https://...?ref=...",
        save: "Salva",
        saved: "Landing page aggiornata",
        slugHint: "2–30 caratteri, a–z, 0–9 e trattino. Diventa parte del tuo URL.",
        slugLabel: "Il tuo slug personale",
        slugPh: "es. max, sonic-max, max-2026",
        slugTaken: "Questo slug è già in uso.",
        subtitle: "Crea il tuo link personale e inserisci il tuo link referral. Tutti i pulsanti CTA della landing page pubblica rimanderanno al tuo referral.",
        title: "La tua landing page",
        yourUrl: "Il tuo URL pubblico"
      },
      onboarding: {
        accepted: "Confermato",
        allAccepted: "Tutti i documenti confermati",
        back: "Indietro",
        completed: "Portale sbloccato",
        finish: "Sblocca il portale",
        maxLoss: "Tolleranza perdita max (%)",
        maxLossHint: "A partire da questo drawdown vuoi intervenire o essere avvisato.",
        next: "Avanti",
        of: "di",
        openDoc: "Visualizza",
        payoutRate: "Quota di payout (%)",
        pendingHint: "Ancora in sospeso: {n}",
        readAndAccept: "Ho letto e compreso",
        reconsentDesc: "Abbiamo aggiornato uno o più documenti sul rischio. Leggi e conferma la nuova versione per continuare a usare il tuo portale.",
        reconsentTitle: "Documenti sul rischio aggiornati",
        startCapital: "Capitale iniziale ($)",
        step: "Step",
        step1Desc: "Breve introduzione al portale. Qui tracci in modo trasparente il tuo percorso di copy trading, registri i payout e tieni sotto controllo il rischio.",
        step1Points: [
          "I tuoi dati sono privati: li vedi solo tu e l’admin.",
          "Il trading è ad alto rischio. Ci limitiamo a mostrare i dati, non diamo consulenza.",
          "Tutti i rendimenti si basano sui tuoi inserimenti reali."
        ],
        step1Title: "Benvenuto",
        step2Desc: "Leggi con attenzione ogni documento e conferma singolarmente di averne compreso il contenuto.",
        step2Title: "Conferma i documenti sul rischio",
        step3Desc: "Definisci i parametri iniziali. Puoi modificarli in qualsiasi momento nel Centro Rischio.",
        step3Title: "Profilo di rischio personale",
        step4Desc: "Controlla i tuoi dati e sblocca il portale.",
        step4Title: "Riepilogo",
        subtitle: "Segui i passaggi seguenti per sbloccare il tuo portale personale.",
        summaryDocs: "Documenti confermati",
        summaryProfile: "Il tuo profilo di rischio",
        targetLeverage: "Fattore di copia target",
        title: "Benvenuto in Team Phoenix"
      },
      personal: {
        currentDrawdown: "Drawdown attuale",
        currentGain: "Profitto attuale",
        entries: "Voci",
        goalDouble: "Raddoppiare il capitale",
        goalGain: "Profitto target",
        leverageTarget: "Leva target",
        lossToleranceNear: "La perdita si avvicina alla tua tolleranza.",
        lossToleranceReached: "Tolleranza di perdita superata: controlla il setup del rischio.",
        maxDrawdown: "Drawdown max",
        openRiskCenter: "Vai al Centro Rischio",
        payoutRateActual: "Effettivo",
        payoutRateGoal: "Obiettivo di prelievo",
        profileMissing: "Configura prima il tuo profilo di rischio.",
        progress: "Progresso",
        subtitle: "Il tuo progresso personale rispetto agli obiettivi del profilo di rischio.",
        title: "Il mio progresso"
      },
      register: {
        desc: "Sei stato invitato al portale membri di Team Phoenix. Crea il tuo account personale.",
        displayName: "Nome e cognome",
        email: "E-mail",
        expired: "Questo invito è scaduto. Richiedi un nuovo link di invito.",
        invalid: "Questo invito non è valido o è già stato utilizzato. Contatta il tuo referente.",
        password: "Password (min. 8 caratteri)",
        password2: "Ripeti password",
        pendingMsg: "Registrazione riuscita! Il tuo account deve ancora essere attivato da un amministratore.",
        pwMismatch: "Le password non coincidono.",
        pwShort: "La password deve avere almeno 8 caratteri.",
        riskNote: "Con la registrazione confermi che questo portale è a scopo di documentazione e non costituisce consulenza finanziaria. Il trading può comportare la perdita totale.",
        submit: "Crea account",
        title: "Registrazione (solo su invito)"
      },
      riskCenter: {
        acceptedOn: "Confermato il",
        close: "Chiudi",
        docsSection: "Documenti sui rischi",
        notAccepted: "Non ancora confermato",
        profileSection: "Il tuo profilo di rischio",
        profileUpdated: "Profilo aggiornato",
        reAccept: "Conferma nuova versione",
        subtitle: "I tuoi documenti accettati e il tuo profilo di rischio personale.",
        title: "Centro rischi",
        updateProfile: "Salva profilo",
        version: "Versione",
        view: "Visualizza"
      },
      support: {
        admin: "Supporto",
        adminSubtitle: "Tutte le richieste dei membri. Rispondi direttamente dal ticket.",
        adminTitle: "Ticket di supporto",
        created: "Creato",
        filterAll: "Tutti",
        message: "Messaggio",
        messagePh: "Descrivi la tua richiesta nel modo più dettagliato possibile.",
        newTicket: "Nuovo ticket",
        noTickets: "Nessuna richiesta finora.",
        reply: "Rispondi",
        replySent: "Risposta inviata",
        send: "Invia",
        setStatus: "Cambia stato",
        status: "Stato",
        statusClosed: "Chiuso",
        statusInProgress: "In lavorazione",
        statusOpen: "Aperto",
        subject: "Oggetto",
        subjectPh: "es. domanda su una lezione",
        subtitle: "Le tue richieste al team. Rispondiamo il prima possibile.",
        ticketCreated: "Richiesta inviata",
        title: "Supporto",
        unread: "Nuovo",
        updated: "Aggiornato",
        you: "Tu"
      }
    },
  tr: {
      appTitle: "Team Phoenix Portal",
      disclaimer: {
        title: "Devam etmeden önce",
        intro: "Sayfayı kullanmak için lütfen aşağıdaki maddeleri oku ve onayla.",
        items: [
          "Sorumluluk reddini okudum ve anladım: Bu sayfadaki tüm içerikler yatırım, finans, vergi veya hukuk danışmanlığı değildir. Yalnızca site sahibinin kişisel deneyim ve görüşlerinin belgelenmesidir.",
          "Kişisel sorumluluk: Tüm bilgiler yalnızca genel bilgilendirme amaçlıdır. Bu içeriklere dayanarak verdiğim her karar bağımsız olarak ve kendi riskim üzerine gerçekleşir.",
          "Risk uyarısı: Finansal araçlarla (ör. hisse senetleri, fonlar veya kripto varlıklar) işlem yapmak önemli riskler içerir ve yatırılan sermayenin tamamen kaybına yol açabilir. Geçmiş sonuçlar gelecekteki gelişmeler için garanti değildir.",
          "Kendimin de danışmanlık veremeyeceğimin ve tavsiyede bulunamayacağımın farkındayım. Bu sayfa yalnızca kişisel deneyimleri anlatır."
        ],
        yes: "EVET",
        accept: "Kabul et ve devam et",
        ipNote: "Kabul ettiğinde IP adresin kanıt amaçlı kaydedilir."
      },
      tabs: {
        dashboard: "Yolculuğum",
        calculator: "Hesaplayıcı",
        tracking: "Takip",
        history: "Geçmiş",
        strategy: "Strateji",
        risk: "Risk",
        social: "Sosyal",
        settings: "Ayarlar",
        academy: "Bilgi bankası",
        adminAcademy: "Bilgi CMS",
        adminGroup: "Admin",
        adminSupport: "Destek (Admin)",
        audit: "Denetim kaydı",
        calendar: "Takvim",
        marketing: "Pazarlama",
        members: "Üyeler",
        riskCenter: "Risk Merkezi",
        riskDocs: "Risk Dokümanları",
        support: "Portal Support",
        links: "Bağlantılar & e-posta adresleri",
        adminLinks: "Bağlantılar & e-posta (Admin)"
      },
      edu: {
        heroBadge: "Bilgi platformu · Satış yok, vaat yok",
        heroH1a: "Deneyimli trader'lar senin için işlem yapsın —",
        heroH1b: "paran her zaman kendi broker hesabında kalır.",
        heroSub: "Grafik okumana ya da kendin işlem yapmana gerek yok. Doğrulanmış bir strateji otomatik olarak kendi hesabına aynalanır. Kontrol her zaman sende.",
        b1t: "Sermayen sende kalır",
        b1x: "Para kendi broker hesabında – bizde değil.",
        b2t: "İşlemler kopyalanır",
        b2x: "Otomatik – müdahale etmen gerekmez.",
        b3t: "Her şey şeffaf",
        b3x: "Her bir işlem herkese açık şekilde doğrulanabilir.",
        ctaStart: "Hemen başla",
        ctaLearn: "Daha fazla bilgi",
        illBroker: "Broker hesabın",
        illControl: "senin kontrolünde",
        illGold: "Altın",
        illGoldNote: "Stratejinin işlem yaptığı pazar.",
        illApp: "Sonic App",
        illProgress: "İlerleme",
        illLastTrade: "Son işlem",
        illStrategy: "Strateji",
        illActive: "Aktif · Kontrol sende",
        whatEye: "Önce temeller",
        whatTitle: "Copy trading nedir?",
        whatIntro: "Kısaca: deneyimli bir trader karar verir. Bu kararlar otomatik olarak senin hesabına aktarılır. Sen hiçbir şey yapmak zorunda değilsin.",
        whatStep: "Adım",
        whatS1t: "Deneyimli trader",
        whatS1x: "Piyasayı analiz edip kararı verir.",
        whatS2t: "Bir işlem açar",
        whatS2x: "Kendi hesabında alım veya satım emri.",
        whatS3t: "Otomatik senin hesabına",
        whatS3x: "Aynı emir sermayene orantılı olarak aynalanır.",
        whatS4t: "Sonuç sana yansır",
        whatS4x: "Kâr veya zarar hesabında orantılı görünür.",
        whatImportant: "Önemli: sen işlem yapmıyorsun. Stratejiyi kopyalıyorsun. Kararlar trader'da kalır, sermayen sende.",
        howEye: "Süreç",
        howTitle: "Tam olarak nasıl çalışır?",
        howS1t: "Broker hesabı aç",
        howS1x: "TAG Markets'ta ücretsiz hesap – birkaç dakika.",
        howS2t: "Stratejiyi bağla",
        howS2x: "Özel bir servis (COPYX) üzerinden otomatik kopyayı yetkilendirirsin.",
        howS3t: "Trader pozisyon açar",
        howS3x: "Deneyimli trader kendi hesabında kararı verir.",
        howS4t: "İşlem sende görünür",
        howS4x: "Aynı emir hesabına otomatik olarak düşer – müdahale gerekmez.",
        howS5t: "Gelişimi izle",
        howS5x: "Portalda her an her şeyi görürsün – şeffaf ve gerçek zamanlı.",
        skillEye: "Yeni başlayanlar için",
        skillTitle: "Trading bilmem gerekiyor mu?",
        skillNo: "Hayır.",
        skillNoNote: "Ön bilgi gerekmez.",
        skillDesc: "Tüm kararlar deneyimli trader'ın. Sen sadece olanları görür ve bu arada öğrenirsin.",
        skill1: "grafik okumak yok",
        skill2: "piyasa analizi yok",
        skill3: "alım kararı yok",
        skill4: "satım sinyali yok",
        skill5: "haber takibi yok",
        skill6: "pazar günü mesaisi yok",
        moneyEye: "Güven",
        moneyTitle: "Peki param nerede?",
        moneySub: "En önemli soru – ve en basit yanıt:",
        moneyAccLabel: "Broker hesabın",
        moneyAccNote: "Sermayen burada – ve sadece burada – durur.",
        moneyP1t: "Broker hesabında",
        moneyP1x: "Sadece sana ait, regüle edilmiş bir hesap. Bakiyene hiçbir erişimimiz yok.",
        moneyP2t: "Sadece işlem yetkisi",
        moneyP2x: "Strateji yalnızca işlem açabilir – paraya asla dokunamaz.",
        moneyP3t: "Üçüncü tarafa ödeme yok",
        moneyP3x: "Yatırım ve çekimler yalnızca senin ile broker arasında.",
        moneyP4t: "İstediğin zaman duraklat veya iptal et",
        moneyP4x: "Bir tıklama ile durdurabilir ya da tamamen sonlandırabilirsin.",
        moneyCtrl: "Tam kontrol sende kalır.",
        moneyCtrlSub: "Fon yöneticisi yok, saklama yok, üçüncü taraftan ödeme yok.",
        whyEye: "Hedef kitle",
        whyTitle: "İnsanlar neden copy trading kullanır?",
        whyP1t: "“Vaktim yok”",
        whyP1x: "İş, aile, hayat – copy trading sen yaşarken çalışmaya devam eder.",
        whyP2t: "“Deneyimim yok”",
        whyP2x: "Trading bilgisi gerekmez. Strateji karar verir, sen yol boyunca öğrenirsin.",
        whyP3t: "“Şeffaf yatırım istiyorum”",
        whyP3x: "Her işlem doğrulanabilir. Ne olduğunu ve neden olduğunu tam görürsün.",
        whyP4t: "“İşi profesyonellere bırakırım”",
        whyP4x: "Deneyimli trader'ların yılların pratiği var. Kararlarını 1:1 kullanabilirsin.",
        transEye: "Şeffaflık",
        transTitle: "Myfxbook nedir — ve neden önemli?",
        transPara: "Myfxbook, trading hesapları için bağımsız bir doğrulama servisidir. Doğrudan trader'ın broker hesabına bağlanır ve her işlemi otomatik kaydeder – sonradan rakamların &bdquo;güzelleştirilmesi&ldquo; mümkün değildir.",
        trans1: "Her işlem gerçek zamanlı kaydedilir – ay sonu değil.",
        trans2: "Manipülasyon imkânsız: veri doğrudan broker'dan gelir.",
        trans3: "İstediğin zaman bakabilirsin – kamuya açık, girişsiz.",
        trans4: "Zararlar da görünür – sadece kârlar değil. Bu gerçek güven yaratır.",
        transCta: "Kamuya açık geçmişi gör",
        transVer: "Doğrulanmış hesap",
        transLive: "Live",
        transK1: "Toplam işlem",
        transK2: "Kazanma oranı",
        transK3: "Yayında",
        transK4: "Maks. kayıp",
        transK3v: "21 ay",
        transExpl: "&bdquo;Kayıp fazı&ldquo; = bir zirveden takip eden dip noktasına en büyük düşüş. Sayı ne kadar küçükse, eğri o kadar sakindir.",
        oppEye: "Reklam değil dürüstlük",
        oppTitle: "Fırsatlar & riskler – açıkça",
        oppSub: "İkisi birlikte var. Yan yana, süslemeden gösteriyoruz.",
        oppTitleC: "Fırsatlar",
        oppTitleR: "Riskler",
        opp1: "Sermaye (sende) ve strateji (trader'da) kesin ayrı.",
        opp2: "Zamandan tasarruf: piyasa analizi yok, grafik çalışması yok, alarmlı telefon yok.",
        opp3: "Doğrulanmış geçmişle tam şeffaflık.",
        opp4: "Öğrenme eğrisi dahil: bir profesyonel nasıl çalışır görürsün.",
        opp5: "İstediğin zaman duraklat – sözleşme yok, taahhüt yok.",
        risk1: "Kayıplar mümkündür – yatırımın tamamının kaybı dahil.",
        risk2: "Geçmiş performans gelecek sonuçları garanti etmez.",
        risk3: "Piyasa (altın) kısa sürede sert hareket edebilir.",
        risk4: "Broker deneyimi yoksa ilk kurulum biraz zaman alır.",
        risk5: "Kısa vadede ihtiyaç duyacağın sermaye için uygun değildir.",
        faqEye: "SSS",
        faqTitle: "Sık sorulan sorular",
        faqQ1: "Copy trading tam olarak nedir?",
        faqA1: "Copy trading: deneyimli bir trader kararları verir ve bunlar otomatik olarak kendi broker hesabına aktarılır. Sen kendin işlem yapmazsın – stratejiyi kopyalarsın.",
        faqQ2: "Param gerçekten hesabımda mı kalır?",
        faqA2: "Evet. Sermayen sadece sana ait, regüle edilmiş bir broker hesabındadır. Strateji sadece işlem açma yetkisine sahiptir – paraya asla erişim yoktur.",
        faqQ3: "İstediğim zaman durabilir miyim?",
        faqA3: "Evet. Kopyayı tek tıkla duraklatabilir veya tamamen sonlandırabilirsin. Minimum süre yok, ihbar süresi yok.",
        faqQ4: "Kârı nasıl çekerim?",
        faqA4: "Doğrudan broker hesabından kendi banka hesabına. Yatırım ve çekimler yalnızca senin ile broker arasında – bizden geçmez.",
        faqQ5: "Trading deneyimi lazım mı?",
        faqA5: "Hayır. Ön bilgi gerekmez. Strateji tüm kararları yönetir. Daha fazlasını öğrenmek istersen üye portalında yapılandırılmış bir bilgi tabanı var.",
        faqQ6: "Ücreti nedir?",
        faqA6: "Yalnızca sonuç bazlı: gerçekleşen kâra bir performans ücreti. Kâr yoksa ücret yok. Tüm detaylar bağlanmadan önce görünür.",
        faqQ7: "Zarar olursa ne olur?",
        faqA7: "Zararlar piyasanın parçasıdır ve sermayene orantılı şekilde aynalanır. Geçmiş kayıt hem kâr hem zarar dönemlerini açıkça gösterir.",
        faqQ8: "Neden altın?",
        faqA8: "Altın (ticker &bdquo;XAUUSD&ldquo;) dünyanın en likit piyasalarından biridir: dar spread'ler, net hareketler ve 7/24 işlem. Strateji bu pazarın özelliklerine göre optimize edilmiştir.",
        faqQ9: "MT5 nedir?",
        faqA9: "MetaTrader 5 (MT5) yaygın bir trading platformudur. Broker ücretsiz sağlar. Strateji MT5 üzerinden broker'la &bdquo;konuşarak&ldquo; işlem açar. Sen MT5 kullanmak zorunda değilsin.",
        softH1: "Copy trading'in nasıl işlediğini anladıysan,",
        softH2: "stratejinin geçmişte nasıl çalıştığına bakabilirsin.",
        softSub: "Vaat yok, baskı yok. Sadece gerçek, doğrulanmış hesaplardan sayılar.",
        softAgain: "Baştan tekrar oku",
      },
      strategy: {
        badge: "Strateji aktif – canlı çalışıyor",
        hero1: "Otomatik altın ticareti –",
        heroHighlight: "stratejim bir bakışta",
        heroSub: "SONIC stratejisi altını (XAUUSD) deneyimli trader'lar tarafından işler. Her işlem MT5 üzerinden kendi hesabınıza yansıtılır – kendiniz işlem yapmanıza gerek kalmadan. Burada en önemli bilgileri ve başlangıç yolunu bulabilirsiniz.",
        kpiDaily: "Günlük getiri (24x)",
        kpiMonthly: "Aylık getiri (24x)",
        kpiDrawdown: "Maks. düşüş (1x)",
        kpiTrades: "İşlem · Kazanma oranı",
        kpiNote: "Göstergeler gerçek işlem geçmişinden canlı hesaplanır ({months} ay, ücretler öncesi, 24x kaldıraç). Geçmiş sonuçlar gelecek için garanti değildir.",
        cta: "Hemen başla",
        ctaBandTitle: "Bir sonraki adıma hazır mısın?",
        ctaBandSub: "Hesabını bağla ve stratejinin senin için işlem yapmasına izin ver.",
        verified: "Doğrulanmış geçmiş (myfxbook)",
        howTitle: "Nasıl çalışır",
        howSub: "Hesaptan ilk kopyalanan işleme birkaç adımda.",
        step1Title: "Hesabı bağla",
        step1Text: "Kendi MT5 hesabını birkaç dakika içinde stratejiye bağlarsın. Sermaye her zaman kendi hesabında kalır.",
        step2Title: "İşlemler yansıtılır",
        step2Text: "Strateji bir pozisyon açtığında, hesabında otomatik olarak ve gecikmesiz kopyalanır – giriş, çıkış ve pozisyon büyüklüğü dahil.",
        step3Title: "Birlikte yoldayız",
        step3Text: "Birçok ülkeden aktif bir topluluk stratejiyi zaten kullanıyor. Kurulumla ilgili sorularda adım adım destek var.",
        mirrorTitle: "Kendin işlem yapmak yerine kopyala",
        whatTitle: "Copy trading nedir?",
        whatText1: "Copy trading'de bir işlem hesabı mevcut bir stratejiye otomatik olarak bağlanır. Stratejinin yaptığı her işlem, kendi hesabında gerçek zamanlı olarak – hesap büyüklüğüne orantılı şekilde – kopyalanır. Grafik okumana, giriş-çıkış zamanlamana veya işlem deneyimine gerek yok.",
        whatText2: "Klasik fonlardan veya varlık yönetiminden en büyük fark: sermaye her zaman kendi broker hesabında kalır. Senden başka kimsenin erişimi yok – strateji yalnızca işlem yapma yetkisi alır.",
        whatFacts: [
          "Sermaye kendi hesabında kalır – her zaman tam kontrol",
          "İşlemler tamamen otomatik ve gerçek zamanlı kopyalanır",
          "Kopyalama istediğin zaman duraklatılabilir veya tamamen durdurulabilir",
          "Her işlem Myfxbook'ta herkese açık şekilde doğrulanabilir"
        ],
        possTitle: "Bununla hangi imkanlara sahipsin?",
        possSub: "Copy trading esnektir – nasıl kullanacağına sen karar verirsin.",
        poss1Title: "Bileşik faiz etkisini kullan",
        poss1Text: "Kazançlar hesapta kalır ve otomatik olarak işleme dahil edilir. Pozisyon büyüklüğü bakiyeyle birlikte büyür – bileşik faiz etkisi sermayeyi aylar içinde doğrusal birikimden çok daha hızlı büyütebilir.",
        poss2Title: "Düzenli ödemeler",
        poss2Text: "Alternatif olarak kazançların bir kısmı düzenli olarak çekilebilir – örneğin önce yatırılan başlangıç sermayesini geri almak için. Bu noktadan sonra sadece „kasanın parasıyla“ işlem yaparsın.",
        poss3Title: "Kopyalama faktörünü kendin seç",
        poss3Text: "Kopyalama faktörüyle (ör. 12x veya 24x) hesabının stratejiyi ne kadar kaldıraçlayacağını belirlersin. Daha yüksek faktör daha yüksek potansiyel getiri demektir – ama aynı ölçüde daha yüksek kayıp riski.",
        poss4Title: "Tamamen pasif katılım",
        poss4Text: "Tek seferlik kurulumdan sonra her şey otomatik çalışır. Grafik okumak yok, işlem kararları yok, zaman harcamak yok – gelişimi her zaman şeffaf şekilde takip edebilirsin.",
        riskTitle: "Fırsatlar ve riskler – dürüst bir bakış",
        riskSub: "Kaldıraçlı copy trading yüksek riskli bir yatırımdır. Her iki taraf da masaya konmalı.",
        chancesLabel: "Fırsatlar",
        risksLabel: "Riskler",
        chances: [
          "Ortalamanın üzerinde aylık getiriler mümkün – tüm geçmiş Myfxbook'ta doğrulanmış",
          "Kazançların otomatik yeniden yatırımıyla bileşik faiz etkisi",
          "İşlem bilgisi gerekmez – tamamen otomatik uygulama",
          "Tam kontrol: kendi hesabın, istediğin zaman duraklat veya çık"
        ],
        risks: [
          "Kaldıraç her iki yönde de çalışır – kayıplar kazançlar gibi büyütülür",
          "Yatırılan sermayenin tamamen kaybı her an mümkündür",
          "Geçmiş sonuçlar gelecekteki gelişmeler için garanti değildir",
          "Sadece tamamen kaybını kaldırabileceğin sermayeyi yatır"
        ],
        videoTitle: "Copy trading sistemi böyle çalışır",
        videoSub: "Açıklayıcı video sistemin nasıl çalıştığını adım adım gösterir.",
        mirrorText: "Prensip basit: deneyimli bir sistem işlem yapar, hesabın otomatik olarak takip eder. Sermayen üzerinde tam kontrolü korursun ve istediğin zaman duraklatabilir veya çıkabilirsin. Bu sayfada bunun bende nasıl geliştiğini şeffaf şekilde belgeliyorum.",
        disclaimer: "Kişisel deneyim dokümantasyonu – yatırım, finans veya hukuk danışmanlığı değildir ve tavsiye niteliği taşımaz. Finansal araçlarla işlem yapmak önemli riskler içerir ve tam kayba yol açabilir. Her kararı kendi sorumluluğunda verirsin.",
        landing: {
          liveBadge: "Strateji aktif · Canlı sinyal",
          heroHead1: "Otomatik Altın İşlemleri",
          heroHead2: "şeffaf geçmişe sahip.",
          heroSub: "Doğrulanmış bir copy-trading stratejisini kendi broker hesabına yansıt. Sermayen her an senin kontrolünde kalır – tek tıkla duraklat ya da bitir.",
          ctaStart: "Hemen başla",
          ctaLive: "Canlı performansı gör",
          trust: ["Doğrulanmış Myfxbook geçmişi", "Kendi broker hesabın", "İstediğin zaman duraklat", "Sermayen üzerinde tam kontrol"],
          liveDash: "Canlı Panel",
          kpiAvgMonth: "Ø ay",
          kpiWinRate: "Kazanma oranı",
          kpiDrawdown: "Drawdown",
          kpiTrades: "İşlem",
          timelineEyebrow: "Bu kadar basit",
          timelineTitle: "Beş adımda canlı",
          steps: [
            { title: "Broker hesabı aç", text: "TAG Markets'ta birkaç dakikada ücretsiz hesap." },
            { title: "Stratejiyi bağla", text: "COPYX ile copy-trading'i etkinleştir – 2 dakika sürer." },
            { title: "İşlemler yansıtılır", text: "Otomatik, hesabına 1:1. Hiçbir müdahale gerekmez." },
            { title: "Gelişimi izle", text: "Üye portalında ve Myfxbook'ta günlük ilerleme." },
            { title: "Topluluğu kullan", text: "Canlı yayınlar, bilgi tabanı, doğrudan destek." },
          ],
          perfEyebrow: "Gerçek & doğrulanmış",
          perfTitle: "İlk günden beri canlı performans",
          perfSub: "1 000 $ başlangıçlı hesapta simüle edilmiş net sermaye eğrisi (24× amplifiye, %30 performans-ücreti düşülmüş) – her işlem kesintisiz belgelendi.",
          perfAvgMonth: "Ø ay (net)",
          perfWinRate: "Kazanma oranı",
          perfDrawdown: "Max drawdown",
          perfMonths: "Ay canlı",
          perfChartLabel: "Sermaye eğrisi",
          perfSourceLine1: "Canlı veri kaynağı: history_trades.",
          perfSourceLine2: "Broker & performans ücretleri sonrası simülasyon.",
          perfMilestones: "Kilometre taşları",
          perfMilestoneGoal: "Hedef",
          perfMilestoneReached: "Ulaşıldı:",
          perfMilestoneOpen: "Henüz açık",
          portalEyebrow: "Üye alanın",
          portalTitle: "Her şey tek yerde. Sade. Net. Senin.",
          portalSub: "Üye olarak yolculuğunu yapılandıran üç temel araca sahip olursun – başlangıç sermayesinden ilk çekime kadar.",
          journeyLabel: "Yolculuğum",
          journeyLive: "Canlı",
          journeySub: "Net ilerleme · 6 ay",
          journeyMilestone: "Kilometre taşı",
          journeyReached: "ulaşıldı",
          journeyShare: "Herkese açık link ile paylaşılabilir · PDF dışa aktar",
          calendarLabel: "Takvim",
          calendarMonth: "Şubat 2026",
          calendarSub: "4 topluluk etkinliği · .ics dışa aktar",
          calendarNext: "Sonraki etkinlik",
          calendarNextText: "Canlı Q&A · 18 Şub · 19:00",
          kbLabel: "Bilgi Tabanı",
          kbTitle: "AI Q&A · Anlık yanıtlar",
          kbSub: "Seçilmiş dersler · Yapay zekâ destekli arama",
          kbUserQ: "Sorun",
          kbUserQText: "Başlangıç sermayem ne kadar olmalı?",
          kbAI: "Sonic AI yanıtlıyor",
          kbAnswer: "24× hesapta 1 000 €'dan başlaması önerilir. Daha küçük tutarlar mümkün ancak bileşik etkiyi belirgin biçimde yavaşlatır…",
          kbLatency: "0,8 s · 24 derse dayalı",
          cardJourney: { title: "Yolculuğum", desc: "Kilometre taşları belirle, net ilerlemeni izle ve herkese açık bir link ile paylaş." },
          cardCalendar: { title: "Takvim", desc: "Canlı yayınlar, Q&A oturumları ve işlem özetleri – \"Takvime ekle\" tek tıkla .ics dosyası oluşturur." },
          cardKb: { title: "Bilgi Tabanı", desc: "Seçilmiş dersler ve yapay zekâ destekli arama. \"Sermayem ne kadar olmalı?\" gibi sorular saniyeler içinde yanıtlanır." },
          ctaMember: "Üye ol",
        },
      },
      kpi: {
        startCapital: "Başlangıç sermayesi",
        currentBalance: "Güncel bakiye",
        totalProfit: "Toplam kazanç",
        totalPayouts: "Ödemeler",
        netProfit: "Net kazanç",
        totalReturn: "Toplam getiri",
        monthlyReturn: "Aylık getiri",
        dailyReturn: "Ø günlük getiri",
        volume: "İşlem hacmi",
        leverage: "Kaldıraç"
      },
      recovery: "Başlangıç sermayesinin geri kazanımı",
      recoveryHint: "ödemelerle geri alındı",
      growthChart: "Büyüme eğrisi",
      balance: "Bakiye",
      planLine: "Plan ({target} %/ay)",
      payoutsCurve: "Kümülatif ödemeler",
      monthlyTable: "Aylık özet",
      month: "Ay",
      profit: "Kazanç",
      fees: "Ücretler",
      feesHint: "Komisyon: −{c} · Prim: −{p}",
      payout: "Ödeme",
      trades: "İşlemler",
      return: "Getiri",
      endBalance: "Kapanış bakiyesi",
      noData: "Henüz kayıt yok. İlk gününü takibe ekle.",
      calc: {
        title: "Bileşik faiz hesaplayıcı",
        startCapital: "Başlangıç sermayesi ($)",
        monthlyReturn: "Aylık getiri (%)",
        months: "Süre (ay)",
        reinvestRate: "Yeniden yatırım oranı (%)",
        payoutRate: "Ödeme oranı (%)",
        leverage: "Kaldıraç faktörü",
        compare: "Karşılaştırma: %100 yeniden yatırım vs. ödeme stratejisi",
        fullReinvest: "%100 yeniden yatırıldı",
        withPayout: "ödemelerle",
        cumPayout: "Kümülatif ödemeler",
        tableTitle: "Aylık gelişim",
        balanceEnd: "Bakiye",
        volume: "Hacim",
        totalWithPayout: "Ödemeler dahil son değer",
        totalFull: "%100 yeniden yatırılmış son değer",
        payoutSum: "Ödemeler toplamı",
        breakeven: "Başabaş (ödemeler ≥ başlangıç sermayesi)",
        breakevenDouble: "Başabaş (bakiye ≥ 2× yatırım)",
        payoutEur: "Ödeme ($/ay)",
        effReturn: "≙ {lev}x ile aylık efektif {eff} %",
        histAvgNote: "Ön dolu: tarihsel ortalama {avg} % (24x'te, kâr payı öncesi)",
        feeNote: "− %30 kâr payı (her cuma haftalık kazançtan kesilir) ≙ net aylık {net} %",
        noCompound: "Bileşik faizsiz: {v}",
        breakevenMonths: "{m} ay sonra",
        breakevenWeeks: "≈ {w} hafta",
        breakevenNot: "Dönem içinde ulaşılamadı",
        calcDisclaimer: "Model hesaplama – garanti yok. Gerçek getiriler dalgalanır, tam kayıp mümkündür."
      },
      track: {
        title: "Günlük takip",
        date: "Tarih",
        startBalance: "Başlangıç bakiyesi ($)",
        endBalance: "Kapanış bakiyesi ($)",
        payout: "Ödeme ($)",
        commission: "Komisyon ($)",
        traderFee: "Trader primi %30 ($)",
        commissionShort: "Komisyon",
        traderFeeShort: "Prim",
        netProfit: "Net",
        suggestedFee: "Öneri (kazancın %30'u)",
        netPreview: "Ücretler sonrası net",
        trades: "İşlem sayısı",
        note: "Not",
        marketEvent: "Piyasa olayı",
        profitPreview: "Günlük kazanç/kayıp",
        suggestedPayout: "Öneri (kazancın %10'u)",
        apply: "uygula",
        save: "Günü kaydet",
        update: "Güncelle",
        editing: "{date} tarihli kayıt düzenleniyor",
        cancel: "İptal",
        saved: "Kayıt kaydedildi",
        deleted: "Kayıt silindi",
        entries: "Kayıtlar",
        exportCsv: "CSV dışa aktar",
        settings: "Ayarlar",
        settingsStart: "Başlangıç sermayesi ($)",
        settingsLeverage: "Kaldıraç",
        settingsSave: "Kaydet",
        settingsSaved: "Ayarlar kaydedildi",
        reinvested: "Yeniden yatırıldı",
        actions: ""
      },
      social: {
        title: "Sosyal medya üretici",
        type: "Gönderi türü",
        types: {
          daily: "Günlük güncelleme",
          weekly: "Haftalık güncelleme",
          monthly: "Aylık güncelleme",
          milestone: "Kilometre taşı",
          loss: "Dürüst kayıp güncellemesi"
        },
        language: "Gönderinin dili",
        context: "Ek bağlam (isteğe bağlı)",
        contextPlaceholder: "ör. bugün güçlü piyasa, %25 kilometre taşına ulaşıldı ...",
        generate: "Gönderi oluştur",
        generating: "Oluşturuluyor ...",
        copy: "Kopyala",
        copied: "Panoya kopyalandı",
        empty: "Oluşturulan gönderi burada görünecek.",
        note: "Her gönderi otomatik olarak risk uyarısıyla biter."
      },
      risk: {
        title: "Risk takibi",
        worstDay: "En büyük günlük kayıp",
        maxDrawdown: "Maks. düşüş",
        lossStreak: "En uzun kayıp serisi",
        winStreak: "En yüksek kazanç serisi",
        currentStreak: "Güncel seri",
        liqDistance: "Likidasyona uzaklık",
        days: "gün",
        hypoTitle: "Piyasa/strateji hareketinde varsayımsal kayıp (kaldıraçlı)",
        move: "Hareket",
        loss: "Kayıp",
        remaining: "Kalan sermaye",
        wiped: "Hesap silindi",
        ddChart: "Düşüş grafiği",
        milestones: "Kilometre taşları – başlangıç sermayesinin geri kazanımı",
        milestoneReached: "Kilometre taşına ulaşıldı: başlangıç sermayesinin %{th} kadarı geri alındı!",
        reachedOn: "ulaşıldığı tarih",
        open: "açık",
        generatePost: "Gönderi oluştur",
        milestoneContext: "Kilometre taşına ulaşıldı: başlangıç sermayesinin %{th} kadarı ödemelerle geri alındı ({date} tarihinde).",
        warnTitle: "Uyarılar",
        warnings: {
          liquidation_close: "{lev}x kaldıraçta yaklaşık -%{liq} hareket bile tam kayba (likidasyon) yeter.",
          drawdown_high: "Maksimum düşüş %15'i aşıyor – artan risk.",
          loss_streak: "3+ günlük güncel kayıp serisi – stratejiyi eleştirel gözden geçir.",
          big_daily_loss: "%5'in üzerinde bir günlük kayıp yaşandı – yüksek volatilite.",
          none: "Akut uyarı yok. Kaldıraçtan kaynaklanan temel risk devam ediyor."
        }
      },
      settings: {
        title: "Deney parametreleri",
        description: "Bu değerler tüm deneyi kontrol eder: gösterge paneli hesaplamaları, ödeme önerisi, plan çizgisi ve risk göstergeleri.",
        startCapital: "Başlangıç sermayesi ($)",
        leverage: "Kaldıraç faktörü",
        reinvestRate: "Yeniden yatırım oranı (%)",
        payoutRate: "Ödeme oranı (%)",
        monthlyTarget: "Hedef aylık getiri (%)",
        journeyDays: "Yolculuğun hedef süresi (gün)",
        goalAmount: "Bakiye hedefi ($)",
        sumHint: "Not: yeniden yatırım + ödeme toplamı %100 etmiyor.",
        save: "Kaydet",
        saved: "Ayarlar kaydedildi",
        preview: "Önizleme",
        leverageWarning: "Dikkat: {lev}x kaldıraçta yaklaşık -%{liq} hareket tam kayba yol açar."
      },
      share: {
        live: "Canlı · Halka açık deney",
        subtitle: "Şeffaf copy trading deneyi – tüm rakamlar olduğu gibi, kayıplar dahil.",
        copyLink: "Paylaşım linkini kopyala",
        copied: "Link kopyalandı",
        historySubtitle: "21 aylık gerçek işlem geçmişi – girişinden ne çıkacağını kendin simüle et.",
        calcTitle: "Olası gelecekteki seyrini hesapla",
        calcHero1: "Olası",
        calcHeroHighlight: "gelecekteki seyrini hesapla",
        tabHistory: "İşlem geçmişi",
        tabCalc: "Hesaplayıcı",
        tabJourney: "Yolculuğum",
        tabLive: "Canlı panel",
        hero1: "Senin",
        heroHighlight: "performansın",
        hero2: "gözünün önünde",
        config: "Senin yapılandırman",
        configStart: "Başlangıç sermayesi",
        configLeverage: "Kaldıraç / faktör",
        configPayout: "Ödeme oranı",
        configEdit: "Yapılandırmayı düzenle",
        quote: "Bugün disiplin, yarın özgürlük.",
        quoteSub: "Senin hedefin. Senin yolun. Senin başarın.",
        footerLine: "Şeffaflık. Disiplin. Başarı.",
        historyBadge: "Gerçek işlemler · Tarihsel olarak belgelenmiş",
        copyHistoryLink: "Geçmişin herkese açık linkini kopyala",
        toDashboard: "Canlı panele git",
        toHistory: "İşlem geçmişine git"
      },
      weekly: {
        title: "Haftalık güncelleme zamanı",
        desc: "Dönem {since} – {until} · {days} gün takip edildi · Kazanç {profit} · Ödemeler {payout} · Getiri {return}",
        context: "{since} - {until} dönemi için haftalık güncelleme: kazanç {profit}, ödemeler {payout}, haftalık getiri {return}, {days} takip edilen gün.",
        generate: "Haftalık güncelleme oluştur",
        dismiss: "Daha sonra"
      },
      history: {
        title: "Tarihsel geriye dönük test",
        subtitle: "{trades} gerçek işleme dayanır ({first} - {last}, {months} ay). Girişinden ne çıkardı?",
        startCapital: "Başlangıç sermayesi ($)",
        leverage: "Kaldıraç / kopyalama faktörü",
        payoutRate: "Ödeme oranı (%)",
        endBalance: "Dönem sonu bakiyesi",
        endBalanceFull: "Ödemesiz (%100 yeniden yatırım)",
        totalPayouts: "Ödemeler toplamı",
        totalReturn: "Toplam getiri (ödemeler dahil)",
        maxDrawdown: "Maks. düşüş",
        avgMonthly: "Ø aylık getiri",
        winRate: "İşlem kazanma oranı",
        bestDay: "En iyi gün",
        worstDay: "En kötü gün",
        breakeven: "Başabaş (ödemeler ≥ başlangıç sermayesi)",
        breakevenDouble: "Başabaş (bakiye ≥ 2× yatırım)",
        payoutEur: "Ödeme ($/ay)",
        feeNote: "Tüm değerler trader'ların %30 kâr payını içerir (her cuma haftalık brüt kazançtan kesilir, sadece pozitif haftalarda).",
        simpleReturn: "Bileşik faizsiz getiri",
        simpleReturnSub: "Kazançlar yeniden yatırılmadı",
        breakevenMonths: "{m} ay sonra",
        breakevenWeeks: "≈ {w} hafta · {date} tarihinde ulaşıldı",
        breakevenNot: "Dönem içinde ulaşılamadı",
        curve: "Sermaye gelişimi (tarihsel simülasyon)",
        withPayout: "Bakiye (ödemelerle)",
        fullReinvest: "%100 yeniden yatırıldı",
        cumPayout: "Kümülatif ödemeler",
        monthlyTable: "Aylık gelişim",
        note: "Geçmiş işlemlere dayalı tarihsel simülasyon. Geçmiş sonuçlar gelecek için GARANTİ DEĞİLDİR – {lev}x kaldıraçta maksimum düşüş %{dd} idi. Tam kayıp her an mümkündür.",
        loading: "Hesaplanıyor ...",
        noData: "Tarihsel işlem bulunamadı.",
        upload: "İşlemleri güncelle (CSV)",
        uploadOk: "{n} işlem içe aktarıldı ({last} tarihine kadar)",
        uploadFail: "İçe aktarma başarısız",
        dataStatus: "Veri: {n} işlem · son işlem {last}",
        mfbStatus: "myfxbook canlı: %{gain} kazanç · %{dd} düşüş",
        mfbLink: "Doğrulanmış geçmişi Myfxbook'ta görüntüle"
      },
      stats: {
        title: "İşlem analizi",
        profitFactor: "Kâr faktörü",
        profitFactorSub: "Brüt kazanç ÷ brüt kayıp",
        avgWin: "Ø kazançlı işlem",
        avgLoss: "Ø kayıplı işlem",
        longWinRate: "Long kazanma oranı",
        shortWinRate: "Short kazanma oranı",
        avgDuration: "Ø işlem süresi",
        byWeekday: "Haftanın gününe göre performans",
        byHour: "Saate göre performans",
        byMonth: "Aya göre performans",
        pips: "Pip",
        winShort: "Kazanma oranı",
        winTrades: "Kazançlı işlemler",
        lossTrades: "Kayıplı işlemler",
        weekdaysShort: ["Pzt", "Sal", "Çar", "Per", "Cum", "Cmt", "Paz"]
      },
      journey: {
        heroTitle: "Finansal özgürlüğe giden yolum",
        publicNote: "Burada gördüğün, her gün şeffaf şekilde belgelediğim kişisel işlem hesabım – tüm kazançlar, kayıplar ve aksiliklerle birlikte. Bu yolculuğu kendi deneyimlerimi kaydetmek için paylaşıyorum. Tüm içerikler yalnızca bilgilendirme amaçlıdır ve tavsiye veya danışmanlık niteliği taşımaz.",
        heroSubtitle: "Her işlem beni hedefime yaklaştırıyor. Bu proje tüm yolumu şeffaf şekilde belgeliyor – kazançlar, kayıplar ve aksilikler dahil.",
        dayLabel: "Yolculuğum",
        day: "Gün {d} / {total}",
        totalProfit: "Başlangıçtan beri toplam kazanç",
        remaining: "Başlangıç sermayesine kalan",
        balance: "Güncel bakiye",
        doneShort: "Başardık!",
        capitalBack: "Başlangıç sermayesini geri al",
        capitalBackDone: "Başlangıç sermayesi tamamen geri alındı",
        goal: "Hedef: {goal}",
        goalHint: "Bakiyeye göre – hedef ayarlardan değiştirilebilir.",
        payoutIncluded: "bunun ödemesi (kâra dahil)",
        todayProfit: "Bugünkü kazanç",
        lastProfit: "Son işlem günü",
        winStreak: "Kazanç serisi",
        days: "gün",
        roi: "ROI",
        timeline: "Yolculuğum – gün gün",
        win: "Kazanç",
        loss: "Kayıp",
        noTrade: "İşlem yok",
        trades: "işlem",
        tradesOne: "işlem",
        balanceArrow: "Bakiye",
        achievements: "Kilometre taşları",
        achievedAt: "{date} tarihinde ulaşıldı",
        locked: "Henüz ulaşılmadı",
        newAchievement: "Yeni kilometre taşına ulaşıldı:",
        goalBanner: "Hedefin ufukta seni bekliyor – devam et.",
        quotes: [
          "İstikrar yeteneği yener.",
          "Küçük adımlar büyük hedeflere götürür.",
          "Disiplin, hedef ile başarı arasındaki köprüdür.",
          "Her işlem yolundaki bir adımdan ibarettir.",
          "Kazanan mükemmellik değil – süreklilik.",
          "Başlamak için en iyi zaman dündü. İkinci en iyi zaman bugün."
        ],
        a: {
          first_trade: "İlk işlem",
          first_payout: "İlk ödeme",
          profit_100: "100 $ kazanç",
          profit_500: "500 $ kazanç",
          profit_1000: "1.000 $ kazanç",
          capital_back: "Başlangıç sermayesi geri alındı",
          streak_10: "Üst üste 10 kazançlı gün",
          trades_100: "100 işlem",
          balance_10k: "10.000 $ bakiye",
          balance_50k: "50.000 $ bakiye",
          balance_100k: "100.000 $ bakiye"
        }
      },
      auth: {
        title: "Korunan alan",
        desc: "Paneli yönetmek için lütfen şifre gir. Herkese açık sayfalar erişilebilir kalır.",
        password: "Şifre",
        login: "Giriş yap",
        back: "Genel görünüme dön",
        error: "Yanlış şifre",
        locked: "Çok fazla deneme – lütfen 15 dakika bekle.",
        logout: "Çıkış yap",
        email: "E-posta (üye girişi)",
        forgot: "Şifremi unuttum?",
        forgotPanel: {
          backShort: "geri",
          title: "Şifreyi sıfırla",
          desc: "E-postanı gir. Bir hesap varsa, sana bir sıfırlama bağlantısı göndereceğiz.",
          emailLabel: "E-posta",
          emailPh: "senin@email.com",
          submit: "Sıfırlama bağlantısı gönder",
          done: {
            title: "E-posta gönderildi",
            desc: "Bu e-posta ile bir hesap varsa, posta kutunda şifre sıfırlama bağlantısını bulacaksın. Bağlantı 2 saat geçerlidir.",
            toLogin: "Girişe dön",
          },
        },
        reset: {
          title: "Şifreyi sıfırla",
          newPw: "Yeni şifre",
          confirmPw: "Yeni şifreyi onayla",
          submit: "Şifreyi ayarla",
          intro: "Lütfen yeni şifreni gir (en az 8 karakter).",
          pwTooShort: "Şifre çok kısa (min. 8 karakter)",
          pwMismatch: "Şifreler eşleşmiyor",
          invalidToken: "Sıfırlama bağlantısı geçersiz veya eksik.",
          genericError: "Sıfırlama başarısız. Bağlantının süresi dolmuş olabilir.",
          done: {
            title: "Şifre değiştirildi",
            desc: "Artık yeni şifrenle giriş yapabilirsin. Yönlendiriliyor …",
          },
        },
      },
      footer: "Kişisel deney. Tarihsel ve beklenen getiriler gelecekteki sonuçların garantisi değildir. Tam kayıp mümkündür. Kaldıraç kazanç ve kayıpları eşit şekilde artırır. Bu finansal danışmanlık değildir.",
      error: "Hata – lütfen tekrar dene",
      academy: {
        close: "Kapat",
        completed: "Tamamlandı",
        lessons: "Dersler",
        markComplete: "Tamamlandı olarak işaretle",
        markIncomplete: "Geri al",
        minutes: "Dak.",
        noLessons: "Henüz ders yok.",
        overallProgress: "Genel ilerleme",
        startLesson: "Aç",
        subtitle: "Temeller, risk yönetimi, copy trading ve vergi üzerine kısa dersler.",
        title: "Akademi",
        videoLabel: "Video"
      },
      admin: {
        actions: "İşlemler",
        activate: "Etkinleştir",
        confirmDelete: "Gerçekten silinsin mi?",
        createInvite: "Davet linki oluştur",
        days: "Gün",
        delete: "Sil",
        docContentDe: "İçerik (DE)",
        docContentEn: "İçerik (EN)",
        docDraft: "Taslak",
        docKey: "Anahtar",
        docOrder: "Sıra",
        docPublished: "Yayınlandı",
        docTitleDe: "Başlık (DE)",
        docTitleEn: "Başlık (EN)",
        docVersion: "Sürüm",
        edit: "Düzenle",
        invExpired: "Süresi doldu",
        invOpen: "Açık",
        invRevoked: "İptal edildi",
        invUsed: "Kullanıldı",
        invitations: "Davetler",
        inviteCreated: "Davet oluşturuldu – link panoya kopyalandı",
        inviteExpiry: "Geçerlilik",
        inviteHint: "Link, oluşturulduğunda otomatik olarak kopyalanır. Yeni üyeye e-posta veya mesajlaşma ile gönder. Her link yalnızca bir kez kullanılabilir.",
        inviteLabel: "Etiket",
        inviteLabelPh: "örn. davet edilenin adı",
        inviteRevoked: "Davet iptal edildi",
        lock: "Kilitle",
        members: "Üyeler",
        newDoc: "Yeni doküman",
        newPwFor: "Şunun için yeni şifre",
        publish: "Yayınla",
        publishHint: "Yayınlamak sürümü artırır ve tüm üyeler yeniden onaylamak zorundadır.",
        publishNew: "Yeni sürüm yayınla",
        pwReset: "Şifre sıfırlandı",
        resetPw: "Şifre ayarla",
        riskDocs: "Risk dokümanları",
        riskDocsHint: "Portal kullanmadan önce her üyenin onaylaması gereken risk dokümanlarını buradan yönet. Yeni bir sürüm yayınladığında tüm üyeler yeniden onaylamak zorundadır.",
        role: "Rol",
        save: "Kaydet",
        saved: "Kaydedildi",
        statuses: {
          active: "Aktif",
          disabled: "Devre dışı",
          locked: "Kilitli",
          pending: "Aktivasyon bekliyor"
        }
      },
      audit: {
        action: "İşlem",
        actor: "İşlemi yapan",
        meta: "Detaylar",
        subtitle: "Portaldaki tüm önemli değişikliklerin kronolojik kaydı.",
        target: "Hedef",
        timestamp: "Zaman",
        title: "Denetim kaydı"
      },
      calendar: {
        allCategories: "Tüm kategoriler",
        confirmDelete: "Bu randevuyu gerçekten silmek istiyor musun?",
        created: "Randevu oluşturuldu",
        deleted: "Randevu silindi",
        duration: "Süre",
        editEvent: "Randevuyu düzenle",
        fields: {
          category: "Kategori",
          description: "Açıklama",
          descriptionPh: "Detaylar, gündem, notlar …",
          endAt: "Bitiş (opsiyonel)",
          link: "Link (Zoom / Meet / webinar)",
          linkPh: "https://…",
          location: "Konum (opsiyonel)",
          locationPh: "örn. Online, Zoom, Berlin",
          recurrence: "Tekrarlama",
          recurrenceNone: "Yok (tek sefer)",
          recurrenceUntil: "Tekrar bitişi (opsiyonel)",
          recurrenceWeekly: "Her hafta",
          startAt: "Başlangıç",
          title: "Başlık",
          titlePh: "örn. Haftalık canlı görüşme"
        },
        ical: {
          close: "Kapat",
          detectedUrl: "Algılandı ve şuna dönüştürüldü",
          enabledLabel: "Otomatik senkron açık",
          lastError: "Son hata",
          lastSync: "Son senkron",
          neverSynced: "Henüz senkronlanmadı",
          openAdmin: "Google Takvim içe aktar",
          save: "URL’yi kaydet",
          stats: "{added} eklendi · {updated} güncellendi · {removed} kaldırıldı",
          subtitle: "Google Takvim’inin gizli iCal URL’sini veya herkese açık embed linkini yapıştır — otomatik çeviriyoruz. Saatlik senkronlanır.",
          syncNow: "Şimdi senkronla",
          title: "Google Takvim içe aktar",
          urlLabel: "iCal veya takvim URL’si",
          urlPh: "https://calendar.google.com/calendar/..."
        },
        joinLink: "Etkinliğe git",
        months: [
          "Ocak",
          "Şubat",
          "Mart",
          "Nisan",
          "Mayıs",
          "Haziran",
          "Temmuz",
          "Ağustos",
          "Eylül",
          "Ekim",
          "Kasım",
          "Aralık"
        ],
        moreEvents: "+ {n} tane daha",
        newEvent: "Yeni etkinlik",
        next: "İleri",
        noEvents: "Bu ay etkinlik yok.",
        noUpcoming: "Yaklaşan etkinlik yok.",
        prev: "Geri",
        recurringBadge: "Haftalık",
        recurringUntil: "{date} tarihine kadar",
        save: "Kaydet",
        subtitle: "Tüm canlı çağrılar, webinarlar ve bakım pencereleri tek bakışta.",
        title: "Takvim",
        today: "Bugün",
        upcoming: "Yaklaşan etkinlikler",
        updated: "Etkinlik güncellendi",
        weekdaysShort: ["Pzt", "Sal", "Çar", "Per", "Cum", "Cmt", "Paz"],
        when: "Saat"
      },
      heroSubtitles: {
        academy: "Kısa dersler, eğitimler ve kaynaklar",
        adminAcademy: "Bilgi bankası kategorilerini ve derslerini yönet",
        adminSupport: "Tüm destek taleplerine genel bakış",
        audit: "Portal işlemlerinin kronolojik kaydı",
        calculator: "Getiri, kaldıraç ve çekimleri simüle et",
        calendar: "Canlı çağrılar, webinarlar ve etkinlikler – hepsi tek bakışta",
        dashboard: "Copy trading’de kişisel ilerlemen ve kilometre taşların",
        history: "Tüm işlem geçmişin tek bakışta",
        members: "Üye yönetimi ve davetler",
        riskCenter: "Risk belgelerin ve kişisel risk profilin",
        riskDocs: "Sürümlü risk belgelerini yönet",
        settings: "Portal ayarları ve tercihlerin",
        social: "Topluluk ve sosyal medya için otomatik gönderi üret",
        strategy: "Kişisel landing page’in ve referral yönetimi",
        support: "Portal yöneticisine doğrudan hattın – Team Portal ile ilgili sorular ve sorunlar",
        tracking: "İşlemlerini düzenli ve eksiksiz kaydet"
      },
      kb: {
        backToOverview: "Genel görünüme dön",
        categories: "Kategoriler",
        close: "Kapat",
        empty: "Henüz içerik yok.",
        featured: "Senin için önerilen içerikler",
        items: "İçerikler",
        lessons: "Dersler",
        minutes: "dk",
        noRecent: "Henüz bir şey izlemedin.",
        noResults: "İçerik bulunamadı.",
        popular: "Popüler içerikler",
        readMore: "Aç",
        recent: "Son görüntülenenler",
        relativeDayAgo: "{n} gün önce",
        relativeDaysAgo: "{n} gün önce",
        relativeToday: "bugün",
        relativeYesterday: "dün",
        searchPh: "Konular, kurslar veya içerikler ara…",
        showAll: "Tümünü göster",
        subtitle: "Özenle seçilmiş konular, eğitimler ve kaynaklar.",
        title: "Bilgi Bankası",
        typeArticle: "Makale",
        typeCourse: "Kurs",
        typeFaq: "SSS",
        typeGuide: "Kılavuz",
        typeQuiz: "Quiz",
        typeVideo: "Video",
        videoLabel: "Video",
        viewsSuffix: "görüntülenme"
      },
      landing: {
        copied: "Panoya kopyalandı",
        copyUrl: "URL'yi kopyala",
        notSet: "Önce bir referans gir.",
        openPreview: "Önizlemeyi aç",
        refHint: "http(s):// ile başlamalı. Bu bağlantı, landing sayfandaki tüm CTA butonlarında kullanılır.",
        refLabel: "CopyXapp / IB Portal Backoffice linkin (Profile altında Partner → Linki kopyala)",
        refPh: "https://...?ref=...",
        save: "Kaydet",
        saved: "Landing sayfası güncellendi",
        slugHint: "2–30 karakter; a–z, 0–9 ve tire. URL'inin bir parçası olur.",
        slugLabel: "Kişisel referansın",
        slugPh: "örn. max, sonic-max, max-2026",
        slugTaken: "Bu referans zaten alınmış.",
        subtitle: "Kişisel referansını oluştur ve IB Portal Backoffice linkini ekle. Herkese açık landing sayfasındaki tüm CTA butonları sonra bu linke gider.",
        title: "Landing sayfan",
        yourUrl: "Herkese açık URL'in"
      },
      onboarding: {
        accepted: "Onaylandı",
        allAccepted: "Tüm belgeler onaylandı",
        back: "Geri",
        completed: "Portal açıldı",
        finish: "Portalı aç",
        maxLoss: "Maks. kayıp toleransı (%)",
        maxLossHint: "Bu drawdown seviyesinden itibaren müdahale etmek ya da bilgilendirilmek istersin.",
        next: "İleri",
        of: "/",
        openDoc: "Görüntüle",
        payoutRate: "Ödeme oranı (%)",
        pendingHint: "Hâlâ beklemede: {n}",
        readAndAccept: "Okudum ve anladım",
        reconsentDesc: "Bir veya daha fazla risk dokümanını güncelledik. Portalını kullanmaya devam etmek için lütfen yeni sürümü oku ve onayla.",
        reconsentTitle: "Güncellenen risk dokümanları",
        startCapital: "Başlangıç sermayesi ($)",
        step: "Adım",
        step1Desc: "Portalın kısa tanıtımı. Burada copy trading yolculuğunu şeffaf şekilde takip eder, ödemeleri belgelersin ve riskini kontrol altında tutarsın.",
        step1Points: [
          "Verilerin gizli: sadece sen ve admin görür.",
          "Trading yüksek risklidir. Sadece yansıtırız, danışmanlık vermeyiz.",
          "Tüm getiriler, senin gerçek girişlerine dayanır."
        ],
        step1Title: "Hoş geldin",
        step2Desc: "Lütfen her dokümanı dikkatle oku ve içeriği anladığını tek tek onayla.",
        step2Title: "Risk dokümanlarını onayla",
        step3Desc: "Başlangıç parametrelerini belirle. Bunları istediğin zaman Risk Merkezi’nde değiştirebilirsin.",
        step3Title: "Kişisel risk profili",
        step4Desc: "Bilgilerini kontrol et ve portalını aç.",
        step4Title: "Özet",
        subtitle: "Kişisel portalını açmak için lütfen aşağıdaki adımları tamamla.",
        summaryDocs: "Onaylanan dokümanlar",
        summaryProfile: "Risk profilin",
        targetLeverage: "Hedef kopyalama katsayısı",
        title: "Team Phoenix’e hoş geldin"
      },
      personal: {
        currentDrawdown: "Mevcut drawdown",
        currentGain: "Mevcut kâr",
        entries: "Kayıtlar",
        goalDouble: "Sermayeyi ikiye katla",
        goalGain: "Hedef kâr",
        leverageTarget: "Hedef kaldıraç",
        lossToleranceNear: "Kayıp toleransına yaklaşıyor.",
        lossToleranceReached: "Kayıp toleransı aşıldı — lütfen risk kurulumunu kontrol et.",
        maxDrawdown: "Maks. drawdown",
        openRiskCenter: "Risk Merkezi’ne git",
        payoutRateActual: "Gerçekleşen",
        payoutRateGoal: "Çekim hedefi",
        profileMissing: "Lütfen önce risk profilini oluştur.",
        progress: "İlerleme",
        subtitle: "Risk profilindeki hedeflerine göre kişisel ilerlemen.",
        title: "İlerlemem"
      },
      register: {
        desc: "Team Phoenix üye portalına davet edildin. Kişisel hesabını oluştur.",
        displayName: "Ad ve soyad",
        email: "E-posta",
        expired: "Bu davetin süresi doldu. Lütfen yeni bir davet linki iste.",
        invalid: "Bu davet geçersiz veya daha önce kullanılmış. Lütfen yetkilinle iletişime geç.",
        password: "Şifre (min. 8 karakter)",
        password2: "Şifreyi tekrarla",
        pendingMsg: "Kayıt başarılı! Hesabının bir yönetici tarafından onaylanması gerekiyor.",
        pwMismatch: "Şifreler eşleşmiyor.",
        pwShort: "Şifre en az 8 karakter olmalı.",
        riskNote: "Kayıt olarak bu portalın yalnızca dokümantasyon amaçlı olduğunu ve yatırım tavsiyesi olmadığını kabul edersin. Trading, toplam kayba yol açabilir.",
        submit: "Hesap oluştur",
        title: "Kayıt (sadece davetle)"
      },
      riskCenter: {
        acceptedOn: "Onay tarihi",
        close: "Kapat",
        docsSection: "Risk belgeleri",
        notAccepted: "Henüz onaylanmadı",
        profileSection: "Risk profilin",
        profileUpdated: "Profil güncellendi",
        reAccept: "Yeni sürümü onayla",
        subtitle: "Onayladığın belgeler ve kişisel risk profilin.",
        title: "Risk Merkezi",
        updateProfile: "Profili kaydet",
        version: "Sürüm",
        view: "Görüntüle"
      },
      support: {
        admin: "Destek",
        adminSubtitle: "Üyelerden gelen tüm talepler. Doğrudan ticket üzerinden yanıtla.",
        adminTitle: "Destek talepleri",
        created: "Oluşturuldu",
        filterAll: "Tümü",
        message: "Mesaj",
        messagePh: "Talebini mümkün olduğunca detaylı açıkla.",
        newTicket: "Yeni ticket",
        noTickets: "Şu ana kadar talep yok.",
        reply: "Yanıtla",
        replySent: "Yanıt gönderildi",
        send: "Gönder",
        setStatus: "Durumu değiştir",
        status: "Durum",
        statusClosed: "Kapalı",
        statusInProgress: "İşlemde",
        statusOpen: "Açık",
        subject: "Konu",
        subjectPh: "örn. bir dersle ilgili soru",
        subtitle: "Ekibe taleplerin. En kısa sürede yanıtlarız.",
        ticketCreated: "Talep gönderildi",
        title: "Destek",
        unread: "Yeni",
        updated: "Güncellendi",
        you: "Sen"
      }
    },
  ru: {
      appTitle: "Team Phoenix Portal",
      disclaimer: {
        title: "Прежде чем продолжить",
        intro: "Пожалуйста, прочитай и подтверди следующие пункты, чтобы пользоваться сайтом.",
        items: [
          "Я прочитал и понял отказ от ответственности: всё содержимое этой страницы не является инвестиционной, финансовой, налоговой или юридической консультацией. Это исключительно документация личного опыта и мнений владельца сайта.",
          "Личная ответственность: вся информация служит исключительно общему информированию. Каждое решение, принятое на основе этого содержимого, принимается самостоятельно и на собственный риск.",
          "Предупреждение о рисках: торговля финансовыми инструментами (напр. акциями, фондами или криптоактивами) связана со значительными рисками и может привести к полной потере вложенного капитала. Прошлые результаты не гарантируют будущих.",
          "Я осознаю, что и сам не могу давать консультации и рекомендации. Эта страница рассказывает исключительно о собственном опыте."
        ],
        yes: "ДА",
        accept: "Принять и продолжить",
        ipNote: "При принятии твой IP-адрес записывается в целях подтверждения."
      },
      tabs: {
        dashboard: "Мой путь",
        calculator: "Калькулятор",
        tracking: "Трекинг",
        history: "История",
        strategy: "Стратегия",
        risk: "Риск",
        social: "Соцсети",
        settings: "Настройки",
        academy: "База знаний",
        adminAcademy: "CMS базы знаний",
        adminGroup: "Админ",
        adminSupport: "Поддержка (Админ)",
        audit: "Журнал аудита",
        calendar: "Календарь",
        marketing: "Маркетинг",
        members: "Участники",
        riskCenter: "Центр рисков",
        riskDocs: "Документы по рискам",
        support: "Portal Support",
        links: "Ссылки и email-адреса",
        adminLinks: "Ссылки и email (Админ)"
      },
      edu: {
        heroBadge: "Обучающая платформа · Без продаж, без обещаний",
        heroH1a: "Опытные трейдеры торгуют за тебя —",
        heroH1b: "твои деньги всегда остаются на твоём брокерском счёте.",
        heroSub: "Тебе не нужно читать графики и торговать самому. Проверенная стратегия автоматически копируется на твой счёт. Полный контроль всегда у тебя.",
        b1t: "Капитал остаётся у тебя",
        b1x: "Деньги на твоём брокерском счёте – не у нас.",
        b2t: "Сделки копируются",
        b2x: "Автоматически – без твоего вмешательства.",
        b3t: "Всё прозрачно",
        b3x: "Каждая сделка публично проверяема.",
        ctaStart: "Начать сейчас",
        ctaLearn: "Узнать больше",
        illBroker: "Твой брокерский счёт",
        illControl: "под твоим контролем",
        illGold: "Золото",
        illGoldNote: "Рынок, где работает стратегия.",
        illApp: "Sonic App",
        illProgress: "Прогресс",
        illLastTrade: "Последняя сделка",
        illStrategy: "Стратегия",
        illActive: "Активна · Контроль у тебя",
        whatEye: "Сначала основы",
        whatTitle: "Что такое copy trading?",
        whatIntro: "Кратко: опытный трейдер принимает решения. Они автоматически переносятся на твой счёт. Тебе делать ничего не нужно.",
        whatStep: "Шаг",
        whatS1t: "Опытный трейдер",
        whatS1x: "Анализирует рынок и принимает решение.",
        whatS2t: "Открывает сделку",
        whatS2x: "Покупка или продажа на его счёте.",
        whatS3t: "Автоматически на твой счёт",
        whatS3x: "Та же сделка отражается – пропорционально твоему капиталу.",
        whatS4t: "Результат идёт к тебе",
        whatS4x: "Прибыль или убыток появляются на твоём счёте пропорционально.",
        whatImportant: "Важно: ты не торгуешь сам. Ты копируешь стратегию. Решения остаются у трейдера, капитал остаётся у тебя.",
        howEye: "Процесс",
        howTitle: "Как это работает?",
        howS1t: "Открой брокерский счёт",
        howS1x: "Бесплатный счёт в TAG Markets – несколько минут.",
        howS2t: "Подключи стратегию",
        howS2x: "Через специальный сервис (COPYX) ты разрешаешь автоматическое копирование.",
        howS3t: "Трейдер открывает позицию",
        howS3x: "Опытный трейдер принимает решение на своём счёте.",
        howS4t: "Сделка появляется у тебя",
        howS4x: "Та же сделка попадает на твой счёт автоматически – без твоих действий.",
        howS5t: "Отслеживай прогресс",
        howS5x: "В портале всё видно в любой момент – прозрачно и в реальном времени.",
        skillEye: "Для новичков",
        skillTitle: "Нужно ли уметь торговать?",
        skillNo: "Нет.",
        skillNoNote: "Опыт не нужен.",
        skillDesc: "Все решения принимает опытный трейдер. Ты только видишь, что происходит – и учишься попутно.",
        skill1: "не читать графики",
        skill2: "не анализировать рынок",
        skill3: "не принимать решения о покупке",
        skill4: "не искать сигналы продажи",
        skill5: "не разбирать новости",
        skill6: "не работать по воскресеньям",
        moneyEye: "Доверие",
        moneyTitle: "А где мои деньги?",
        moneySub: "Самый важный вопрос – и простой ответ:",
        moneyAccLabel: "Твой брокерский счёт",
        moneyAccNote: "Именно здесь – и только здесь – находится твой капитал.",
        moneyP1t: "На твоём брокерском счёте",
        moneyP1x: "Регулируемый счёт, принадлежащий только тебе. У нас нет доступа к балансу.",
        moneyP2t: "Только торговое разрешение",
        moneyP2x: "Стратегия может только открывать сделки – но никогда не касается денег.",
        moneyP3t: "Никаких платежей третьим лицам",
        moneyP3x: "Ввод и вывод идут только между тобой и брокером.",
        moneyP4t: "Пауза или отмена в любой момент",
        moneyP4x: "Один клик останавливает или полностью прекращает копирование.",
        moneyCtrl: "Полный контроль остаётся у тебя.",
        moneyCtrlSub: "Никаких управляющих фондов, хранения или платежей через третьих лиц.",
        whyEye: "Целевая аудитория",
        whyTitle: "Почему люди используют copy trading?",
        whyP1t: "“У меня нет времени”",
        whyP1x: "Работа, семья, жизнь – copy trading работает, пока ты живёшь.",
        whyP2t: "“У меня нет опыта”",
        whyP2x: "Не нужно знаний трейдинга. Стратегия решает, ты учишься по пути.",
        whyP3t: "“Хочу прозрачно инвестировать”",
        whyP3x: "Каждая сделка проверяема. Ты точно видишь, что и почему делается.",
        whyP4t: "“Лучше доверю профи”",
        whyP4x: "У опытных трейдеров годы практики. Ты можешь использовать их решения 1:1.",
        transEye: "Прозрачность",
        transTitle: "Что такое Myfxbook — и почему это важно?",
        transPara: "Myfxbook – независимый сервис верификации торговых счетов. Он подключается напрямую к брокерскому счёту трейдера и автоматически фиксирует каждую сделку – никто не может задним числом &bdquo;приукрасить&ldquo; цифры.",
        trans1: "Каждая сделка сохраняется в реальном времени – не в конце месяца.",
        trans2: "Манипуляция невозможна: данные приходят напрямую от брокера.",
        trans3: "Можно посмотреть в любой момент – публично, без логина.",
        trans4: "Видны и убытки – не только прибыль. Это создаёт настоящее доверие.",
        transCta: "Посмотреть публичную историю",
        transVer: "Верифицированный счёт",
        transLive: "Live",
        transK1: "Всего сделок",
        transK2: "Winrate",
        transK3: "В работе",
        transK4: "Макс. просадка",
        transK3v: "21 месяц",
        transExpl: "&bdquo;Фаза просадки&ldquo; = наибольшее падение от пика до последующей ямы. Чем меньше число, тем спокойнее кривая.",
        oppEye: "Честно, не реклама",
        oppTitle: "Возможности и риски – начистоту",
        oppSub: "Обе стороны важны. Показываем их рядом.",
        oppTitleC: "Возможности",
        oppTitleR: "Риски",
        opp1: "Чёткое разделение капитала (у тебя) и стратегии (у трейдера).",
        opp2: "Экономия времени: без анализа рынка, без графиков, без звонков-будильников.",
        opp3: "Полная прозрачность через верифицированную историю.",
        opp4: "Кривая обучения в комплекте: видишь, как работает профи.",
        opp5: "Пауза в любой момент – без контракта, без привязки.",
        risk1: "Возможны убытки – вплоть до потери всей суммы.",
        risk2: "Прошлые результаты не гарантируют будущих.",
        risk3: "Рынок (золото) может сильно двигаться даже за короткое время.",
        risk4: "Без опыта работы с брокером первичная настройка занимает время.",
        risk5: "Не подходит для средств, которые нужны в ближайшее время.",
        faqEye: "FAQ",
        faqTitle: "Частые вопросы",
        faqQ1: "Что такое copy trading?",
        faqA1: "Copy trading – это когда опытный трейдер принимает торговые решения, и они автоматически переносятся на твой брокерский счёт. Ты не торгуешь сам – ты копируешь стратегию.",
        faqQ2: "Мои деньги правда остаются на моём счёте?",
        faqA2: "Да. Твой капитал у регулируемого брокера на счёте, принадлежащем только тебе. У стратегии только разрешение открывать сделки – она никогда не имеет доступа к деньгам.",
        faqQ3: "Могу ли я в любой момент остановиться?",
        faqA3: "Да. Пауза или полное прекращение – один клик. Никакого минимального срока, никакого уведомления.",
        faqQ4: "Как вывести прибыль?",
        faqA4: "Напрямую с брокерского счёта на твой банковский. Ввод и вывод идут только между тобой и брокером – не через нас.",
        faqQ5: "Нужен ли опыт трейдинга?",
        faqA5: "Нет. Никаких знаний не требуется. Стратегия принимает все решения. Если захочешь узнать больше – в портале участников есть структурированная база знаний.",
        faqQ6: "Сколько это стоит?",
        faqA6: "Оплата только за результат: performance-fee на реальную прибыль. Нет прибыли – нет комиссии. Все детали видны до подключения.",
        faqQ7: "Что будет при убытке?",
        faqA7: "Убытки – часть рынка и отражаются пропорционально твоему капиталу. История показывает и прибыльные, и убыточные фазы открыто.",
        faqQ8: "Почему именно золото?",
        faqA8: "Золото (тикер &bdquo;XAUUSD&ldquo;) – один из самых ликвидных рынков мира: узкие спреды, ясные движения, круглосуточная торговля. Стратегия оптимизирована под особенности этого рынка.",
        faqQ9: "Что такое MT5?",
        faqA9: "MetaTrader 5 (MT5) – широко распространённая торговая платформа. Брокер предоставляет её бесплатно. Стратегия через MT5 &bdquo;общается&ldquo; с брокером и размещает сделки. Ты сам MT5 использовать не должен.",
        softH1: "Когда ты понял, как работает copy trading,",
        softH2: "ты можешь посмотреть, как стратегия работала исторически.",
        softSub: "Никаких обещаний, никакого давления. Только цифры из реальных, верифицированных счетов.",
        softAgain: "Прочитать сначала",
      },
      strategy: {
        badge: "Стратегия активна – работает в реальном времени",
        hero1: "Автоматическая торговля золотом –",
        heroHighlight: "моя стратегия в обзоре",
        heroSub: "Стратегия SONIC торгует золотом (XAUUSD) руками опытных трейдеров. Каждая сделка зеркалируется через MT5 на собственный счёт – без необходимости торговать самому. Здесь ты найдёшь основные факты и путь к старту.",
        kpiDaily: "Дневная доходность (24x)",
        kpiMonthly: "Месячная доходность (24x)",
        kpiDrawdown: "Макс. просадка (1x)",
        kpiTrades: "Сделки · Процент прибыльных",
        kpiNote: "Показатели рассчитываются в реальном времени на основе реальной истории сделок ({months} мес., до комиссий, плечо 24x). Прошлые результаты не гарантируют будущих.",
        cta: "Начать сейчас",
        ctaBandTitle: "Готов к следующему шагу?",
        ctaBandSub: "Подключи свой счёт и позволь стратегии торговать за тебя.",
        verified: "Проверенный трек-рекорд (myfxbook)",
        howTitle: "Как это работает",
        howSub: "От счёта до первой скопированной сделки за несколько шагов.",
        step1Title: "Подключи счёт",
        step1Text: "Ты подключаешь собственный счёт MT5 к стратегии за несколько минут. Капитал всегда остаётся на твоём собственном счёте.",
        step2Title: "Сделки зеркалируются",
        step2Text: "Когда стратегия открывает позицию, она автоматически и без задержки воспроизводится на твоём счёте – включая вход, выход и размер позиции.",
        step3Title: "Вместе в пути",
        step3Text: "Активное сообщество из многих стран уже использует стратегию. По вопросам настройки есть пошаговая поддержка.",
        mirrorTitle: "Копировать вместо самостоятельной торговли",
        whatTitle: "Что такое копитрейдинг?",
        whatText1: "При копитрейдинге торговый счёт автоматически подключается к существующей стратегии. Каждая сделка стратегии воспроизводится на собственном счёте в реальном времени – пропорционально размеру счёта. Не нужно читать графики, выбирать точки входа и выхода или иметь торговый опыт.",
        whatText2: "Главное отличие от классических фондов или доверительного управления: капитал всё время остаётся на собственном брокерском счёте. Никто, кроме тебя, не имеет к нему доступа – стратегия получает лишь право размещать сделки.",
        whatFacts: [
          "Капитал остаётся на твоём собственном счёте – полный контроль в любое время",
          "Сделки зеркалируются полностью автоматически в реальном времени",
          "Копирование можно приостановить или полностью прекратить в любой момент",
          "Каждая сделка публично проверяема на Myfxbook"
        ],
        possTitle: "Какие возможности это даёт?",
        possSub: "Копитрейдинг гибок – ты сам решаешь, как его использовать.",
        poss1Title: "Использовать сложный процент",
        poss1Text: "Прибыль остаётся на счёте и автоматически участвует в торговле. Размер позиций растёт вместе с балансом – эффект сложного процента может увеличивать капитал за месяцы значительно быстрее линейного накопления.",
        poss2Title: "Регулярные выплаты",
        poss2Text: "Альтернативно можно регулярно выводить часть прибыли – например, чтобы сначала вернуть вложенный стартовый капитал. С этого момента ты торгуешь только «деньгами казино».",
        poss3Title: "Выбирай коэффициент копирования сам",
        poss3Text: "Коэффициентом копирования (напр. 12x или 24x) ты определяешь, насколько сильно твой счёт использует плечо стратегии. Более высокий коэффициент – более высокая возможная доходность, но и такой же более высокий риск потерь.",
        poss4Title: "Полностью пассивное участие",
        poss4Text: "После однократной настройки всё работает автоматически. Никаких графиков, никаких торговых решений, никаких затрат времени – развитие можно прозрачно отслеживать в любой момент.",
        riskTitle: "Возможности и риски – честный взгляд",
        riskSub: "Копитрейдинг с плечом – это высокорискованная инвестиция. Обе стороны должны быть на столе.",
        chancesLabel: "Возможности",
        risksLabel: "Риски",
        chances: [
          "Возможна доходность выше средней – вся история проверена на Myfxbook",
          "Эффект сложного процента благодаря автоматическому реинвестированию прибыли",
          "Не требуется собственных торговых знаний – полностью автоматическое исполнение",
          "Полный контроль: собственный счёт, пауза или выход в любой момент"
        ],
        risks: [
          "Плечо работает в обе стороны – убытки усиливаются так же, как прибыль",
          "Полная потеря вложенного капитала возможна в любой момент",
          "Прошлые результаты не гарантируют будущих",
          "Вкладывай только капитал, полную потерю которого сможешь пережить"
        ],
        videoTitle: "Как работает система копитрейдинга",
        videoSub: "Обучающее видео показывает шаг за шагом, как работает система.",
        mirrorText: "Принцип прост: опытная система торгует, твой счёт автоматически следует за ней. Ты сохраняешь полный контроль над своим капиталом и можешь в любой момент приостановить или выйти. На этой странице я прозрачно документирую, как это развивается у меня.",
        disclaimer: "Документация личного опыта – не является инвестиционной, финансовой или юридической консультацией и не является рекомендацией. Торговля финансовыми инструментами связана со значительными рисками и может привести к полной потере. Каждое решение ты принимаешь под собственную ответственность.",
        landing: {
          liveBadge: "Стратегия активна · Live-сигнал",
          heroHead1: "Автоматизированный трейдинг золотом",
          heroHead2: "с прозрачной историей.",
          heroSub: "Отзеркаль проверенную copy-стратегию на свой собственный брокерский счёт. Твой капитал всегда под твоим контролем – пауза или выход в один клик.",
          ctaStart: "Начать сейчас",
          ctaLive: "Смотреть live-результаты",
          trust: ["Проверенная история на Myfxbook", "Собственный брокерский счёт", "Пауза в любой момент", "Полный контроль над капиталом"],
          liveDash: "Live Dashboard",
          kpiAvgMonth: "Ø месяц",
          kpiWinRate: "Winrate",
          kpiDrawdown: "Просадка",
          kpiTrades: "Сделки",
          timelineEyebrow: "Всё очень просто",
          timelineTitle: "В работе за пять шагов",
          steps: [
            { title: "Открой брокерский счёт", text: "Бесплатный счёт в TAG Markets за пару минут." },
            { title: "Подключи стратегию", text: "Активируй copy-trading через COPYX – 2 минуты." },
            { title: "Сделки копируются", text: "Автоматически, 1:1 на твой счёт. Никакого вмешательства." },
            { title: "Отслеживай прогресс", text: "Ежедневные результаты в портале и на Myfxbook." },
            { title: "Используй сообщество", text: "Live-звонки, база знаний, прямая поддержка." },
          ],
          perfEyebrow: "Реально и проверено",
          perfTitle: "Live-производительность с первого дня",
          perfSub: "Симулированная net-кривая капитала на счёте с депозитом 1 000 $ (24× усиление, 30 % performance-fee уже вычтена) – каждая сделка полностью задокументирована.",
          perfAvgMonth: "Ø месяц (net)",
          perfWinRate: "Winrate",
          perfDrawdown: "Макс. просадка",
          perfMonths: "Месяцев в работе",
          perfChartLabel: "Кривая капитала",
          perfSourceLine1: "Live-источник: history_trades.",
          perfSourceLine2: "Симуляция после комиссий брокера и performance-fee.",
          perfMilestones: "Вехи",
          perfMilestoneGoal: "Цель",
          perfMilestoneReached: "Достигнуто:",
          perfMilestoneOpen: "Ещё открыто",
          portalEyebrow: "Твой раздел участника",
          portalTitle: "Всё в одном месте. Чисто. Ясно. Твоё.",
          portalSub: "Как участник ты получаешь три ключевых инструмента, которые структурируют твой путь – от стартового капитала до первой выплаты.",
          journeyLabel: "Мой путь",
          journeyLive: "Live",
          journeySub: "Чистый прогресс · 6 месяцев",
          journeyMilestone: "Веха",
          journeyReached: "достигнуто",
          journeyShare: "Делится через публичную ссылку · PDF-экспорт",
          calendarLabel: "Календарь",
          calendarMonth: "Февраль 2026",
          calendarSub: "4 события сообщества · .ics-экспорт",
          calendarNext: "Следующее событие",
          calendarNextText: "Live Q&A · 18 фев · 19:00",
          kbLabel: "База знаний",
          kbTitle: "AI Q&A · Мгновенные ответы",
          kbSub: "Отобранные уроки · Поиск с ИИ",
          kbUserQ: "Твой вопрос",
          kbUserQText: "Каким должен быть мой стартовый капитал?",
          kbAI: "Sonic AI отвечает",
          kbAnswer: "Рекомендуемый старт — от 1 000 € на счёте 24×. Меньшие суммы возможны, но заметно замедляют эффект сложного процента…",
          kbLatency: "0,8 с · на основе 24 уроков",
          cardJourney: { title: "Мой путь", desc: "Ставь вехи, отслеживай чистый прогресс и делись им по публичной ссылке." },
          cardCalendar: { title: "Календарь", desc: "Live-звонки, Q&A-сессии и разборы сделок – клик по \"Добавить в календарь\" создаёт файл .ics." },
          cardKb: { title: "База знаний", desc: "Отобранные уроки и поиск с ИИ. Вопросы вроде \"Каким должен быть мой капитал?\" получают ответ за секунды." },
          ctaMember: "Стать участником",
        },
      },
      kpi: {
        startCapital: "Стартовый капитал",
        currentBalance: "Текущий баланс",
        totalProfit: "Общая прибыль",
        totalPayouts: "Выплаты",
        netProfit: "Чистая прибыль",
        totalReturn: "Общая доходность",
        monthlyReturn: "Месячная доходность",
        dailyReturn: "Ø дневная доходность",
        volume: "Торговый объём",
        leverage: "Плечо"
      },
      recovery: "Возврат стартового капитала",
      recoveryHint: "возвращено через выплаты",
      growthChart: "Кривая роста",
      balance: "Баланс",
      planLine: "План ({target} %/мес.)",
      payoutsCurve: "Накопленные выплаты",
      monthlyTable: "Месячный обзор",
      month: "Месяц",
      profit: "Прибыль",
      fees: "Комиссии",
      feesHint: "Комиссия: −{c} · Вознаграждение: −{p}",
      payout: "Выплата",
      trades: "Сделки",
      return: "Доходность",
      endBalance: "Конечный баланс",
      noData: "Записей пока нет. Внеси свой первый день в трекинг.",
      calc: {
        title: "Калькулятор сложного процента",
        startCapital: "Стартовый капитал ($)",
        monthlyReturn: "Месячная доходность (%)",
        months: "Срок (месяцев)",
        reinvestRate: "Доля реинвестирования (%)",
        payoutRate: "Доля выплат (%)",
        leverage: "Коэффициент плеча",
        compare: "Сравнение: 100% реинвестирование vs. стратегия выплат",
        fullReinvest: "100% реинвестировано",
        withPayout: "с выплатами",
        cumPayout: "Накопленные выплаты",
        tableTitle: "Помесячное развитие",
        balanceEnd: "Баланс",
        volume: "Объём",
        totalWithPayout: "Итог с учётом выплат",
        totalFull: "Итог при 100% реинвестировании",
        payoutSum: "Сумма выплат",
        breakeven: "Точка безубыточности (выплаты ≥ стартовый капитал)",
        breakevenDouble: "Точка безубыточности (баланс ≥ 2× вклада)",
        payoutEur: "Выплата ($/мес.)",
        effReturn: "≙ эффективно {eff} % в месяц при {lev}x",
        histAvgNote: "Предзаполнено: исторически Ø {avg} % (при 24x, до вознаграждения)",
        feeNote: "− 30 % вознаграждения (удерживается каждую пятницу с недельной прибыли) ≙ чистыми {net} % в месяц",
        noCompound: "Без сложного процента: {v}",
        breakevenMonths: "через {m} мес.",
        breakevenWeeks: "≈ {w} недель",
        breakevenNot: "Не достигнуто за период",
        calcDisclaimer: "Модельный расчёт – без гарантий. Реальная доходность колеблется, возможна полная потеря."
      },
      track: {
        title: "Ежедневный трекинг",
        date: "Дата",
        startBalance: "Начальный баланс ($)",
        endBalance: "Конечный баланс ($)",
        payout: "Выплата ($)",
        commission: "Комиссия ($)",
        traderFee: "Вознаграждение трейдера 30% ($)",
        commissionShort: "Комиссия",
        traderFeeShort: "Вознаграждение",
        netProfit: "Нетто",
        suggestedFee: "Предложение (30% от прибыли)",
        netPreview: "Нетто после комиссий",
        trades: "Количество сделок",
        note: "Заметка",
        marketEvent: "Рыночное событие",
        profitPreview: "Дневная прибыль/убыток",
        suggestedPayout: "Предложение (10% от прибыли)",
        apply: "применить",
        save: "Сохранить день",
        update: "Обновить",
        editing: "Редактирование записи от {date}",
        cancel: "Отмена",
        saved: "Запись сохранена",
        deleted: "Запись удалена",
        entries: "Записи",
        exportCsv: "Экспорт CSV",
        settings: "Настройки",
        settingsStart: "Стартовый капитал ($)",
        settingsLeverage: "Плечо",
        settingsSave: "Сохранить",
        settingsSaved: "Настройки сохранены",
        reinvested: "Реинвестировано",
        actions: ""
      },
      social: {
        title: "Генератор для соцсетей",
        type: "Тип поста",
        types: {
          daily: "Ежедневное обновление",
          weekly: "Еженедельное обновление",
          monthly: "Ежемесячное обновление",
          milestone: "Веха",
          loss: "Честное обновление об убытках"
        },
        language: "Язык поста",
        context: "Дополнительный контекст (необязательно)",
        contextPlaceholder: "напр. сегодня сильный рынок, достигнута веха 25% ...",
        generate: "Сгенерировать пост",
        generating: "Генерация ...",
        copy: "Копировать",
        copied: "Скопировано в буфер обмена",
        empty: "Сгенерированный пост появится здесь.",
        note: "Каждый пост автоматически заканчивается предупреждением о рисках."
      },
      risk: {
        title: "Отслеживание рисков",
        worstDay: "Наибольший дневной убыток",
        maxDrawdown: "Макс. просадка",
        lossStreak: "Самая длинная серия убытков",
        winStreak: "Самая длинная серия прибыли",
        currentStreak: "Текущая серия",
        liqDistance: "Дистанция до ликвидации",
        days: "дней",
        hypoTitle: "Гипотетический убыток при движении рынка/стратегии (с плечом)",
        move: "Движение",
        loss: "Убыток",
        remaining: "Остаток капитала",
        wiped: "Счёт обнулён",
        ddChart: "График просадки",
        milestones: "Вехи – возврат стартового капитала",
        milestoneReached: "Веха достигнута: возвращено {th} % стартового капитала!",
        reachedOn: "достигнуто",
        open: "открыто",
        generatePost: "Сгенерировать пост",
        milestoneContext: "Веха достигнута: {th} % стартового капитала возвращено через выплаты ({date}).",
        warnTitle: "Предупреждения",
        warnings: {
          liquidation_close: "При плече {lev}x уже движение примерно на -{liq} % ведёт к полной потере (ликвидации).",
          drawdown_high: "Максимальная просадка превышает 15 % – повышенный риск.",
          loss_streak: "Текущая серия убытков 3+ дня – критически проверь стратегию.",
          big_daily_loss: "Уже был дневной убыток более 5 % – высокая волатильность.",
          none: "Острых предупреждений нет. Базовый риск из-за плеча сохраняется."
        }
      },
      settings: {
        title: "Параметры эксперимента",
        description: "Эти значения управляют всем экспериментом: расчёты дашборда, предложение выплат, плановая линия и показатели риска.",
        startCapital: "Стартовый капитал ($)",
        leverage: "Коэффициент плеча",
        reinvestRate: "Доля реинвестирования (%)",
        payoutRate: "Доля выплат (%)",
        monthlyTarget: "Целевая месячная доходность (%)",
        journeyDays: "Целевая длительность пути (дней)",
        goalAmount: "Целевой баланс ($)",
        sumHint: "Примечание: реинвестирование + выплаты в сумме не дают 100 %.",
        save: "Сохранить",
        saved: "Настройки сохранены",
        preview: "Предпросмотр",
        leverageWarning: "Внимание: при плече {lev}x уже движение примерно на -{liq} % ведёт к полной потере."
      },
      share: {
        live: "Live · Публичный эксперимент",
        subtitle: "Прозрачный эксперимент по копитрейдингу – все цифры без прикрас, включая убытки.",
        copyLink: "Скопировать ссылку",
        copied: "Ссылка скопирована",
        historySubtitle: "Реальная история сделок за 21 месяц – смоделируй сам, что стало бы с твоим входом.",
        calcTitle: "Рассчитай свой возможный дальнейший путь",
        calcHero1: "Рассчитай свой возможный",
        calcHeroHighlight: "дальнейший путь",
        tabHistory: "История сделок",
        tabCalc: "Калькулятор",
        tabJourney: "Мой путь",
        tabLive: "Live-дашборд",
        hero1: "Твоя",
        heroHighlight: "результативность",
        hero2: "как на ладони",
        config: "Твоя конфигурация",
        configStart: "Стартовый капитал",
        configLeverage: "Плечо / коэффициент",
        configPayout: "Доля выплат",
        configEdit: "Изменить конфигурацию",
        quote: "Дисциплина сегодня – свобода завтра.",
        quoteSub: "Твоя цель. Твой путь. Твой успех.",
        footerLine: "Прозрачность. Дисциплина. Успех.",
        historyBadge: "Реальные сделки · Исторически подтверждено",
        copyHistoryLink: "Скопировать публичную ссылку на историю",
        toDashboard: "К live-дашборду",
        toHistory: "К истории сделок"
      },
      weekly: {
        title: "Пора публиковать еженедельное обновление",
        desc: "Период {since} – {until} · {days} дней отслежено · Прибыль {profit} · Выплаты {payout} · Доходность {return}",
        context: "Еженедельное обновление за период с {since} по {until}: прибыль {profit}, выплаты {payout}, недельная доходность {return}, {days} отслеженных дней.",
        generate: "Сгенерировать еженедельное обновление",
        dismiss: "Позже"
      },
      history: {
        title: "Исторический бэктест",
        subtitle: "На основе {trades} реальных сделок (с {first} по {last}, {months} мес.). Что стало бы с твоим входом?",
        startCapital: "Стартовый капитал ($)",
        leverage: "Плечо / коэффициент копирования",
        payoutRate: "Доля выплат (%)",
        endBalance: "Баланс на конец",
        endBalanceFull: "Без выплат (100 % реинвестирование)",
        totalPayouts: "Сумма выплат",
        totalReturn: "Общая доходность (вкл. выплаты)",
        maxDrawdown: "Макс. просадка",
        avgMonthly: "Ø месячная доходность",
        winRate: "Процент прибыльных сделок",
        bestDay: "Лучший день",
        worstDay: "Худший день",
        breakeven: "Безубыточность (выплаты ≥ стартовый капитал)",
        breakevenDouble: "Безубыточность (баланс ≥ 2× вклада)",
        payoutEur: "Выплата ($/мес.)",
        feeNote: "Все значения учитывают 30 % вознаграждения трейдеров (удерживается каждую пятницу с недельной валовой прибыли, только в прибыльные недели).",
        simpleReturn: "Доходность без сложного процента",
        simpleReturnSub: "Прибыль не реинвестировалась",
        breakevenMonths: "через {m} мес.",
        breakevenWeeks: "≈ {w} недель · достигнуто {date}",
        breakevenNot: "Не достигнуто за период",
        curve: "Развитие капитала (историческая симуляция)",
        withPayout: "Баланс (с выплатами)",
        fullReinvest: "100 % реинвестировано",
        cumPayout: "Накопленные выплаты",
        monthlyTable: "Помесячное развитие",
        note: "Историческая симуляция на основе прошлых сделок. Прошлые результаты НЕ гарантируют будущего – при плече {lev}x максимальная просадка составила {dd} %. Полная потеря возможна в любой момент.",
        loading: "Расчёт ...",
        noData: "Исторические сделки не найдены.",
        upload: "Обновить сделки (CSV)",
        uploadOk: "Импортировано {n} сделок (по {last})",
        uploadFail: "Импорт не удался",
        dataStatus: "Данные: {n} сделок · последняя сделка {last}",
        mfbStatus: "myfxbook live: {gain} % прибыль · {dd} % просадка",
        mfbLink: "Посмотреть проверенную историю на Myfxbook"
      },
      stats: {
        title: "Анализ сделок",
        profitFactor: "Профит-фактор",
        profitFactorSub: "Валовая прибыль ÷ валовый убыток",
        avgWin: "Ø прибыльная сделка",
        avgLoss: "Ø убыточная сделка",
        longWinRate: "Успешность лонгов",
        shortWinRate: "Успешность шортов",
        avgDuration: "Ø длительность сделки",
        byWeekday: "Результаты по дням недели",
        byHour: "Результаты по часам",
        byMonth: "Результаты по месяцам",
        pips: "Пункты",
        winShort: "Успешность",
        winTrades: "Прибыльные сделки",
        lossTrades: "Убыточные сделки",
        weekdaysShort: ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"]
      },
      journey: {
        heroTitle: "Мой путь к финансовой свободе",
        publicNote: "То, что ты здесь видишь, – мой личный торговый счёт, который я день за днём прозрачно документирую – со всеми прибылями, убытками и неудачами. Я делюсь этим путём, чтобы фиксировать собственный опыт. Всё содержимое служит исключительно информированию и не является рекомендацией или консультацией.",
        heroSubtitle: "Каждая сделка приближает меня к цели. Этот проект прозрачно документирует весь мой путь – включая прибыли, убытки и неудачи.",
        dayLabel: "Мой путь",
        day: "День {d} из {total}",
        totalProfit: "Общая прибыль с начала",
        remaining: "Осталось до возврата капитала",
        balance: "Текущий баланс",
        doneShort: "Готово!",
        capitalBack: "Вернуть стартовый капитал",
        capitalBackDone: "Стартовый капитал полностью возвращён",
        goal: "Цель: {goal}",
        goalHint: "Относительно баланса – цель настраивается в настройках.",
        payoutIncluded: "из них выплачено (уже в прибыли)",
        todayProfit: "Прибыль сегодня",
        lastProfit: "Последний торговый день",
        winStreak: "Серия прибыли",
        days: "дней",
        roi: "ROI",
        timeline: "Мой путь – день за днём",
        win: "Прибыль",
        loss: "Убыток",
        noTrade: "Без сделок",
        trades: "сделок",
        tradesOne: "сделка",
        balanceArrow: "Баланс",
        achievements: "Вехи",
        achievedAt: "Достигнуто {date}",
        locked: "Ещё не достигнуто",
        newAchievement: "Достигнута новая веха:",
        goalBanner: "Твоя цель ждёт на горизонте – не сдавайся.",
        quotes: [
          "Постоянство побеждает талант.",
          "Маленькие шаги ведут к большим целям.",
          "Дисциплина – мост между целью и успехом.",
          "Каждая сделка – лишь ещё один шаг на твоём пути.",
          "Побеждает не совершенство, а постоянство.",
          "Лучшее время начать было вчера. Второе лучшее – сегодня."
        ],
        a: {
          first_trade: "Первая сделка",
          first_payout: "Первая выплата",
          profit_100: "100 $ прибыли",
          profit_500: "500 $ прибыли",
          profit_1000: "1 000 $ прибыли",
          capital_back: "Стартовый капитал возвращён",
          streak_10: "10 прибыльных дней подряд",
          trades_100: "100 сделок",
          balance_10k: "Баланс 10 000 $",
          balance_50k: "Баланс 50 000 $",
          balance_100k: "Баланс 100 000 $"
        }
      },
      auth: {
        title: "Защищённая зона",
        desc: "Введи пароль для управления дашбордом. Публичные страницы остаются свободно доступными.",
        password: "Пароль",
        login: "Войти",
        back: "Назад к обзору",
        error: "Неверный пароль",
        locked: "Слишком много попыток – подожди 15 минут.",
        logout: "Выйти",
        email: "E-mail (вход участника)",
        forgot: "Забыли пароль?",
        forgotPanel: {
          backShort: "назад",
          title: "Сбросить пароль",
          desc: "Введи свой e-mail. Если аккаунт существует, мы отправим ссылку для сброса.",
          emailLabel: "E-mail",
          emailPh: "твой@email.com",
          submit: "Отправить ссылку",
          done: {
            title: "E-mail отправлен",
            desc: "Если аккаунт с этим e-mail существует, в твоём почтовом ящике появится ссылка для сброса пароля. Ссылка действительна 2 часа.",
            toLogin: "К входу",
          },
        },
        reset: {
          title: "Сбросить пароль",
          newPw: "Новый пароль",
          confirmPw: "Подтвердите новый пароль",
          submit: "Установить пароль",
          intro: "Пожалуйста, введите новый пароль (минимум 8 символов).",
          pwTooShort: "Пароль слишком короткий (мин. 8 символов)",
          pwMismatch: "Пароли не совпадают",
          invalidToken: "Ссылка для сброса недействительна или неполная.",
          genericError: "Ошибка сброса. Срок действия ссылки мог истечь.",
          done: {
            title: "Пароль изменён",
            desc: "Теперь ты можешь войти с новым паролем. Перенаправление …",
          },
        },
      },
      footer: "Личный эксперимент. Историческая и ожидаемая доходность не гарантируют будущих результатов. Возможна полная потеря. Плечо одинаково усиливает прибыль и убытки. Это не финансовая консультация.",
      error: "Ошибка – попробуй ещё раз",
      academy: {
        close: "Закрыть",
        completed: "Завершено",
        lessons: "Уроки",
        markComplete: "Отметить как завершено",
        markIncomplete: "Отменить",
        minutes: "Мин.",
        noLessons: "Пока нет доступных уроков.",
        overallProgress: "Общий прогресс",
        startLesson: "Открыть",
        subtitle: "Короткие уроки про основы, риск-менеджмент, copy-trading и налоги.",
        title: "Академия",
        videoLabel: "Видео"
      },
      admin: {
        actions: "Действия",
        activate: "Активировать",
        confirmDelete: "Точно удалить?",
        createInvite: "Создать ссылку-приглашение",
        days: "Дни",
        delete: "Удалить",
        docContentDe: "Содержимое (DE)",
        docContentEn: "Содержимое (EN)",
        docDraft: "Черновик",
        docKey: "Ключ",
        docOrder: "Порядок",
        docPublished: "Опубликовано",
        docTitleDe: "Заголовок (DE)",
        docTitleEn: "Заголовок (EN)",
        docVersion: "Версия",
        edit: "Редактировать",
        invExpired: "Истекло",
        invOpen: "Открыто",
        invRevoked: "Отозвано",
        invUsed: "Использовано",
        invitations: "Приглашения",
        inviteCreated: "Приглашение создано — ссылка скопирована в буфер",
        inviteExpiry: "Срок действия",
        inviteHint: "Ссылка автоматически копируется при создании. Отправь её новому участнику по e-mail или в мессенджере. Каждая ссылка используется только один раз.",
        inviteLabel: "Метка",
        inviteLabelPh: "напр., имя приглашённого",
        inviteRevoked: "Приглашение отозвано",
        lock: "Заблокировать",
        members: "Участники",
        newDoc: "Новый документ",
        newPwFor: "Новый пароль для",
        publish: "Опубликовать",
        publishHint: "Публикация повышает версию, и всем участникам нужно снова согласиться.",
        publishNew: "Опубликовать новую версию",
        pwReset: "Пароль сброшен",
        resetPw: "Задать пароль",
        riskDocs: "Риск-документы",
        riskDocsHint: "Здесь ты управляешь риск-документами, которые каждый участник должен подтвердить перед использованием портала. При публикации новой версии всем участникам нужно снова согласиться.",
        role: "Роль",
        save: "Сохранить",
        saved: "Сохранено",
        statuses: {
          active: "Активен",
          disabled: "Отключён",
          locked: "Заблокирован",
          pending: "Ожидает активации"
        }
      },
      audit: {
        action: "Действие",
        actor: "Инициатор",
        meta: "Детали",
        subtitle: "Хронологический журнал всех важных изменений на портале.",
        target: "Цель",
        timestamp: "Время",
        title: "Журнал аудита"
      },
      calendar: {
        allCategories: "Все категории",
        confirmDelete: "Точно удалить эту встречу?",
        created: "Встреча создана",
        deleted: "Встреча удалена",
        duration: "Длительность",
        editEvent: "Редактировать встречу",
        fields: {
          category: "Категория",
          description: "Описание",
          descriptionPh: "Детали, повестка, заметки …",
          endAt: "Окончание (необязательно)",
          link: "Ссылка (Zoom / Meet / вебинар)",
          linkPh: "https://…",
          location: "Место (необязательно)",
          locationPh: "напр. Online, Zoom, Берлин",
          recurrence: "Повтор",
          recurrenceNone: "Нет (разово)",
          recurrenceUntil: "Повторять до (опционально)",
          recurrenceWeekly: "Каждую неделю",
          startAt: "Начало",
          title: "Название",
          titlePh: "напр. Еженедельный live-call"
        },
        ical: {
          close: "Закрыть",
          detectedUrl: "Обнаружено и преобразовано в",
          enabledLabel: "Автосинк включён",
          lastError: "Последняя ошибка",
          lastSync: "Последняя синхронизация",
          neverSynced: "Ещё не синхронизировано",
          openAdmin: "Импорт Google Календаря",
          save: "Сохранить URL",
          stats: "{added} добавлено · {updated} обновлено · {removed} удалено",
          subtitle: "Вставь секретный iCal-URL или публичную embed-ссылку твоего Google Календаря — мы автоматически конвертируем. Синхронизация каждый час.",
          syncNow: "Синхронизировать сейчас",
          title: "Импорт Google Календаря",
          urlLabel: "iCal или URL календаря",
          urlPh: "https://calendar.google.com/calendar/..."
        },
        joinLink: "К событию",
        months: [
          "Январь",
          "Февраль",
          "Март",
          "Апрель",
          "Май",
          "Июнь",
          "Июль",
          "Август",
          "Сентябрь",
          "Октябрь",
          "Ноябрь",
          "Декабрь"
        ],
        moreEvents: "+ ещё {n}",
        newEvent: "Новое событие",
        next: "Далее",
        noEvents: "В этом месяце событий нет.",
        noUpcoming: "Ближайших событий нет.",
        prev: "Назад",
        recurringBadge: "Еженедельно",
        recurringUntil: "до {date}",
        save: "Сохранить",
        subtitle: "Все live-call, вебинары и окна обслуживания — с первого взгляда.",
        title: "Календарь",
        today: "Сегодня",
        upcoming: "Ближайшие события",
        updated: "Событие обновлено",
        weekdaysShort: ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"],
        when: "Время"
      },
      heroSubtitles: {
        academy: "Короткие уроки, туториалы и материалы",
        adminAcademy: "Управляй категориями и уроками базы знаний",
        adminSupport: "Обзор всех обращений в поддержку",
        audit: "Хронологический журнал всех действий в портале",
        calculator: "Симулируй доходность, плечо и выводы",
        calendar: "Live-call, вебинары и события — всё с первого взгляда",
        dashboard: "Твой прогресс и вехи в copy-trading",
        history: "Вся твоя история сделок — в одном месте",
        members: "Управление участниками и приглашения",
        riskCenter: "Твои риск-документы и личный риск-профиль",
        riskDocs: "Управляй версионными риск-документами",
        settings: "Настройки и предпочтения портала",
        social: "Автоматически генерируй посты для комьюнити и соцсетей",
        strategy: "Твоя личная landing-page и управление рефералами",
        support: "Прямая связь с администратором портала – вопросы и проблемы по Team Portal",
        tracking: "Веди учёт сделок аккуратно и без пробелов"
      },
      kb: {
        backToOverview: "Назад к обзору",
        categories: "Категории",
        close: "Закрыть",
        empty: "Пока нет доступных материалов.",
        featured: "Рекомендуемые материалы для тебя",
        items: "Материалы",
        lessons: "Уроки",
        minutes: "мин",
        noRecent: "Пока ничего не смотрел(а).",
        noResults: "Контент не найден.",
        popular: "Популярные материалы",
        readMore: "Открыть",
        recent: "Недавно просмотрено",
        relativeDayAgo: "{n} день назад",
        relativeDaysAgo: "{n} дней назад",
        relativeToday: "сегодня",
        relativeYesterday: "вчера",
        searchPh: "Ищи темы, курсы или материалы…",
        showAll: "Показать все",
        subtitle: "Подборка тем, туториалов и ресурсов.",
        title: "База знаний",
        typeArticle: "Статья",
        typeCourse: "Курс",
        typeFaq: "FAQ",
        typeGuide: "Инструкция",
        typeQuiz: "Квиз",
        typeVideo: "Видео",
        videoLabel: "Видео",
        viewsSuffix: "просмотров"
      },
      landing: {
        copied: "Скопировано в буфер обмена",
        copyUrl: "Скопировать URL",
        notSet: "Сначала введи персональную ссылку-идентификатор.",
        openPreview: "Открыть предпросмотр",
        refHint: "Должно начинаться с http(s)://. Эта ссылка используется на всех CTA-кнопках твоей лендинговой страницы.",
        refLabel: "Твоя ссылка из CopyXapp / IB Portal Backoffice (в Profile ссылка в разделе Partner → Копировать ссылку)",
        refPh: "https://...?ref=...",
        save: "Сохранить",
        saved: "Лендинг обновлён",
        slugHint: "2–30 символов, a–z, 0–9 и дефис. Станет частью твоего URL.",
        slugLabel: "Твоя персональная ссылка-идентификатор",
        slugPh: "напр. max, sonic-max, max-2026",
        slugTaken: "Эта ссылка-идентификатор уже занята.",
        subtitle: "Создай свою персональную ссылку-идентификатор и добавь ссылку из IB Portal Backoffice. Все CTA-кнопки на публичном лендинге будут вести на неё.",
        title: "Твой лендинг",
        yourUrl: "Твой публичный URL"
      },
      onboarding: {
        accepted: "Подтверждено",
        allAccepted: "Все документы подтверждены",
        back: "Назад",
        completed: "Портал открыт",
        finish: "Открыть доступ к порталу",
        maxLoss: "Макс. допуск по убытку (%)",
        maxLossHint: "Начиная с этого drawdown ты хочешь вмешаться или получать уведомления.",
        next: "Далее",
        of: "из",
        openDoc: "Открыть",
        payoutRate: "Доля выплат (%)",
        pendingHint: "Ещё не закрыто: {n}",
        readAndAccept: "Я прочитал(а) и понял(а)",
        reconsentDesc: "Мы обновили один или несколько риск-документов. Пожалуйста, прочитай и подтверди новую версию, чтобы продолжить пользоваться порталом.",
        reconsentTitle: "Обновлённые риск-документы",
        startCapital: "Стартовый капитал ($)",
        step: "Шаг",
        step1Desc: "Коротко о портале. Здесь ты прозрачно отслеживаешь свой путь в copy trading, фиксируешь выплаты и держишь риск под контролем.",
        step1Points: [
          "Твои данные приватны — их видишь только ты и админ.",
          "Трейдинг — высокорисковая деятельность. Мы лишь отображаем данные, не консультируем.",
          "Вся доходность основана на твоих фактических вводах."
        ],
        step1Title: "Добро пожаловать",
        step2Desc: "Пожалуйста, внимательно прочитай каждый документ и по отдельности подтверди, что ты понял(а) содержание.",
        step2Title: "Подтвердить риск-документы",
        step3Desc: "Задай стартовые параметры. Их можно в любой момент изменить в Риск-центре.",
        step3Title: "Личный риск-профиль",
        step4Desc: "Проверь данные и открой доступ к порталу.",
        step4Title: "Сводка",
        subtitle: "Пройди следующие шаги, чтобы открыть доступ к своему порталу.",
        summaryDocs: "Подтверждённые документы",
        summaryProfile: "Твой риск-профиль",
        targetLeverage: "Целевой коэффициент копирования",
        title: "Добро пожаловать в Team Phoenix"
      },
      personal: {
        currentDrawdown: "Текущий drawdown",
        currentGain: "Текущая прибыль",
        entries: "Записи",
        goalDouble: "Удвоить капитал",
        goalGain: "Целевая прибыль",
        leverageTarget: "Целевое плечо",
        lossToleranceNear: "Убыток приближается к твоему допуску.",
        lossToleranceReached: "Допуск по убытку превышен — проверь настройки риска.",
        maxDrawdown: "Макс. drawdown",
        openRiskCenter: "В Риск-центр",
        payoutRateActual: "Фактически",
        payoutRateGoal: "Цель по выплатам",
        profileMissing: "Сначала настрой свой риск-профиль.",
        progress: "Прогресс",
        subtitle: "Твой личный прогресс относительно целей из риск-профиля.",
        title: "Мой прогресс"
      },
      register: {
        desc: "Тебя пригласили в портал участников Team Phoenix. Создай личный аккаунт.",
        displayName: "Имя и фамилия",
        email: "E-mail",
        expired: "Срок действия приглашения истёк. Запроси новую ссылку-приглашение.",
        invalid: "Приглашение недействительно или уже использовано. Обратись к своему контактному лицу.",
        password: "Пароль (мин. 8 символов)",
        password2: "Повтори пароль",
        pendingMsg: "Регистрация успешна! Твой аккаунт ещё должен быть активирован администратором.",
        pwMismatch: "Пароли не совпадают.",
        pwShort: "Пароль должен быть не короче 8 символов.",
        riskNote: "Регистрируясь, ты подтверждаешь, что этот портал предназначен для документации и не является инвестиционной рекомендацией. Трейдинг может привести к полной потере средств.",
        submit: "Создать аккаунт",
        title: "Регистрация (только по приглашению)"
      },
      riskCenter: {
        acceptedOn: "Подтверждено",
        close: "Закрыть",
        docsSection: "Риск-документы",
        notAccepted: "Ещё не подтверждено",
        profileSection: "Твой риск-профиль",
        profileUpdated: "Профиль обновлён",
        reAccept: "Подтвердить новую версию",
        subtitle: "Твои принятые документы и твой личный риск-профиль.",
        title: "Риск-центр",
        updateProfile: "Сохранить профиль",
        version: "Версия",
        view: "Открыть"
      },
      support: {
        admin: "Поддержка",
        adminSubtitle: "Все обращения участников. Отвечай прямо в тикете.",
        adminTitle: "Тикеты поддержки",
        created: "Создано",
        filterAll: "Все",
        message: "Сообщение",
        messagePh: "Опиши свой запрос как можно подробнее.",
        newTicket: "Новый тикет",
        noTickets: "Пока нет обращений.",
        reply: "Ответить",
        replySent: "Ответ отправлен",
        send: "Отправить",
        setStatus: "Изменить статус",
        status: "Статус",
        statusClosed: "Закрыто",
        statusInProgress: "В работе",
        statusOpen: "Открыто",
        subject: "Тема",
        subjectPh: "напр. вопрос по уроку",
        subtitle: "Твои обращения в команду. Ответим как можно быстрее.",
        ticketCreated: "Обращение отправлено",
        title: "Поддержка",
        unread: "Новое",
        updated: "Обновлено",
        you: "Ты"
      }
    },
  es: {
      appTitle: "Team Phoenix Portal",
      disclaimer: {
        title: "Antes de continuar",
        intro: "Lee y confirma los siguientes puntos para usar el sitio.",
        items: [
          "He leído y comprendido el descargo de responsabilidad: todo el contenido de esta página no constituye asesoramiento de inversión, financiero, fiscal ni legal. Se trata exclusivamente de la documentación de experiencias y opiniones personales del operador.",
          "Responsabilidad propia: toda la información sirve exclusivamente para información general. Cada decisión que tome basándome en este contenido la tomo de forma independiente y bajo mi propio riesgo.",
          "Aviso de riesgo: el trading de instrumentos financieros (p. ej. acciones, fondos o criptoactivos) conlleva riesgos considerables y puede llevar a la pérdida total del capital invertido. Los resultados pasados no garantizan la evolución futura.",
          "Soy consciente de que yo tampoco puedo prestar asesoramiento ni hacer recomendaciones. Esta página informa exclusivamente sobre experiencias propias."
        ],
        yes: "SÍ",
        accept: "Aceptar y continuar",
        ipNote: "Al aceptar, tu dirección IP se registra con fines probatorios."
      },
      tabs: {
        dashboard: "Mi viaje",
        calculator: "Calculadora",
        tracking: "Seguimiento",
        history: "Historial",
        strategy: "Estrategia",
        risk: "Riesgo",
        social: "Social",
        settings: "Ajustes",
        academy: "Base de conocimientos",
        adminAcademy: "CMS de conocimientos",
        adminGroup: "Admin",
        adminSupport: "Soporte (Admin)",
        audit: "Registro de auditoría",
        calendar: "Calendario",
        marketing: "Marketing",
        members: "Miembros",
        riskCenter: "Centro de riesgo",
        riskDocs: "Documentos de riesgo",
        support: "Portal Support",
        links: "Enlaces y direcciones de correo",
        adminLinks: "Enlaces y correos (Admin)"
      },
      edu: {
        heroBadge: "Plataforma educativa · Sin ventas, sin promesas",
        heroH1a: "Deja que traders con experiencia operen por ti —",
        heroH1b: "tu dinero siempre permanece en tu propia cuenta de bróker.",
        heroSub: "No tienes que leer gráficos ni operar tú mismo. Una estrategia verificada se refleja automáticamente en tu propia cuenta. Mantienes el control total en todo momento.",
        b1t: "Tu capital se queda contigo",
        b1x: "El dinero está en tu cuenta de bróker, no con nosotros.",
        b2t: "Las operaciones se copian",
        b2x: "De forma automática – tú no tienes que intervenir.",
        b3t: "Todo transparente",
        b3x: "Cada operación es verificable públicamente.",
        ctaStart: "Empieza ahora",
        ctaLearn: "Saber más",
        illBroker: "Tu cuenta de bróker",
        illControl: "bajo tu control",
        illGold: "Oro",
        illGoldNote: "El mercado en el que opera la estrategia.",
        illApp: "Sonic App",
        illProgress: "Progreso",
        illLastTrade: "Última operación",
        illStrategy: "Estrategia",
        illActive: "Activa · El control es tuyo",
        whatEye: "Primero lo básico",
        whatTitle: "¿Qué es el copy trading?",
        whatIntro: "En resumen: un trader con experiencia toma las decisiones. Estas se transfieren automáticamente a tu cuenta. Tú no tienes que hacer nada.",
        whatStep: "Paso",
        whatS1t: "Trader con experiencia",
        whatS1x: "Analiza el mercado y toma la decisión.",
        whatS2t: "Abre una operación",
        whatS2x: "Orden de compra o venta en su cuenta.",
        whatS3t: "Automático en tu cuenta",
        whatS3x: "La misma orden se refleja – en proporción a tu capital.",
        whatS4t: "El resultado llega a ti",
        whatS4x: "Ganancia o pérdida aparecen proporcionalmente en tu cuenta.",
        whatImportant: "Importante: tú no operas. Copias la estrategia. Las decisiones se quedan con el trader; tu capital se queda contigo.",
        howEye: "El flujo",
        howTitle: "¿Cómo funciona exactamente?",
        howS1t: "Abre una cuenta de bróker",
        howS1x: "Cuenta gratuita en TAG Markets – lleva unos minutos.",
        howS2t: "Conecta la estrategia",
        howS2x: "A través de un servicio dedicado (COPYX) autorizas la copia automática.",
        howS3t: "El trader abre una posición",
        howS3x: "El trader con experiencia decide en su cuenta.",
        howS4t: "La operación aparece en la tuya",
        howS4x: "La misma orden llega a tu cuenta automáticamente – sin acción de tu parte.",
        howS5t: "Sigue tu evolución",
        howS5x: "Ves todo en el portal en cualquier momento – transparente y en tiempo real.",
        skillEye: "Para principiantes",
        skillTitle: "¿Necesito saber operar?",
        skillNo: "No.",
        skillNoNote: "No se requiere conocimiento previo.",
        skillDesc: "Todas las decisiones las toma el trader con experiencia. Tú solo ves lo que pasa – y aprendes por el camino.",
        skill1: "sin leer gráficos",
        skill2: "sin análisis de mercado",
        skill3: "sin decisiones de compra",
        skill4: "sin señales de venta",
        skill5: "sin evaluar noticias",
        skill6: "sin trabajar los domingos",
        moneyEye: "Confianza",
        moneyTitle: "¿Y mi dinero, dónde está?",
        moneySub: "La pregunta más importante – y la respuesta más sencilla:",
        moneyAccLabel: "Tu cuenta de bróker",
        moneyAccNote: "Aquí – y solo aquí – está tu capital.",
        moneyP1t: "En tu cuenta de bróker",
        moneyP1x: "Una cuenta regulada que solo te pertenece a ti. No tenemos acceso a tu saldo.",
        moneyP2t: "Solo autorización de trading",
        moneyP2x: "La estrategia solo puede colocar operaciones – nunca tocar el dinero.",
        moneyP3t: "Sin pagos a terceros",
        moneyP3x: "Depósitos y retiros van directamente entre tú y tu bróker.",
        moneyP4t: "Pausa o cancelación en cualquier momento",
        moneyP4x: "Un clic detiene o termina la copia por completo.",
        moneyCtrl: "El control total sigue siendo tuyo.",
        moneyCtrlSub: "Sin gestores de fondos, sin custodia, sin pagos por terceros.",
        whyEye: "Público",
        whyTitle: "¿Por qué la gente usa copy trading?",
        whyP1t: "“No tengo tiempo”",
        whyP1x: "Trabajo, familia, vida – el copy trading sigue funcionando mientras vives la tuya.",
        whyP2t: "“No tengo experiencia”",
        whyP2x: "No hace falta saber de trading. La estrategia decide, tú aprendes por el camino.",
        whyP3t: "“Quiero invertir con transparencia”",
        whyP3x: "Cada operación es verificable. Ves exactamente qué se hace y por qué.",
        whyP4t: "“Prefiero dejárselo a los profesionales”",
        whyP4x: "Los traders con experiencia tienen años de práctica. Puedes aprovechar sus decisiones 1:1.",
        transEye: "Transparencia",
        transTitle: "¿Qué es Myfxbook — y por qué importa?",
        transPara: "Myfxbook es un servicio independiente de verificación de cuentas de trading. Se conecta directamente a la cuenta de bróker del trader y registra automáticamente cada operación – es imposible &bdquo;maquillar&ldquo; los números después.",
        trans1: "Cada operación se guarda en tiempo real – no a final de mes.",
        trans2: "La manipulación es imposible: los datos vienen directamente del bróker.",
        trans3: "Puedes consultar cuando quieras – público, sin login.",
        trans4: "También se ven las pérdidas – no solo las ganancias. Eso crea confianza real.",
        transCta: "Ver el historial público",
        transVer: "Cuenta verificada",
        transLive: "Live",
        transK1: "Operaciones totales",
        transK2: "Tasa de acierto",
        transK3: "Activo desde hace",
        transK4: "Máx. pérdida",
        transK3v: "21 meses",
        transExpl: "&bdquo;Fase de pérdida&ldquo; = la mayor caída entre un pico y el siguiente valle. Cuanto menor el número, más tranquila la curva.",
        oppEye: "Honesto, no publicitario",
        oppTitle: "Oportunidades y riesgos – claros",
        oppSub: "Ambos van juntos. Los mostramos uno al lado del otro, sin adornos.",
        oppTitleC: "Oportunidades",
        oppTitleR: "Riesgos",
        opp1: "Separación clara entre capital (contigo) y estrategia (con el trader).",
        opp2: "Ahorro de tiempo: sin análisis, sin gráficos, sin móvil de alarma.",
        opp3: "Transparencia total gracias al historial verificado.",
        opp4: "Curva de aprendizaje incluida: ves cómo trabaja un profesional.",
        opp5: "Pausa cuando quieras – sin contrato, sin permanencia.",
        risk1: "Las pérdidas son posibles – incluida la pérdida total del capital.",
        risk2: "El rendimiento histórico no garantiza resultados futuros.",
        risk3: "El mercado (oro) puede moverse mucho, incluso en poco tiempo.",
        risk4: "Sin experiencia con brókers, la primera configuración lleva tiempo.",
        risk5: "No apto para capital que puedas necesitar a corto plazo.",
        faqEye: "FAQ",
        faqTitle: "Preguntas frecuentes",
        faqQ1: "¿Qué es exactamente el copy trading?",
        faqA1: "Copy trading significa: un trader con experiencia toma las decisiones y estas se transfieren automáticamente a tu cuenta de bróker. Tú no operas – copias la estrategia.",
        faqQ2: "¿Mi dinero se queda realmente en mi cuenta?",
        faqA2: "Sí. Tu capital está en un bróker regulado en una cuenta que solo te pertenece a ti. La estrategia solo tiene permiso para colocar operaciones – nunca acceso al dinero.",
        faqQ3: "¿Puedo dejarlo cuando quiera?",
        faqA3: "Sí. Puedes pausar o terminar la copia con un clic. Sin plazo mínimo ni preaviso.",
        faqQ4: "¿Cómo retiro las ganancias?",
        faqA4: "Directamente de la cuenta de bróker a tu banco. Depósitos y retiros van solo entre tú y el bróker – no pasan por nosotros.",
        faqQ5: "¿Necesito experiencia en trading?",
        faqA5: "No. No hace falta conocimiento previo. La estrategia gestiona todas las decisiones. Si quieres aprender, encontrarás una base de conocimiento estructurada en el portal de miembros.",
        faqQ6: "¿Cuánto cuesta?",
        faqA6: "Solo pagas por resultado: una performance fee sobre los beneficios realmente obtenidos. Sin ganancia, no hay comisión. Todos los detalles se muestran antes de conectar.",
        faqQ7: "¿Qué pasa en caso de pérdida?",
        faqA7: "Las pérdidas son parte del mercado y se reflejan proporcionalmente a tu capital. El historial muestra tanto las fases positivas como las negativas.",
        faqQ8: "¿Por qué precisamente oro?",
        faqA8: "El oro (ticker &bdquo;XAUUSD&ldquo;) es uno de los mercados más líquidos del mundo: spreads ajustados, movimientos claros y disponibilidad 24/7. La estrategia está optimizada para sus características.",
        faqQ9: "¿Qué es MT5?",
        faqA9: "MetaTrader 5 (MT5) es una plataforma de trading muy extendida. El bróker la proporciona gratis. La estrategia &bdquo;habla&ldquo; con el bróker mediante MT5 para colocar las operaciones. Tú no tienes que usar MT5.",
        softH1: "Cuando entiendas cómo funciona el copy trading,",
        softH2: "puedes ver cómo ha trabajado históricamente la estrategia.",
        softSub: "Sin promesas, sin presión. Solo números de cuentas reales y verificadas.",
        softAgain: "Volver a leer desde el principio",
      },
      strategy: {
        badge: "Estrategia activa – en vivo",
        hero1: "Trading automático de oro –",
        heroHighlight: "mi estrategia de un vistazo",
        heroSub: "La estrategia SONIC opera oro (XAUUSD) a través de traders experimentados. Cada operación se replica vía MT5 en tu propia cuenta – sin que tengas que operar tú mismo. Aquí encontrarás los datos clave y el camino para empezar.",
        kpiDaily: "Rentabilidad diaria (24x)",
        kpiMonthly: "Rentabilidad mensual (24x)",
        kpiDrawdown: "Drawdown máx. (1x)",
        kpiTrades: "Operaciones · Tasa de acierto",
        kpiNote: "Indicadores calculados en vivo a partir del historial real de operaciones ({months} meses, antes de comisiones, apalancamiento 24x). Los resultados pasados no garantizan el futuro.",
        cta: "Empezar ahora",
        ctaBandTitle: "¿Listo para el siguiente paso?",
        ctaBandSub: "Conecta tu cuenta y deja que la estrategia opere por ti.",
        verified: "Historial verificado (myfxbook)",
        howTitle: "Cómo funciona",
        howSub: "De la cuenta a la primera operación copiada en pocos pasos.",
        step1Title: "Conecta la cuenta",
        step1Text: "Vinculas tu propia cuenta MT5 con la estrategia en pocos minutos. El capital permanece en todo momento en tu propia cuenta.",
        step2Title: "Las operaciones se replican",
        step2Text: "Cuando la estrategia abre una posición, se reproduce automáticamente y sin retraso en tu cuenta – entrada, salida y tamaño de posición incluidos.",
        step3Title: "Juntos en el camino",
        step3Text: "Una comunidad activa de muchos países ya utiliza la estrategia. Para la configuración hay soporte paso a paso.",
        mirrorTitle: "Copiar en lugar de operar tú mismo",
        whatTitle: "¿Qué es el copy trading?",
        whatText1: "Con el copy trading, una cuenta de trading se conecta automáticamente a una estrategia existente. Cada operación que ejecuta la estrategia se replica en tiempo real en tu propia cuenta – proporcionalmente al tamaño de tu cuenta. No necesitas leer gráficos, elegir entradas y salidas ni tener experiencia en trading.",
        whatText2: "La gran diferencia con los fondos clásicos o la gestión patrimonial: el capital permanece todo el tiempo en tu propia cuenta de bróker. Nadie más que tú tiene acceso – la estrategia solo recibe permiso para colocar operaciones.",
        whatFacts: [
          "El capital permanece en tu propia cuenta – control total, siempre",
          "Las operaciones se replican de forma totalmente automática y en tiempo real",
          "La copia se puede pausar o detener por completo en cualquier momento",
          "Cada operación es verificable públicamente en Myfxbook"
        ],
        possTitle: "¿Qué posibilidades tienes con ello?",
        possSub: "El copy trading es flexible – tú decides cómo usarlo.",
        poss1Title: "Aprovechar el interés compuesto",
        poss1Text: "Las ganancias permanecen en la cuenta y se operan automáticamente. El tamaño de las posiciones crece con el saldo – el efecto del interés compuesto puede hacer crecer el capital en meses mucho más rápido que el ahorro lineal.",
        poss2Title: "Retiros regulares",
        poss2Text: "Alternativamente, parte de las ganancias puede retirarse regularmente – por ejemplo, para recuperar primero el capital inicial invertido. A partir de ese punto solo operas con „dinero de la casa“.",
        poss3Title: "Elige tu factor de copia",
        poss3Text: "Con el factor de copia (p. ej. 12x o 24x) determinas cuánto apalanca tu cuenta la estrategia. Un factor más alto significa mayor rentabilidad potencial – pero igualmente mayor riesgo de pérdida.",
        poss4Title: "Participación totalmente pasiva",
        poss4Text: "Tras la configuración única, todo funciona automáticamente. Sin leer gráficos, sin decisiones de trading, sin dedicar tiempo – y puedes seguir la evolución de forma transparente en cualquier momento.",
        riskTitle: "Oportunidades y riesgos – una mirada honesta",
        riskSub: "El copy trading con apalancamiento es una inversión de alto riesgo. Ambos lados deben estar sobre la mesa.",
        chancesLabel: "Oportunidades",
        risksLabel: "Riesgos",
        chances: [
          "Rentabilidades mensuales por encima de la media posibles – todo el historial está verificado en Myfxbook",
          "Efecto de interés compuesto mediante la reinversión automática de las ganancias",
          "No se requieren conocimientos de trading – ejecución totalmente automática",
          "Control total: cuenta propia, pausar o salir en cualquier momento"
        ],
        risks: [
          "El apalancamiento funciona en ambas direcciones – las pérdidas se amplifican igual que las ganancias",
          "La pérdida total del capital invertido es posible en cualquier momento",
          "Los resultados pasados no garantizan la evolución futura",
          "Invierte solo capital cuya pérdida total puedas asumir"
        ],
        videoTitle: "Así funciona el sistema de copy trading",
        videoSub: "El vídeo explicativo muestra paso a paso cómo trabaja el sistema.",
        mirrorText: "El principio es simple: un sistema experimentado opera, tu cuenta lo sigue automáticamente. Mantienes el control total de tu capital y puedes pausar o salir en cualquier momento. En esta página documento de forma transparente cómo evoluciona en mi caso.",
        disclaimer: "Documentación de experiencias personales – no es asesoramiento de inversión, financiero ni legal, ni una recomendación. El trading de instrumentos financieros conlleva riesgos considerables y puede llevar a la pérdida total. Cada decisión la tomas bajo tu propia responsabilidad.",
        landing: {
          liveBadge: "Estrategia activa · Señal en vivo",
          heroHead1: "Trading de oro automatizado",
          heroHead2: "con historial transparente.",
          heroSub: "Duplica una estrategia de copy-trading verificada en tu propia cuenta de bróker. Tu capital siempre bajo tu control – pausa o sal con un solo clic.",
          ctaStart: "Empieza ahora",
          ctaLive: "Ver rendimiento en vivo",
          trust: ["Historial Myfxbook verificado", "Tu propia cuenta de bróker", "Pausa cuando quieras", "Control total sobre tu capital"],
          liveDash: "Panel en vivo",
          kpiAvgMonth: "Ø mes",
          kpiWinRate: "Tasa de acierto",
          kpiDrawdown: "Drawdown",
          kpiTrades: "Operaciones",
          timelineEyebrow: "Así de simple",
          timelineTitle: "Activo en cinco pasos",
          steps: [
            { title: "Abre una cuenta de bróker", text: "Cuenta gratuita en TAG Markets en pocos minutos." },
            { title: "Conecta la estrategia", text: "Activa copy-trading vía COPYX – 2 minutos." },
            { title: "Las operaciones se replican", text: "Automático, 1:1 en tu cuenta. Sin intervención." },
            { title: "Sigue tu evolución", text: "Progreso diario en el portal de miembros & Myfxbook." },
            { title: "Aprovecha la comunidad", text: "Llamadas en vivo, base de conocimiento, soporte directo." },
          ],
          perfEyebrow: "Real & verificado",
          perfTitle: "Rendimiento en vivo desde el día uno",
          perfSub: "Curva de capital neta simulada sobre una cuenta inicial de 1 000 $ (24× amplificado, 30 % de fee de rendimiento ya deducido) – cada operación documentada al detalle.",
          perfAvgMonth: "Ø mes (neto)",
          perfWinRate: "Tasa de acierto",
          perfDrawdown: "Drawdown máx.",
          perfMonths: "Meses en vivo",
          perfChartLabel: "Curva de capital",
          perfSourceLine1: "Fuente en vivo: history_trades.",
          perfSourceLine2: "Simulación tras comisiones de bróker y fee de rendimiento.",
          perfMilestones: "Hitos",
          perfMilestoneGoal: "Objetivo",
          perfMilestoneReached: "Alcanzado:",
          perfMilestoneOpen: "Aún abierto",
          portalEyebrow: "Tu área de miembros",
          portalTitle: "Todo en un lugar. Limpio. Claro. Tuyo.",
          portalSub: "Como miembro obtienes tres herramientas clave que estructuran tu recorrido – desde el capital inicial hasta el primer retiro.",
          journeyLabel: "Mi camino",
          journeyLive: "Live",
          journeySub: "Progreso neto · 6 meses",
          journeyMilestone: "Hito",
          journeyReached: "alcanzado",
          journeyShare: "Compartible vía enlace público · Exportación PDF",
          calendarLabel: "Calendario",
          calendarMonth: "Febrero 2026",
          calendarSub: "4 eventos de comunidad · Exportación .ics",
          calendarNext: "Próximo evento",
          calendarNextText: "Live Q&A · 18 feb · 19:00",
          kbLabel: "Base de conocimiento",
          kbTitle: "AI Q&A · Respuestas instantáneas",
          kbSub: "Lecciones seleccionadas · Búsqueda con IA",
          kbUserQ: "Tu pregunta",
          kbUserQText: "¿Cuánto debería ser mi capital inicial?",
          kbAI: "Sonic AI responde",
          kbAnswer: "Inicio recomendado desde 1 000 € en una cuenta 24×. Cantidades menores son posibles pero ralentizan claramente el efecto compuesto…",
          kbLatency: "0,8 s · basado en 24 lecciones",
          cardJourney: { title: "Mi camino", desc: "Fija hitos, sigue tu progreso neto y compártelo por enlace público." },
          cardCalendar: { title: "Calendario", desc: "Llamadas en vivo, sesiones Q&A y recapitulaciones – un clic en \"Añadir al calendario\" genera un archivo .ics." },
          cardKb: { title: "Base de conocimiento", desc: "Lecciones seleccionadas más búsqueda con IA. Preguntas como \"¿Cuánto capital necesito?\" contestadas en segundos." },
          ctaMember: "Hazte miembro",
        },
      },
      kpi: {
        startCapital: "Capital inicial",
        currentBalance: "Saldo actual",
        totalProfit: "Ganancia total",
        totalPayouts: "Retiros",
        netProfit: "Ganancia neta",
        totalReturn: "Rentabilidad total",
        monthlyReturn: "Rentabilidad mensual",
        dailyReturn: "Ø rentabilidad diaria",
        volume: "Volumen de trading",
        leverage: "Apalancamiento"
      },
      recovery: "Recuperación del capital inicial",
      recoveryHint: "recuperado mediante retiros",
      growthChart: "Curva de crecimiento",
      balance: "Saldo",
      planLine: "Plan ({target} %/mes)",
      payoutsCurve: "Retiros acumulados",
      monthlyTable: "Resumen mensual",
      month: "Mes",
      profit: "Ganancia",
      fees: "Comisiones",
      feesHint: "Comisión: −{c} · Participación: −{p}",
      payout: "Retiro",
      trades: "Operaciones",
      return: "Rentabilidad",
      endBalance: "Saldo final",
      noData: "Aún no hay registros. Introduce tu primer día en el seguimiento.",
      calc: {
        title: "Calculadora de interés compuesto",
        startCapital: "Capital inicial ($)",
        monthlyReturn: "Rentabilidad mensual (%)",
        months: "Duración (meses)",
        reinvestRate: "Tasa de reinversión (%)",
        payoutRate: "Tasa de retiro (%)",
        leverage: "Factor de apalancamiento",
        compare: "Comparación: 100% reinvertido vs. estrategia de retiros",
        fullReinvest: "100% reinvertido",
        withPayout: "con retiros",
        cumPayout: "Retiros acumulados",
        tableTitle: "Evolución mensual",
        balanceEnd: "Saldo",
        volume: "Volumen",
        totalWithPayout: "Valor final incl. retiros",
        totalFull: "Valor final 100% reinvertido",
        payoutSum: "Suma de retiros",
        breakeven: "Punto de equilibrio (retiros ≥ capital inicial)",
        breakevenDouble: "Punto de equilibrio (saldo ≥ 2× depósito)",
        payoutEur: "Retiro ($/mes)",
        effReturn: "≙ efectivo {eff} % al mes con {lev}x",
        histAvgNote: "Precargado: media histórica {avg} % (a 24x, antes de la participación en beneficios)",
        feeNote: "− 30 % de participación en beneficios (deducida cada viernes de la ganancia semanal) ≙ neto {net} % al mes",
        noCompound: "Sin interés compuesto: {v}",
        breakevenMonths: "tras {m} meses",
        breakevenWeeks: "≈ {w} semanas",
        breakevenNot: "No alcanzado en el período",
        calcDisclaimer: "Cálculo modelo – sin garantía. Las rentabilidades reales fluctúan, pérdida total posible."
      },
      track: {
        title: "Seguimiento diario",
        date: "Fecha",
        startBalance: "Saldo inicial ($)",
        endBalance: "Saldo final ($)",
        payout: "Retiro ($)",
        commission: "Comisión ($)",
        traderFee: "Participación del trader 30% ($)",
        commissionShort: "Comisión",
        traderFeeShort: "Participación",
        netProfit: "Neto",
        suggestedFee: "Sugerencia (30% de la ganancia)",
        netPreview: "Neto después de comisiones",
        trades: "Número de operaciones",
        note: "Nota",
        marketEvent: "Evento de mercado",
        profitPreview: "Ganancia/pérdida diaria",
        suggestedPayout: "Sugerencia (10% de la ganancia)",
        apply: "aplicar",
        save: "Guardar día",
        update: "Actualizar",
        editing: "Editando registro del {date}",
        cancel: "Cancelar",
        saved: "Registro guardado",
        deleted: "Registro eliminado",
        entries: "Registros",
        exportCsv: "Exportar CSV",
        settings: "Ajustes",
        settingsStart: "Capital inicial ($)",
        settingsLeverage: "Apalancamiento",
        settingsSave: "Guardar",
        settingsSaved: "Ajustes guardados",
        reinvested: "Reinvertido",
        actions: ""
      },
      social: {
        title: "Generador de redes sociales",
        type: "Tipo de publicación",
        types: {
          daily: "Actualización diaria",
          weekly: "Actualización semanal",
          monthly: "Actualización mensual",
          milestone: "Hito",
          loss: "Actualización honesta de pérdidas"
        },
        language: "Idioma de la publicación",
        context: "Contexto adicional (opcional)",
        contextPlaceholder: "p. ej. mercado fuerte hoy, hito del 25% alcanzado ...",
        generate: "Generar publicación",
        generating: "Generando ...",
        copy: "Copiar",
        copied: "Copiado al portapapeles",
        empty: "La publicación generada aparecerá aquí.",
        note: "Cada publicación termina automáticamente con el aviso de riesgo."
      },
      risk: {
        title: "Seguimiento de riesgo",
        worstDay: "Mayor pérdida diaria",
        maxDrawdown: "Drawdown máx.",
        lossStreak: "Racha de pérdidas más larga",
        winStreak: "Racha de ganancias más alta",
        currentStreak: "Racha actual",
        liqDistance: "Distancia a la liquidación",
        days: "días",
        hypoTitle: "Pérdida hipotética con movimiento de mercado/estrategia (con apalancamiento)",
        move: "Movimiento",
        loss: "Pérdida",
        remaining: "Capital restante",
        wiped: "Cuenta liquidada",
        ddChart: "Evolución del drawdown",
        milestones: "Hitos – recuperación del capital inicial",
        milestoneReached: "¡Hito alcanzado: {th} % del capital inicial recuperado!",
        reachedOn: "alcanzado el",
        open: "pendiente",
        generatePost: "Generar publicación",
        milestoneContext: "Hito alcanzado: {th} % del capital inicial recuperado mediante retiros (el {date}).",
        warnTitle: "Advertencias",
        warnings: {
          liquidation_close: "Con apalancamiento {lev}x, un movimiento de aprox. -{liq} % ya basta para una pérdida total (liquidación).",
          drawdown_high: "El drawdown máximo supera el 15 % – riesgo elevado.",
          loss_streak: "Racha de pérdidas actual de 3+ días – revisa la estrategia críticamente.",
          big_daily_loss: "Ya hubo una pérdida diaria superior al 5 % – alta volatilidad.",
          none: "Sin advertencias agudas. El riesgo básico del apalancamiento permanece."
        }
      },
      settings: {
        title: "Parámetros del experimento",
        description: "Estos valores controlan todo el experimento: cálculos del panel, sugerencia de retiro, línea del plan e indicadores de riesgo.",
        startCapital: "Capital inicial ($)",
        leverage: "Factor de apalancamiento",
        reinvestRate: "Tasa de reinversión (%)",
        payoutRate: "Tasa de retiro (%)",
        monthlyTarget: "Rentabilidad mensual objetivo (%)",
        journeyDays: "Duración objetivo del viaje (días)",
        goalAmount: "Objetivo de saldo ($)",
        sumHint: "Nota: reinversión + retiro no suman 100 %.",
        save: "Guardar",
        saved: "Ajustes guardados",
        preview: "Vista previa",
        leverageWarning: "Atención: con apalancamiento {lev}x, un movimiento de aprox. -{liq} % lleva a la pérdida total."
      },
      share: {
        live: "En vivo · Experimento público",
        subtitle: "Experimento de copy trading transparente – todas las cifras sin maquillar, pérdidas incluidas.",
        copyLink: "Copiar enlace para compartir",
        copied: "Enlace copiado",
        historySubtitle: "Historial real de operaciones de 21 meses – simula tú mismo qué habría pasado con tu entrada.",
        calcTitle: "Calcula tu posible evolución futura",
        calcHero1: "Calcula tu posible",
        calcHeroHighlight: "evolución futura",
        tabHistory: "Historial de operaciones",
        tabCalc: "Calculadora",
        tabJourney: "Mi viaje",
        tabLive: "Panel en vivo",
        hero1: "Tu",
        heroHighlight: "rendimiento",
        hero2: "a la vista",
        config: "Tu configuración",
        configStart: "Capital inicial",
        configLeverage: "Apalancamiento / factor",
        configPayout: "Tasa de retiro",
        configEdit: "Editar configuración",
        quote: "Disciplina hoy, libertad mañana.",
        quoteSub: "Tu objetivo. Tu camino. Tu éxito.",
        footerLine: "Transparencia. Disciplina. Éxito.",
        historyBadge: "Operaciones reales · Documentado históricamente",
        copyHistoryLink: "Copiar enlace público del historial",
        toDashboard: "Al panel en vivo",
        toHistory: "Al historial de operaciones"
      },
      weekly: {
        title: "Actualización semanal pendiente",
        desc: "Período {since} – {until} · {days} días registrados · Ganancia {profit} · Retiros {payout} · Rentabilidad {return}",
        context: "Actualización semanal para el período del {since} al {until}: ganancia {profit}, retiros {payout}, rentabilidad semanal {return}, {days} días registrados.",
        generate: "Generar actualización semanal",
        dismiss: "Más tarde"
      },
      history: {
        title: "Backtest histórico",
        subtitle: "Basado en {trades} operaciones reales (del {first} al {last}, {months} meses). ¿Qué habría pasado con tu entrada?",
        startCapital: "Capital inicial ($)",
        leverage: "Apalancamiento / factor de copia",
        payoutRate: "Tasa de retiro (%)",
        endBalance: "Saldo al final",
        endBalanceFull: "Sin retiros (100 % reinvertido)",
        totalPayouts: "Suma de retiros",
        totalReturn: "Rentabilidad total (incl. retiros)",
        maxDrawdown: "Drawdown máx.",
        avgMonthly: "Ø rentabilidad mensual",
        winRate: "Tasa de acierto de operaciones",
        bestDay: "Mejor día",
        worstDay: "Peor día",
        breakeven: "Punto de equilibrio (retiros ≥ capital inicial)",
        breakevenDouble: "Punto de equilibrio (saldo ≥ 2× depósito)",
        payoutEur: "Retiro ($/mes)",
        feeNote: "Todos los valores incluyen el 30 % de participación en beneficios de los traders (deducido cada viernes de la ganancia bruta semanal, solo en semanas positivas).",
        simpleReturn: "Rentabilidad sin interés compuesto",
        simpleReturnSub: "Ganancias no reinvertidas",
        breakevenMonths: "tras {m} meses",
        breakevenWeeks: "≈ {w} semanas · alcanzado el {date}",
        breakevenNot: "No alcanzado en el período",
        curve: "Evolución del capital (simulación histórica)",
        withPayout: "Saldo (con retiros)",
        fullReinvest: "100 % reinvertido",
        cumPayout: "Retiros acumulados",
        monthlyTable: "Evolución mensual",
        note: "Simulación histórica basada en operaciones pasadas. Los resultados pasados NO garantizan el futuro – con apalancamiento {lev}x el drawdown máximo fue del {dd} %. La pérdida total es posible en cualquier momento.",
        loading: "Calculando ...",
        noData: "No se encontraron operaciones históricas.",
        upload: "Actualizar operaciones (CSV)",
        uploadOk: "{n} operaciones importadas (hasta {last})",
        uploadFail: "Importación fallida",
        dataStatus: "Datos: {n} operaciones · última operación {last}",
        mfbStatus: "myfxbook en vivo: {gain} % ganancia · {dd} % drawdown",
        mfbLink: "Ver el historial verificado en Myfxbook"
      },
      stats: {
        title: "Análisis de operaciones",
        profitFactor: "Factor de beneficio",
        profitFactorSub: "Ganancia bruta ÷ pérdida bruta",
        avgWin: "Ø operación ganadora",
        avgLoss: "Ø operación perdedora",
        longWinRate: "Acierto en largos",
        shortWinRate: "Acierto en cortos",
        avgDuration: "Ø duración de operación",
        byWeekday: "Rendimiento por día de la semana",
        byHour: "Rendimiento por hora",
        byMonth: "Rendimiento por mes",
        pips: "Pips",
        winShort: "Acierto",
        winTrades: "Operaciones ganadoras",
        lossTrades: "Operaciones perdedoras",
        weekdaysShort: ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"]
      },
      journey: {
        heroTitle: "Mi camino hacia la libertad financiera",
        publicNote: "Lo que ves aquí es mi cuenta de trading personal, que documento día a día de forma transparente – con todas las ganancias, pérdidas y contratiempos. Comparto este viaje para registrar mis propias experiencias. Todo el contenido sirve exclusivamente para tu información y no constituye recomendación ni asesoramiento.",
        heroSubtitle: "Cada operación me acerca a mi objetivo. Este proyecto documenta de forma transparente todo mi camino – incluidas ganancias, pérdidas y contratiempos.",
        dayLabel: "Mi viaje",
        day: "Día {d} de {total}",
        totalProfit: "Ganancia total desde el inicio",
        remaining: "Falta para recuperar el capital",
        balance: "Saldo actual",
        doneShort: "¡Conseguido!",
        capitalBack: "Recuperar el capital inicial",
        capitalBackDone: "Capital inicial completamente recuperado",
        goal: "Objetivo: {goal}",
        goalHint: "Referido al saldo – el objetivo se puede ajustar en los ajustes.",
        payoutIncluded: "de los cuales pagados (ya en ganancia)",
        todayProfit: "Ganancia hoy",
        lastProfit: "Último día de trading",
        winStreak: "Racha de ganancias",
        days: "días",
        roi: "ROI",
        timeline: "Mi viaje – día a día",
        win: "Ganancia",
        loss: "Pérdida",
        noTrade: "Sin operaciones",
        trades: "operaciones",
        tradesOne: "operación",
        balanceArrow: "Saldo",
        achievements: "Hitos",
        achievedAt: "Alcanzado el {date}",
        locked: "Aún no alcanzado",
        newAchievement: "Nuevo hito alcanzado:",
        goalBanner: "Tu objetivo te espera en el horizonte – sigue adelante.",
        quotes: [
          "La constancia vence al talento.",
          "Los pequeños pasos llevan a grandes metas.",
          "La disciplina es el puente entre la meta y el éxito.",
          "Cada operación es solo un paso más en tu camino.",
          "No gana la perfección – sino la constancia.",
          "El mejor momento para empezar fue ayer. El segundo mejor es hoy."
        ],
        a: {
          first_trade: "Primera operación",
          first_payout: "Primer retiro",
          profit_100: "100 $ de ganancia",
          profit_500: "500 $ de ganancia",
          profit_1000: "1.000 $ de ganancia",
          capital_back: "Capital inicial recuperado",
          streak_10: "10 días ganadores seguidos",
          trades_100: "100 operaciones",
          balance_10k: "Saldo de 10.000 $",
          balance_50k: "Saldo de 50.000 $",
          balance_100k: "Saldo de 100.000 $"
        }
      },
      auth: {
        title: "Área protegida",
        desc: "Introduce la contraseña para gestionar el panel. Las páginas públicas siguen siendo de libre acceso.",
        password: "Contraseña",
        login: "Iniciar sesión",
        back: "Volver a la vista general",
        error: "Contraseña incorrecta",
        locked: "Demasiados intentos – espera 15 minutos.",
        logout: "Cerrar sesión",
        email: "E-mail (login de miembros)",
        forgot: "¿Olvidaste la contraseña?",
        forgotPanel: {
          backShort: "atrás",
          title: "Restablecer contraseña",
          desc: "Introduce tu e-mail. Si existe una cuenta, te enviaremos un enlace de restablecimiento.",
          emailLabel: "E-mail",
          emailPh: "tu@email.com",
          submit: "Enviar enlace",
          done: {
            title: "E-mail enviado",
            desc: "Si existe una cuenta con este e-mail, encontrarás en tu bandeja un enlace para restablecer la contraseña. El enlace es válido durante 2 horas.",
            toLogin: "Volver al login",
          },
        },
        reset: {
          title: "Restablecer contraseña",
          newPw: "Nueva contraseña",
          confirmPw: "Confirmar nueva contraseña",
          submit: "Establecer contraseña",
          intro: "Por favor, introduce tu nueva contraseña (mínimo 8 caracteres).",
          pwTooShort: "Contraseña demasiado corta (mín. 8 caracteres)",
          pwMismatch: "Las contraseñas no coinciden",
          invalidToken: "El enlace de restablecimiento no es válido o está incompleto.",
          genericError: "Error al restablecer. El enlace podría haber expirado.",
          done: {
            title: "Contraseña cambiada",
            desc: "Ahora puedes iniciar sesión con tu nueva contraseña. Redirigiendo …",
          },
        },
      },
      footer: "Experimento personal. Las rentabilidades históricas y esperadas no garantizan resultados futuros. La pérdida total es posible. El apalancamiento amplifica ganancias y pérdidas por igual. Esto no es asesoramiento financiero.",
      error: "Error – inténtalo de nuevo",
      academy: {
        close: "Cerrar",
        completed: "Completado",
        lessons: "Lecciones",
        markComplete: "Marcar como completado",
        markIncomplete: "Deshacer",
        minutes: "Min.",
        noLessons: "Aún no hay lecciones disponibles.",
        overallProgress: "Progreso total",
        startLesson: "Abrir",
        subtitle: "Lecciones cortas sobre fundamentos, gestión del riesgo, copy-trading e impuestos.",
        title: "Academia",
        videoLabel: "Vídeo"
      },
      admin: {
        actions: "Acciones",
        activate: "Activar",
        confirmDelete: "¿Seguro que quieres borrarlo?",
        createInvite: "Crear enlace de invitación",
        days: "Días",
        delete: "Borrar",
        docContentDe: "Contenido (DE)",
        docContentEn: "Contenido (EN)",
        docDraft: "Borrador",
        docKey: "Clave",
        docOrder: "Orden",
        docPublished: "Publicado",
        docTitleDe: "Título (DE)",
        docTitleEn: "Título (EN)",
        docVersion: "Versión",
        edit: "Editar",
        invExpired: "Caducado",
        invOpen: "Abierto",
        invRevoked: "Revocado",
        invUsed: "Usado",
        invitations: "Invitaciones",
        inviteCreated: "Invitación creada – enlace copiado al portapapeles",
        inviteExpiry: "Validez",
        inviteHint: "El enlace se copia automáticamente al crearlo. Envíalo por e-mail o messenger al nuevo miembro. Cada enlace solo se puede usar una vez.",
        inviteLabel: "Etiqueta",
        inviteLabelPh: "p. ej., nombre del invitado",
        inviteRevoked: "Invitación revocada",
        lock: "Bloquear",
        members: "Miembros",
        newDoc: "Nuevo documento",
        newPwFor: "Nueva contraseña para",
        publish: "Publicar",
        publishHint: "Publicar incrementa la versión y todos los miembros deben aceptar de nuevo.",
        publishNew: "Publicar nueva versión",
        pwReset: "Contraseña restablecida",
        resetPw: "Establecer contraseña",
        riskDocs: "Documentos de riesgo",
        riskDocsHint: "Gestiona aquí los documentos de riesgo que cada miembro debe confirmar antes de usar el portal. Al publicar una nueva versión, todos los miembros deben aceptar de nuevo.",
        role: "Rol",
        save: "Guardar",
        saved: "Guardado",
        statuses: {
          active: "Activo",
          disabled: "Desactivado",
          locked: "Bloqueado",
          pending: "Pendiente de activación"
        }
      },
      audit: {
        action: "Acción",
        actor: "Autor",
        meta: "Detalles",
        subtitle: "Registro cronológico de todos los cambios importantes en el portal.",
        target: "Objetivo",
        timestamp: "Fecha/hora",
        title: "Registro de auditoría"
      },
      calendar: {
        allCategories: "Todas las categorías",
        confirmDelete: "¿Seguro que quieres eliminar esta cita?",
        created: "Cita creada",
        deleted: "Cita eliminada",
        duration: "Duración",
        editEvent: "Editar cita",
        fields: {
          category: "Categoría",
          description: "Descripción",
          descriptionPh: "Detalles, agenda, notas …",
          endAt: "Fin (opcional)",
          link: "Enlace (Zoom / Meet / webinar)",
          linkPh: "https://…",
          location: "Lugar (opcional)",
          locationPh: "p. ej., Online, Zoom, Berlín",
          recurrence: "Repetición",
          recurrenceNone: "Ninguna (una vez)",
          recurrenceUntil: "Repetir hasta (opcional)",
          recurrenceWeekly: "Cada semana",
          startAt: "Inicio",
          title: "Título",
          titlePh: "p. ej. Live call semanal"
        },
        ical: {
          close: "Cerrar",
          detectedUrl: "Detectado y convertido a",
          enabledLabel: "Auto-sync activo",
          lastError: "Último error",
          lastSync: "Última sincronización",
          neverSynced: "Aún no sincronizado",
          openAdmin: "Importar Google Calendar",
          save: "Guardar URL",
          stats: "{added} añadidos · {updated} actualizados · {removed} eliminados",
          subtitle: "Pega la URL secreta de iCal o un enlace público de embed de tu Google Calendar: lo convertimos automáticamente. Se sincroniza cada hora.",
          syncNow: "Sincronizar ahora",
          title: "Importar Google Calendar",
          urlLabel: "URL de iCal o calendario",
          urlPh: "https://calendar.google.com/calendar/..."
        },
        joinLink: "Ir al evento",
        months: [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre"
        ],
        moreEvents: "+ {n} más",
        newEvent: "Nuevo evento",
        next: "Siguiente",
        noEvents: "No hay eventos este mes.",
        noUpcoming: "No hay próximos eventos.",
        prev: "Atrás",
        recurringBadge: "Semanal",
        recurringUntil: "hasta {date}",
        save: "Guardar",
        subtitle: "Todas las live calls, webinars y ventanas de mantenimiento de un vistazo.",
        title: "Calendario",
        today: "Hoy",
        upcoming: "Próximos eventos",
        updated: "Evento actualizado",
        weekdaysShort: ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"],
        when: "Hora"
      },
      heroSubtitles: {
        academy: "Lecciones cortas, tutoriales y recursos",
        adminAcademy: "Gestiona categorías y lecciones de la base de conocimiento",
        adminSupport: "Vista general de todos los tickets de soporte",
        audit: "Registro cronológico de todas las acciones del portal",
        calculator: "Simula rentabilidad, apalancamiento y retiros",
        calendar: "Live calls, webinars y eventos: todo de un vistazo",
        dashboard: "Tu progreso y hitos en el copy trading",
        history: "Tu historial completo de trades de un vistazo",
        members: "Gestión de miembros e invitaciones",
        riskCenter: "Tus documentos de riesgo y tu perfil de riesgo personal",
        riskDocs: "Gestiona documentos de riesgo versionados",
        settings: "Ajustes y preferencias del portal",
        social: "Genera posts automáticamente para la comunidad y redes sociales",
        strategy: "Tu landing page personal y gestión de referidos",
        support: "Tu línea directa con el admin del portal – preguntas y problemas sobre el Team Portal",
        tracking: "Registra tus trades de forma limpia y sin huecos"
      },
      kb: {
        backToOverview: "Volver al resumen",
        categories: "Categorías",
        close: "Cerrar",
        empty: "Aún no hay contenido disponible.",
        featured: "Contenido recomendado para ti",
        items: "Contenido",
        lessons: "Lecciones",
        minutes: "min",
        noRecent: "Aún no has visto nada.",
        noResults: "No se encontró contenido.",
        popular: "Contenido popular",
        readMore: "Abrir",
        recent: "Visto recientemente",
        relativeDayAgo: "hace {n} día",
        relativeDaysAgo: "hace {n} días",
        relativeToday: "hoy",
        relativeYesterday: "ayer",
        searchPh: "Busca temas, cursos o contenido…",
        showAll: "Mostrar todo",
        subtitle: "Temas, tutoriales y recursos seleccionados.",
        title: "Base de conocimiento",
        typeArticle: "Artículo",
        typeCourse: "Curso",
        typeFaq: "FAQ",
        typeGuide: "Guía",
        typeQuiz: "Quiz",
        typeVideo: "Video",
        videoLabel: "Video",
        viewsSuffix: "vistas"
      },
      landing: {
        copied: "Copiado al portapapeles",
        copyUrl: "Copiar URL",
        notSet: "Primero introduce una referencia.",
        openPreview: "Abrir vista previa",
        refHint: "Debe empezar por http(s)://. Este enlace se usa en todos los botones CTA de tu landing page.",
        refLabel: "Tu enlace del back office de CopyXapp / IB Portal (en Profile, el enlace bajo Partner → Copiar enlace)",
        refPh: "https://...?ref=...",
        save: "Guardar",
        saved: "Landing page actualizada",
        slugHint: "2–30 caracteres; a–z, 0–9 y guion. Será parte de tu URL.",
        slugLabel: "Tu referencia personal",
        slugPh: "p. ej. max, sonic-max, max-2026",
        slugTaken: "Esta referencia ya está en uso.",
        subtitle: "Crea tu referencia personal e introduce tu enlace del IB Portal Backoffice. Todos los botones CTA de la landing page pública enlazarán a él.",
        title: "Tu landing page",
        yourUrl: "Tu URL pública"
      },
      onboarding: {
        accepted: "Confirmado",
        allAccepted: "Todos los documentos confirmados",
        back: "Atrás",
        completed: "Portal habilitado",
        finish: "Desbloquear portal",
        maxLoss: "Tolerancia máx. de pérdida (%)",
        maxLossHint: "A partir de este drawdown quieres intervenir o que te avisemos.",
        next: "Siguiente",
        of: "de",
        openDoc: "Ver",
        payoutRate: "Porcentaje de payout (%)",
        pendingHint: "Pendiente: {n}",
        readAndAccept: "He leído y entendido",
        reconsentDesc: "Hemos actualizado uno o varios documentos de riesgo. Por favor, lee y confirma la nueva versión para seguir usando tu portal.",
        reconsentTitle: "Documentos de riesgo actualizados",
        startCapital: "Capital inicial ($)",
        step: "Paso",
        step1Desc: "Breve presentación del portal. Aquí sigues tu recorrido de copy trading con transparencia, registras payouts y mantienes el riesgo bajo control.",
        step1Points: [
          "Tus datos son privados: solo tú y el admin los ven.",
          "El trading es de alto riesgo. Solo reflejamos la info, no asesoramos.",
          "Todos los rendimientos se basan en tus datos reales."
        ],
        step1Title: "Bienvenido",
        step2Desc: "Lee cada documento con atención y confirma por separado que has entendido el contenido.",
        step2Title: "Confirmar documentos de riesgo",
        step3Desc: "Define tus parámetros iniciales. Puedes ajustarlos en cualquier momento en el Centro de Riesgo.",
        step3Title: "Perfil de riesgo personal",
        step4Desc: "Revisa tus datos y desbloquea el portal.",
        step4Title: "Resumen",
        subtitle: "Completa los siguientes pasos para desbloquear tu portal personal.",
        summaryDocs: "Documentos confirmados",
        summaryProfile: "Tu perfil de riesgo",
        targetLeverage: "Factor de copia objetivo",
        title: "Bienvenido a Team Phoenix"
      },
      personal: {
        currentDrawdown: "Drawdown actual",
        currentGain: "Ganancia actual",
        entries: "Registros",
        goalDouble: "Duplicar capital",
        goalGain: "Ganancia objetivo",
        leverageTarget: "Apalancamiento objetivo",
        lossToleranceNear: "La pérdida se acerca a tu tolerancia.",
        lossToleranceReached: "Tolerancia de pérdida superada: revisa tu configuración de riesgo.",
        maxDrawdown: "Drawdown máx.",
        openRiskCenter: "Ir al Centro de Riesgo",
        payoutRateActual: "Real",
        payoutRateGoal: "Objetivo de retiro",
        profileMissing: "Primero configura tu perfil de riesgo.",
        progress: "Progreso",
        subtitle: "Tu progreso personal frente a tus objetivos del perfil de riesgo.",
        title: "Mi progreso"
      },
      register: {
        desc: "Has sido invitado al portal de miembros de Team Phoenix. Crea tu cuenta personal.",
        displayName: "Nombre y apellido",
        email: "E-mail",
        expired: "Esta invitación ha caducado. Solicita un nuevo enlace de invitación.",
        invalid: "Esta invitación no es válida o ya se ha usado. Ponte en contacto con tu persona de referencia.",
        password: "Contraseña (mín. 8 caracteres)",
        password2: "Repite la contraseña",
        pendingMsg: "¡Registro correcto! Tu cuenta aún debe ser habilitada por un administrador.",
        pwMismatch: "Las contraseñas no coinciden.",
        pwShort: "La contraseña debe tener al menos 8 caracteres.",
        riskNote: "Al registrarte, confirmas que este portal es solo para documentación y no constituye asesoramiento financiero. El trading puede llevar a la pérdida total.",
        submit: "Crear cuenta",
        title: "Registro (solo con invitación)"
      },
      riskCenter: {
        acceptedOn: "Confirmado el",
        close: "Cerrar",
        docsSection: "Documentos de riesgo",
        notAccepted: "Aún no confirmado",
        profileSection: "Tu perfil de riesgo",
        profileUpdated: "Perfil actualizado",
        reAccept: "Confirmar nueva versión",
        subtitle: "Tus documentos aceptados y tu perfil de riesgo personal.",
        title: "Centro de riesgo",
        updateProfile: "Guardar perfil",
        version: "Versión",
        view: "Ver"
      },
      support: {
        admin: "Soporte",
        adminSubtitle: "Todas las consultas de miembros. Responde directamente desde el ticket.",
        adminTitle: "Tickets de soporte",
        created: "Creado",
        filterAll: "Todos",
        message: "Mensaje",
        messagePh: "Describe tu solicitud con el mayor detalle posible.",
        newTicket: "Nuevo ticket",
        noTickets: "Aún no hay consultas.",
        reply: "Responder",
        replySent: "Respuesta enviada",
        send: "Enviar",
        setStatus: "Cambiar estado",
        status: "Estado",
        statusClosed: "Cerrado",
        statusInProgress: "En curso",
        statusOpen: "Abierto",
        subject: "Asunto",
        subjectPh: "p. ej., pregunta sobre una lección",
        subtitle: "Tus solicitudes al equipo. Respondemos lo antes posible.",
        ticketCreated: "Solicitud enviada",
        title: "Soporte",
        unread: "Nuevo",
        updated: "Actualizado",
        you: "Tú"
      }
    },

  fr: {
    appTitle: "Team Phoenix Portal",
    tabs: { welcome: "Accueil", dashboard: "Mon parcours", calculator: "Calculatrice", tracking: "Suivi", history: "Historique", strategy: "Landing page", risk: "Risque", social: "Social", settings: "Paramètres", members: "Membres", riskCenter: "Centre de risque", riskDocs: "Documents de risque", academy: "Base de connaissances", support: "Portal Support", adminAcademy: "CMS Savoir", audit: "Journal d'audit", calendar: "Calendrier", adminSupport: "Support (Admin)", marketing: "Marketing", adminGroup: "Admin", leads: "Leads", links: "Liens & e-mails", adminLinks: "Liens & e-mails (Admin)", profitCalc: "Calculateur de profits", marketingMaterial: "Matériel marketing", adminMarketingMaterial: "Matériel (Admin)", news: "Actualités", gallery: "Galerie", network: "Mon équipe", messages: "Messages", courses: "Cours", adminCourses: "Cours (Admin)" },
    heroSubtitles: {
      dashboard: "Ton progrès personnel & jalons du copy-trading",
      calculator: "Simule rendements, effet de levier et retraits",
      tracking: "Consigne tes trades proprement et sans lacune",
      history: "Ton historique complet des trades en un coup d'œil",
      strategy: "Ta landing page personnelle & gestion des parrainages",
      calendar: "Live-calls, webinaires & rendez-vous — tout en un clin d'œil",
      riskCenter: "Tes documents de risque et ton profil de risque personnel",
      academy: "Leçons courtes, tutoriels et ressources",
      support: "Ta ligne directe avec l'admin du portail – questions et problèmes concernant le Team Portal",
      social: "Génère automatiquement des posts pour la communauté & les réseaux",
      settings: "Paramètres du portail et préférences",
      members: "Gestion des membres et invitations",
    },
    disclaimer: {
      title: "Avant de continuer",
      intro: "Merci de lire et confirmer les points suivants pour utiliser le site.",
      yes: "OUI",
      accept: "Accepter et continuer",
      logHint: "En acceptant, ton adresse IP est enregistrée à des fins de preuve.",
      items: [
        "J'ai lu et compris l'avis de non-responsabilité : les contenus ne constituent pas un conseil en investissement, financier, fiscal ou juridique. Il s'agit uniquement de la documentation d'expériences et d'opinions personnelles.",
        "Responsabilité personnelle : les informations sont fournies à titre général. Chaque décision prise sur cette base l'est de manière autonome et à mes propres risques.",
        "Avertissement sur les risques : le trading d'instruments financiers (actions, fonds, crypto-actifs) comporte des risques élevés et peut entraîner une perte totale. Les performances passées ne garantissent pas les résultats futurs.",
        "Je suis conscient(e) que je ne fournis pas moi-même de conseils ni de recommandations. Ce site rapporte uniquement des expériences personnelles."
      ]
    },
    auth: {
      title: "Zone protégée",
      desc: "Saisissez le mot de passe pour gérer le tableau de bord. Les pages publiques restent librement accessibles.",
      email: "E-mail (connexion membre)",
      password: "Mot de passe",
      login: "Connexion",
      logout: "Déconnexion",
      back: "Retour à l'aperçu",
      error: "Mot de passe incorrect",
      locked: "Trop de tentatives – veuillez attendre 15 minutes.",
      submit: "Se connecter",
      loggingIn: "Connexion…",
      forgot: "Mot de passe oublié ?",
      register: "S'inscrire",
      needAccount: "Pas encore de compte ?",
      forgotPanel: {
        backShort: "retour",
        title: "Réinitialiser le mot de passe",
        desc: "Saisissez votre e-mail. Si un compte existe, nous vous enverrons un lien de réinitialisation.",
        emailLabel: "E-mail",
        emailPh: "votre@email.com",
        submit: "Envoyer le lien",
        done: {
          title: "E-mail envoyé",
          desc: "Si un compte avec cet e-mail existe, vous trouverez dans votre boîte de réception un lien pour réinitialiser le mot de passe. Le lien est valable 2 heures.",
          toLogin: "Retour à la connexion",
        },
      },
      reset: {
        title: "Réinitialiser le mot de passe",
        newPw: "Nouveau mot de passe",
        confirmPw: "Confirmer le nouveau mot de passe",
        submit: "Définir le mot de passe",
        intro: "Veuillez saisir votre nouveau mot de passe (minimum 8 caractères).",
        pwTooShort: "Mot de passe trop court (min. 8 caractères)",
        pwMismatch: "Les mots de passe ne correspondent pas",
        invalidToken: "Le lien de réinitialisation est invalide ou incomplet.",
        genericError: "Échec de la réinitialisation. Le lien a peut-être expiré.",
        done: {
          title: "Mot de passe modifié",
          desc: "Vous pouvez maintenant vous connecter avec votre nouveau mot de passe. Redirection …",
        },
      },
    },
    common: {
      save: "Enregistrer",
      cancel: "Annuler",
      delete: "Supprimer",
      edit: "Modifier",
      close: "Fermer",
      loading: "Chargement…",
      confirm: "Confirmer",
      search: "Rechercher",
      back: "Retour",
      next: "Suivant",
      yes: "Oui",
      no: "Non",
    },
    kb: {
      categories: "Catégories",
      lessons: "Leçons",
      items: "Éléments",
      itemSingular: "Élément",
      lessonSingular: "Leçon",
      searchPh: "Rechercher des sujets, cours ou contenus…",
      empty: "Aucun contenu pour le moment.",
      noResults: "Aucun résultat.",
      noLessonsInCategory: "Aucune leçon dans cette catégorie.",
      minutes: "min",
      viewsSuffix: "vues",
      backToOverview: "Retour à l'aperçu",
      downloadPdf: "Télécharger en PDF",
      featured: "Recommandé",
      popular: "Populaire",
      recent: "Récemment consulté",
      noRecent: "Aucune activité récente.",
      typeCourse: "Cours",
      typeVideo: "Vidéo",
      typeGuide: "Guide",
      typeArticle: "Article",
      typeFaq: "FAQ",
      typeQuiz: "Quiz",
      relativeToday: "Aujourd'hui",
      relativeYesterday: "Hier",
      relativeDayAgo: "il y a {n} jour",
      relativeDaysAgo: "il y a {n} jours",
    },
    edu: {
          "heroBadge": "Plateforme de connaissances · Pas de vente, pas de promesses",
          "heroH1a": "Laisse des traders expérimentés trader pour toi —",
          "heroH1b": "ton argent reste à tout moment sur ton propre compte chez le broker.",
          "heroSub": "Tu n’as ni besoin de lire des graphiques ni de trader toi-même. Une stratégie vérifiée est automatiquement copiée sur ton propre compte. Tu gardes le contrôle total à tout moment.",
          "b1t": "Ton capital reste chez toi",
          "b1x": "L’argent est sur ton propre compte chez le broker – pas chez nous.",
          "b2t": "Les trades sont copiés",
          "b2x": "Automatiquement, sans que tu aies à intervenir.",
          "b3t": "Tout est transparent",
          "b3x": "Chaque trade est publiquement traçable.",
          "ctaStart": "Commencer maintenant",
          "ctaLearn": "En savoir plus",
          "illBroker": "Ton compte chez le broker",
          "illControl": "sous ton contrôle",
          "illGold": "Or",
          "illGoldNote": "Le marché sur lequel la stratégie trade.",
          "illApp": "Application Sonic",
          "illProgress": "Progression",
          "illLastTrade": "Dernier trade",
          "illStrategy": "Stratégie",
          "illActive": "Actif · le contrôle est entre tes mains",
          "whatEye": "Les bases d’abord",
          "whatTitle": "Qu’est-ce que le copy trading ?",
          "whatIntro": "En bref : un trader expérimenté prend les décisions de trading. Elles sont automatiquement copiées sur ton propre compte. Tu n’as rien à faire.",
          "whatStep": "Étape",
          "whatS1t": "Trader expérimenté",
          "whatS1x": "Analyse le marché et prend la décision.",
          "whatS2t": "Ouvre un trade",
          "whatS2x": "Ordre d’achat ou de vente sur son compte.",
          "whatS3t": "Automatiquement sur ton compte",
          "whatS3x": "Le même ordre est reproduit – proportionnellement à ton capital.",
          "whatS4t": "Le résultat te revient",
          "whatS4x": "Le gain ou la perte apparaissent au prorata sur ton compte.",
          "whatImportant": "Important : tu ne trades pas toi-même. Tu copies la stratégie. Les décisions de trading restent chez le trader, ton capital reste chez toi.",
          "howEye": "Le déroulement",
          "howTitle": "Comment ça fonctionne exactement ?",
          "howS1t": "Ouvrir un compte",
          "howS1x": "Ouvrir un compte broker gratuit chez TAG Markets – cela prend quelques minutes.",
          "howS2t": "Connecter la stratégie",
          "howS2x": "Via un service spécial (COPYX), tu autorises la copie automatique.",
          "howS3t": "Le trader ouvre une position",
          "howS3x": "Le trader expérimenté prend la décision de trading sur son compte.",
          "howS4t": "Le trade apparaît chez toi",
          "howS4x": "Le même ordre arrive automatiquement sur ton compte – sans action de ta part.",
          "howS5t": "Suivre l’évolution",
          "howS5x": "Tu vois à tout moment dans le portail ce qui se passe – de manière transparente et en temps réel.",
          "skillEye": "Pour débutants",
          "skillTitle": "Dois-je savoir trader ?",
          "skillNo": "Non.",
          "skillNoNote": "Aucun prérequis.",
          "skillDesc": "Toutes les décisions de trading sont prises par le trader expérimenté. Tu vois simplement ce qui se passe – et tu apprends automatiquement au passage.",
          "skill1": "pas besoin de lire des graphiques",
          "skill2": "pas d’analyse de marché",
          "skill3": "pas de décisions d’achat",
          "skill4": "pas de signaux de vente",
          "skill5": "pas d’analyse de l’actualité",
          "skill6": "pas de travail le dimanche",
          "moneyEye": "Confiance",
          "moneyTitle": "Où est réellement mon argent ?",
          "moneySub": "La question la plus importante – et la réponse la plus simple :",
          "moneyAccLabel": "Ton compte chez le broker",
          "moneyAccNote": "Ici – et uniquement ici – se trouve ton capital.",
          "moneyP1t": "Sur ton compte chez le broker",
          "moneyP1x": "Un compte réglementé qui n’appartient qu’à toi. Nous n’avons absolument aucun accès à ton solde.",
          "moneyP2t": "Uniquement une autorisation de trading",
          "moneyP2x": "La stratégie peut uniquement placer des trades – mais ne peut jamais toucher à ton argent.",
          "moneyP3t": "Aucun encaissement par des tiers",
          "moneyP3x": "Tes dépôts et retraits se font directement entre toi et ton broker.",
          "moneyP4t": "Suspendable ou résiliable à tout moment",
          "moneyP4x": "Un clic suffit pour arrêter la copie ou y mettre fin complètement.",
          "moneyCtrl": "Le contrôle total reste entre tes mains.",
          "moneyCtrlSub": "Pas de gérant de fonds, pas de conservation, pas de retrait par des tiers.",
          "whyEye": "Public cible",
          "whyTitle": "Pourquoi les gens utilisent-ils le copy trading ?",
          "whyP1t": "« Je n’ai pas le temps »",
          "whyP1x": "Travail, famille, quotidien – le copy trading continue de fonctionner pendant que tu vis ta vie.",
          "whyP2t": "« Je n’ai pas d’expérience »",
          "whyP2x": "Tu n’as pas besoin de connaissances en trading. La stratégie prend les décisions, et tu apprends en parallèle.",
          "whyP3t": "« Je veux investir en toute transparence »",
          "whyP3x": "Chaque trade est traçable. Tu vois exactement ce qui est fait et pourquoi.",
          "whyP4t": "« Je préfère laisser ça à des pros »",
          "whyP4x": "Les traders expérimentés ont des années d’expérience. Tu peux utiliser leurs décisions à l’identique.",
          "transEye": "Transparence",
          "transTitle": "Qu’est-ce que Myfxbook — et pourquoi est-ce important ?",
          "transPara": "Myfxbook est un service de vérification indépendant pour les comptes de trading. Il se connecte directement au compte broker du trader et enregistre automatiquement chaque trade – sans que quiconque puisse ensuite &bdquo;arranger&ldquo; les chiffres.",
          "trans1": "Chaque trade est enregistré en temps réel – pas seulement en fin de mois.",
          "trans2": "Toute manipulation est exclue : les données proviennent directement du broker.",
          "trans3": "Tu peux consulter à tout moment – publiquement, sans inscription.",
          "trans4": "On voit aussi les pertes – pas seulement les gains. Cela crée une vraie confiance.",
          "transCta": "Voir le track record public",
          "transVer": "Compte vérifié",
          "transLive": "En direct",
          "transK1": "Trades au total",
          "transK2": "Taux de réussite",
          "transK3": "En direct depuis",
          "transK4": "Phase de perte max.",
          "transK3v": "21 mois",
          "transExpl": "&bdquo;Phase de perte&ldquo; signifie : la plus forte baisse entre un sommet et le creux qui suit. Plus le chiffre est faible, plus la courbe est régulière.",
          "oppEye": "Honnête plutôt que publicitaire",
          "oppTitle": "Opportunités & risques, clairement",
          "oppSub": "Les deux vont ensemble. Nous les montrons côte à côte – sans enjoliver.",
          "oppTitleC": "Opportunités",
          "oppTitleR": "Risques",
          "opp1": "Séparation claire entre le capital (chez toi) et la stratégie (chez le trader).",
          "opp2": "Gain de temps : pas d’analyse de marché, pas d’étude de graphiques, pas de téléphone d’alerte.",
          "opp3": "Transparence totale grâce à un track record vérifié.",
          "opp4": "Courbe d’apprentissage incluse : tu vois comment travaille un pro.",
          "opp5": "Suspendable à tout moment – pas de contrat, pas d’engagement.",
          "risk1": "Des pertes sont possibles – y compris la perte totale de ton investissement.",
          "risk2": "Les performances passées ne garantissent pas les résultats futurs.",
          "risk3": "Le marché (or) peut fortement bouger, même sur une courte période.",
          "risk4": "Sans connaissances de broker, la première mise en place du compte prend du temps.",
          "risk5": "Non adapté à un capital dont tu as besoin à court terme.",
          "faqEye": "FAQ",
          "faqTitle": "Questions fréquentes",
          "faqQ1": "Qu’est-ce que le copy trading, exactement ?",
          "faqA1": "Le copy trading signifie : un trader expérimenté prend les décisions de trading. Elles sont automatiquement copiées sur ton propre compte chez le broker. Tu ne trades pas toi-même – tu copies la stratégie.",
          "faqQ2": "Mon argent reste-t-il vraiment sur mon compte ?",
          "faqA2": "Oui. Ton capital est chez un broker réglementé sur un compte qui n’appartient qu’à toi. La stratégie n’a que l’autorisation de placer des trades – et n’a jamais accès à ton argent.",
          "faqQ3": "Puis-je arrêter à tout moment ?",
          "faqA3": "Oui. Tu peux mettre la copie en pause en un clic ou l’arrêter complètement. Il n’y a pas de durée minimale, pas de préavis de résiliation.",
          "faqQ4": "Comment retirer mes gains ?",
          "faqA4": "Directement depuis le compte broker vers ton propre compte bancaire. Les dépôts et retraits se font exclusivement entre toi et ton broker – pas via nous.",
          "faqQ5": "Ai-je besoin d’expérience en trading ?",
          "faqA5": "Non. Aucun prérequis. La stratégie prend toutes les décisions de trading. Si tu veux apprendre davantage, tu trouveras dans le portail membres une base de connaissances structurée.",
          "faqQ6": "Combien ça coûte ?",
          "faqA6": "L’utilisation de la stratégie se fait sur une base de performance : des frais de performance s’appliquent aux gains réellement réalisés. Pas de gain, pas de frais. Tu verras tous les détails avant la connexion.",
          "faqQ7": "Que se passe-t-il en cas de pertes ?",
          "faqA7": "Les pertes font partie du marché et sont reproduites proportionnellement à ton capital. Le track record montre ouvertement les phases de gain comme de perte.",
          "faqQ8": "Pourquoi trader l’or précisément ?",
          "faqA8": "L’or (ticker &bdquo;XAUUSD&ldquo;) est l’un des marchés les plus liquides au monde : spreads serrés, mouvements clairs et négociable 24h/24. La stratégie est spécialement optimisée pour les caractéristiques de ce marché.",
          "faqQ9": "Qu’est-ce que MT5 ?",
          "faqA9": "MetaTrader 5 (MT5) est une plateforme de trading très répandue. Le broker la met gratuitement à disposition. La stratégie &bdquo;communique&ldquo; avec ton broker via MT5 et y place les trades. Toi, tu n’as pas besoin d’utiliser MT5.",
          "softH1": "Une fois que tu as compris comment fonctionne le copy trading,",
          "softH2": "tu peux maintenant voir comment la stratégie a travaillé historiquement.",
          "softSub": "Pas de promesses, pas de pression. Juste des chiffres provenant de comptes réels et vérifiés.",
          "softAgain": "Relire depuis le début"
    },
    calendar: {
          "title": "Calendrier",
          "subtitle": "Tous les live calls, webinaires et créneaux de maintenance en un coup d’œil.",
          "today": "Aujourd’hui",
          "prev": "Retour",
          "next": "Suivant",
          "newEvent": "Nouveau rendez-vous",
          "editEvent": "Modifier le rendez-vous",
          "upcoming": "Prochains rendez-vous",
          "noEvents": "Aucun rendez-vous ce mois-ci.",
          "noUpcoming": "Aucun rendez-vous à venir.",
          "allCategories": "Toutes les catégories",
          "moreEvents": "+ {n} de plus",
          "ical": {
                "title": "Importer Google Agenda",
                "subtitle": "Colle soit l’URL iCal secrète, soit un lien d’intégration public de ton Google Agenda – nous convertissons automatiquement. Synchronisation horaire.",
                "urlLabel": "URL iCal ou du calendrier",
                "urlPh": "https://calendar.google.com/calendar/...",
                "enabledLabel": "Auto-sync activée",
                "save": "Enregistrer l’URL",
                "syncNow": "Synchroniser maintenant",
                "lastSync": "Dernière synchronisation",
                "neverSynced": "Pas encore synchronisé",
                "lastError": "Dernière erreur",
                "stats": "{added} ajoutés · {updated} mis à jour · {removed} supprimés",
                "openAdmin": "Import Google Agenda",
                "close": "Fermer",
                "detectedUrl": "Détecté et converti en"
          },
          "fields": {
                "title": "Titre",
                "titlePh": "p. ex. Live call hebdomadaire",
                "description": "Description",
                "descriptionPh": "Détails, agenda, notes …",
                "startAt": "Début",
                "endAt": "Fin (optionnel)",
                "link": "Lien (Zoom / Meet / Webinar)",
                "linkPh": "https://…",
                "location": "Lieu (optionnel)",
                "locationPh": "p. ex. En ligne, Zoom, Berlin",
                "category": "Catégorie",
                "recurrence": "Récurrence",
                "recurrenceNone": "Aucune (unique)",
                "recurrenceWeekly": "Chaque semaine",
                "recurrenceUntil": "Récurrence jusqu’au (optionnel)"
          },
          "recurringBadge": "Hebdomadaire",
          "recurringUntil": "jusqu’au {date}",
          "save": "Enregistrer",
          "created": "Rendez-vous créé",
          "updated": "Rendez-vous mis à jour",
          "deleted": "Rendez-vous supprimé",
          "confirmDelete": "Vraiment supprimer ce rendez-vous ?",
          "duration": "Durée",
          "joinLink": "Rejoindre",
          "when": "Horaire",
          "weekdaysShort": [
                "Lun",
                "Mar",
                "Mer",
                "Jeu",
                "Ven",
                "Sam",
                "Dim"
          ],
          "months": [
                "Janvier",
                "Février",
                "Mars",
                "Avril",
                "Mai",
                "Juin",
                "Juillet",
                "Août",
                "Septembre",
                "Octobre",
                "Novembre",
                "Décembre"
          ]
    },
    settings: {
          "title": "Capital de référence & objectifs",
          "description": "Ces valeurs pilotent ton parcours personnel : calculs de progression, proposition de retrait et indicateurs d’objectif. Elles n’influencent aucun trade réel – elles servent uniquement à simuler et à visualiser ton parcours.",
          "startCapital": "Capital de départ ($)",
          "leverage": "Effet de levier",
          "reinvestRate": "Taux de réinvestissement (%)",
          "payoutRate": "Taux de retrait (%)",
          "monthlyTarget": "Objectif de rendement mensuel (%)",
          "journeyDays": "Durée cible du parcours (jours)",
          "goalAmount": "Objectif de solde ($)",
          "sumHint": "Remarque : réinvestissement + retrait ne font pas 100 % au total.",
          "save": "Enregistrer",
          "saved": "Paramètres enregistrés",
          "preview": "Aperçu",
          "leverageWarning": "Attention : avec un levier {lev}x, un mouvement d’environ -{liq} % suffit à entraîner une perte totale."
    },
    strategy: {
          "badge": "Stratégie active – en direct",
          "hero1": "Trading automatisé sur l’or –",
          "heroHighlight": "ma stratégie en un coup d’œil",
          "heroSub": "La stratégie SONIC s’appuie sur des traders expérimentés pour trader l’or (XAUUSD). Chaque trade est répliqué sur ton propre compte via MT5 – sans que tu aies besoin de trader toi-même. Tu trouveras ici les informations essentielles et la marche à suivre pour démarrer.",
          "kpiDaily": "Rendement quotidien (24×, net)",
          "kpiMonthly": "Rendement mensuel (24×, net)",
          "kpiDrawdown": "Drawdown max. (1×)",
          "kpiTrades": "Trades · Taux de réussite",
          "kpiNote": "Indicateurs nets (compte 24×, après 30 % de commission de performance) selon la présentation (diapo 8, compte suiveur réel vérifié). Drawdown & trades tirés en temps réel de l’historique ({months} mois). Les performances passées ne préjugent pas des performances futures.",
          "cta": "Démarrer maintenant",
          "ctaBandTitle": "Prêt(e) pour la prochaine étape ?",
          "ctaBandSub": "Connecte ton compte et laisse la stratégie trader pour toi.",
          "verified": "Track record vérifié (myfxbook)",
          "howTitle": "Comment ça marche",
          "howSub": "Du compte au premier trade copié en quelques étapes.",
          "step1Title": "Connecter le compte",
          "step1Text": "Tu relies ton propre compte MT5 à la stratégie en quelques minutes. Le capital reste à tout moment sur ton compte personnel.",
          "step2Title": "Les trades sont répliqués",
          "step2Text": "Lorsque la stratégie ouvre une position, elle est automatiquement reproduite sur ton compte sans délai – entrée, sortie et taille de position incluses.",
          "step3Title": "En route ensemble",
          "step3Text": "Une communauté active réunissant des personnes de nombreux pays utilise déjà la stratégie. Si tu as des questions sur la configuration, tu bénéficies d’un accompagnement pas à pas.",
          "mirrorTitle": "Copier plutôt que trader soi-même",
          "whatTitle": "Qu’est-ce que le copy-trading ?",
          "whatText1": "Avec le copy-trading, un compte de trading est automatiquement connecté à une stratégie existante. Chaque trade exécuté par la stratégie est répliqué en temps réel sur ton propre compte – proportionnellement à la taille de ton compte. Pas besoin de lire des graphiques, de choisir le bon moment pour les entrées et les sorties, ni d’avoir de l’expérience en trading.",
          "whatText2": "La grande différence par rapport aux fonds classiques ou à la gestion de patrimoine : ton capital reste en permanence sur ton propre compte chez ton broker. Personne d’autre que toi ne peut y accéder – la stratégie est uniquement autorisée à placer des trades.",
          "whatFacts": ["Le capital reste sur ton propre compte – contrôle total, à tout moment", "Les trades sont répliqués de manière entièrement automatique en temps réel", "Tu peux mettre la copie en pause à tout moment ou l’arrêter complètement", "Chaque trade peut être consulté publiquement sur Myfxbook"],
          "possTitle": "Quelles possibilités s’offrent à toi ?",
          "possSub": "Le copy-trading est flexible – tu décides de l’usage que tu veux en faire.",
          "poss1Title": "Profiter de l’effet des intérêts composés",
          "poss1Text": "Les gains restent sur le compte et sont automatiquement pris en compte dans les trades suivants. Ainsi, la taille des positions augmente avec le temps – l’effet des intérêts composés peut faire croître le capital nettement plus vite sur plusieurs mois qu’une épargne à croissance linéaire.",
          "poss2Title": "Retraits réguliers",
          "poss2Text": "Sinon, il est possible de retirer régulièrement une partie des gains – par exemple pour récupérer d’abord le capital initial investi. Dès lors, tu ne trades plus qu’avec « l’argent de la maison ».",
          "poss3Title": "Choisir toi-même le facteur de copie",
          "poss3Text": "Avec le facteur de copie (p. ex. 12× ou 24×), tu détermines le niveau de levier avec lequel ton compte réplique la stratégie. Un facteur plus élevé signifie un potentiel de rendement plus élevé – mais aussi un risque de perte plus élevé.",
          "poss4Title": "Participer de façon totalement passive",
          "poss4Text": "Une fois la configuration initiale effectuée, tout fonctionne automatiquement. Aucun graphique à analyser, aucune décision de trading, aucun temps à y consacrer – l’évolution peut être suivie à tout moment en toute transparence.",
          "riskTitle": "Opportunités & risques – une vision honnête",
          "riskSub": "Le copy-trading avec levier est un investissement à haut risque. Il faut mettre les deux sur la table.",
          "chancesLabel": "Opportunités",
          "risksLabel": "Risques",
          "chances": [
                "Des rendements mensuels supérieurs à la moyenne sont possibles – tout l’historique est vérifié sur Myfxbook",
                "Effet des intérêts composés via le réinvestissement automatique des gains",
                "Aucune connaissance en trading requise – exécution entièrement automatisée",
                "Contrôle total : compte personnel, pause ou sortie à tout moment"
          ],
          "risks": [
                "Le levier fonctionne dans les deux sens – les pertes sont amplifiées autant que les gains",
                "Une perte totale du capital investi est possible à tout moment",
                "Les performances passées ne garantissent pas les évolutions futures",
                "N’investir que du capital dont tu peux supporter la perte totale"
          ],
          "videoTitle": "Comment fonctionne le système de copy-trading",
          "videoSub": "La vidéo explicative montre étape par étape comment le système fonctionne.",
          "mirrorText": "Le principe est simple : un système expérimenté trade, et ton compte suit automatiquement. Tu gardes le contrôle total de ton capital et peux mettre en pause ou sortir à tout moment. Sur cette page, je documente en toute transparence comment cela évolue pour moi.",
          "disclaimer": "Documentation d’expérience personnelle – pas de conseil en investissement, financier ou juridique, ni de recommandation. Le trading d’instruments financiers comporte des risques importants et peut entraîner une perte totale. Tu prends chaque décision sous ta propre responsabilité.",
          "landing": {
                "liveBadge": "Stratégie active · Signal live",
                "heroHead1": "Trading automatisé sur l’or",
                "heroHead2": "avec un historique transparent.",
                "heroSub": "Réplique une stratégie de copy-trading vérifiée sur ton propre compte broker. Ton capital reste sous ton contrôle à tout moment – pause ou arrêt en un clic.",
                "ctaStart": "Démarrer maintenant",
                "ctaLive": "Voir la performance en direct",
                "trust": [
                      "Track record Myfxbook vérifié",
                      "Compte broker personnel",
                      "Mise en pause à tout moment",
                      "Contrôle total sur ton capital"
                ],
                "liveDash": "Tableau de bord live",
                "kpiAvgMonth": "Ø mois",
                "kpiWinRate": "Winrate",
                "kpiDrawdown": "Drawdown",
                "kpiTrades": "Trades",
                "timelineEyebrow": "C’est aussi simple que ça",
                "timelineTitle": "Actif en cinq étapes",
                "steps": [
                      {
                            "title": "Ouvrir un compte broker",
                            "text": "Compte gratuit chez TAG Markets en quelques minutes."
                      },
                      {
                            "title": "Connecter la stratégie",
                            "text": "Activer le copy-trading via COPYX – 2 minutes."
                      },
                      {
                            "title": "Les trades sont répliqués",
                            "text": "Automatiquement, 1:1 sur ton compte. Aucune intervention nécessaire."
                      },
                      {
                            "title": "Suivre l’évolution",
                            "text": "Progression quotidienne dans le portail membre & Myfxbook."
                      },
                      {
                            "title": "Profiter de la communauté",
                            "text": "Live calls, base de connaissances, support direct."
                      }
                ],
                "perfEyebrow": "Réel & vérifié",
                "perfTitle": "Performance live depuis le jour 1",
                "perfSub": "Courbe de capital nette simulée sur un compte de départ à 1 000 $ (Amplified 24×, performance fee de 30 % déjà déduite) – chaque trade est documenté sans lacune.",
                "perfAvgMonth": "Ø mois (net)",
                "perfWinRate": "Winrate",
                "perfDrawdown": "Drawdown max.",
                "perfMonths": "Mois en live",
                "perfChartLabel": "Courbe de capital",
                "perfSourceLine1": "Source de données live : history_trades.",
                "perfSourceLine2": "Simulation après frais broker & performance fee.",
                "perfMilestones": "Jalons",
                "perfMilestoneGoal": "Objectif",
                "perfMilestoneReached": "Atteint :",
                "perfMilestoneOpen": "Encore non atteint",
                "portalEyebrow": "Ton espace membre",
                "portalTitle": "Tout au même endroit. Propre. Clair. À toi.",
                "portalSub": "En tant que membre, tu reçois trois outils centraux qui structurent ton parcours – du capital de départ au premier retrait.",
                "journeyLabel": "Mon parcours",
                "journeyLive": "Live",
                "journeySub": "Progression nette · 6 mois",
                "journeyMilestone": "Jalon",
                "journeyReached": "atteint",
                "journeyShare": "Partageable via lien public · Export PDF",
                "calendarLabel": "Calendrier",
                "calendarMonth": "Février 2026",
                "calendarSub": "4 événements communauté · export .ics",
                "calendarNext": "Prochain événement",
                "calendarNextText": "Live Q&A · 18 fév · 19:00",
                "kbLabel": "Base de connaissances",
                "kbTitle": "AI Q&A · Réponses instantanées",
                "kbSub": "Leçons sélectionnées · recherche assistée par IA",
                "kbUserQ": "Ta question",
                "kbUserQText": "Quel devrait être mon capital de départ ?",
                "kbAI": "Sonic AI répond",
                "kbAnswer": "Départ recommandé à partir de 1 000 € sur un compte 24×. Des montants plus faibles sont possibles, mais ralentissent sensiblement l’effet de composition…",
                "kbLatency": "0,8 s · basé sur 24 leçons",
                "cardJourney": {
                      "title": "Mon parcours",
                      "desc": "Fixe des jalons, suis ta progression nette et partage-la via un lien public."
                },
                "cardCalendar": {
                      "title": "Calendrier",
                      "desc": "Live calls, sessions Q&A et récapitulatifs de trades – un clic sur « Add to Calendar » génère un fichier .ics."
                },
                "cardKb": {
                      "title": "Base de connaissances",
                      "desc": "Leçons sélectionnées + recherche assistée par IA. Des questions comme « Quel devrait être mon capital ? » sont répondues en quelques secondes."
                },
                "ctaMember": "Devenir membre maintenant"
          }
    },
    risk: {
          "title": "Suivi du risque",
          "worstDay": "Plus grosse perte journalière",
          "maxDrawdown": "Drawdown max.",
          "lossStreak": "Plus longue série de pertes",
          "winStreak": "Plus longue série de gains",
          "currentStreak": "Série en cours",
          "liqDistance": "Distance jusqu’à la liquidation",
          "days": "Jours",
          "hypoTitle": "Perte hypothétique en cas de mouvement du marché/de la stratégie (avec levier)",
          "move": "Mouvement",
          "loss": "Perte",
          "remaining": "Capital restant",
          "wiped": "Compte anéanti",
          "ddChart": "Évolution du drawdown",
          "milestones": "Jalons – récupération du capital de départ",
          "milestoneReached": "Jalon atteint : {th} % du capital de départ récupéré !",
          "reachedOn": "atteint le",
          "open": "ouvert",
          "generatePost": "Générer un post",
          "milestoneContext": "Jalon atteint : {th} % du capital de départ récupéré via des retraits (le {date}).",
          "warnTitle": "Avertissements",
          "warnings": {
                "liquidation_close": "Avec un levier de {lev}x, un mouvement d’environ -{liq} % suffit déjà pour une perte totale (liquidation).",
                "drawdown_high": "Le drawdown maximal dépasse 15 % – risque accru.",
                "loss_streak": "Série de pertes actuelle de 3+ jours – analyser la stratégie de manière critique.",
                "big_daily_loss": "Il y a déjà eu une perte journalière de plus de 5 % – forte volatilité.",
                "none": "Aucun avertissement immédiat. Le risque de base lié au levier demeure."
          }
    },
    share: {
          "live": "Live · Expérience publique",
          "subtitle": "Expérience de copy-trading transparente – tous les chiffres sans filtre, pertes incluses.",
          "copyLink": "Copier le lien de partage",
          "copied": "Lien de partage copié",
          "historySubtitle": "Historique réel de trades sur 21 mois – simule toi-même ce que ton entrée aurait donné.",
          "calcTitle": "Calcule ton évolution potentielle à venir",
          "calcHero1": "Calcule ton",
          "calcHeroHighlight": "évolution potentielle",
          "tabHistory": "Historique des trades",
          "tabCalc": "Calculateur",
          "tabJourney": "Mon parcours",
          "tabLive": "Tableau de bord live",
          "hero1": "Ta",
          "heroHighlight": "performance",
          "hero2": "en vue",
          "config": "Ta configuration",
          "configStart": "Capital de départ",
          "configLeverage": "Levier / facteur",
          "configPayout": "Taux de retrait",
          "configEdit": "Modifier la configuration",
          "quote": "Discipline aujourd’hui, liberté demain.",
          "quoteSub": "Ton objectif. Ton chemin. Ton succès.",
          "footerLine": "Transparence. Discipline. Succès.",
          "historyBadge": "Trades réels · Historiquement prouvé",
          "copyHistoryLink": "Copier le lien public vers l’historique",
          "toDashboard": "Vers le tableau de bord live",
          "toHistory": "Vers l’historique des trades"
    },
    journey: {
          "heroTitle": "Mon chemin vers la liberté financière",
          "publicNote": "Ce que tu vois ici est mon compte de trading personnel, que je documente jour après jour en toute transparence – avec tous les gains, pertes et revers. Je partage ce parcours pour consigner mes propres expériences. Tous les contenus sont fournis uniquement à titre informatif et ne constituent ni recommandation ni conseil.",
          "heroSubtitle": "Chaque trade me rapproche de mon objectif. Ce projet documente en toute transparence tout mon parcours – gains, pertes et revers inclus.",
          "dayLabel": "Mon parcours",
          "day": "Jour {d} sur {total}",
          "totalProfit": "Gain total depuis le départ",
          "remaining": "Reste à récupérer du capital initial",
          "balance": "Solde actuel du compte",
          "doneShort": "C’est fait !",
          "capitalBack": "Récupérer le capital de départ",
          "capitalBackDone": "Capital de départ entièrement récupéré",
          "goal": "Objectif : {goal}",
          "goalHint": "Basé sur le solde du compte – objectif ajustable dans les paramètres.",
          "payoutIncluded": "dont retiré (inclus dans le gain)",
          "todayProfit": "Gain aujourd’hui",
          "lastProfit": "Dernier jour de trading",
          "winStreak": "Série de gains",
          "days": "Jours",
          "roi": "ROI",
          "timeline": "Mon parcours – jour après jour",
          "win": "Gain",
          "loss": "Perte",
          "noTrade": "Aucun trade",
          "trades": "Trades",
          "tradesOne": "Trade",
          "balanceArrow": "Solde du compte",
          "achievements": "Jalons",
          "achievedAt": "Atteint le {date}",
          "locked": "Pas encore atteint",
          "newAchievement": "Nouveau jalon atteint :",
          "goalBanner": "Ton objectif t’attend à l’horizon – continue.",
          "quotes": [
                "La constance bat le talent.",
                "Les petits pas mènent à de grands objectifs.",
                "La discipline est le pont entre l’objectif et la réussite.",
                "Chaque trade n’est qu’une étape de plus sur ton chemin.",
                "Ce n’est pas la perfection qui gagne – mais la régularité.",
                "Le meilleur moment pour commencer, c’était hier. Le deuxième meilleur, c’est aujourd’hui."
          ],
          "a": {
                "first_trade": "Premier trade",
                "first_payout": "Premier retrait",
                "profit_100": "100 $ de gain",
                "profit_500": "500 $ de gain",
                "profit_1000": "1 000 $ de gain",
                "capital_back": "Capital de départ récupéré",
                "streak_10": "10 jours gagnants d’affilée",
                "trades_100": "100 trades",
                "balance_10k": "Solde du compte : 10 000 $",
                "balance_50k": "Solde du compte : 50 000 $",
                "balance_100k": "Solde du compte : 100 000 $"
          }
    },
    track: {
          "title": "Suivi quotidien",
          "date": "Date",
          "startBalance": "Solde initial ($)",
          "endBalance": "Solde final ($)",
          "payout": "Retrait ($)",
          "commission": "Commission ($)",
          "traderFee": "Commission trader 30% ($)",
          "commissionShort": "Commission",
          "traderFeeShort": "Commission",
          "netProfit": "Net",
          "suggestedFee": "Suggestion (30% du gain)",
          "netPreview": "Net après frais",
          "trades": "Nombre de trades",
          "note": "Remarque",
          "marketEvent": "Événement de marché",
          "profitPreview": "Gain/perte du jour",
          "suggestedPayout": "Suggestion (10% du gain)",
          "apply": "appliquer",
          "save": "Enregistrer le jour",
          "update": "Mettre à jour",
          "editing": "Modifier l’entrée du {date}",
          "cancel": "Annuler",
          "saved": "Entrée enregistrée",
          "deleted": "Entrée supprimée",
          "entries": "Entrées",
          "exportCsv": "Export CSV",
          "settings": "Paramètres",
          "settingsStart": "Capital de départ ($)",
          "settingsLeverage": "Levier",
          "settingsSave": "Enregistrer",
          "settingsSaved": "Paramètres enregistrés",
          "reinvested": "Réinvesti",
          "actions": ""
    },
    calc: {
          "title": "Calculateur d’intérêts composés",
          "startCapital": "Capital de départ ($)",
          "monthlyReturn": "Rendement mensuel (%)",
          "months": "Durée (mois)",
          "reinvestRate": "Taux de réinvestissement (%)",
          "payoutRate": "Taux de retrait (%)",
          "leverage": "Facteur de levier",
          "compare": "Comparaison : réinvestir 100% vs. stratégie de retrait",
          "fullReinvest": "100% réinvesti",
          "withPayout": "avec retraits",
          "cumPayout": "Retraits cumulés",
          "tableTitle": "Évolution mensuelle",
          "balanceEnd": "Solde du compte",
          "volume": "Volume",
          "totalWithPayout": "Valeur finale incl. retraits",
          "totalFull": "Valeur finale 100% réinvestie",
          "payoutSum": "Somme des retraits",
          "breakeven": "Break-even (retraits ≥ capital de départ)",
          "breakevenDouble": "Break-even (solde ≥ 2× dépôt)",
          "payoutEur": "Retrait ($/mois)",
          "effReturn": "≙ effectif {eff} % par mois avec {lev}x",
          "histAvgNote": "Prérempli : Ø historique {avg} % (à 24x, avant partage des gains)",
          "feeNote": "− 30 % de partage des gains (déduit chaque vendredi du gain hebdomadaire) ≙ net {net} % par mois",
          "noCompound": "Sans compounding : {v}",
          "breakevenMonths": "après {m} mois",
          "breakevenWeeks": "≈ {w} semaines",
          "breakevenNot": "Non atteint sur la période",
          "calcDisclaimer": "Calcul modèle – aucune garantie. Les rendements réels fluctuent, perte totale possible."
    },
    kpi: {
          "startCapital": "Capital de départ",
          "currentBalance": "Solde actuel du compte",
          "totalProfit": "Gains totaux",
          "totalPayouts": "Retraits",
          "netProfit": "Gain net",
          "totalReturn": "Rendement total",
          "monthlyReturn": "Rendement mensuel",
          "dailyReturn": "Ø rendement quotidien",
          "volume": "Volume de trading",
          "leverage": "Levier"
    },
    recovery: "Récupération du capital de départ",
    recoveryHint: "récupéré via des retraits",
    growthChart: "Courbe de croissance",
    balance: "Solde du compte",
    planLine: "Plan ({target} %/mois)",
    payoutsCurve: "Retraits cumulés",
    monthlyTable: "Aperçu mensuel",
    month: "Mois",
    profit: "Gain",
    fees: "Frais",
    feesHint: "Commission : −{c} · Commission : −{p}",
    payout: "Retrait",
    trades: "Trades",
    return: "Rendement",
    endBalance: "Solde final",
    noData: "Aucune entrée pour l’instant. Saisis ton premier jour dans le suivi.",
    weekly: {
          "title": "Mise à jour hebdo due",
          "desc": "Période {since} – {until} · {days} jours suivis · Gain {profit} · Retraits {payout} · Rendement {return}",
          "context": "Mise à jour hebdo pour la période du {since} au {until} : gain {profit}, retraits {payout}, rendement hebdo {return}, {days} jours suivis.",
          "generate": "Générer la mise à jour hebdo",
          "dismiss": "Plus tard"
    },
    history: {
          "title": "Backtest historique",
          "subtitle": "Basé sur {trades} trades réels ({first} à {last}, {months} mois). Qu’aurait donné ton entrée ?",
          "startCapital": "Capital de départ ($)",
          "leverage": "Levier / facteur de copie",
          "payoutRate": "Taux de retrait (%)",
          "endBalance": "Solde du compte à la fin",
          "endBalanceFull": "Sans retraits (100 % réinvesti)",
          "totalPayouts": "Somme des retraits",
          "totalReturn": "Rendement total (incl. retraits)",
          "maxDrawdown": "Drawdown max.",
          "avgMonthly": "Ø rendement mensuel",
          "winRate": "Taux de trades gagnants",
          "bestDay": "Meilleure journée",
          "worstDay": "Pire journée",
          "breakeven": "Break-even (retraits ≥ capital de départ)",
          "breakevenDouble": "Break-even (solde ≥ 2× dépôt)",
          "payoutEur": "Retrait ($/mois)",
          "feeNote": "Toutes les valeurs incluent 30 % de partage des gains des traders (déduit chaque vendredi du gain brut hebdomadaire, uniquement en semaine positive).",
          "simpleReturn": "Rendement sans compounding",
          "simpleReturnSub": "Gains non réinvestis",
          "breakevenMonths": "après {m} mois",
          "breakevenWeeks": "≈ {w} semaines · atteint le {date}",
          "breakevenNot": "Non atteint sur la période",
          "curve": "Évolution du capital (simulation historique)",
          "withPayout": "Solde du compte (avec retraits)",
          "fullReinvest": "100 % réinvesti",
          "cumPayout": "Retraits cumulés",
          "monthlyTable": "Évolution mensuelle",
          "note": "Simulation historique basée sur des trades passés. Les résultats passés ne constituent AUCUNE garantie pour l’avenir – avec un levier {lev}x, le drawdown maximal était de {dd} %. Une perte totale est possible à tout moment.",
          "loading": "Calcul en cours ...",
          "noData": "Aucun trade historique trouvé.",
          "upload": "Mettre à jour les trades (CSV)",
          "uploadOk": "{n} trades importés (jusqu’au {last})",
          "uploadFail": "Échec de l’import",
          "dataStatus": "Stock de données : {n} trades · dernier trade {last}",
          "mfbStatus": "myfxbook live : {gain} % Gain · {dd} % Drawdown",
          "mfbLink": "Voir l’historique vérifié sur Myfxbook"
    },
    stats: {
          "title": "Analyse des trades",
          "profitFactor": "Facteur de profit",
          "profitFactorSub": "Gain brut ÷ perte brute",
          "avgWin": "Ø trade gagnant",
          "avgLoss": "Ø trade perdant",
          "longWinRate": "Taux de réussite Long",
          "shortWinRate": "Taux de réussite Short",
          "avgDuration": "Ø durée des trades",
          "byWeekday": "Performance par jour de la semaine",
          "byHour": "Performance par heure",
          "byMonth": "Performance par mois",
          "pips": "Pips",
          "winShort": "Taux de réussite",
          "winTrades": "Trades gagnants",
          "lossTrades": "Trades perdants",
          "weekdaysShort": [
                "Lu",
                "Ma",
                "Me",
                "Je",
                "Ve",
                "Sa",
                "Di"
          ]
    },
    register: {
          "title": "Inscription (sur invitation uniquement)",
          "desc": "Tu as été invité(e) au portail membre Sonic-Trading. Crée ton compte personnel.",
          "displayName": "Prénom et nom",
          "email": "E-mail",
          "password": "Mot de passe (min. 8 caractères)",
          "password2": "Répéter le mot de passe",
          "submit": "Créer un compte",
          "invalid": "Cette invitation est invalide ou a déjà été utilisée. Merci de contacter ton interlocuteur.",
          "expired": "Cette invitation a expiré. Merci de demander un nouveau lien d’invitation.",
          "pendingMsg": "Inscription réussie ! Ton compte doit encore être activé par un administrateur.",
          "pwShort": "Le mot de passe doit contenir au moins 8 caractères.",
          "pwMismatch": "Les mots de passe ne correspondent pas.",
          "riskNote": "En t’inscrivant, tu confirmes que ce portail sert à la documentation et ne constitue pas un conseil en investissement. Le trading peut entraîner une perte totale."
    },
    admin: {
          "members": "Membres",
          "invitations": "Invitations",
          "inviteLabel": "Libellé",
          "inviteLabelPh": "p. ex. nom de l’invité(e)",
          "inviteExpiry": "Validité",
          "days": "Jours",
          "createInvite": "Créer un lien d’invitation",
          "inviteCreated": "Invitation créée – lien copié dans le presse-papiers",
          "inviteRevoked": "Invitation révoquée",
          "inviteHint": "Le lien est automatiquement copié lors de la création. Envoie-le par e-mail ou messagerie au nouveau membre. Chaque lien n’est utilisable qu’une seule fois.",
          "invOpen": "Ouverte",
          "invUsed": "Utilisée",
          "invRevoked": "Révoquée",
          "invExpired": "Expirée",
          "role": "Rôle",
          "actions": "Actions",
          "statuses": {
                "active": "Actif",
                "pending": "En attente d’activation",
                "locked": "Verrouillé",
                "disabled": "Désactivé"
          },
          "activate": "Activer",
          "lock": "Verrouiller",
          "resetPw": "Définir le mot de passe",
          "newPwFor": "Nouveau mot de passe pour",
          "pwReset": "Mot de passe réinitialisé",
          "saved": "Enregistré",
          "riskDocs": "Documents de risque",
          "riskDocsHint": "Gère ici les documents de risque que chaque membre doit valider avant d’utiliser le portail. Lors de la publication d’une nouvelle version, tous les membres doivent accepter à nouveau.",
          "docKey": "Clé",
          "docOrder": "Ordre",
          "docVersion": "Version",
          "docPublished": "Publié",
          "docDraft": "Brouillon",
          "docTitleDe": "Titre (DE)",
          "docContentDe": "Contenu (DE)",
          "docTitleEn": "Titre (EN)",
          "docContentEn": "Contenu (EN)",
          "publish": "Publier",
          "publishNew": "Publier une nouvelle version",
          "publishHint": "La publication augmente la version et tous les membres doivent accepter à nouveau.",
          "newDoc": "Nouveau document",
          "save": "Enregistrer",
          "edit": "Modifier",
          "delete": "Supprimer",
          "confirmDelete": "Vraiment supprimer ?"
    },
    onboarding: {
          "title": "Bienvenue chez Team Phoenix",
          "subtitle": "Merci de suivre les étapes suivantes pour activer ton portail personnel.",
          "step": "Étape",
          "of": "sur",
          "next": "Suivant",
          "back": "Retour",
          "finish": "Activer le portail",
          "step1Title": "Bienvenue",
          "step1Desc": "Brève présentation du portail. Ici, tu suis ton parcours de copy-trading en toute transparence, tu documentes les retraits et tu gardes ton risque à l’œil.",
          "step1Points": [
                "Tes données sont privées – seul toi et l’admin les voyez.",
                "Le trading est une activité à haut risque. Nous ne faisons que refléter, nous ne conseillons pas.",
                "Tous les rendements reposent sur tes saisies réelles."
          ],
          "step2Title": "Valider les documents de risque",
          "step2Desc": "Merci de lire chaque document attentivement et de confirmer individuellement que tu en as compris le contenu.",
          "readAndAccept": "J’ai lu et compris",
          "accepted": "Confirmé",
          "openDoc": "Afficher",
          "allAccepted": "Tous les documents confirmés",
          "pendingHint": "Restant : {n}",
          "step3Title": "Profil de risque personnel",
          "step3Desc": "Définis tes paramètres de départ. Tu peux les ajuster à tout moment dans le centre de risque.",
          "startCapital": "Capital de départ ($)",
          "targetLeverage": "Facteur de copie cible",
          "payoutRate": "Taux de retrait (%)",
          "maxLoss": "Tolérance de perte max. (%)",
          "maxLossHint": "À partir de ce drawdown, tu veux intervenir ou être informé(e).",
          "step4Title": "Récapitulatif",
          "step4Desc": "Vérifie tes informations et active ton portail.",
          "summaryProfile": "Ton profil de risque",
          "summaryDocs": "Documents confirmés",
          "completed": "Portail activé",
          "reconsentTitle": "Documents de risque mis à jour",
          "reconsentDesc": "Nous avons mis à jour un ou plusieurs documents de risque. Merci de lire et de confirmer la nouvelle version pour continuer à utiliser ton portail."
    },
    riskCenter: {
          "title": "Centre de risque",
          "subtitle": "Tes documents acceptés et ton profil de risque personnel.",
          "docsSection": "Documents de risque",
          "profileSection": "Ton profil de risque",
          "updateProfile": "Enregistrer le profil",
          "profileUpdated": "Profil mis à jour",
          "version": "Version",
          "acceptedOn": "Confirmé le",
          "notAccepted": "Pas encore confirmé",
          "reAccept": "Confirmer la nouvelle version",
          "view": "Afficher",
          "close": "Fermer"
    },
    personal: {
          "title": "Ma progression",
          "subtitle": "Progression personnelle par rapport à tes objectifs du profil de risque.",
          "profileMissing": "Merci de configurer d’abord ton profil de risque.",
          "goalDouble": "Doubler le capital",
          "goalGain": "Gain cible",
          "currentGain": "Gain actuel",
          "progress": "Progression",
          "currentDrawdown": "Drawdown actuel",
          "maxDrawdown": "Drawdown max.",
          "lossToleranceReached": "Tolérance de perte dépassée – merci de vérifier ta configuration de risque.",
          "lossToleranceNear": "La perte se rapproche de ta tolérance.",
          "openRiskCenter": "Aller au centre de risque",
          "payoutRateGoal": "Objectif de retrait",
          "payoutRateActual": "Réel",
          "leverageTarget": "Levier cible",
          "entries": "Entrées"
    },
    academy: {
          "title": "Académie",
          "subtitle": "Courtes leçons sur les bases, la gestion du risque, le copy-trading et la fiscalité.",
          "overallProgress": "Progression globale",
          "lessons": "Leçons",
          "minutes": "min",
          "completed": "Terminé",
          "startLesson": "Ouvrir",
          "markComplete": "Marquer comme terminé",
          "markIncomplete": "Annuler",
          "noLessons": "Aucune leçon disponible pour le moment.",
          "videoLabel": "Vidéo",
          "close": "Fermer"
    },
    support: {
          "title": "Support",
          "subtitle": "Tes demandes à l’équipe. Nous répondons aussi vite que possible.",
          "newTicket": "Nouveau ticket",
          "subject": "Objet",
          "subjectPh": "p. ex. question sur une leçon",
          "message": "Message",
          "messagePh": "Décris ton besoin aussi précisément que possible.",
          "send": "Envoyer",
          "reply": "Répondre",
          "status": "Statut",
          "statusOpen": "Ouvert",
          "statusInProgress": "En cours",
          "statusClosed": "Fermé",
          "you": "Toi",
          "admin": "Support",
          "noTickets": "Aucune demande pour le moment.",
          "created": "Créé",
          "updated": "Mis à jour",
          "ticketCreated": "Demande envoyée",
          "replySent": "Réponse envoyée",
          "adminTitle": "Tickets support",
          "adminSubtitle": "Toutes les demandes des membres. Réponds directement depuis le ticket.",
          "setStatus": "Modifier le statut",
          "unread": "Nouveau",
          "filterAll": "Tous"
    },
    audit: {
          "title": "Journal d’audit",
          "subtitle": "Journal chronologique de toutes les modifications importantes du portail.",
          "timestamp": "Horodatage",
          "action": "Action",
          "actor": "Acteur",
          "target": "Cible",
          "meta": "Détails"
    },
    landing: {
          "title": "Ta landing page",
          "subtitle": "Crée ta référence personnelle et saisis ton lien depuis le backoffice du portail IB. Tous les boutons CTA de la landing page publique pointeront ensuite vers ton lien.",
          "slugLabel": "Ta référence personnelle",
          "slugPh": "p. ex. max, sonic-max, max-2026",
          "slugHint": "2–30 caractères, a–z, 0–9 et tiret. Fera partie de ton URL.",
          "refLabel": "Ton lien depuis le back-office CopyXapp / IB Portal (dans Profile, le lien sous Partner → Copier le lien)",
          "refPh": "https://...?ref=...",
          "refHint": "Doit commencer par http(s)://. Ce lien est utilisé sur tous les boutons CTA de ta landing page.",
          "save": "Enregistrer",
          "saved": "Landing page mise à jour",
          "yourUrl": "Ton URL publique",
          "copyUrl": "Copier l’URL",
          "copied": "Copié dans le presse-papiers",
          "openPreview": "Ouvrir l’aperçu",
          "notSet": "Merci de saisir d’abord une référence.",
          "slugTaken": "Cette référence est déjà utilisée."
    },
    social: {
          "title": "Générateur de réseaux sociaux",
          "type": "Type de post",
          "types": {
                "daily": "Mise à jour quotidienne",
                "weekly": "Mise à jour hebdomadaire",
                "monthly": "Mise à jour mensuelle",
                "milestone": "Jalon",
                "loss": "Mise à jour honnête de perte"
          },
          "language": "Langue du post",
          "context": "Contexte additionnel (optionnel)",
          "contextPlaceholder": "p. ex. marché fort aujourd’hui, jalon 25% atteint ...",
          "generate": "Générer un post",
          "generating": "Génération en cours ...",
          "copy": "Copier",
          "copied": "Copié dans le presse-papiers",
          "empty": "Le post généré apparaîtra ici.",
          "note": "Chaque post se termine automatiquement par l’avertissement sur les risques.",
          "imgTitle": "Générer en image",
          "imgSubtitle": "Crée une image motivante à partir de ton post – pour Instagram Story, feed ou TikTok.",
          "format": "Format",
          "formatStory": "Story / TikTok (9:16)",
          "formatFeed": "Post feed (1:1)",
          "styleLabel": "Style d’image",
          "styleBranded": "Motivant + branding Emerald",
          "stylePhoto": "Photo-réaliste",
          "imgGenerate": "Générer l’image",
          "imgGenerating": "Création de l’image ...",
          "imgDownload": "Télécharger l’image",
          "imgNeedPost": "Merci de générer ou de saisir d’abord un texte de post.",
          "imgReady": "Ton image est prête",
          "imgError": "Échec de la création de l’image"
    },
    footer: "Expérience personnelle. Les performances passées et attendues ne garantissent pas les résultats futurs. Une perte totale est possible. L'effet de levier amplifie gains et pertes. Ceci n'est pas un conseil financier.",
    error: "Erreur — merci de réessayer",
  },

  pl: {
    appTitle: "Team Phoenix Portal",
    tabs: { welcome: "Powitanie", dashboard: "Moja podróż", calculator: "Kalkulator", tracking: "Śledzenie", history: "Historia", strategy: "Landing page", risk: "Ryzyko", social: "Social", settings: "Ustawienia", members: "Członkowie", riskCenter: "Centrum ryzyka", riskDocs: "Dokumenty ryzyka", academy: "Baza wiedzy", support: "Portal Support", adminAcademy: "CMS Wiedzy", audit: "Dziennik audytu", calendar: "Kalendarz", adminSupport: "Wsparcie (Admin)", marketing: "Marketing", adminGroup: "Admin", leads: "Leady", links: "Linki i e-maile", adminLinks: "Linki i e-maile (Admin)", profitCalc: "Kalkulator zysków", marketingMaterial: "Materiały marketingowe", adminMarketingMaterial: "Materiały (Admin)", news: "Aktualności", gallery: "Galeria", network: "Mój zespół", messages: "Wiadomości", courses: "Kursy", adminCourses: "Kursy (Admin)" },
    heroSubtitles: {
      dashboard: "Twój osobisty postęp i kamienie milowe w copy-tradingu",
      calculator: "Symuluj zyski, dźwignię i wypłaty",
      tracking: "Zapisuj swoje transakcje czysto i bez luk",
      history: "Pełna historia transakcji w skrócie",
      strategy: "Twoja osobista strona lądowania i zarządzanie poleceniami",
      calendar: "Live-calls, webinary i terminy — wszystko na jeden rzut oka",
      riskCenter: "Twoje dokumenty ryzyka i osobisty profil ryzyka",
      academy: "Krótkie lekcje, poradniki i zasoby",
      support: "Twój bezpośredni kontakt z adminem portalu – pytania i problemy dotyczące Team Portal",
      social: "Automatycznie generuj posty dla społeczności i mediów społecznościowych",
      settings: "Ustawienia portalu i preferencje",
      members: "Zarządzanie członkami i zaproszeniami",
    },
    disclaimer: {
      title: "Zanim przejdziesz dalej",
      intro: "Prosimy o przeczytanie i potwierdzenie poniższych punktów, aby korzystać z serwisu.",
      yes: "TAK",
      accept: "Akceptuj i kontynuuj",
      logHint: "Po akceptacji Twój adres IP zostanie zapisany do celów dowodowych.",
      items: [
        "Przeczytałem(-am) i zrozumiałem(-am) wyłączenie odpowiedzialności: wszystkie treści nie stanowią doradztwa inwestycyjnego, finansowego, podatkowego ani prawnego. To wyłącznie dokumentacja osobistych doświadczeń i opinii.",
        "Odpowiedzialność własna: wszystkie informacje mają charakter ogólny. Każda decyzja podjęta na ich podstawie jest podejmowana samodzielnie i na własne ryzyko.",
        "Ostrzeżenie o ryzyku: handel instrumentami finansowymi (akcje, fundusze, kryptowaluty) wiąże się ze znacznym ryzykiem i może prowadzić do całkowitej utraty kapitału. Wyniki z przeszłości nie gwarantują przyszłych rezultatów.",
        "Mam świadomość, że sam(-a) również nie mogę udzielać doradztwa ani rekomendacji. Strona przedstawia wyłącznie własne doświadczenia."
      ]
    },
    auth: {
      title: "Strefa chroniona",
      desc: "Wprowadź hasło, aby zarządzać panelem. Strony publiczne pozostają ogólnodostępne.",
      email: "E-mail (login członka)",
      password: "Hasło",
      login: "Logowanie",
      logout: "Wyloguj",
      back: "Powrót do przeglądu",
      error: "Nieprawidłowe hasło",
      locked: "Zbyt wiele prób – odczekaj 15 minut.",
      submit: "Zaloguj się",
      loggingIn: "Logowanie…",
      forgot: "Zapomniałeś hasła?",
      register: "Zarejestruj się",
      needAccount: "Nie masz konta?",
      forgotPanel: {
        backShort: "wróć",
        title: "Zresetuj hasło",
        desc: "Wpisz swój e-mail. Jeśli konto istnieje, wyślemy ci link do resetu.",
        emailLabel: "E-mail",
        emailPh: "twoj@email.com",
        submit: "Wyślij link resetujący",
        done: {
          title: "E-mail wysłany",
          desc: "Jeśli konto z tym e-mailem istnieje, w skrzynce odbiorczej znajdziesz link do zresetowania hasła. Link jest ważny 2 godziny.",
          toLogin: "Powrót do logowania",
        },
      },
      reset: {
        title: "Zresetuj hasło",
        newPw: "Nowe hasło",
        confirmPw: "Potwierdź nowe hasło",
        submit: "Ustaw hasło",
        intro: "Wprowadź nowe hasło (minimum 8 znaków).",
        pwTooShort: "Hasło za krótkie (min. 8 znaków)",
        pwMismatch: "Hasła nie są zgodne",
        invalidToken: "Link do resetu jest nieprawidłowy lub niekompletny.",
        genericError: "Reset nie powiódł się. Link mógł wygasnąć.",
        done: {
          title: "Hasło zmienione",
          desc: "Możesz teraz zalogować się nowym hasłem. Przekierowywanie …",
        },
      },
    },
    common: {
      save: "Zapisz",
      cancel: "Anuluj",
      delete: "Usuń",
      edit: "Edytuj",
      close: "Zamknij",
      loading: "Ładowanie…",
      confirm: "Potwierdź",
      search: "Szukaj",
      back: "Wstecz",
      next: "Dalej",
      yes: "Tak",
      no: "Nie",
    },
    kb: {
      categories: "Kategorie",
      lessons: "Lekcje",
      items: "Pozycje",
      itemSingular: "Pozycja",
      lessonSingular: "Lekcja",
      searchPh: "Szukaj tematów, kursów lub treści…",
      empty: "Brak treści.",
      noResults: "Brak wyników.",
      noLessonsInCategory: "Brak lekcji w tej kategorii.",
      minutes: "min",
      viewsSuffix: "wyśw.",
      backToOverview: "Powrót do przeglądu",
      downloadPdf: "Pobierz PDF",
      featured: "Polecane",
      popular: "Popularne",
      recent: "Ostatnio oglądane",
      noRecent: "Brak niedawnej aktywności.",
      typeCourse: "Kurs",
      typeVideo: "Wideo",
      typeGuide: "Przewodnik",
      typeArticle: "Artykuł",
      typeFaq: "FAQ",
      typeQuiz: "Quiz",
      relativeToday: "Dziś",
      relativeYesterday: "Wczoraj",
      relativeDayAgo: "{n} dzień temu",
      relativeDaysAgo: "{n} dni temu",
    },
    edu: {
          "heroBadge": "Platforma wiedzy · Bez sprzedaży, bez obietnic",
          "heroH1a": "Pozwól doświadczonym traderom handlować za Ciebie —",
          "heroH1b": "Twoje pieniądze przez cały czas pozostają na Twoim własnym koncie brokerskim.",
          "heroSub": "Nie musisz czytać wykresów ani handlować samodzielnie. Zweryfikowana strategia jest automatycznie kopiowana na Twoje własne konto. W każdej chwili zachowujesz pełną kontrolę.",
          "b1t": "Twój kapitał zostaje u Ciebie",
          "b1x": "Pieniądze są na Twoim własnym koncie brokerskim – nie u nas.",
          "b2t": "Transakcje są kopiowane",
          "b2x": "Automatycznie, bez konieczności Twojej ingerencji.",
          "b3t": "Wszystko transparentne",
          "b3x": "Każdą pojedynczą transakcję można publicznie prześledzić.",
          "ctaStart": "Zacznij teraz",
          "ctaLearn": "Dowiedz się więcej",
          "illBroker": "Twoje konto brokerskie",
          "illControl": "pod Twoją kontrolą",
          "illGold": "Złoto",
          "illGoldNote": "Rynek, na którym handluje strategia.",
          "illApp": "Aplikacja Sonic",
          "illProgress": "Postęp",
          "illLastTrade": "Ostatnia transakcja",
          "illStrategy": "Strategia",
          "illActive": "Aktywne · kontrola po Twojej stronie",
          "whatEye": "Najpierw podstawy",
          "whatTitle": "Czym jest Copy Trading?",
          "whatIntro": "W skrócie: doświadczony trader podejmuje decyzje handlowe. Są one automatycznie kopiowane na Twoje własne konto. Ty nie musisz nic robić.",
          "whatStep": "Krok",
          "whatS1t": "Doświadczony trader",
          "whatS1x": "Analizuje rynek i podejmuje decyzję.",
          "whatS2t": "Otwiera transakcję",
          "whatS2x": "Zlecenie kupna lub sprzedaży na swoim koncie.",
          "whatS3t": "Automatycznie na Twoje konto",
          "whatS3x": "To samo zlecenie jest kopiowane – proporcjonalnie do Twojego kapitału.",
          "whatS4t": "Wynik trafia do Ciebie",
          "whatS4x": "Zysk lub strata pojawiają się proporcjonalnie na Twoim koncie.",
          "whatImportant": "Ważne: nie handlujesz samodzielnie. Kopiujesz strategię. Decyzje handlowe pozostają po stronie tradera, Twój kapitał pozostaje u Ciebie.",
          "howEye": "Przebieg",
          "howTitle": "Jak to działa dokładnie?",
          "howS1t": "Załóż konto",
          "howS1x": "Otwórz darmowe konto brokerskie w TAG Markets – zajmuje to kilka minut.",
          "howS2t": "Połącz strategię",
          "howS2x": "Za pomocą specjalnej usługi (COPYX) autoryzujesz automatyczne kopiowanie.",
          "howS3t": "Trader otwiera pozycję",
          "howS3x": "Doświadczony trader podejmuje decyzję handlową na swoim koncie.",
          "howS4t": "Transakcja pojawia się u Ciebie",
          "howS4x": "To samo zlecenie trafia automatycznie na Twoje konto – bez Twojego udziału.",
          "howS5t": "Śledź wyniki",
          "howS5x": "W każdej chwili widzisz w portalu, co się dzieje – transparentnie i w czasie rzeczywistym.",
          "skillEye": "Dla początkujących",
          "skillTitle": "Czy muszę umieć handlować?",
          "skillNo": "Nie.",
          "skillNoNote": "Nie jest wymagana żadna wiedza wstępna.",
          "skillDesc": "Wszystkie decyzje handlowe podejmuje doświadczony trader. Ty tylko widzisz, co się dzieje – i przy okazji uczysz się automatycznie.",
          "skill1": "bez czytania wykresów",
          "skill2": "bez analizy rynku",
          "skill3": "bez decyzji zakupowych",
          "skill4": "bez sygnałów sprzedaży",
          "skill5": "bez analizy newsów",
          "skill6": "bez pracy w niedziele",
          "moneyEye": "Zaufanie",
          "moneyTitle": "Gdzie właściwie są moje pieniądze?",
          "moneySub": "Najważniejsze pytanie – i najprostsza odpowiedź:",
          "moneyAccLabel": "Twoje konto brokerskie",
          "moneyAccNote": "Tutaj – i tylko tutaj – znajduje się Twój kapitał.",
          "moneyP1t": "Na Twoim koncie brokerskim",
          "moneyP1x": "Regulowane konto, które należy wyłącznie do Ciebie. Nie mamy żadnego dostępu do Twoich środków.",
          "moneyP2t": "Tylko pełnomocnictwo do handlu",
          "moneyP2x": "Strategia może wyłącznie składać zlecenia – ale nigdy nie może dotknąć Twoich pieniędzy.",
          "moneyP3t": "Brak przyjmowania płatności przez osoby trzecie",
          "moneyP3x": "Wpłaty i wypłaty odbywają się bezpośrednio między Tobą a Twoim brokerem.",
          "moneyP4t": "Możesz w każdej chwili wstrzymać lub zakończyć",
          "moneyP4x": "Wystarczy jedno kliknięcie, aby zatrzymać kopiowanie lub całkowicie je zakończyć.",
          "moneyCtrl": "Pełna kontrola pozostaje po Twojej stronie.",
          "moneyCtrlSub": "Żaden zarządzający funduszem, żadna depozytacja, żadnych wypłat przez osoby trzecie.",
          "whyEye": "Dla kogo",
          "whyTitle": "Dlaczego ludzie korzystają z Copy Tradingu?",
          "whyP1t": "„Nie mam czasu”",
          "whyP1x": "Praca, rodzina, codzienność – Copy Trading działa dalej, gdy Ty żyjesz swoim życiem.",
          "whyP2t": "„Nie mam doświadczenia”",
          "whyP2x": "Nie potrzebujesz wiedzy o tradingu. Strategia podejmuje decyzje, a Ty uczysz się po drodze.",
          "whyP3t": "„Chcę inwestować transparentnie”",
          "whyP3x": "Każdą transakcję można prześledzić. Widzisz dokładnie, co jest robione i dlaczego.",
          "whyP4t": "„Wolę zostawić to profesjonalistom”",
          "whyP4x": "Doświadczeni traderzy mają lata praktyki. Możesz wykorzystać ich decyzje 1:1.",
          "transEye": "Transparentność",
          "transTitle": "Czym jest Myfxbook — i dlaczego to ważne?",
          "transPara": "Myfxbook to niezależna usługa weryfikacji kont tradingowych. Łączy się bezpośrednio z kontem brokerskim tradera i automatycznie rejestruje każdą pojedynczą transakcję – bez możliwości późniejszego &bdquo;podrasowania&ldquo; liczb przez kogokolwiek.",
          "trans1": "Każda transakcja jest zapisywana w czasie rzeczywistym – nie dopiero na koniec miesiąca.",
          "trans2": "Manipulacja jest wykluczona: dane pochodzą bezpośrednio od brokera.",
          "trans3": "W każdej chwili możesz zajrzeć sam – publicznie, bez logowania.",
          "trans4": "Widać też straty – nie tylko zyski. To buduje prawdziwe zaufanie.",
          "transCta": "Zobacz publiczny track record",
          "transVer": "Zweryfikowane konto",
          "transLive": "Na żywo",
          "transK1": "Transakcji łącznie",
          "transK2": "Skuteczność",
          "transK3": "Na żywo od",
          "transK4": "Maks. okres strat",
          "transK3v": "21 miesięcy",
          "transExpl": "&bdquo;Okres strat&ldquo; oznacza: największy spadek między szczytem a następującym po nim dołkiem. Im mniejsza liczba, tym spokojniejsza krzywa.",
          "oppEye": "Szczerze zamiast reklamowo",
          "oppTitle": "Szanse i ryzyka wprost",
          "oppSub": "Oba idą w parze. Pokazujemy je obok siebie – bez upiększania.",
          "oppTitleC": "Szanse",
          "oppTitleR": "Ryzyka",
          "opp1": "Wyraźne rozdzielenie kapitału (u Ciebie) i strategii (u tradera).",
          "opp2": "Oszczędność czasu: bez analizy rynku, bez studiowania wykresów, bez telefonu z alarmami.",
          "opp3": "Pełna transparentność dzięki zweryfikowanemu track recordowi.",
          "opp4": "Krzywa nauki w pakiecie: widzisz, jak pracuje profesjonalista.",
          "opp5": "Możliwość wstrzymania w każdej chwili – bez umowy, bez zobowiązań.",
          "risk1": "Straty są możliwe – także całkowita utrata wpłaconych środków.",
          "risk2": "Wyniki historyczne nie są gwarancją przyszłych rezultatów.",
          "risk3": "Rynek (złoto) może silnie się poruszać, także w krótkim czasie.",
          "risk4": "Bez znajomości brokera pierwsze założenie konta wymaga czasu.",
          "risk5": "Nieodpowiednie dla kapitału, którego potrzebujesz w krótkim terminie.",
          "faqEye": "FAQ",
          "faqTitle": "Najczęstsze pytania",
          "faqQ1": "Czym właściwie jest Copy Trading?",
          "faqA1": "Copy Trading oznacza: doświadczony trader podejmuje decyzje handlowe. Są one automatycznie kopiowane na Twoje własne konto brokerskie. Nie handlujesz samodzielnie – kopiujesz strategię.",
          "faqQ2": "Czy moje pieniądze naprawdę zostają na moim koncie?",
          "faqA2": "Tak. Twój kapitał znajduje się u regulowanego brokera na koncie, które należy wyłącznie do Ciebie. Strategia ma jedynie pozwolenie na składanie zleceń – nigdy jednak dostępu do Twoich pieniędzy.",
          "faqQ3": "Czy mogę w każdej chwili przestać?",
          "faqA3": "Tak. Możesz wstrzymać kopiowanie jednym kliknięciem albo całkowicie je zakończyć. Nie ma minimalnego okresu, nie ma okresu wypowiedzenia.",
          "faqQ4": "Jak wypłacam zyski?",
          "faqA4": "Bezpośrednio z konta brokerskiego na Twoje własne konto bankowe. Wpłaty i wypłaty odbywają się wyłącznie między Tobą a Twoim brokerem – nie przez nas.",
          "faqQ5": "Czy potrzebuję doświadczenia w tradingu?",
          "faqA5": "Nie. Nie jest wymagana żadna wiedza wstępna. Strategia przejmuje wszystkie decyzje handlowe. Jeśli chcesz nauczyć się więcej, w portalu członkowskim znajdziesz uporządkowaną bazę wiedzy.",
          "faqQ6": "Ile to kosztuje?",
          "faqA6": "Korzystanie ze strategii odbywa się na zasadzie success fee: pobierana jest opłata performance od faktycznie osiągniętych zysków. Bez zysku nie ma opłaty. Wszystkie szczegóły zobaczysz przed połączeniem.",
          "faqQ7": "Co dzieje się w przypadku strat?",
          "faqA7": "Straty są częścią rynku i są kopiowane proporcjonalnie do Twojego kapitału. Track record otwarcie pokazuje zarówno okresy zysków, jak i strat.",
          "faqQ8": "Dlaczego handlowane jest akurat złoto?",
          "faqA8": "Złoto (ticker &bdquo;XAUUSD&ldquo;) to jeden z najbardziej płynnych rynków na świecie: wąskie spready, czytelne ruchy i handel przez całą dobę. Strategia jest specjalnie zoptymalizowana pod właściwości tego rynku.",
          "faqQ9": "Czym jest MT5?",
          "faqA9": "MetaTrader 5 (MT5) to powszechnie używana platforma handlowa. Broker udostępnia ją bezpłatnie. Strategia &bdquo;komunikuje się&ldquo; z Twoim brokerem przez MT5 i tam składa transakcje. Ty sam nie musisz obsługiwać MT5.",
          "softH1": "Gdy już zrozumiesz, jak działa Copy Trading,",
          "softH2": "możesz teraz sprawdzić, jak strategia działała historycznie.",
          "softSub": "Bez obietnic, bez presji. Tylko liczby z prawdziwych, zweryfikowanych kont.",
          "softAgain": "Przeczytaj od początku jeszcze raz"
    },
    calendar: {
          "title": "Kalendarz",
          "subtitle": "Wszystkie live call’e, webinary i okna serwisowe w jednym miejscu.",
          "today": "Dzisiaj",
          "prev": "Wstecz",
          "next": "Dalej",
          "newEvent": "Nowe wydarzenie",
          "editEvent": "Edytuj wydarzenie",
          "upcoming": "Nadchodzące wydarzenia",
          "noEvents": "Brak wydarzeń w tym miesiącu.",
          "noUpcoming": "Brak nadchodzących wydarzeń.",
          "allCategories": "Wszystkie kategorie",
          "moreEvents": "+ {n} więcej",
          "ical": {
                "title": "Importuj Google Kalendarz",
                "subtitle": "Wklej albo tajny adres iCal URL, albo publiczny link do osadzenia Twojego Google Kalendarza – automatycznie konwertujemy. Synchronizacja co godzinę.",
                "urlLabel": "URL iCal lub kalendarza",
                "urlPh": "https://calendar.google.com/calendar/...",
                "enabledLabel": "Auto-sync włączony",
                "save": "Zapisz URL",
                "syncNow": "Synchronizuj teraz",
                "lastSync": "Ostatnia synchronizacja",
                "neverSynced": "Jeszcze nie zsynchronizowano",
                "lastError": "Ostatni błąd",
                "stats": "{added} dodano · {updated} zaktualizowano · {removed} usunięto",
                "openAdmin": "Import Google Kalendarza",
                "close": "Zamknij",
                "detectedUrl": "Wykryto i przekonwertowano na"
          },
          "fields": {
                "title": "Tytuł",
                "titlePh": "np. cotygodniowy live call",
                "description": "Opis",
                "descriptionPh": "Szczegóły, agenda, notatki …",
                "startAt": "Start",
                "endAt": "Koniec (opcjonalnie)",
                "link": "Link (Zoom / Meet / Webinar)",
                "linkPh": "https://…",
                "location": "Miejsce (opcjonalnie)",
                "locationPh": "np. online, Zoom, Berlin",
                "category": "Kategoria",
                "recurrence": "Powtarzanie",
                "recurrenceNone": "Brak (jednorazowo)",
                "recurrenceWeekly": "Co tydzień",
                "recurrenceUntil": "Powtarzaj do (opcjonalnie)"
          },
          "recurringBadge": "Co tydzień",
          "recurringUntil": "do {date}",
          "save": "Zapisz",
          "created": "Wydarzenie utworzone",
          "updated": "Wydarzenie zaktualizowane",
          "deleted": "Wydarzenie usunięte",
          "confirmDelete": "Na pewno usunąć to wydarzenie?",
          "duration": "Czas trwania",
          "joinLink": "Dołącz do wydarzenia",
          "when": "Czas",
          "weekdaysShort": [
                "Pn",
                "Wt",
                "Śr",
                "Cz",
                "Pt",
                "Sb",
                "Nd"
          ],
          "months": [
                "Styczeń",
                "Luty",
                "Marzec",
                "Kwiecień",
                "Maj",
                "Czerwiec",
                "Lipiec",
                "Sierpień",
                "Wrzesień",
                "Październik",
                "Listopad",
                "Grudzień"
          ]
    },
    settings: {
          "title": "Kapitał referencyjny i cele",
          "description": "Te wartości sterują Twoją osobistą ścieżką: obliczeniami postępu, sugestią wypłat i wskaźnikami celu. Nie wpływają na rzeczywiste transakcje – służą wyłącznie do symulacji i wizualizacji Twojej drogi.",
          "startCapital": "Kapitał początkowy ($)",
          "leverage": "Dźwignia",
          "reinvestRate": "Wskaźnik reinwestycji (%)",
          "payoutRate": "Wskaźnik wypłaty (%)",
          "monthlyTarget": "Docelowa miesięczna stopa zwrotu (%)",
          "journeyDays": "Docelowy czas trwania (dni)",
          "goalAmount": "Cel salda konta ($)",
          "sumHint": "Uwaga: reinwestycja + wypłata nie sumują się do 100%.",
          "save": "Zapisz",
          "saved": "Ustawienia zapisane",
          "preview": "Podgląd",
          "leverageWarning": "Uwaga: przy dźwigni {lev}x już ruch o ok. -{liq} % prowadzi do całkowitej straty."
    },
    strategy: {
          "badge": "Strategia aktywna – działa na żywo",
          "hero1": "Zautomatyzowany trading złotem –",
          "heroHighlight": "moja strategia w skrócie",
          "heroSub": "Strategia SONIC handluje złotem (XAUUSD) poprzez doświadczonych traderów. Każda transakcja jest kopiowana na Twoje konto przez MT5 – bez konieczności samodzielnego handlu. Tutaj znajdziesz najważniejsze fakty i drogę do startu.",
          "kpiDaily": "Dzienna stopa zwrotu (24x, netto)",
          "kpiMonthly": "Miesięczna stopa zwrotu (24x, netto)",
          "kpiDrawdown": "Maks. obsunięcie (1x)",
          "kpiTrades": "Transakcje · skuteczność",
          "kpiNote": "Wskaźniki netto (konto 24×, po 30% opłacie performance fee) zgodnie z prezentacją (slajd 8, zweryfikowane realne konto followera). Drawdown i transakcje na żywo z historii ({months} mies.). Wyniki z przeszłości nie gwarantują wyników w przyszłości.",
          "cta": "Zacznij teraz",
          "ctaBandTitle": "Gotowy na kolejny krok?",
          "ctaBandSub": "Podłącz swoje konto i pozwól, by strategia handlowała za Ciebie.",
          "verified": "Zweryfikowany track record (myfxbook)",
          "howTitle": "Jak to działa",
          "howSub": "Od podłączenia konta do pierwszej skopiowanej transakcji w kilku krokach.",
          "step1Title": "Podłącz konto",
          "step1Text": "W kilka minut połączysz swoje konto MT5 ze strategią. Kapitał przez cały czas pozostaje na Twoim własnym koncie.",
          "step2Title": "Transakcje są kopiowane",
          "step2Text": "Gdy strategia otwiera pozycję, jest ona automatycznie i bez opóźnień odtwarzana na Twoim koncie – wraz z wejściem, wyjściem i wielkością pozycji.",
          "step3Title": "Razem w drodze",
          "step3Text": "Aktywna społeczność z wielu krajów już korzysta ze strategii. W razie pytań dotyczących konfiguracji otrzymasz wsparcie krok po kroku.",
          "mirrorTitle": "Kopiuj zamiast handlować samodzielnie",
          "whatTitle": "Czym jest copy-trading?",
          "whatText1": "W copy-tradingu konto handlowe jest automatycznie łączone z istniejącą strategią. Każda transakcja wykonywana przez strategię jest odtwarzana na Twoim koncie w czasie rzeczywistym – proporcjonalnie do wielkości Twojego konta. Nie musisz samodzielnie analizować wykresów, wybierać momentów wejścia i wyjścia ani mieć doświadczenia w tradingu.",
          "whatText2": "Kluczowa różnica względem klasycznych funduszy lub zarządzania aktywami: kapitał przez cały czas pozostaje na Twoim koncie u brokera. Nikt poza Tobą nie ma do niego dostępu – strategia otrzymuje jedynie uprawnienie do składania zleceń.",
          "whatFacts": [
                "Kapitał pozostaje na Twoim własnym koncie – pełna kontrola, w każdej chwili",
                "Transakcje są w pełni automatycznie kopiowane w czasie rzeczywistym",
                "Kopiowanie można w każdej chwili wstrzymać lub całkowicie zakończyć",
                "Każdą transakcję można publicznie zweryfikować na Myfxbook"
          ],
          "possTitle": "Jakie masz dzięki temu możliwości?",
          "possSub": "Copy-trading jest elastyczny – to Ty decydujesz, jak go wykorzystasz.",
          "poss1Title": "Wykorzystaj efekt procentu składanego",
          "poss1Text": "Zyski pozostają na koncie i są automatycznie reinwestowane. Dzięki temu rośnie wielkość pozycji – efekt procentu składanego może sprawić, że kapitał przez miesiące będzie rósł wyraźnie szybciej niż przy liniowym oszczędzaniu.",
          "poss2Title": "Regularne wypłaty",
          "poss2Text": "Alternatywnie można regularnie wypłacać część zysków – na przykład, aby najpierw odzyskać wniesiony kapitał początkowy. Od tego momentu handlujesz już tylko „pieniędzmi z domu”.",
          "poss3Title": "Sam wybierz mnożnik kopiowania",
          "poss3Text": "Za pomocą mnożnika kopiowania (np. 12x lub 24x) określasz, jak mocno Twoje konto lewaruje strategię. Wyższy mnożnik oznacza wyższą potencjalną stopę zwrotu – ale też odpowiednio wyższe ryzyko straty.",
          "poss4Title": "Uczestnicz całkowicie pasywnie",
          "poss4Text": "Po jednorazowej konfiguracji wszystko działa automatycznie. Bez czytania wykresów, bez decyzji tradingowych, bez poświęcania czasu – a postępy możesz śledzić w każdej chwili w pełni transparentnie.",
          "riskTitle": "Szanse i ryzyka – uczciwie",
          "riskSub": "Copy-trading z dźwignią to inwestycja wysokiego ryzyka. Obie strony trzeba jasno pokazać.",
          "chancesLabel": "Szanse",
          "risksLabel": "Ryzyka",
          "chances": [
                "Możliwe ponadprzeciętne miesięczne stopy zwrotu – pełna historia jest zweryfikowana na Myfxbook",
                "Efekt procentu składanego dzięki automatycznemu reinwestowaniu zysków",
                "Brak potrzeby własnej wiedzy tradingowej – w pełni automatyczna realizacja",
                "Pełna kontrola: własne konto, możliwość wstrzymania lub wyjścia w każdej chwili"
          ],
          "risks": [
                "Dźwignia działa w obie strony – straty są wzmacniane tak samo jak zyski",
                "Całkowita utrata zainwestowanego kapitału jest możliwa w każdej chwili",
                "Wyniki z przeszłości nie gwarantują przyszłych rezultatów",
                "Inwestuj tylko kapitał, którego całkowitą utratę jesteś w stanie udźwignąć"
          ],
          "videoTitle": "Jak działa system copy-tradingu",
          "videoSub": "Film instruktażowy pokazuje krok po kroku, jak działa system.",
          "mirrorText": "Zasada jest prosta: doświadczony system handluje, a Twoje konto automatycznie podąża za nim. Zachowujesz pełną kontrolę nad kapitałem i możesz w każdej chwili wstrzymać lub zakończyć. Na tej stronie transparentnie dokumentuję, jak to wygląda u mnie.",
          "disclaimer": "Osobista dokumentacja doświadczeń – brak doradztwa inwestycyjnego, finansowego lub prawnego oraz brak rekomendacji. Handel instrumentami finansowymi wiąże się ze znacznym ryzykiem i może prowadzić do całkowitej utraty kapitału. Każdą decyzję podejmujesz na własną odpowiedzialność.",
          "landing": {
                "liveBadge": "Strategia aktywna · Sygnał na żywo",
                "heroHead1": "Zautomatyzowany trading złotem",
                "heroHead2": "z transparentną historią.",
                "heroSub": "Kopiuj sprawdzoną strategię copy-tradingową na własne konto brokerskie. Kapitał zawsze pozostaje pod Twoją kontrolą – wstrzymanie lub zakończenie jednym kliknięciem.",
                "ctaStart": "Zacznij teraz",
                "ctaLive": "Zobacz wyniki na żywo",
                "trust": [
                      "Zweryfikowany track record Myfxbook",
                      "Własne konto brokerskie",
                      "Możliwość wstrzymania w każdej chwili",
                      "Pełna kontrola nad kapitałem"
                ],
                "liveDash": "Panel na żywo",
                "kpiAvgMonth": "Ø miesiąc",
                "kpiWinRate": "Skuteczność",
                "kpiDrawdown": "Drawdown",
                "kpiTrades": "Transakcje",
                "timelineEyebrow": "To takie proste",
                "timelineTitle": "Aktywny w pięciu krokach",
                "steps": [
                      {
                            "title": "Otwórz konto brokerskie",
                            "text": "Darmowe konto w TAG Markets w kilka minut."
                      },
                      {
                            "title": "Podłącz strategię",
                            "text": "Włącz copy-trading przez COPYX – zajmuje 2 minuty."
                      },
                      {
                            "title": "Transakcje są kopiowane",
                            "text": "Automatycznie, 1:1 na Twoje konto. Bez ingerencji."
                      },
                      {
                            "title": "Śledź postępy",
                            "text": "Codzienny progres w portalu członkowskim i Myfxbook."
                      },
                      {
                            "title": "Korzystaj ze społeczności",
                            "text": "Live-call’e, baza wiedzy, bezpośredni support."
                      }
                ],
                "perfEyebrow": "Realne i zweryfikowane",
                "perfTitle": "Wyniki na żywo od pierwszego dnia",
                "perfSub": "Symulowana netto krzywa kapitału na koncie startowym 1 000 $ (24× Amplified, 30% opłaty performance fee już odjęte) – każda transakcja udokumentowana bez luk.",
                "perfAvgMonth": "Ø miesiąc (netto)",
                "perfWinRate": "Skuteczność",
                "perfDrawdown": "Maks. drawdown",
                "perfMonths": "Miesiące na żywo",
                "perfChartLabel": "Krzywa kapitału",
                "perfSourceLine1": "Źródło danych live: history_trades.",
                "perfSourceLine2": "Symulacja po opłatach brokera i performance fee.",
                "perfMilestones": "Kamienie milowe",
                "perfMilestoneGoal": "Cel",
                "perfMilestoneReached": "Osiągnięte:",
                "perfMilestoneOpen": "Wciąż otwarte",
                "portalEyebrow": "Twoja strefa członkowska",
                "portalTitle": "Wszystko w jednym miejscu. Porządnie. Klarownie. Twoje.",
                "portalSub": "Jako członek otrzymujesz trzy kluczowe narzędzia, które porządkują Twoją drogę – od kapitału startowego do pierwszej wypłaty.",
                "journeyLabel": "Moja podróż",
                "journeyLive": "Na żywo",
                "journeySub": "Postęp netto · 6 miesięcy",
                "journeyMilestone": "Kamień milowy",
                "journeyReached": "osiągnięty",
                "journeyShare": "Do udostępnienia przez publiczny link · eksport PDF",
                "calendarLabel": "Kalendarz",
                "calendarMonth": "Luty 2026",
                "calendarSub": "4 wydarzenia społeczności · eksport .ics",
                "calendarNext": "Następne wydarzenie",
                "calendarNextText": "Live Q&A · 18 lut · 19:00",
                "kbLabel": "Baza wiedzy",
                "kbTitle": "AI Q&A · Natychmiastowe odpowiedzi",
                "kbSub": "Kuratowane lekcje · wyszukiwanie wspierane przez AI",
                "kbUserQ": "Twoje pytanie",
                "kbUserQText": "Jaki powinien być mój kapitał startowy?",
                "kbAI": "Sonic AI odpowiada",
                "kbAnswer": "Rekomendowany start od 1 000 € na koncie 24×. Mniejsze kwoty są możliwe, ale zauważalnie spowalniają efekt procentu składanego…",
                "kbLatency": "0,8 s · na podstawie 24 lekcji",
                "cardJourney": {
                      "title": "Moja podróż",
                      "desc": "Ustalaj kamienie milowe, śledź swój postęp netto i udostępniaj go przez publiczny link."
                },
                "cardCalendar": {
                      "title": "Kalendarz",
                      "desc": "Live-call’e, sesje Q&A i podsumowania transakcji – jedno kliknięcie w „Add to Calendar\" generuje plik .ics."
                },
                "cardKb": {
                      "title": "Baza wiedzy",
                      "desc": "Kuratowane lekcje plus wyszukiwanie wspierane przez AI. Pytania typu „Jaki powinien być mój kapitał?\" w kilka sekund z odpowiedzią."
                },
                "ctaMember": "Zostań członkiem teraz"
          }
    },
    risk: {
          "title": "Śledzenie ryzyka",
          "worstDay": "Największa dzienna strata",
          "maxDrawdown": "Maks. drawdown",
          "lossStreak": "Najdłuższa seria strat",
          "winStreak": "Najdłuższa seria zysków",
          "currentStreak": "Aktualna seria",
          "liqDistance": "Odległość do likwidacji",
          "days": "Dni",
          "hypoTitle": "Hipotetyczna strata przy ruchu rynku/strategii (z dźwignią)",
          "move": "Ruch",
          "loss": "Strata",
          "remaining": "Pozostały kapitał",
          "wiped": "Konto wyzerowane",
          "ddChart": "Przebieg drawdownu",
          "milestones": "Kamienie milowe – odzyskiwanie kapitału startowego",
          "milestoneReached": "Kamień milowy osiągnięty: odzyskano {th} % kapitału startowego!",
          "reachedOn": "osiągnięto dnia",
          "open": "otwarte",
          "generatePost": "Generuj post",
          "milestoneContext": "Kamień milowy osiągnięty: odzyskano {th} % kapitału startowego poprzez wypłaty (dnia {date}).",
          "warnTitle": "Ostrzeżenia",
          "warnings": {
                "liquidation_close": "Przy dźwigni {lev}x wystarczy już ruch ok. -{liq} % do całkowitej straty (likwidacji).",
                "drawdown_high": "Maksymalny drawdown przekracza 15% – podwyższone ryzyko.",
                "loss_streak": "Aktualna seria strat 3+ dni – krytycznie sprawdź strategię.",
                "big_daily_loss": "Wystąpiła już dzienna strata powyżej 5% – wysoka zmienność.",
                "none": "Brak pilnych ostrzeżeń. Podstawowe ryzyko wynikające z dźwigni pozostaje."
          }
    },
    share: {
          "live": "Na żywo · Publiczny eksperyment",
          "subtitle": "Transparentny eksperyment copy-tradingowy – wszystkie liczby bez upiększeń, także straty.",
          "copyLink": "Skopiuj link do udostępnienia",
          "copied": "Link do udostępnienia skopiowany",
          "historySubtitle": "Prawdziwa historia transakcji z 21 miesięcy – zasymuluj sam, co wyszłoby z Twojego wejścia.",
          "calcTitle": "Oblicz swój możliwy dalszy przebieg",
          "calcHero1": "Oblicz swój możliwy",
          "calcHeroHighlight": "dalszy przebieg",
          "tabHistory": "Historia transakcji",
          "tabCalc": "Kalkulator",
          "tabJourney": "Moja podróż",
          "tabLive": "Panel na żywo",
          "hero1": "Twoja",
          "heroHighlight": "wydajność",
          "hero2": "pod kontrolą",
          "config": "Twoja konfiguracja",
          "configStart": "Kapitał startowy",
          "configLeverage": "Dźwignia / mnożnik",
          "configPayout": "Procent wypłat",
          "configEdit": "Edytuj konfigurację",
          "quote": "Dyscyplina dziś, wolność jutro.",
          "quoteSub": "Twój cel. Twoja droga. Twój sukces.",
          "footerLine": "Transparentność. Dyscyplina. Sukces.",
          "historyBadge": "Prawdziwe transakcje · Historycznie potwierdzone",
          "copyHistoryLink": "Skopiuj publiczny link do historii",
          "toDashboard": "Do panelu na żywo",
          "toHistory": "Do historii transakcji"
    },
    journey: {
          "heroTitle": "Moja droga do wolności finansowej",
          "publicNote": "To, co tu widzisz, to moje osobiste konto tradingowe, które dzień po dniu transparentnie dokumentuję – ze wszystkimi zyskami, stratami i potknięciami. Udostępniam tę podróż, aby utrwalić własne doświadczenia. Wszystkie treści mają wyłącznie charakter informacyjny i nie stanowią rekomendacji ani doradztwa.",
          "heroSubtitle": "Każda transakcja przybliża mnie do celu. Ten projekt transparentnie dokumentuje całą moją drogę – włącznie z zyskami, stratami i niepowodzeniami.",
          "dayLabel": "Moja podróż",
          "day": "Dzień {d} z {total}",
          "totalProfit": "Łączny zysk od startu",
          "remaining": "Pozostało do odzyskania kapitału startowego",
          "balance": "Aktualny stan konta",
          "doneShort": "Gotowe!",
          "capitalBack": "Odzyskiwanie kapitału startowego",
          "capitalBackDone": "Kapitał startowy w pełni odzyskany",
          "goal": "Cel: {goal}",
          "goalHint": "W odniesieniu do stanu konta – cel można zmienić w ustawieniach.",
          "payoutIncluded": "z tego wypłacone (wliczone w zysk)",
          "todayProfit": "Zysk dzisiaj",
          "lastProfit": "Ostatni dzień handlowy",
          "winStreak": "Seria zysków",
          "days": "Dni",
          "roi": "ROI",
          "timeline": "Moja podróż – dzień po dniu",
          "win": "Zysk",
          "loss": "Strata",
          "noTrade": "Brak transakcji",
          "trades": "Transakcje",
          "tradesOne": "Transakcja",
          "balanceArrow": "Stan konta",
          "achievements": "Kamienie milowe",
          "achievedAt": "Osiągnięto dnia {date}",
          "locked": "Jeszcze nieosiągnięte",
          "newAchievement": "Osiągnięto nowy kamień milowy:",
          "goalBanner": "Twój cel czeka na horyzoncie – trzymaj tempo.",
          "quotes": [
                "Konsekwencja pokonuje talent.",
                "Małe kroki prowadzą do wielkich celów.",
                "Dyscyplina jest mostem między celem a sukcesem.",
                "Każda transakcja to tylko kolejny krok na Twojej drodze.",
                "Nie perfekcja wygrywa – tylko konsekwencja.",
                "Najlepszy moment, by zacząć, był wczoraj. Drugi najlepszy jest dziś."
          ],
          "a": {
                "first_trade": "Pierwsza transakcja",
                "first_payout": "Pierwsza wypłata",
                "profit_100": "100 $ zysku",
                "profit_500": "500 $ zysku",
                "profit_1000": "1 000 $ zysku",
                "capital_back": "Kapitał startowy odzyskany",
                "streak_10": "10 dni zysku z rzędu",
                "trades_100": "100 transakcji",
                "balance_10k": "Stan konta 10 000 $",
                "balance_50k": "Stan konta 50 000 $",
                "balance_100k": "Stan konta 100 000 $"
          }
    },
    track: {
          "title": "Śledzenie dzienne",
          "date": "Data",
          "startBalance": "Stan początkowy konta ($)",
          "endBalance": "Stan końcowy konta ($)",
          "payout": "Wypłata ($)",
          "commission": "Prowizja ($)",
          "traderFee": "Udział tradera 30% ($)",
          "commissionShort": "Prowizja",
          "traderFeeShort": "Udział",
          "netProfit": "Netto",
          "suggestedFee": "Propozycja (30% zysku)",
          "netPreview": "Netto po opłatach",
          "trades": "Liczba transakcji",
          "note": "Uwagi",
          "marketEvent": "Wydarzenie rynkowe",
          "profitPreview": "Dzienny zysk/strata",
          "suggestedPayout": "Propozycja (10% zysku)",
          "apply": "zastosuj",
          "save": "Zapisz dzień",
          "update": "Aktualizuj",
          "editing": "Edytujesz wpis z dnia {date}",
          "cancel": "Anuluj",
          "saved": "Wpis zapisany",
          "deleted": "Wpis usunięty",
          "entries": "Wpisy",
          "exportCsv": "Eksport CSV",
          "settings": "Ustawienia",
          "settingsStart": "Kapitał startowy ($)",
          "settingsLeverage": "Dźwignia",
          "settingsSave": "Zapisz",
          "settingsSaved": "Ustawienia zapisane",
          "reinvested": "Zreinwestowane",
          "actions": ""
    },
    calc: {
          "title": "Kalkulator procentu składanego",
          "startCapital": "Kapitał startowy ($)",
          "monthlyReturn": "Miesięczna stopa zwrotu (%)",
          "months": "Okres (miesiące)",
          "reinvestRate": "Procent reinwestycji (%)",
          "payoutRate": "Procent wypłat (%)",
          "leverage": "Mnożnik dźwigni",
          "compare": "Porównanie: 100% reinwestycji vs. strategia wypłat",
          "fullReinvest": "100% zreinwestowane",
          "withPayout": "z wypłatami",
          "cumPayout": "Wypłaty skumulowane",
          "tableTitle": "Rozwój miesięczny",
          "balanceEnd": "Stan konta",
          "volume": "Wolumen",
          "totalWithPayout": "Wartość końcowa wraz z wypłatami",
          "totalFull": "Wartość końcowa 100% reinwestycji",
          "payoutSum": "Suma wypłat",
          "breakeven": "Break-even (wypłaty ≥ kapitał startowy)",
          "breakevenDouble": "Break-even (stan konta ≥ 2× wpłata)",
          "payoutEur": "Wypłata ($/miesiąc)",
          "effReturn": "≙ efektywnie {eff} % miesięcznie przy {lev}x",
          "histAvgNote": "Wstępnie: historyczne Ø {avg} % (przy 24x, przed udziałem w zysku)",
          "feeNote": "− 30% udziału w zysku (potrącenie w każdy piątek z tygodniowego zysku) ≙ netto {net} % miesięcznie",
          "noCompound": "Bez procentu składanego: {v}",
          "breakevenMonths": "po {m} miesiącach",
          "breakevenWeeks": "≈ {w} tygodni",
          "breakevenNot": "Nieosiągnięte w tym okresie",
          "calcDisclaimer": "Wyliczenie modelowe – brak gwarancji. Realne stopy zwrotu się wahają, możliwa całkowita utrata kapitału."
    },
    kpi: {
          "startCapital": "Kapitał startowy",
          "currentBalance": "Aktualny stan konta",
          "totalProfit": "Łączne zyski",
          "totalPayouts": "Wypłaty",
          "netProfit": "Zysk netto",
          "totalReturn": "Łączna stopa zwrotu",
          "monthlyReturn": "Miesięczna stopa zwrotu",
          "dailyReturn": "Ø dzienna stopa zwrotu",
          "volume": "Wolumen obrotu",
          "leverage": "Dźwignia"
    },
    recovery: "Odzyskiwanie kapitału startowego",
    recoveryHint: "odzyskane przez wypłaty",
    growthChart: "Krzywa wzrostu",
    balance: "Stan konta",
    planLine: "Plan ({target} %/miesiąc)",
    payoutsCurve: "Wypłaty skumulowane",
    monthlyTable: "Podsumowanie miesięczne",
    month: "Miesiąc",
    profit: "Zysk",
    fees: "Opłaty",
    feesHint: "Prowizja: −{c} · Udział: −{p}",
    payout: "Wypłata",
    trades: "Transakcje",
    return: "Stopa zwrotu",
    endBalance: "Stan końcowy",
    noData: "Brak wpisów. Dodaj swój pierwszy dzień w trackingu.",
    weekly: {
          "title": "Czas na tygodniową aktualizację",
          "desc": "Okres {since} – {until} · {days} dni śledzone · zysk {profit} · wypłaty {payout} · stopa zwrotu {return}",
          "context": "Tygodniowa aktualizacja za okres {since} do {until}: zysk {profit}, wypłaty {payout}, tygodniowa stopa zwrotu {return}, {days} śledzonych dni.",
          "generate": "Generuj tygodniową aktualizację",
          "dismiss": "Później"
    },
    history: {
          "title": "Historyczny backtest",
          "subtitle": "Na podstawie {trades} prawdziwych transakcji ({first} do {last}, {months} mies.). Co by wyszło z Twojego wejścia?",
          "startCapital": "Kapitał startowy ($)",
          "leverage": "Dźwignia / mnożnik kopiowania",
          "payoutRate": "Procent wypłat (%)",
          "endBalance": "Stan konta na końcu",
          "endBalanceFull": "Bez wypłat (100% reinwestycji)",
          "totalPayouts": "Suma wypłat",
          "totalReturn": "Łączna stopa zwrotu (wraz z wypłatami)",
          "maxDrawdown": "Maks. drawdown",
          "avgMonthly": "Ø miesięczna stopa zwrotu",
          "winRate": "Skuteczność transakcji",
          "bestDay": "Najlepszy dzień",
          "worstDay": "Najgorszy dzień",
          "breakeven": "Break-even (wypłaty ≥ kapitał startowy)",
          "breakevenDouble": "Break-even (stan konta ≥ 2× wpłata)",
          "payoutEur": "Wypłata ($/miesiąc)",
          "feeNote": "Wszystkie wartości uwzględniają 30% udziału w zysku traderów (potrącane w każdy piątek z tygodniowego zysku brutto, tylko przy dodatnim tygodniu).",
          "simpleReturn": "Stopa zwrotu bez procentu składanego",
          "simpleReturnSub": "Zyski nie były reinwestowane",
          "breakevenMonths": "po {m} miesiącach",
          "breakevenWeeks": "≈ {w} tygodni · osiągnięto dnia {date}",
          "breakevenNot": "Nieosiągnięte w tym okresie",
          "curve": "Rozwój kapitału (historycznie symulowany)",
          "withPayout": "Stan konta (z wypłatami)",
          "fullReinvest": "100% reinwestycji",
          "cumPayout": "Wypłaty skumulowane",
          "monthlyTable": "Rozwój miesięczny",
          "note": "Symulacja historyczna na podstawie minionych transakcji. Wyniki z przeszłości NIE stanowią gwarancji na przyszłość – przy dźwigni {lev}x maksymalny drawdown wyniósł {dd} %. Całkowita utrata kapitału jest możliwa w każdej chwili.",
          "loading": "Obliczam ...",
          "noData": "Nie znaleziono historycznych transakcji.",
          "upload": "Zaktualizuj transakcje (CSV)",
          "uploadOk": "Zaimportowano {n} transakcji (do {last})",
          "uploadFail": "Import nie powiódł się",
          "dataStatus": "Zestaw danych: {n} transakcji · ostatnia transakcja {last}",
          "mfbStatus": "myfxbook na żywo: {gain} % Gain · {dd} % Drawdown",
          "mfbLink": "Zobacz zweryfikowaną historię na Myfxbook"
    },
    stats: {
          "title": "Analiza transakcji",
          "profitFactor": "Współczynnik zysku",
          "profitFactorSub": "Zysk brutto ÷ strata brutto",
          "avgWin": "Ø zyskowna transakcja",
          "avgLoss": "Ø stratna transakcja",
          "longWinRate": "Skuteczność longów",
          "shortWinRate": "Skuteczność shortów",
          "avgDuration": "Ø czas trwania transakcji",
          "byWeekday": "Wyniki wg dnia tygodnia",
          "byHour": "Wyniki wg godziny",
          "byMonth": "Wyniki wg miesiąca",
          "pips": "Pipsy",
          "winShort": "Skuteczność",
          "winTrades": "Zyskowne transakcje",
          "lossTrades": "Stratne transakcje",
          "weekdaysShort": [
                "Pn",
                "Wt",
                "Śr",
                "Cz",
                "Pt",
                "So",
                "Nd"
          ]
    },
    register: {
          "title": "Rejestracja (tylko z zaproszeniem)",
          "desc": "Zostałeś zaproszony do portalu członkowskiego Sonic-Trading. Utwórz swoje konto osobiste.",
          "displayName": "Imię i nazwisko",
          "email": "E-mail",
          "password": "Hasło (min. 8 znaków)",
          "password2": "Powtórz hasło",
          "submit": "Utwórz konto",
          "invalid": "To zaproszenie jest nieprawidłowe lub zostało już użyte. Skontaktuj się ze swoim opiekunem.",
          "expired": "To zaproszenie wygasło. Poproś o nowy link z zaproszeniem.",
          "pendingMsg": "Rejestracja udana! Twoje konto musi jeszcze zostać aktywowane przez administratora.",
          "pwShort": "Hasło musi mieć co najmniej 8 znaków.",
          "pwMismatch": "Hasła nie są zgodne.",
          "riskNote": "Rejestrując się, potwierdzasz, że ten portal służy dokumentacji i nie stanowi doradztwa inwestycyjnego. Trading może prowadzić do całkowitej utraty kapitału."
    },
    admin: {
          "members": "Członkowie",
          "invitations": "Zaproszenia",
          "inviteLabel": "Etykieta",
          "inviteLabelPh": "np. imię zaproszonej osoby",
          "inviteExpiry": "Ważność",
          "days": "Dni",
          "createInvite": "Utwórz link z zaproszeniem",
          "inviteCreated": "Zaproszenie utworzone – link skopiowany do schowka",
          "inviteRevoked": "Zaproszenie cofnięte",
          "inviteHint": "Link jest automatycznie kopiowany podczas tworzenia. Wyślij go e-mailem lub komunikatorem do nowego członka. Każdy link można wykorzystać tylko raz.",
          "invOpen": "Otwarte",
          "invUsed": "Wykorzystane",
          "invRevoked": "Cofnięte",
          "invExpired": "Wygasłe",
          "role": "Rola",
          "actions": "Akcje",
          "statuses": {
                "active": "Aktywny",
                "pending": "Oczekuje na aktywację",
                "locked": "Zablokowany",
                "disabled": "Wyłączony"
          },
          "activate": "Aktywuj",
          "lock": "Zablokuj",
          "resetPw": "Ustaw hasło",
          "newPwFor": "Nowe hasło dla",
          "pwReset": "Hasło zresetowane",
          "saved": "Zapisano",
          "riskDocs": "Dokumenty ryzyka",
          "riskDocsHint": "Zarządzaj tutaj dokumentami ryzyka, które każdy członek musi potwierdzić przed korzystaniem z portalu. Po opublikowaniu nowej wersji wszyscy członkowie muszą zaakceptować je ponownie.",
          "docKey": "Klucz",
          "docOrder": "Kolejność",
          "docVersion": "Wersja",
          "docPublished": "Opublikowane",
          "docDraft": "Szkic",
          "docTitleDe": "Tytuł (DE)",
          "docContentDe": "Treść (DE)",
          "docTitleEn": "Tytuł (EN)",
          "docContentEn": "Treść (EN)",
          "publish": "Opublikuj",
          "publishNew": "Opublikuj nową wersję",
          "publishHint": "Publikacja zwiększa wersję i wszyscy członkowie muszą wyrazić zgodę ponownie.",
          "newDoc": "Nowy dokument",
          "save": "Zapisz",
          "edit": "Edytuj",
          "delete": "Usuń",
          "confirmDelete": "Na pewno usunąć?"
    },
    onboarding: {
          "title": "Witamy w Team Phoenix",
          "subtitle": "Przejdź proszę przez poniższe kroki, aby odblokować swoje osobiste konto w portalu.",
          "step": "Krok",
          "of": "z",
          "next": "Dalej",
          "back": "Wstecz",
          "finish": "Odblokuj portal",
          "step1Title": "Witamy",
          "step1Desc": "Krótkie wprowadzenie do portalu. Tutaj transparentnie śledzisz swoją podróż w copy-tradingu, dokumentujesz wypłaty i kontrolujesz ryzyko.",
          "step1Points": [
                "Twoje dane są prywatne – widzisz je tylko Ty i admin.",
                "Trading to działalność wysokiego ryzyka. My jedynie pokazujemy dane, nie doradzamy.",
                "Wszystkie stopy zwrotu opierają się na Twoich rzeczywistych wpisach."
          ],
          "step2Title": "Potwierdź dokumenty ryzyka",
          "step2Desc": "Przeczytaj proszę każdy dokument uważnie i potwierdź osobno, że zrozumiałeś jego treść.",
          "readAndAccept": "Przeczytałem(-am) i zrozumiałem(-am)",
          "accepted": "Potwierdzone",
          "openDoc": "Wyświetl",
          "allAccepted": "Wszystkie dokumenty potwierdzone",
          "pendingHint": "Pozostało: {n}",
          "step3Title": "Osobisty profil ryzyka",
          "step3Desc": "Zdefiniuj parametry początkowe. Możesz je w każdej chwili zmienić w Centrum ryzyka.",
          "startCapital": "Kapitał startowy ($)",
          "targetLeverage": "Docelowy mnożnik kopiowania",
          "payoutRate": "Procent wypłat (%)",
          "maxLoss": "Maks. tolerancja straty (%)",
          "maxLossHint": "Od tego drawdownu chcesz reagować lub być informowany(-a).",
          "step4Title": "Podsumowanie",
          "step4Desc": "Sprawdź swoje dane i odblokuj portal.",
          "summaryProfile": "Twój profil ryzyka",
          "summaryDocs": "Potwierdzone dokumenty",
          "completed": "Portal odblokowany",
          "reconsentTitle": "Zaktualizowane dokumenty ryzyka",
          "reconsentDesc": "Zaktualizowaliśmy jeden lub kilka dokumentów ryzyka. Przeczytaj i potwierdź nową wersję, aby dalej korzystać z portalu."
    },
    riskCenter: {
          "title": "Centrum ryzyka",
          "subtitle": "Twoje zaakceptowane dokumenty i Twój osobisty profil ryzyka.",
          "docsSection": "Dokumenty ryzyka",
          "profileSection": "Twój profil ryzyka",
          "updateProfile": "Zapisz profil",
          "profileUpdated": "Profil zaktualizowany",
          "version": "Wersja",
          "acceptedOn": "Potwierdzone dnia",
          "notAccepted": "Jeszcze niepotwierdzone",
          "reAccept": "Potwierdź nową wersję",
          "view": "Wyświetl",
          "close": "Zamknij"
    },
    personal: {
          "title": "Mój postęp",
          "subtitle": "Osobisty postęp względem Twoich celów z profilu ryzyka.",
          "profileMissing": "Najpierw skonfiguruj swój profil ryzyka.",
          "goalDouble": "Podwoić kapitał",
          "goalGain": "Docelowy zysk",
          "currentGain": "Aktualny zysk",
          "progress": "Postęp",
          "currentDrawdown": "Aktualny drawdown",
          "maxDrawdown": "Maks. drawdown",
          "lossToleranceReached": "Przekroczono tolerancję straty – sprawdź swoje ustawienia ryzyka.",
          "lossToleranceNear": "Strata zbliża się do Twojej tolerancji.",
          "openRiskCenter": "Do Centrum ryzyka",
          "payoutRateGoal": "Cel wypłat",
          "payoutRateActual": "Rzeczywiście",
          "leverageTarget": "Docelowa dźwignia",
          "entries": "Wpisy"
    },
    academy: {
          "title": "Akademia",
          "subtitle": "Krótkie lekcje o podstawach, zarządzaniu ryzykiem, copy-tradingu i podatkach.",
          "overallProgress": "Łączny postęp",
          "lessons": "Lekcje",
          "minutes": "min",
          "completed": "Ukończone",
          "startLesson": "Otwórz",
          "markComplete": "Oznacz jako ukończone",
          "markIncomplete": "Cofnij",
          "noLessons": "Brak dostępnych lekcji.",
          "videoLabel": "Wideo",
          "close": "Zamknij"
    },
    support: {
          "title": "Wsparcie",
          "subtitle": "Twoje zgłoszenia do zespołu. Odpowiadamy tak szybko, jak to możliwe.",
          "newTicket": "Nowe zgłoszenie",
          "subject": "Temat",
          "subjectPh": "np. pytanie do lekcji",
          "message": "Wiadomość",
          "messagePh": "Opisz swoje zgłoszenie tak szczegółowo, jak to możliwe.",
          "send": "Wyślij",
          "reply": "Odpowiedz",
          "status": "Status",
          "statusOpen": "Otwarte",
          "statusInProgress": "W trakcie",
          "statusClosed": "Zamknięte",
          "you": "Ty",
          "admin": "Wsparcie",
          "noTickets": "Brak zgłoszeń.",
          "created": "Utworzono",
          "updated": "Zaktualizowano",
          "ticketCreated": "Zgłoszenie wysłane",
          "replySent": "Odpowiedź wysłana",
          "adminTitle": "Zgłoszenia wsparcia",
          "adminSubtitle": "Wszystkie zgłoszenia od członków. Odpowiedz bezpośrednio z poziomu zgłoszenia.",
          "setStatus": "Zmień status",
          "unread": "Nowe",
          "filterAll": "Wszystkie"
    },
    audit: {
          "title": "Dziennik audytu",
          "subtitle": "Chronologiczny zapis wszystkich ważnych zmian w portalu.",
          "timestamp": "Czas",
          "action": "Akcja",
          "actor": "Wykonawca",
          "target": "Cel",
          "meta": "Szczegóły"
    },
    landing: {
          "title": "Twoja landing page",
          "subtitle": "Utwórz swoją osobistą referencję i wklej swój link z backoffice IB Portal. Wszystkie przyciski CTA na publicznej landing page będą wtedy prowadzić do Twojego linku.",
          "slugLabel": "Twoja osobista referencja",
          "slugPh": "np. max, sonic-max, max-2026",
          "slugHint": "2–30 znaków, a–z, 0–9 i myślnik. Będzie częścią Twojego URL.",
          "refLabel": "Twój link z backoffice CopyXapp / IB Portal (w Profile link w sekcji Partner → Kopiuj link)",
          "refPh": "https://...?ref=...",
          "refHint": "Musi zaczynać się od http(s)://. Ten link będzie używany we wszystkich przyciskach CTA na Twojej landing page.",
          "save": "Zapisz",
          "saved": "Landing page zaktualizowana",
          "yourUrl": "Twój publiczny URL",
          "copyUrl": "Skopiuj URL",
          "copied": "Skopiowano do schowka",
          "openPreview": "Otwórz podgląd",
          "notSet": "Najpierw wpisz referencję.",
          "slugTaken": "Ta referencja jest już zajęta."
    },
    social: {
          "title": "Generator treści do social mediów",
          "type": "Typ posta",
          "types": {
                "daily": "Aktualizacja dzienna",
                "weekly": "Aktualizacja tygodniowa",
                "monthly": "Aktualizacja miesięczna",
                "milestone": "Kamień milowy",
                "loss": "Uczciwa aktualizacja o stracie"
          },
          "language": "Język posta",
          "context": "Dodatkowy kontekst (opcjonalnie)",
          "contextPlaceholder": "np. dziś mocny rynek, osiągnięto kamień milowy 25% ...",
          "generate": "Generuj post",
          "generating": "Generuję ...",
          "copy": "Kopiuj",
          "copied": "Skopiowano do schowka",
          "empty": "Wygenerowany post pojawi się tutaj.",
          "note": "Każdy post automatycznie kończy się ostrzeżeniem o ryzyku.",
          "imgTitle": "Generuj jako obraz",
          "imgSubtitle": "Stwórz motywujący obraz z posta – na Instagram Story, feed lub TikToka.",
          "format": "Format",
          "formatStory": "Story / TikTok (9:16)",
          "formatFeed": "Post w feedzie (1:1)",
          "styleLabel": "Styl obrazu",
          "styleBranded": "Motywujący + branding Emerald",
          "stylePhoto": "Fotorealistyczny",
          "imgGenerate": "Generuj obraz",
          "imgGenerating": "Tworzę obraz ...",
          "imgDownload": "Pobierz obraz",
          "imgNeedPost": "Najpierw wygeneruj lub wpisz tekst posta.",
          "imgReady": "Twój obraz jest gotowy",
          "imgError": "Nie udało się utworzyć obrazu"
    },
    footer: "Osobisty eksperyment. Historyczne i oczekiwane zwroty nie gwarantują przyszłych wyników. Możliwa jest całkowita utrata. Dźwignia zwiększa zarówno zyski, jak i straty. To nie jest porada finansowa.",
    error: "Błąd — spróbuj ponownie",
  },

};

export const NEW_LANGS = ["sr", "hr", "sq", "sl", "pt", "cs", "hu", "hi", "ms", "nl", "zh"];
T.sr = srDict;
T.hr = hrDict;
T.sq = sqDict;
T.sl = slDict;
T.pt = ptDict;
T.cs = csDict;
T.hu = huDict;
T.hi = hiDict;
T.ms = msDict;
T.zh = zhDict;
T.nl = nlDict;
export const LANGS = ["de", "en", "it", "tr", "ru", "es", "fr", "pl", ...NEW_LANGS];

const LOCALES = { de: "de-DE", en: "en-US", it: "it-IT", tr: "tr-TR", ru: "ru-RU", es: "es-ES", fr: "fr-FR", pl: "pl-PL", sr: "sr-RS", hr: "hr-HR", sq: "sq-AL", sl: "sl-SI", pt: "pt-PT", cs: "cs-CZ", hu: "hu-HU", hi: "hi-IN", ms: "ms-MY", nl: "nl-NL", zh: "zh-CN" };
export const locale = (lang) => LOCALES[lang] || "en-US";

const deepFallback = (base, over) => {
  const out = Array.isArray(over) ? [...over] : { ...base, ...over };
  if (!Array.isArray(over)) {
    for (const k of Object.keys(base)) {
      if (over[k] !== undefined && typeof base[k] === "object" && base[k] !== null && typeof over[k] === "object") {
        out[k] = deepFallback(base[k], over[k]);
      }
    }
  }
  return out;
};

export const getT = (lang) => (T[lang] ? deepFallback(NEW_LANGS.includes(lang) ? deepFallback(T.de, T.en) : T.de, T[lang]) : T.de);

/**
 * Adds fallback entries (fr, pl, and any missing LANGS) that mirror the `de`
 * value on every leaf of a per-lang string map. Use for inline L-dicts inside
 * components so switching to a language without translations shows the German
 * text instead of `undefined`.
 *
 * Accepts a single dict `{ key: { de, en, ... } }` or an already-composed
 * label dict `{ de, en, ... }` (auto-detected).
 */
export const hydrateLangDict = (dict) => {
  if (!dict || typeof dict !== "object") return dict;
  const isLeaf = typeof dict.de === "string";
  if (isLeaf) {
    for (const lg of LANGS) if (dict[lg] === undefined) dict[lg] = NEW_LANGS.includes(lg) ? (dict.en ?? dict.de) : dict.de;
    return dict;
  }
  for (const k of Object.keys(dict)) hydrateLangDict(dict[k]);
  return dict;
};

export const fmtEur = (v, lang = "de") =>
  new Intl.NumberFormat(locale(lang), { style: "currency", currency: "USD" }).format(v ?? 0);

export const fmtPct = (v, lang = "de") =>
  `${new Intl.NumberFormat(locale(lang), { maximumFractionDigits: 2 }).format(v ?? 0)} %`;

export const fmtNum = (v, lang = "de") =>
  new Intl.NumberFormat(locale(lang), { maximumFractionDigits: 1 }).format(v ?? 0);

